// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.step-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  line-height: 1.2;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 8px 16px;
  border-radius: 35px;
  border: 2px solid currentColor;
  background: transparent;
  flex-shrink: 0;
}

.step-label .step-count,
.step-label .label-text {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.step-label.complete {
  border-color: #16a34a;
  color: #16a34a;
  background: rgba(22, 163, 74, 0.1);
}

.step-label .label-check {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.step-label.complete .label-check {
  font-size: 18px;
  margin-left: 0.15rem;
}

.square_btn {
  text-align: center;
  padding: 7px 20px;
  border-radius: 25px;
  border: 1px solid #5ea1d8;
  text-decoration: none;
  color: #5ea1d8;
  background-image: linear-gradient(45deg, white 0%, white 100%);
  transition: 0.4s;
  font-family: "Raleway";
}

.square_btn:hover {
  color: white;
  background-image: linear-gradient(45deg, #5ea1d8 0%, #5ea1d8 100%);
}

.publish {
  font-family: "Raleway";
  cursor: pointer;
  text-align: center;
  padding: 4px 20px;
  border-radius: 25px;
  border: 1px solid #5ea1d8;
  text-decoration: none;
  background-color: #5ea1d8 !important;
  color: white;
  height: 40px;
  transition: 0.4s;
}
.publish span {
  color: #fff !important;
}
.publish:hover {
  background: #5ea1d8 !important;
  border: 1px solid #5ea1d8;
}

.upload-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  overflow: hidden;
}

.upload-dialog {
  width: 90%;
  max-width: 1380px;
  height: 90vh;
  max-height: 90vh;
  background: #fff;
  border-radius: 22px;
  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: auto;
  z-index: 10000;
}

.upload-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10px;
  background: #fff;
  color: #111827;
  border-bottom: 1px solid #e4e8f0;
  position: relative;
  z-index: 10008;
  isolation: isolate;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-right {
  position: relative;
  z-index: 10009;
  isolation: isolate;
}

.icon-circle {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-circle mat-icon {
  color: #5ea1d8;
  font-size: 24px;
}

.header-copy {
  min-width: 0;
}
.header-copy p {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}
.header-copy span {
  font-size: 14px;
  color: #6b7280;
}

.mobile-current-access-bar {
  display: none;
}

@media (max-width: 768px) {
  .mobile-current-access-bar {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    box-sizing: border-box;
    margin: 0;
    padding: 10px 16px;
    background: #eef6fc;
    border-bottom: 1px solid rgba(94, 161, 216, 0.35);
  }
  .mobile-access-icon-wrap {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: #d7ebf8;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .mobile-access-icon-wrap mat-icon {
    color: #1565c0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    width: 20px;
    height: 20px;
    line-height: 20px;
    overflow: visible;
  }
  .mobile-access-copy {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 1px;
  }
  .mobile-access-copy .mobile-access-kicker {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #1976d2;
  }
  .mobile-access-copy strong {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #0f172a;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.icon-button {
  border: none;
  background: #f3f4f6;
  color: inherit;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
  position: relative;
  z-index: 10007;
}
.icon-button mat-icon {
  font-size: 22px;
}
.icon-button:hover {
  background: #e5e7eb;
  transform: translateY(-1px);
}

.create-type-button {
  margin-right: 8px;
}

::ng-deep .create-type-menu .mat-mdc-menu-content {
  padding: 8px 0;
}
::ng-deep .create-type-menu .mat-mdc-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  padding-right: 100px;
  min-height: auto;
  height: auto;
  position: relative;
}
::ng-deep .create-type-menu .mat-mdc-menu-item mat-icon {
  color: #5ea1d8;
  font-size: 24px;
  width: 24px;
  height: 24px;
}
::ng-deep .create-type-menu .mat-mdc-menu-item .menu-item-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}
::ng-deep .create-type-menu .mat-mdc-menu-item .menu-item-content .menu-item-title {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  line-height: 1.2;
  display: block;
}
::ng-deep .create-type-menu .mat-mdc-menu-item .menu-item-content .menu-item-description {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.2;
}
::ng-deep .create-type-menu .mat-mdc-menu-item .menu-badge.paid {
  position: absolute !important;
  top: 10px !important;
  right: 10px !important;
  left: auto !important;
  margin: 0 !important;
  z-index: 2;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.6rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  background: #e83e8c !important;
  color: #ffffff !important;
  border: none;
  line-height: 1.2;
  box-shadow: 0 1px 4px rgba(232, 62, 140, 0.3);
  pointer-events: none;
}
::ng-deep .create-type-menu .mat-mdc-menu-item:hover {
  background: #f3f4f6;
}

.stage-banner {
  padding: 1px 10px 1px;
  background: #fff;
  border-bottom: 1px solid #edf1f7;
  flex-shrink: 0;
}

.status-badges {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.status-pill {
  background: #e8f0fe;
  color: #0f62fe;
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
}

.stage-title-row {
  margin-top: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.stage-title-block {
  display: flex;
  align-items: center;
  gap: 18px;
  flex-wrap: wrap;
}

.stage-title {
  font-size: 24px;
  font-weight: 600;
  color: #111827;
}

.stage-meta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #4a5568;
}
.stage-meta mat-icon {
  font-size: 20px;
  color: #1a73e8;
}

.helper-text {
  margin: 10px 0 0;
  color: #5f6368;
  font-size: 14px;
}

.upload-body {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 10px;
  background: #fdfdff;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  flex: 1 1 auto;
}
.upload-body::-webkit-scrollbar {
  width: 8px;
}
.upload-body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.upload-body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.upload-body::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.sponsored-label-group {
  display: flex;
  align-items: center;
  gap: 6px;
}
.sponsored-label-group .field-prefix-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
  color: #888;
}

.field-hint {
  font-size: 12px;
  color: #777;
  margin-top: 4px;
  line-height: 1.4;
}

.collab-section {
  border-top: 1px solid #eee;
  padding-top: 16px;
}

.collab-fields {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.collab-info-strip {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #e3f2fd;
  border: 1px solid #90caf9;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 12px;
  color: #0d47a1;
  line-height: 1.5;
}
.collab-info-strip mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-top: 1px;
}

.collab-visibility-notice {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #fff8e1;
  border: 1px solid #ffe082;
  border-radius: 8px;
  padding: 8px 12px;
  margin-top: 8px;
  font-size: 12px;
  color: #e65100;
  line-height: 1.5;
}
.collab-visibility-notice mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-top: 1px;
  color: #f57c00;
}

.collab-invitees-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.collab-invitee-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  border: 1.5px solid #e0e0e0;
  border-radius: 40px;
  padding: 6px 10px 6px 6px;
  transition: border-color 0.18s, box-shadow 0.18s;
}
.collab-invitee-badge:hover {
  border-color: #90caf9;
  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.1);
}
.collab-invitee-badge.badge-expanded {
  border-radius: 14px;
}

.collab-badge-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 1.5px solid #e0e0e0;
}

.collab-badge-initial {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  letter-spacing: 0;
}

.collab-badge-body {
  flex: 1;
  min-width: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.collab-badge-username {
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.collab-badge-email {
  font-size: 11px;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  animation: fadeSlideIn 0.15s ease;
}

@keyframes fadeSlideIn {
  from {
    opacity: 0;
    transform: translateY(-3px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.collab-badge-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  border-radius: 20px;
  padding: 2px 8px 2px 5px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
}
.collab-badge-status-pill mat-icon {
  font-size: 13px;
  width: 13px;
  height: 13px;
}
.collab-badge-status-pill.pill-new {
  background: #e8eaf6;
  color: #5c6bc0;
}
.collab-badge-status-pill.pill-pending {
  background: #fff8e1;
  color: #f57f17;
}
.collab-badge-status-pill.pill-accepted {
  background: #e8f5e9;
  color: #2e7d32;
}
.collab-badge-status-pill.pill-rejected {
  background: #fce4ec;
  color: #c62828;
}

.collab-badge-remove {
  width: 24px !important;
  height: 24px !important;
  line-height: 24px !important;
  flex-shrink: 0;
  color: #aaa;
}
.collab-badge-remove mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}
.collab-badge-remove:hover {
  color: #e53935;
}

:host-context(body.theme-dark) .collab-invitee-badge {
  background: #1e293b;
  border-color: #334155;
}
:host-context(body.theme-dark) .collab-invitee-badge:hover {
  border-color: #60a5fa;
  box-shadow: 0 2px 8px rgba(96, 165, 250, 0.15);
}
:host-context(body.theme-dark) .collab-badge-username {
  color: #e2e8f0;
}
:host-context(body.theme-dark) .collab-badge-email {
  color: #94a3b8;
}
:host-context(body.theme-dark) .collab-badge-status-pill.pill-new {
  background: #1e1b4b;
  color: #818cf8;
}
:host-context(body.theme-dark) .collab-badge-status-pill.pill-pending {
  background: #451a03;
  color: #fbbf24;
}
:host-context(body.theme-dark) .collab-badge-status-pill.pill-accepted {
  background: #052e16;
  color: #4ade80;
}
:host-context(body.theme-dark) .collab-badge-status-pill.pill-rejected {
  background: #450a0a;
  color: #f87171;
}
:host-context(body.theme-dark) .collab-badge-remove {
  color: #475569;
}
:host-context(body.theme-dark) .collab-badge-remove:hover {
  color: #f87171;
}

.collab-sent-chip {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #e8f5e9;
  border: 1px solid #a5d6a7;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  color: #1b5e20;
}
.collab-sent-chip mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #43a047;
}

.collab-search-wrapper {
  position: relative;
}

.collab-search-results {
  position: absolute;
  top: calc(100% - 20px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  z-index: 200;
  max-height: 260px;
  overflow-y: auto;
}

.collab-user-result {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;
  transition: background 0.15s;
}
.collab-user-result:last-child {
  border-bottom: none;
}
.collab-user-result:hover {
  background: #f0f7ff;
}
.collab-user-result .collab-result-approval {
  margin-left: auto;
  font-size: 16px;
  color: #f59e0b;
}

.collab-user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 1px solid #e0e0e0;
}

.collab-user-avatar-placeholder {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #e8eaf6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.collab-user-avatar-placeholder mat-icon {
  font-size: 20px;
  color: #7986cb;
}

.collab-user-info {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.collab-result-name {
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.collab-result-username {
  font-weight: 400;
  color: #666;
  margin-left: 4px;
}

.collab-result-email {
  font-size: 11px;
  color: #888;
}

.collab-result-bio {
  font-size: 11px;
  color: #aaa;
  font-style: italic;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

.collab-no-results {
  padding: 14px;
  text-align: center;
  font-size: 13px;
  color: #999;
}

.collab-selected-user {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #e8f5e9;
  border: 1px solid #a5d6a7;
  border-radius: 10px;
  padding: 10px 12px;
}
.collab-selected-user .collab-user-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}
.collab-selected-user .collab-user-name {
  font-size: 13px;
  font-weight: 700;
  color: #1b5e20;
}
.collab-selected-user .collab-user-email {
  font-size: 12px;
  color: #388e3c;
}
.collab-selected-user .collab-user-bio {
  font-size: 11px;
  color: #555;
  font-style: italic;
}
.collab-selected-user .collab-approval-note {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #e65100;
  margin-top: 4px;
}
.collab-selected-user .collab-approval-note mat-icon {
  font-size: 13px;
  width: 13px;
  height: 13px;
}
.collab-selected-user .collab-card-actions {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
  margin-left: auto;
}
.collab-selected-user .collab-add-btn {
  height: 32px;
  line-height: 30px;
  padding: 0 10px;
  font-size: 13px;
  white-space: nowrap;
}
.collab-selected-user .collab-add-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  margin-right: 2px;
  vertical-align: middle;
}
.collab-selected-user .collab-clear-btn {
  width: 32px !important;
  height: 32px !important;
  line-height: 32px !important;
  color: #388e3c;
  flex-shrink: 0;
}
.collab-selected-user .collab-clear-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.sponsored-summary-card .card-header-icon,
.collab-summary-card .card-header-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
  vertical-align: middle;
  margin-right: 4px;
  color: #555;
}
.sponsored-summary-card h5,
.collab-summary-card h5 {
  display: flex;
  align-items: center;
}
.sponsored-summary-card .collab-summary-body,
.collab-summary-card .collab-summary-body {
  margin-top: 8px;
}

:host-context(body.theme-dark) .collab-info-strip {
  background: rgba(144, 202, 249, 0.1);
  border-color: rgba(144, 202, 249, 0.3);
  color: #90caf9;
}
:host-context(body.theme-dark) .collab-visibility-notice {
  background: rgba(255, 224, 130, 0.08);
  border-color: rgba(255, 224, 130, 0.3);
  color: #ffcc80;
}
:host-context(body.theme-dark) .collab-visibility-notice mat-icon {
  color: #ffa726;
}
:host-context(body.theme-dark) .collab-sent-chip {
  background: rgba(67, 160, 71, 0.12);
  border-color: rgba(67, 160, 71, 0.3);
  color: #a5d6a7;
}
:host-context(body.theme-dark) .collab-section {
  border-top-color: #333;
}
:host-context(body.theme-dark) .collab-search-results {
  background: #1e1e2e;
  border-color: #333;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
}
:host-context(body.theme-dark) .collab-search-results .collab-user-result {
  border-bottom-color: #2a2a3a;
}
:host-context(body.theme-dark) .collab-search-results .collab-user-result:hover {
  background: #1a2744;
}
:host-context(body.theme-dark) .collab-result-name {
  color: #e2e8f0;
}
:host-context(body.theme-dark) .collab-result-email {
  color: #94a3b8;
}
:host-context(body.theme-dark) .collab-result-bio {
  color: #64748b;
}
:host-context(body.theme-dark) .collab-user-avatar-placeholder {
  background: #2a2a4a;
}
:host-context(body.theme-dark) .collab-user-avatar-placeholder mat-icon {
  color: #7986cb;
}
:host-context(body.theme-dark) .collab-selected-user {
  background: rgba(67, 160, 71, 0.12);
  border-color: rgba(67, 160, 71, 0.3);
}
:host-context(body.theme-dark) .collab-selected-user .collab-user-name {
  color: #a5d6a7;
}
:host-context(body.theme-dark) .collab-selected-user .collab-user-email {
  color: #81c784;
}
:host-context(body.theme-dark) .collab-selected-user .collab-clear-btn {
  color: #81c784;
}

.publishing-state {
  padding: 0 32px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.publishing-state__banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  border-radius: 10px;
  font-size: 13px;
  line-height: 1.5;
}
.publishing-state__banner mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.publishing-state__banner--rejected {
  background: #fdecea;
  border: 1px solid #f5b5ae;
  color: #8a1c12;
}
.publishing-state__banner--rejected mat-icon {
  color: #d93025;
}
.publishing-state__banner--status {
  background: #eef4ff;
  border: 1px solid #c7d7fe;
  color: #1e3a8a;
}
.publishing-state__banner--status mat-icon {
  color: #2563eb;
}
.publishing-state__text {
  flex: 1;
}
.publishing-state__hint {
  display: block;
  font-size: 12px;
  opacity: 0.8;
}
.publishing-state__change {
  margin-left: auto;
  border: 1px solid currentColor;
  background: transparent;
  color: inherit;
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}
.publishing-state__change:disabled {
  opacity: 0.5;
  cursor: default;
}

.publishing-info-btn {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #2563eb;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.publishing-info-btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
}
.publishing-info-btn:hover, .publishing-info-btn:focus-visible {
  background: rgba(37, 99, 235, 0.1);
}

:host-context(body.theme-dark) .publishing-info-btn {
  color: #8ab4f8;
}

:host-context(body.theme-dark) .publishing-state .publishing-state__banner--rejected {
  background: rgba(217, 48, 37, 0.12);
  border-color: rgba(217, 48, 37, 0.35);
  color: #f9b4ad;
}
:host-context(body.theme-dark) .publishing-state .publishing-state__banner--rejected mat-icon {
  color: #f28b82;
}
:host-context(body.theme-dark) .publishing-state .publishing-state__banner--status {
  background: rgba(37, 99, 235, 0.12);
  border-color: rgba(37, 99, 235, 0.35);
  color: #bfd3fe;
}
:host-context(body.theme-dark) .publishing-state .publishing-state__banner--status mat-icon {
  color: #8ab4f8;
}

.collab-publish-banner {
  padding: 0 32px 12px;
}
.collab-publish-banner .collab-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  border-radius: 10px;
  font-size: 13px;
  line-height: 1.5;
}
.collab-publish-banner .collab-banner mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.collab-publish-banner .collab-banner--pending {
  background: #fff8e1;
  border: 1px solid #ffe082;
  color: #7c5a00;
}
.collab-publish-banner .collab-banner--pending mat-icon {
  color: #f59e0b;
}
.collab-publish-banner .collab-banner--accepted {
  background: #e8f5e9;
  border: 1px solid #a5d6a7;
  color: #1b5e20;
}
.collab-publish-banner .collab-banner--accepted mat-icon {
  color: #43a047;
}
.collab-publish-banner .collab-banner--denied {
  background: #fce4ec;
  border: 1px solid #f48fb1;
  color: #880e4f;
}
.collab-publish-banner .collab-banner--denied mat-icon {
  color: #e91e63;
}

:host-context(body.theme-dark) .collab-publish-banner .collab-banner--pending {
  background: rgba(245, 158, 11, 0.12);
  border-color: rgba(245, 158, 11, 0.35);
  color: #fde68a;
}
:host-context(body.theme-dark) .collab-publish-banner .collab-banner--pending mat-icon {
  color: #fbbf24;
}
:host-context(body.theme-dark) .collab-publish-banner .collab-banner--accepted {
  background: rgba(67, 160, 71, 0.12);
  border-color: rgba(67, 160, 71, 0.35);
  color: #a5d6a7;
}
:host-context(body.theme-dark) .collab-publish-banner .collab-banner--accepted mat-icon {
  color: #6ee7a8;
}
:host-context(body.theme-dark) .collab-publish-banner .collab-banner--denied {
  background: rgba(233, 30, 99, 0.12);
  border-color: rgba(233, 30, 99, 0.35);
  color: #f48fb1;
}
:host-context(body.theme-dark) .collab-publish-banner .collab-banner--denied mat-icon {
  color: #f472b6;
}

.upload-footer {
  padding: 20px 32px;
  border-top: 1px solid #e4e8f0;
  background: #fff;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 -6px 18px rgba(15, 23, 42, 0.05);
  flex-shrink: 0;
}
.upload-footer .footer-step {
  flex: 1 1 220px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.footer-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-end;
  flex: 2 1 320px;
  align-items: center;
}

/* Disabled buttons swallow hover, so the tooltip with the reason lives on this wrapper */
.take-public-group {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.take-public-wrap,
.publish-wrap {
  display: inline-flex;
}

.take-public-info {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #6b7280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.take-public-info mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
}
.take-public-info:hover, .take-public-info:focus-visible {
  color: #5ea1d8;
  background: rgba(94, 161, 216, 0.1);
}

.approval-review {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 6px 6px 12px;
  border: 1px solid #c7ddef;
  border-radius: 12px;
  background: #f5faff;
}
.approval-review__label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 600;
  color: #1565c0;
  white-space: nowrap;
}
.approval-review__label mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.approval-comment-input {
  min-width: 200px;
  max-width: 280px;
  height: 38px;
  padding: 0 12px;
  border: 1px solid #d0d7de;
  border-radius: 8px;
  background: #fff;
  color: #1f2328;
  font-size: 13px;
  box-sizing: border-box;
}
.approval-comment-input:focus {
  outline: none;
  border-color: #5ea1d8;
  box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.2);
}

.approval-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 38px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid transparent;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}
.approval-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.approval-btn--approve {
  background: #12b76a;
  color: #fff;
}
.approval-btn--approve:hover:not(:disabled) {
  background: #039855;
  box-shadow: 0 2px 6px rgba(18, 183, 106, 0.3);
}
.approval-btn--reject {
  background: #fff;
  color: #b42318;
  border-color: #fda29b;
}
.approval-btn--reject:hover:not(:disabled) {
  background: #fef3f2;
  border-color: #f97066;
}
.approval-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.current-access-pill.approval-state-pill[data-state=InReview] {
  background: #fff4e5;
  color: #b54708;
}
.current-access-pill.approval-state-pill[data-state=Approved], .current-access-pill.approval-state-pill[data-state=Published] {
  background: #e8f7ee;
  color: #067647;
}
.current-access-pill.approval-state-pill[data-state=Rejected] {
  background: #fdecec;
  color: #b42318;
}

@media (max-width: 767px) {
  .approval-review {
    flex-wrap: wrap;
    width: 100%;
    box-sizing: border-box;
  }
  .approval-review .approval-comment-input {
    flex: 1 1 100%;
    max-width: none;
    order: 1;
  }
  .approval-review .approval-btn {
    flex: 1 1 0;
    order: 2;
  }
}
.current-access-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 240px;
  padding: 6px 12px;
  border-radius: 999px;
  background: #eef6fc;
  color: #1565c0;
  font-size: 12px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.current-access-pill mat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
  overflow: visible;
}

.footer-btn {
  border-radius: 8px;
  border: 1px solid transparent;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  text-transform: none;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
  box-sizing: border-box;
}
.footer-btn.primary {
  background: #5ea1d8;
  color: #fff;
  border-color: #5ea1d8;
}
.footer-btn.primary:hover:not(:disabled) {
  background: #4c8ec2;
}
.footer-btn.secondary {
  background: #f4f6fb;
  color: #1f2937;
  border-color: #d1d5db;
}
.footer-btn.secondary:hover:not(:disabled) {
  background: #e8edf5;
}
.footer-btn.ghost {
  background: transparent;
  color: #5ea1d8;
  border-color: #5ea1d8;
}
.footer-btn.ghost:hover:not(:disabled) {
  background: rgba(94, 161, 216, 0.08);
}
.footer-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.preview-btn {
  border-color: #5ea1d8;
  color: #5ea1d8;
}
.preview-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.preview-btn:hover:not(:disabled) {
  background: rgba(94, 161, 216, 0.1);
}

.next-label {
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
}

.primary-pane {
  flex: 2 1 640px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: 0;
  max-height: 100%;
  overflow: hidden;
}
.primary-pane.full-width {
  flex: 1 1 100%;
  max-width: 100%;
}
.primary-pane.access-primary-pane {
  flex: 3.2 1 0;
  min-width: 0;
  max-width: none;
}

.secondary-pane {
  flex: 1 1 320px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.secondary-pane.access-secondary-pane {
  flex: 0 0 280px;
  max-width: 300px;
}

.flow-layout-container {
  width: 100%;
  padding: 0;
  margin: 0;
}
.flow-layout-container .flow-main-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 402px;
  gap: 24px;
  max-width: 100%;
  margin: 0;
  padding: 16px 24px;
}
@media (min-width: 1920px) {
  .flow-layout-container .flow-main-grid {
    max-width: 1920px;
    margin: 0 auto;
    padding: 24px 48px;
  }
}
@media (max-width: 1024px) {
  .flow-layout-container .flow-main-grid {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 16px;
  }
}
@media (max-width: 768px) {
  .flow-layout-container .flow-main-grid {
    padding: 12px;
    gap: 12px;
  }
}

.flow-main-content {
  min-width: 0;
}
.flow-main-content .flow-title-sticky {
  background: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  padding: 16px 0 8px 0;
  margin-bottom: 8px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: space-between;
}
.flow-main-content .flow-title-sticky .video-title-sticky {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
  color: #0f0f0f;
  margin: 4px;
  font-family: "Raleway", sans-serif;
  flex: 1;
  min-width: 0;
}
.flow-main-content .flow-info-panel {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #f9f9f9;
  border-radius: 8px;
  margin-bottom: 16px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}
.flow-main-content .flow-info-panel::-webkit-scrollbar {
  height: 6px;
}
.flow-main-content .flow-info-panel::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
.flow-main-content .flow-info-panel::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}
.flow-main-content .flow-info-panel::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.flow-main-content .flow-info-panel .info-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  font-family: "Raleway", sans-serif;
  color: #0f0f0f;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  padding: 4px 12px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: -moz-fit-content;
  min-width: fit-content;
}
.flow-main-content .flow-info-panel .info-badge:hover {
  background: #f5f5f5;
  border-color: #5ea1d8;
}
.flow-main-content .flow-info-panel .info-badge.active {
  background: #5ea1d8;
  color: #fff;
  border-color: #5ea1d8;
}
.flow-main-content .flow-info-panel .info-badge.active .info-icon,
.flow-main-content .flow-info-panel .info-badge.active .info-label,
.flow-main-content .flow-info-panel .info-badge.active .info-step-title {
  color: #fff;
}
.flow-main-content .flow-info-panel .info-badge .info-icon {
  font-size: 14px;
  flex-shrink: 0;
  line-height: 1;
}
.flow-main-content .flow-info-panel .info-badge .info-label {
  font-family: "Raleway", sans-serif;
  flex-shrink: 0;
  font-size: 13px;
}
.flow-main-content .flow-info-panel .info-badge .info-step-title {
  font-size: 11px;
  color: #606060;
  margin-left: 4px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "Raleway", sans-serif;
}
@media (max-width: 768px) {
  .flow-main-content .flow-info-panel .info-badge .info-step-title {
    display: none;
  }
}
@media (max-width: 768px) {
  .flow-main-content .flow-info-panel {
    gap: 6px;
    padding: 10px 12px;
  }
  .flow-main-content .flow-info-panel .info-badge {
    font-size: 12px;
    padding: 3px 10px;
    font-family: "Raleway", sans-serif;
  }
  .flow-main-content .flow-info-panel .info-badge .info-icon {
    font-size: 12px;
  }
}
.flow-main-content .video-player-section {
  background: #000;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
  position: relative;
}
.flow-main-content .video-player-section .img-wrap {
  width: 100%;
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  background: #000;
}
.flow-main-content .video-player-section .img-wrap img,
.flow-main-content .video-player-section .img-wrap video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}
.flow-main-content .video-player-section .img-wrap .video-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
}
.flow-main-content .video-player-section .img-wrap .main-video-player {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: contain;
  background: #000;
}
.flow-main-content .video-player-section .item {
  padding: 20px;
  background: #fff;
  width: 100%;
  min-height: 400px;
}
.flow-main-content .video-player-section .clickarrow {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  pointer-events: none;
}
.flow-main-content .video-player-section .clickarrow .owl-prev,
.flow-main-content .video-player-section .clickarrow .owl-next {
  pointer-events: all;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s, transform 0.2s;
  font-size: 26px;
  font-weight: bold;
  padding: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  margin: 0;
}
.flow-main-content .video-player-section .clickarrow .owl-prev:hover:not(:disabled),
.flow-main-content .video-player-section .clickarrow .owl-next:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.8);
  transform: translateY(-1px);
}
.flow-main-content .video-player-section .clickarrow .owl-prev:disabled, .flow-main-content .video-player-section .clickarrow .owl-prev[hidden],
.flow-main-content .video-player-section .clickarrow .owl-next:disabled,
.flow-main-content .video-player-section .clickarrow .owl-next[hidden] {
  display: none;
}
.flow-main-content .video-player-section .clickarrow .owl-prev span,
.flow-main-content .video-player-section .clickarrow .owl-next span {
  font-size: 30px;
  line-height: 1;
  font-weight: bold;
}
.flow-main-content .video-player-section .clickarrow .owl-prev {
  margin-right: auto;
  margin-left: 0;
}
.flow-main-content .video-player-section .clickarrow .owl-next {
  margin-left: auto;
  margin-right: 0;
}
.flow-main-content .flow-main-content .video-player-section .img-wrap .video-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
}
.flow-main-content .flow-main-content .video-player-section .img-wrap .video-wrapper video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}

.summary-info-pills {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.summary-info-pills .info-badge,
.summary-info-pills .summary-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #111827;
  font-size: 13px;
  font-weight: 500;
}
.summary-info-pills.secondary {
  margin-top: 8px;
}
.summary-info-pills.secondary .summary-pill {
  background: #eef2ff;
  color: #1f2937;
}

/* Legacy summary-specific styles kept for other parts of the create-flow page */
.summary-cover-placeholder {
  min-height: 220px;
  border-radius: 12px;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  gap: 8px;
}
.summary-cover-placeholder mat-icon {
  font-size: 40px;
}

/* Match viewflow sidebar + step navigation styles for summary right menu */
.flow-sidebar {
  width: 402px;
  min-width: 402px;
  max-width: 402px;
  position: relative;
  z-index: 10;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}
@media (max-width: 1024px) {
  .flow-sidebar {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }
}
.flow-sidebar .step-navigation {
  margin-bottom: 24px;
  flex: 0 0 auto;
  min-height: 0;
}
.flow-sidebar .step-navigation .step-scroll {
  max-height: calc((100vw - 240px - 48px - 402px - 24px) * 0.5625 + 80px);
  overflow-y: auto;
  overflow-x: hidden;
  display: block;
  width: 100%;
  padding-right: 8px;
}
@media (min-width: 1920px) {
  .flow-sidebar .step-navigation .step-scroll {
    max-height: 731.375px;
  }
}
@media (max-width: 1024px) {
  .flow-sidebar .step-navigation .step-scroll {
    max-height: calc((100vw - 32px) * 0.5625);
  }
}
.flow-sidebar .step-navigation .step-scroll::-webkit-scrollbar {
  width: 8px;
}
.flow-sidebar .step-navigation .step-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.flow-sidebar .step-navigation .step-scroll::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}
.flow-sidebar .step-navigation .step-scroll::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.flow-sidebar .step-navigation .steps-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  align-items: stretch;
}
.flow-sidebar .step-navigation .step-panel {
  display: block;
  width: 100%;
}
.flow-sidebar .step-navigation .step-panel .step-btn {
  width: 100%;
}
.flow-sidebar .step-navigation .step-btn {
  padding-block: 1em;
  padding-inline: 1.125em;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #0f0f0f;
  text-align: left;
  transition: all 0.2s;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  height: auto;
  min-height: auto;
  white-space: normal;
  word-break: break-word;
  overflow: visible;
}
.flow-sidebar .step-navigation .step-btn .step-text-block {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1 auto;
  min-width: 0;
}
.flow-sidebar .step-navigation .step-btn .step-number {
  font-weight: 600;
}
.flow-sidebar .step-navigation .step-btn .step-title-text {
  flex: 1;
  text-align: left;
}
.flow-sidebar .step-navigation .step-btn:hover:not(.active) {
  background: #f9f9f9;
  border-color: #c0c0c0;
}
.flow-sidebar .step-navigation .step-panel.active .step-btn {
  background: #5ea1d8 !important;
  color: #0f0f0f !important;
  border: none !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: none !important;
  outline: none !important;
  box-shadow: none !important;
  transition: none !important;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.flow-sidebar .step-navigation .step-panel.active .step-btn .step-number,
.flow-sidebar .step-navigation .step-panel.active .step-btn .step-title-text {
  color: #0f0f0f !important;
}
.flow-sidebar .step-navigation .step-panel.active .step-btn:hover {
  background: #5ea1d8 !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

/* Match viewflow video metadata + actions bar style */
.video-metadata {
  padding: 16px 0;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 16px;
}
.video-metadata .step-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 12px;
  flex-wrap: wrap;
  justify-content: space-between;
}
.video-metadata .step-header .step-header-main {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
}
.video-metadata .step-header .s-num {
  flex-shrink: 0;
}
.video-metadata .step-header .video-title {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: #0f0f0f;
  margin: 0;
  flex: 1;
  min-width: 0;
}
.video-metadata .step-header .share-icon {
  cursor: pointer;
  color: #606060;
  flex-shrink: 0;
}
.video-metadata .video-actions-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}
.video-metadata .video-actions-bar::-webkit-scrollbar {
  height: 6px;
}
.video-metadata .video-actions-bar::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.video-metadata .video-actions-bar::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}
.video-metadata .video-actions-bar .action-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  width: max-content;
}
.video-metadata .video-actions-bar .action-buttons .action-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 18px;
  cursor: pointer;
  transition: background 0.2s;
  background: #f2f2f2;
  flex: 0 0 auto;
}
.video-metadata .video-actions-bar .action-buttons .action-item:hover:not(.disabled) {
  background: #e5e5e5;
}
.video-metadata .video-actions-bar .action-buttons .action-item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
.video-metadata .video-actions-bar .action-buttons .action-item mat-icon {
  font-size: 18px;
}

/* Match viewflow channel info + description style */
.channel-info-section {
  padding: 16px 0;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 16px;
}
.channel-info-section .channel-header {
  display: flex;
  align-items: center;
  gap: 16px;
}
.channel-info-section .channel-header .channel-avatar {
  flex-shrink: 0;
}
.channel-info-section .channel-header .channel-avatar img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
}
.channel-info-section .channel-header .channel-avatar .material-icons {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #606060;
  cursor: pointer;
}
.channel-info-section .channel-header .channel-details {
  flex: 1;
  min-width: 0;
}
.channel-info-section .channel-header .channel-details .channel-name {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  cursor: pointer;
  margin-bottom: 4px;
}
.channel-info-section .channel-header .channel-details .channel-name:hover {
  color: #606060;
}
.channel-info-section .channel-header .channel-details .channel-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 14px;
  color: #606060;
}
.channel-info-section .channel-header .channel-details .channel-meta mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.channel-info-section .channel-header .channel-details .channel-meta .price-tag {
  font-weight: 600;
  color: #d32f2f;
  cursor: pointer;
}
.channel-info-section .channel-header .channel-details .channel-meta .purchased-tag {
  font-weight: 600;
  color: #16a34a;
}
.channel-info-section .channel-header .channel-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.channel-info-section .channel-header .channel-actions .follow-btn,
.channel-info-section .channel-header .channel-actions .purchase-btn {
  border-radius: 999px;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
}
.channel-info-section .channel-header .channel-actions .follow-btn {
  background: #5ea1d8;
  color: #fff;
}
.channel-info-section .channel-header .channel-actions .purchase-btn {
  background: #111827;
  color: #fff;
}

.description-section {
  padding: 16px;
  background: #f9f9f9;
  border-radius: 12px;
  margin-bottom: 16px;
}
.description-section .description-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: -16px !important;
}
.description-section .description-header h3 {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  margin: 0;
}
.description-section .description-content {
  font-size: 14px;
  line-height: 20px;
  color: #0f0f0f;
  max-height: 60px;
  overflow: hidden;
  transition: max-height 0.3s ease;
}
.description-section .description-content.expanded {
  max-height: none;
}
.description-section .description-content .supporting-docs-link {
  margin-top: 12px;
}
.description-section .description-content .supporting-docs-link a {
  color: #5ea1d8;
  text-decoration: none;
  font-weight: 500;
}
.description-section .description-content .supporting-docs-link a:hover {
  text-decoration: underline;
}
.description-section .expand-description-btn {
  margin-top: 8px;
  background: none;
  border: none;
  color: #606060;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
}
.description-section .expand-description-btn:hover {
  color: #0f0f0f;
}

.summary-card {
  background: #fff;
  border-radius: 18px;
  border: 1px solid #e4e8f0;
  padding: 24px;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);
}
.summary-card.summary-items-card, .summary-card.summary-steps-card, .summary-card.summary-faqs-card {
  margin-bottom: 20px;
}
.summary-card .summary-card-header {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}
.summary-card .summary-card-header mat-icon {
  color: #5ea1d8;
}
.summary-card .summary-card-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}
.summary-card .summary-card-header p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 14px;
}

.summary-items-groups {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.summary-items-groups .summary-items-block {
  border: 1px solid #eceff5;
  border-radius: 14px;
  padding: 16px;
  background: #fbfbff;
}
.summary-items-groups .summary-items-block .summary-block-title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}
.summary-items-groups .summary-items-block .summary-block-title h4 {
  margin: 0;
  font-size: 16px;
}
.summary-items-groups .summary-items-block .summary-block-title span {
  color: #94a3b8;
  font-size: 14px;
}
.summary-items-groups .summary-items-block .summary-item-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.summary-items-groups .summary-items-block .summary-item-list li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 14px;
}
.summary-items-groups .summary-items-block .summary-item-list li a {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #2563eb;
  text-decoration: none;
}

.summary-step-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.summary-step-stack .summary-step-panel {
  border: 1px solid #eceff5;
  border-radius: 14px;
  padding: 16px;
}
.summary-step-stack .summary-step-panel .summary-step-heading {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.summary-step-stack .summary-step-panel .summary-step-heading .step-chip {
  background: #eef2ff;
  color: #4338ca;
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 13px;
  font-weight: 600;
}
.summary-step-stack .summary-step-panel .summary-step-heading h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
}
.summary-step-stack .summary-step-panel .summary-step-media {
  margin: 12px 0;
}
.summary-step-stack .summary-step-panel .summary-step-media img,
.summary-step-stack .summary-step-panel .summary-step-media video {
  border-radius: 12px;
  width: 100%;
  display: block;
}
.summary-step-stack .summary-step-panel .summary-step-description {
  font-size: 14px;
  color: #475569;
}

.summary-step-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}

.step-nav-chip {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: #fff;
  cursor: pointer;
  min-width: 160px;
  transition: all 0.2s ease;
}
.step-nav-chip .chip-step-number {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.step-nav-chip .chip-step-title {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}
.step-nav-chip.active {
  border-color: #4c6ef5;
  background: #eef2ff;
}
.step-nav-chip.active .chip-step-number {
  color: #4338ca;
}
.step-nav-chip.active .chip-step-title {
  color: #1d2b53;
}

.empty-steps-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 32px;
  border: 1px dashed #d1d5db;
  border-radius: 12px;
  color: #94a3b8;
}

.summary-faq-collection {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.summary-faq-collection .summary-faq-block {
  border: 1px solid #eceff5;
  border-radius: 14px;
  padding: 16px;
}
.summary-faq-collection .summary-faq-block h4 {
  margin: 0 0 10px;
  font-size: 16px;
  color: #0f172a;
}
.summary-faq-collection .summary-faq-block .summary-faq-item {
  border-top: 1px solid #f1f5f9;
  padding: 12px 0;
}
.summary-faq-collection .summary-faq-block .summary-faq-item:first-child {
  border-top: none;
  padding-top: 0;
}
.summary-faq-collection .summary-faq-block .summary-faq-item .question {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #0f172a;
}
.summary-faq-collection .summary-faq-block .summary-faq-item .answer {
  margin-top: 6px;
  color: #475569;
  font-size: 14px;
}

.flow-sidebar.summary-preview-sidebar {
  position: sticky;
  top: 24px;
  height: -moz-fit-content;
  height: fit-content;
}
.flow-sidebar.summary-preview-sidebar .step-navigation {
  margin-bottom: 24px;
  flex: 0 0 auto;
  min-height: 0;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-scroll {
  max-height: 320px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-scroll::-webkit-scrollbar {
  width: 6px;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-scroll::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-scroll::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .steps-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-btn {
  border: none;
  background: rgba(240, 240, 240, 0.8);
  padding: 10px 16px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-btn .step-icon {
  font-size: 14px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-btn.active {
  background: #5ea1d8;
  color: #fff;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-btn .step-number {
  font-weight: 600;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-btn .step-title-text {
  flex: 1;
  text-align: left;
}

.summary-card.sidebar-card.meta-card .summary-stats-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.summary-card.sidebar-card.meta-card .summary-stats-list li {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #475569;
}
.summary-card.sidebar-card.meta-card .summary-stats-list li strong {
  color: #0f172a;
}

.section-card {
  background: #fff;
  border-radius: 18px;
  border: 1px solid #e4e8f0;
  padding: 24px;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);
}
.section-card.full-screen-summary {
  border-radius: 0;
  border: none;
  background: transparent;
  padding: 0;
  box-shadow: none;
}
.section-card.journey-card {
  padding: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  max-height: 100%;
  overflow: hidden;
}

.section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}
.section-header h5 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}
.section-header p {
  margin: 4px 0 0;
  color: #6b7280;
  font-size: 14px;
}

.link-btn {
  color: #065fd4;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.08em;
  border: none;
  background: transparent;
  font-weight: 600;
  cursor: pointer;
}

.drop-zone {
  border: 2px dashed #cdd7f8;
  border-radius: 18px;
  min-height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 6px;
  background: #f8fafd;
  color: #4a5568;
}
.drop-zone mat-icon {
  font-size: 50px;
  color: #1a73e8;
}
.drop-zone p {
  font-size: 18px;
  font-weight: 600;
  margin: 8px 0 0;
}
.drop-zone span {
  font-size: 13px;
  color: #6b7280;
}

.cover-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}

.media-frame {
  flex: 1 1 360px;
  background: #0f0f0f;
  border-radius: 16px;
  overflow: hidden;
}
.media-frame .img-display,
.media-frame .video-display {
  width: 100%;
  height: auto;
  display: block;
}

.cover-meta {
  flex: 1 1 260px;
  background: #f8fafc;
  border-radius: 16px;
  padding: 16px 20px;
}
.cover-meta .file-name {
  font-weight: 600;
  margin-bottom: 4px;
}
.cover-meta .price {
  color: #0f6bff;
  font-weight: 600;
}
.cover-meta .description-text {
  margin-top: 12px;
  text-align: left;
  color: #4b5563;
}

.group-title {
  margin: 24px 0 12px;
  font-weight: 700;
  color: #111827;
}

.item-avatar img {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.upload-dialog .example-list {
  border: 1px solid #edf1f9;
  border-radius: 14px;
  padding: 6px;
  background: #fff;
}

.upload-dialog .example-box {
  background: #fdfdff;
  border-radius: 12px;
  margin: 6px 0;
  padding: 14px 16px;
  box-shadow: inset 0 0 0 1px #edf0f7;
}

.journey-toolbar {
  display: flex;
  gap: 12px;
  padding: 20px 24px;
  border-bottom: 1px solid #e4e8f0;
  background: #fafbfc;
  flex-wrap: wrap;
  align-items: center;
  flex-shrink: 0;
}
.journey-toolbar button,
.journey-toolbar a {
  display: flex;
  align-items: center;
  gap: 8px;
}
.journey-toolbar button mat-icon,
.journey-toolbar a mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.journey-toolbar a {
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: #2563eb;
}

.journey-progress {
  display: flex;
  align-items: center;
  gap: 0;
  padding: 16px 0 0;
  margin-top: 12px;
  flex-shrink: 0;
  overflow-x: hidden;
  flex-wrap: nowrap;
  width: 100%;
  position: relative;
}

.journey-step {
  background: transparent;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0;
  min-width: auto;
  flex-shrink: 0;
  cursor: pointer;
  color: #9ca3af;
  transition: color 0.2s ease;
  white-space: nowrap;
  align-self: center;
}
.journey-step .tab-count {
  font-size: 11px;
  background: rgba(37, 99, 235, 0.08);
  color: #2563eb;
  border-radius: 999px;
  padding: 2px 8px;
}
.journey-step:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: auto;
}

.journey-step.active {
  color: #5ea1d8;
}
.journey-step.active .step-label {
  border-color: #5ea1d8;
  background: rgba(94, 161, 216, 0.1);
  color: #5ea1d8;
}

.journey-step.complete {
  color: #16a34a;
}
.journey-step.complete .step-label {
  border-color: #16a34a;
  background: rgba(22, 163, 74, 0.1);
  color: #16a34a;
}

.step-indicator {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid currentColor;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  flex-shrink: 0;
}
.step-indicator mat-icon {
  font-size: 20px;
}

.step-label {
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
}

.step-connector {
  flex: 1;
  min-width: 20px;
  height: 2px;
  background: #e5e7eb;
  flex-shrink: 0;
  align-self: center;
  margin: 0;
  position: relative;
  z-index: 0;
  top: -10px;
}

.step-connector.fill {
  background: #16a34a;
}

.journey-content {
  padding: 24px;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1 0;
  min-height: 0;
  max-height: 100%;
}
.journey-content::-webkit-scrollbar {
  width: 8px;
}
.journey-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.journey-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.journey-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.cover-form-wrapper {
  background: #fff;
  border-radius: 0;
  padding: 0;
  max-width: 100%;
}
.cover-form-wrapper h3 {
  font-size: 14px;
  font-weight: 400;
  color: #030303;
  margin: 0 0 8px 0;
  padding: 0;
  border: none;
  text-transform: none;
  letter-spacing: 0;
  line-height: 20px;
}
.cover-form-wrapper .example-form {
  margin-bottom: 0;
  margin-top: 0;
  padding: 0;
}
.cover-form-wrapper .example-form.field-anchor {
  margin-left: 0;
  margin-right: 0;
}
.cover-form-wrapper .example-form:first-child mat-form-field {
  margin-top: 0;
}
.cover-form-wrapper .example-form:first-child .form-label-wrapper {
  margin-top: 0;
}
.cover-form-wrapper .form-label-wrapper {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 0;
  margin-left: 0;
  margin-right: 0;
}
.cover-form-wrapper .form-label-wrapper.label-with-toggle {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
.cover-form-wrapper .form-label-wrapper .form-label {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  display: block;
  margin-bottom: 0;
  margin-top: 0;
  padding: 0;
  line-height: 1.5;
}
.cover-form-wrapper .form-label-wrapper .form-label.font16 {
  font-size: 16px;
}
.cover-form-wrapper .creator-paid-only-notice {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  margin-top: 0.75rem;
  padding: 0.85rem 1rem;
  border-radius: 10px;
  background: rgba(94, 161, 216, 0.1);
  border: 1px solid rgba(94, 161, 216, 0.28);
}
.cover-form-wrapper .creator-paid-only-notice .notice-title-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
}
.cover-form-wrapper .creator-paid-only-notice .notice-icon {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  flex: 0 0 18px;
  width: 18px !important;
  height: 18px !important;
  font-size: 18px !important;
  line-height: 18px !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: visible;
  color: #5ea1d8;
  transform: translateY(1px);
}
.cover-form-wrapper .creator-paid-only-notice .notice-lead {
  margin: 0;
  min-width: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #334155;
}
.cover-form-wrapper .creator-paid-only-notice .notice-detail {
  margin: 0;
  padding-left: 26px;
  font-size: 14px;
  line-height: 20px;
  color: #334155;
}
.cover-form-wrapper .creator-paid-only-notice .upgrade-free-link {
  display: inline-block;
  margin-top: 0.35rem;
  margin-left: 26px;
  border: none;
  background: none;
  padding: 0;
  color: #5ea1d8;
  font-weight: 700;
  font-size: 0.85rem;
  line-height: 1.3;
  cursor: pointer;
  text-decoration: underline;
}
.cover-form-wrapper mat-form-field {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 10px;
}
.cover-form-wrapper mat-form-field ::ng-deep .mdc-notched-outline {
  border-radius: 8px;
}
.cover-form-wrapper mat-form-field ::ng-deep .mdc-notched-outline__leading {
  border-radius: 8px 0 0 8px;
}
.cover-form-wrapper mat-form-field ::ng-deep .mdc-notched-outline__trailing {
  border-radius: 0 8px 8px 0;
}
.cover-form-wrapper mat-form-field ::ng-deep .mat-mdc-text-field-input-wrapper {
  border-radius: 8px;
}
.cover-form-wrapper mat-form-field ::ng-deep input.mat-mdc-input-element,
.cover-form-wrapper mat-form-field ::ng-deep input[matInput] {
  border-radius: 8px;
}
.cover-form-wrapper mat-form-field ::ng-deep .mat-mdc-form-field-label,
.cover-form-wrapper mat-form-field ::ng-deep .mat-mdc-floating-label,
.cover-form-wrapper mat-form-field ::ng-deep mat-label {
  color: #000000 !important;
  font-weight: 500;
  font-size: 16px;
}
.cover-form-wrapper mat-form-field ::ng-deep .mat-mdc-form-field-label-wrapper {
  padding-top: 0;
}
.cover-form-wrapper .commonlintbtn-wrapper {
  margin-top: 8px;
  margin-bottom: 24px;
}
.cover-form-wrapper .commonlintbtn-wrapper.title-rephrase-wrapper {
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
}
.cover-form-wrapper .commonlintbtn-wrapper .commonlintbtn-parent {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-end;
}
.cover-form-wrapper .commonlintbtn-wrapper .commonlintbtn-parent .clickable-text {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #065fd4;
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.2s;
  margin-right: 13px;
}
.cover-form-wrapper .commonlintbtn-wrapper .commonlintbtn-parent .clickable-text:hover {
  color: #0d47a1;
}
.cover-form-wrapper .commonlintbtn-wrapper .commonlintbtn-parent .clickable-text .material-icons {
  font-size: 18px;
}
.cover-form-wrapper .title-field-container {
  position: relative;
  width: 100%;
  margin-bottom: 0;
  margin-top: 0;
}
.cover-form-wrapper .title-field-container .title-field-with-rephrase {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.cover-form-wrapper .title-field-container .title-field-with-rephrase ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  margin-top: 0;
  padding-bottom: 0;
  min-height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.cover-form-wrapper .title-field-container .title-field-with-rephrase ::ng-deep .mat-mdc-form-field-hint-wrapper {
  margin-top: 0;
  padding-bottom: 0;
  order: 1;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.cover-form-wrapper .title-field-container .title-field-with-rephrase ::ng-deep .mat-mdc-form-field-hint {
  text-align: right;
  width: auto;
  margin: 0;
}
.cover-form-wrapper .title-field-container .title-field-with-rephrase ::ng-deep .mat-mdc-form-field-hint-spacer {
  display: none;
}
.cover-form-wrapper .title-field-container .title-rephrase-wrapper-inline {
  margin-top: 4px;
  margin-bottom: 0;
  padding: 0;
  padding-left: 0;
  padding-right: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  width: 100%;
}
.cover-form-wrapper .title-field-container .title-rephrase-wrapper-inline .title-rephrase-progress {
  margin-bottom: 0;
  width: 200px;
}
.cover-form-wrapper .title-field-container .title-rephrase-wrapper-inline .title-rephrase-buttons {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
}
.cover-form-wrapper .title-field-container .title-rephrase-wrapper-inline .title-rephrase-buttons .clickable-text {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #065fd4;
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.2s;
  margin-right: 13px;
}
.cover-form-wrapper .title-field-container .title-rephrase-wrapper-inline .title-rephrase-buttons .clickable-text:hover {
  color: #0d47a1;
}
.cover-form-wrapper .title-field-container .title-rephrase-wrapper-inline .title-rephrase-buttons .clickable-text .material-icons {
  font-size: 18px;
}
.cover-form-wrapper form,
.cover-form-wrapper .example-form {
  margin-left: 0;
  margin-right: 0;
  padding-left: 0;
  padding-right: 0;
}
.cover-form-wrapper mat-form-field {
  margin-left: 0;
  margin-right: 0;
}
.cover-form-wrapper .table-wrapper {
  margin-bottom: 24px;
}
.cover-form-wrapper .table-wrapper .table-inner {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #f9f9f9;
  min-height: 200px;
  max-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}
.cover-form-wrapper .table-wrapper .table-inner img.img-display {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.cover-form-wrapper .table-wrapper .table-inner video.video-display {
  width: 100%;
  height: 100%;
  max-height: 400px;
  object-fit: contain;
}
.cover-form-wrapper .table-wrapper .table-inner p.text-center {
  color: #606060;
  font-size: 13px;
  text-align: center;
  padding: 20px;
  margin: 0;
}
.cover-form-wrapper .upload-icon-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  margin-top: 20px;
  margin-bottom: 10px;
  flex-wrap: nowrap;
  width: 100%;
}
.cover-form-wrapper .upload-icon-row .upload-icon-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex-shrink: 0;
}
.cover-form-wrapper .upload-icon-row .form-label-wrapper {
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
  flex-shrink: 0;
}
.cover-form-wrapper .upload-icon-row .form-label-wrapper .required-hint {
  display: block;
  font-size: 11px;
  color: #b45309;
  margin-top: 2px;
}
.cover-form-wrapper .upload-icon-row .upload-icon-btn {
  margin-top: 0;
  flex-shrink: 0;
}
.cover-form-wrapper .upload-icon-row .flow-upload-progress {
  flex: 1;
  min-width: 0;
  flex-shrink: 1;
}
@media (max-width: 767px) {
  .cover-form-wrapper .upload-icon-row {
    flex-direction: column;
    align-items: stretch;
    flex-wrap: nowrap;
    overflow-x: visible;
    gap: 12px;
  }
  .cover-form-wrapper .upload-icon-row .upload-icon-stack {
    flex-direction: row;
    align-items: center;
    align-self: stretch;
    justify-content: flex-start;
    gap: 12px;
    width: 100%;
  }
  .cover-form-wrapper .upload-icon-row .form-label-wrapper {
    min-width: 0;
    flex: 1;
    text-align: left;
  }
  .cover-form-wrapper .upload-icon-row .form-label-wrapper .form-label {
    margin: 0;
  }
  .cover-form-wrapper .upload-icon-row .flow-upload-progress {
    width: 100%;
    min-width: 0;
  }
  .cover-form-wrapper .upload-icon-row .media-size-recommendation {
    width: 100%;
    margin-top: 0 !important;
  }
}
.cover-form-wrapper .upload-progress-inline {
  font-size: 13px;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 8px;
}
.cover-form-wrapper .upload-progress-inline progress {
  width: 120px;
  height: 6px;
}
.cover-form-wrapper .flow-upload-progress {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  min-width: 200px;
}
.cover-form-wrapper .flow-upload-progress .flow-progress-bar-container {
  flex: 1;
  height: 4px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  overflow: hidden;
  position: relative;
  min-width: 120px;
  max-width: 300px;
}
.cover-form-wrapper .flow-upload-progress .flow-progress-bar-container .flow-progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #065fd4 0%, #0d96ff 100%);
  border-radius: 2px;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}
.cover-form-wrapper .flow-upload-progress .flow-progress-bar-container .flow-progress-bar::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  animation: shimmer 1.5s infinite;
}
.cover-form-wrapper .flow-upload-progress .flow-progress-text {
  font-size: 12px;
  font-weight: 500;
  color: #065fd4;
  min-width: 40px;
  text-align: right;
  font-family: "Roboto", sans-serif;
}
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
.cover-form-wrapper .upload-icon-btn {
  width: 56px;
  height: 56px;
  border-radius: 20px;
  background: #e0f2fe;
  color: #0369a1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition: transform 0.2s, box-shadow 0.2s;
  box-shadow: inset 0 0 0 1px rgba(3, 105, 161, 0.1);
}
.cover-form-wrapper .upload-icon-btn.light {
  background: #f8fafc;
  color: #475569;
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.08);
}
.cover-form-wrapper .upload-icon-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(3, 105, 161, 0.15);
}
.cover-form-wrapper .upload-icon-btn mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
}
.cover-form-wrapper .upload-icon-btn input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}
.cover-form-wrapper .supporting-list {
  margin-bottom: 16px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
}
.cover-form-wrapper .supporting-list__label {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  margin: 0 0 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.cover-form-wrapper .supporting-list ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.cover-form-wrapper .supporting-list li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #0f172a;
}
.cover-form-wrapper .supporting-list li mat-icon {
  font-size: 18px;
  color: #64748b;
}
.cover-form-wrapper .supporting-list li .item-text {
  color: #0f172a;
  text-decoration: none;
  word-break: break-word;
}
.cover-form-wrapper .supporting-list li .item-text:hover {
  text-decoration: underline;
}
.cover-form-wrapper .quill-field {
  width: 100%;
  margin-bottom: 0;
  margin-top: 0;
  padding: 0;
}
.cover-form-wrapper .quill-field.field-anchor {
  margin-left: 0;
  margin-right: 0;
}
.cover-form-wrapper .quill-label {
  display: block;
  color: #000000;
  font-size: 16px;
  font-weight: 500;
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 0;
  line-height: 1.5;
}
.cover-form-wrapper .quill-wrapper {
  margin: 10px 0px;
  border: 1px solid #dadce0;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.cover-form-wrapper .quill-wrapper:focus-within {
  border-color: #1a73e8;
  box-shadow: 0 0 0 1px #1a73e8;
}
.cover-form-wrapper .quill-wrapper:hover:not(:focus-within) {
  border-color: #80868b;
}
.cover-form-wrapper .quill-wrapper ::ng-deep .ql-toolbar {
  border: none;
  border-bottom: 1px solid #e0e0e0;
  background: #fff;
  padding: 10px 12px;
}
.cover-form-wrapper .quill-wrapper ::ng-deep .ql-container {
  border: none !important;
  font-size: 14px;
  min-height: 220px;
  background: #fff;
  font-family: "Roboto", "Helvetica Neue", sans-serif;
}
.cover-form-wrapper .quill-wrapper ::ng-deep .ql-editor {
  min-height: 220px;
  font-size: 14px;
  color: #030303;
  line-height: 20px;
  padding: 16px;
}
.cover-form-wrapper .quill-wrapper ::ng-deep .ql-editor.ql-blank::before {
  color: #80868b;
  font-style: normal;
  font-size: 14px;
}
.cover-form-wrapper mat-tab-group {
  margin-bottom: 24px;
}
.cover-form-wrapper mat-tab-group ::ng-deep .mat-mdc-tab-header {
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 0;
  position: relative;
  overflow: visible;
}
.cover-form-wrapper mat-tab-group ::ng-deep .mat-mdc-tab-label-container {
  overflow: visible;
}
.cover-form-wrapper mat-tab-group ::ng-deep .mat-mdc-tab-list {
  overflow: visible;
}
.cover-form-wrapper mat-tab-group ::ng-deep .mat-mdc-tab-label {
  color: #606060;
  font-weight: 500;
  min-width: 140px;
  width: 140px;
  font-size: 14px;
  text-transform: none;
  letter-spacing: 0;
  padding: 12px 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: none !important;
  will-change: auto;
  contain: layout style paint;
}
.cover-form-wrapper mat-tab-group ::ng-deep .mat-mdc-tab-label .mdc-tab__content {
  transition: none !important;
  will-change: auto;
}
.cover-form-wrapper mat-tab-group ::ng-deep .mat-mdc-tab-label .mdc-tab__text-label {
  display: inline-block;
  min-width: 120px;
  text-align: left;
  will-change: auto;
}
.cover-form-wrapper mat-tab-group ::ng-deep .mat-mdc-tab-header-pagination {
  transition: none !important;
}
.cover-form-wrapper mat-tab-group ::ng-deep .mat-mdc-tab-body {
  transition: none !important;
}
.cover-form-wrapper mat-tab-group ::ng-deep .mat-mdc-tab-label-active {
  color: #065fd4;
  font-weight: 500;
}
.cover-form-wrapper mat-tab-group ::ng-deep .mat-mdc-tab-body-wrapper {
  min-height: 200px;
}
.cover-form-wrapper mat-tab-group .tab-design-wrapper {
  padding: 20px 0;
}
.cover-form-wrapper mat-tab-group .tab-design-wrapper mat-form-field {
  margin-bottom: 12px;
}
.cover-form-wrapper mat-tab-group .tab-design-wrapper mat-form-field ::ng-deep .mdc-notched-outline {
  border-radius: 8px;
}
.cover-form-wrapper mat-tab-group .tab-design-wrapper mat-form-field ::ng-deep .mdc-notched-outline__leading {
  border-radius: 8px 0 0 8px;
}
.cover-form-wrapper mat-tab-group .tab-design-wrapper mat-form-field ::ng-deep .mdc-notched-outline__trailing {
  border-radius: 0 8px 8px 0;
}
.cover-form-wrapper mat-tab-group .tab-design-wrapper mat-form-field ::ng-deep .mat-mdc-text-field-input-wrapper {
  border-radius: 8px;
}
.cover-form-wrapper mat-tab-group .tab-design-wrapper mat-form-field ::ng-deep input.mat-mdc-input-element,
.cover-form-wrapper mat-tab-group .tab-design-wrapper mat-form-field ::ng-deep input[matInput] {
  border-radius: 8px;
}
.cover-form-wrapper mat-tab-group .tab-design-wrapper .upload-field-inline {
  display: flex;
  align-items: flex-start;
}
.cover-form-wrapper mat-tab-group .tab-design-wrapper .upload-label-inline {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
}
.cover-form-wrapper mat-tab-group .tab-design-wrapper .upload-label-inline label {
  margin: 0;
  white-space: nowrap;
}
.cover-form-wrapper mat-tab-group .tab-design-wrapper .upload-label-inline .upload-icon-btn {
  margin: 0;
}
.cover-form-wrapper mat-tab-group .upload-field-inline {
  display: flex;
  align-items: flex-start;
}
.cover-form-wrapper mat-tab-group .upload-field-inline .upload-label-inline {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
}
.cover-form-wrapper mat-tab-group .upload-field-inline .upload-label-inline label {
  margin: 0;
  white-space: nowrap;
}
.cover-form-wrapper mat-tab-group .upload-field-inline .upload-label-inline .upload-icon-btn {
  margin: 0;
}
.cover-form-wrapper .upload-label-inline {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
}
.cover-form-wrapper .upload-label-inline label {
  margin: 0;
  white-space: nowrap;
}
.cover-form-wrapper .upload-label-inline .upload-icon-btn {
  margin: 0;
}
.cover-form-wrapper .upload-field-inline {
  display: flex;
  align-items: flex-start;
}
.cover-form-wrapper .upload-field-inline .addbtn {
  margin-top: 8px;
}
.cover-form-wrapper .upload-field-inline .addbtn button {
  background: #065fd4;
  color: #fff;
  border-radius: 18px;
  padding: 8px 24px;
  font-weight: 500;
}
.cover-form-wrapper .upload-field-inline .addbtn button:disabled {
  background: #e0e0e0;
  color: #909090;
}
.cover-form-wrapper .upload-field-inline .example-list {
  margin-top: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}
.cover-form-wrapper .upload-field-inline .example-list .example-box {
  border: none;
  border-bottom: 1px solid #e0e0e0;
  padding: 12px 16px;
  background: #fff;
}
.cover-form-wrapper .upload-field-inline .example-list .example-box:last-child {
  border-bottom: none;
}
.cover-form-wrapper .upload-field-inline .example-list .example-box .document,
.cover-form-wrapper .upload-field-inline .example-list .example-box .link {
  font-size: 14px;
  color: #030303;
}
.cover-form-wrapper .upload-field-inline .example-list .example-box .material-icons {
  color: #606060;
  transition: color 0.2s;
}
.cover-form-wrapper .upload-field-inline .example-list .example-box .material-icons:hover {
  color: #030303;
}

.standard-tab-group {
  background: #f5f5f5;
  border-radius: 12px;
  padding: 4px 8px 0;
}
.standard-tab-group ::ng-deep .mat-mdc-tab {
  margin-right: 6px;
  border-radius: 8px 8px 0 0;
  background: transparent;
}
.standard-tab-group ::ng-deep .mat-mdc-tab:not(.mdc-tab--active) .mdc-tab__text-label {
  color: #6b7280;
}
.standard-tab-group ::ng-deep .mdc-tab--active .mdc-tab__text-label {
  color: #111827;
  font-weight: 600;
}
.standard-tab-group ::ng-deep .mat-mdc-tab-indicator .mdc-tab-indicator__content--underline {
  border-top-width: 3px;
  border-color: #9ca3af;
  background-color: #9ca3af;
}

.label-button {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 0;
  margin-top: 0;
  padding: 0;
  margin-left: 0;
  margin-right: 0;
  background: transparent;
  border-radius: 0;
}
.label-button ::ng-deep .mat-mdc-slide-toggle .mdc-switch__track {
  background-color: #ccc;
}
.label-button ::ng-deep .mat-mdc-slide-toggle.mat-checked .mdc-switch__track {
  background-color: #065fd4;
}
.label-button ::ng-deep .mat-mdc-slide-toggle .mdc-form-field label {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  margin-left: 8px;
}

button.btn-primary,
.btn-primary {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  background: #5ea1d8;
  color: #ffffff;
  text-transform: none;
  letter-spacing: 0;
}
button.btn-primary:hover:not(:disabled),
.btn-primary:hover:not(:disabled) {
  background: #4a8fc4;
}
button.btn-primary:disabled,
.btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

button.btn-secondary,
.btn-secondary {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  background: #f3f4f6;
  color: #374151;
  text-transform: none;
  letter-spacing: 0;
}
button.btn-secondary:hover:not(:disabled),
.btn-secondary:hover:not(:disabled) {
  background: #e5e7eb;
}
button.btn-secondary:disabled,
.btn-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cam-icon {
  margin-top: 24px;
  margin-bottom: 8px;
}

.col-12 {
  margin-top: 8px;
  margin-bottom: 0;
}
.col-12:has(.fileExplorer) {
  margin-top: 12px;
}

.journey-content .group-title {
  font-size: 14px;
  font-weight: 500;
  color: #030303;
  margin: 24px 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
}
.journey-content .example-list {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fff;
  padding: 8px;
  margin-bottom: 16px;
}
.journey-content .example-list .example-box {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: box-shadow 0.2s, border-color 0.2s;
  cursor: move;
}
.journey-content .example-list .example-box:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-color: #c0c0c0;
}
.journey-content .example-list .example-box:last-child {
  margin-bottom: 0;
}
.journey-content .example-list .example-box .item-avatar {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  background: #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: center;
}
.journey-content .example-list .example-box .item-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}
.journey-content .example-list .example-box .item-name {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: #030303;
  min-width: 0;
}
.journey-content .example-list .example-box .item-name.highlight {
  color: #065fd4;
}
.journey-content .example-list .example-box .item-value {
  flex: 1;
  font-size: 14px;
  color: #606060;
  min-width: 0;
}
.journey-content .example-list .example-box .item-value a {
  color: #065fd4;
  text-decoration: none;
}
.journey-content .example-list .example-box .item-value a:hover {
  text-decoration: underline;
}
.journey-content .example-list .example-box .row-actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}
.journey-content .example-list .example-box .row-actions .icon-button {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: #606060;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}
.journey-content .example-list .example-box .row-actions .icon-button:hover {
  background: #f0f0f0;
  color: #030303;
}
.journey-content .example-list .example-box .row-actions .icon-button mat-icon {
  font-size: 20px;
}

.example-stepList {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.example-stepList .step-card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 20px;
  transition: box-shadow 0.2s, border-color 0.2s;
}
.example-stepList .step-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-color: #c0c0c0;
}
.example-stepList .step-card .step-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 16px;
}
.example-stepList .step-card .step-header .step-number {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #065fd4;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  flex-shrink: 0;
}
.example-stepList .step-card .step-header .step-file {
  font-size: 14px;
  font-weight: 500;
  color: #030303;
  margin: 0 0 4px 0;
}
.example-stepList .step-card .step-header .step-title {
  font-size: 13px;
  color: #606060;
  margin: 0;
}
.example-stepList .step-card .img-and-video-sec {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 16px;
  background: #000;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.example-stepList .step-card .img-and-video-sec img.img-display,
.example-stepList .step-card .img-and-video-sec video.video-display {
  max-width: 100%;
  max-height: 400px;
  object-fit: contain;
  cursor: pointer;
}
.example-stepList .step-card .step-description {
  font-size: 14px;
  color: #030303;
  line-height: 1.5;
  margin-bottom: 16px;
}
.example-stepList .step-card .step-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}
.example-stepList .step-card .step-actions .square_btn {
  padding: 8px 16px;
  border-radius: 18px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid;
}
.example-stepList .step-card .step-actions .square_btn.ghost {
  background: transparent;
  border-color: #e0e0e0;
  color: #030303;
}
.example-stepList .step-card .step-actions .square_btn.ghost:hover {
  background: #f9f9f9;
  border-color: #c0c0c0;
}
.example-stepList .step-card .step-actions .square_btn:not(.ghost) {
  background: #065fd4;
  border-color: #065fd4;
  color: #fff;
}
.example-stepList .step-card .step-actions .square_btn:not(.ghost):hover {
  background: #0d47a1;
  border-color: #0d47a1;
}

.faq-row .faq-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.faq-row .faq-content .faq-question-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}
.faq-row .faq-content .faq-question-row .faq-question {
  flex: 1;
  min-width: 0;
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #030303;
  margin-bottom: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.faq-row .faq-content .faq-question-row .row-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.faq-row .faq-content .show-answer-btn {
  background: #f0f4ff;
  color: #2563eb;
  border: 1px solid #2563eb;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  align-self: flex-start;
  margin-top: 4px;
}
.faq-row .faq-content .show-answer-btn:hover {
  background: #2563eb;
  color: #fff;
}

.empty-state {
  border: 2px dashed #e0e0e0;
  border-radius: 12px;
  padding: 48px 24px;
  text-align: center;
  background: #f9f9f9;
}
.empty-state mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #909090;
  margin-bottom: 16px;
}
.empty-state p {
  font-size: 14px;
  color: #606060;
  margin: 0 0 24px 0;
}
.empty-state .square_btn {
  background: #065fd4;
  color: #fff;
  border: none;
  border-radius: 18px;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}
.empty-state .square_btn:hover {
  background: #0d47a1;
}

.journey-pane-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}
.journey-pane-header h5 {
  margin: 0;
}
.journey-pane-header p {
  margin: 4px 0 0;
  color: #6b7280;
  font-size: 14px;
}

.empty-state {
  border: 1px dashed #dbe2f5;
  border-radius: 16px;
  padding: 32px;
  text-align: center;
  color: #6b7280;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.empty-state mat-icon {
  font-size: 36px;
  color: #94a3b8;
}

.row-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.step-card {
  background: #f9fafb;
  border-radius: 16px;
  padding: 18px;
  margin-bottom: 16px;
  box-shadow: inset 0 0 0 1px #e5e7eb;
}

.step-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.step-number {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

.step-file {
  margin: 0;
  font-weight: 600;
}

.step-title {
  margin: 0;
  color: #4b5563;
  font-size: 14px;
}

.step-description {
  margin-top: 12px;
  text-align: left;
  color: #374151;
}

.step-actions {
  margin-top: 16px;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.question-count-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 10px;
  padding: 3px 10px;
  border-radius: 999px;
  border: 1px solid #5ea1d8;
  background: rgba(94, 161, 216, 0.1);
  color: #1d67a3;
  font-family: "Raleway";
  font-size: 12px;
  font-weight: 500;
}
.question-count-chip mat-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
}
.question-count-chip--inline {
  margin: 0 0 0 8px;
  padding: 1px 8px;
  vertical-align: middle;
}
.question-count-chip--end {
  margin: 12px 0 0;
}

.square_btn.ghost {
  background: transparent;
  border-color: #d1d5db;
  color: #374151;
}

.faq-row {
  align-items: flex-start;
}

.faq-content {
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.faq-content .faq-question-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}
.faq-content .faq-question-row .faq-question {
  flex: 1;
  min-width: 0;
  display: block;
  font-weight: 600;
  margin-bottom: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.faq-content .faq-question-row .row-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.faq-content .show-answer-btn {
  background: #f0f4ff;
  color: #2563eb;
  border: 1px solid #2563eb;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  align-self: flex-start;
  margin-top: 4px;
}
.faq-content .show-answer-btn:hover {
  background: #2563eb;
  color: #fff;
}

.quick-actions .actions-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.summary-card {
  background: #fff;
  border-radius: 18px;
  border: 1px solid #e4e8f0;
  padding: 24px;
  box-shadow: 0 15px 35px rgba(15, 23, 42, 0.09);
}
.summary-card.preview-card {
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: unset;
  max-height: unset;
  box-sizing: border-box;
  overflow: visible;
}
.summary-card h5 {
  margin: 0 0 12px;
  font-size: 17px;
  height: 24px;
  min-height: 24px;
  max-height: 24px;
  flex-shrink: 0;
  line-height: 24px;
  box-sizing: border-box;
}

.preview-card .flow-info-panel {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #f9f9f9;
  border-radius: 8px;
  margin-bottom: 16px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
  height: 60px;
  min-height: 60px;
  max-height: 60px;
  flex-shrink: 0;
}
.preview-card .flow-info-panel::-webkit-scrollbar {
  height: 6px;
}
.preview-card .flow-info-panel::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
.preview-card .flow-info-panel::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}
.preview-card .flow-info-panel::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.preview-card .flow-info-panel .info-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  font-family: "Raleway", sans-serif;
  color: #0f0f0f;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  padding: 4px 12px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: -moz-fit-content;
  min-width: fit-content;
}
.preview-card .flow-info-panel .info-badge:hover {
  background: #f5f5f5;
  border-color: #5ea1d8;
}
.preview-card .flow-info-panel .info-badge.active {
  background: #5ea1d8;
  color: white;
  border-color: #5ea1d8;
}
.preview-card .flow-info-panel .info-badge.active .info-icon,
.preview-card .flow-info-panel .info-badge.active .info-label,
.preview-card .flow-info-panel .info-badge.active .info-step-title {
  color: white;
}
.preview-card .flow-info-panel .info-badge .info-icon {
  font-size: 14px;
  flex-shrink: 0;
  line-height: 1;
}
.preview-card .flow-info-panel .info-badge .info-label {
  font-family: "Raleway", sans-serif;
  flex-shrink: 0;
  font-size: 13px;
}
.preview-card .flow-info-panel .info-badge .info-step-title {
  font-size: 11px;
  color: #606060;
  margin-left: 4px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "Raleway", sans-serif;
}
@media (max-width: 768px) {
  .preview-card .flow-info-panel .info-badge .info-step-title {
    display: none;
  }
}
@media (max-width: 768px) {
  .preview-card .flow-info-panel {
    gap: 6px;
    padding: 10px 12px;
  }
  .preview-card .flow-info-panel .info-badge {
    font-size: 12px;
    padding: 3px 10px;
    font-family: "Raleway", sans-serif;
  }
  .preview-card .flow-info-panel .info-badge .info-icon {
    font-size: 12px;
  }
}
.preview-card .preview-content {
  height: auto;
  min-height: unset;
  max-height: unset;
  overflow-y: visible;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.preview-card .preview-content::-webkit-scrollbar {
  width: 6px;
}
.preview-card .preview-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
.preview-card .preview-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
.preview-card .preview-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.preview-card .mobile-preview-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: auto;
  min-height: unset;
  max-height: unset;
  flex-shrink: 1;
  overflow: visible;
  box-sizing: border-box;
}
.preview-card .mobile-section {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);
  overflow: hidden;
  margin-bottom: 16px;
}
.preview-card .mobile-section:last-child {
  margin-bottom: 0;
}
.preview-card .mobile-section .mobile-media {
  background: #000;
  width: 100%;
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.preview-card .mobile-section .mobile-media img,
.preview-card .mobile-section .mobile-media video {
  width: 100%;
  max-height: 260px;
  object-fit: cover;
  display: block;
}
.preview-card .mobile-section .mobile-media.placeholder {
  color: #9ca3af;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #f3f4f6;
}
.preview-card .mobile-section .mobile-media.placeholder mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
}
.preview-card .mobile-section .mobile-media.placeholder p {
  margin: 0;
  font-size: 14px;
}
.preview-card .mobile-section .mobile-section-body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.preview-card .mobile-section .mobile-section-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #1f2f46;
  line-height: 1.4;
}
.preview-card .mobile-section .mobile-section-description {
  color: #4a5568;
  line-height: 1.6;
  font-size: 14px;
}
.preview-card .mobile-section .mobile-section-description p {
  margin-bottom: 12px;
}
.preview-card .mobile-section .mobile-section-description p:last-child {
  margin-bottom: 0;
}
.preview-card .mobile-section .mobile-meta-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 8px;
}
.preview-card .mobile-section .mobile-meta-row .info-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #475569;
  font-size: 13px;
}
.preview-card .mobile-section .mobile-meta-row .info-badge mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #5ea1d8;
}
.preview-card .steps-summary-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: auto;
  min-height: unset;
  max-height: unset;
  flex-shrink: 1;
  overflow: visible;
  box-sizing: border-box;
  width: 100%;
  position: relative;
}
.preview-card .steps-summary-container .flow-info-panel {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
  flex-direction: row;
  writing-mode: horizontal-tb;
  text-orientation: mixed;
  direction: ltr;
  padding: 12px 16px;
  gap: 8px;
  align-items: center;
  max-width: 520px;
  width: 100%;
  box-sizing: border-box;
  height: 60px;
  min-height: 60px;
  max-height: 60px;
  flex-shrink: 0;
  flex-grow: 0;
}
@media (max-width: 767px) {
  .preview-card .steps-summary-container .flow-info-panel {
    max-width: 100%;
  }
}
.preview-card .steps-summary-container .flow-info-panel::-webkit-scrollbar {
  height: 6px;
}
.preview-card .steps-summary-container .flow-info-panel::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
.preview-card .steps-summary-container .flow-info-panel::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}
.preview-card .steps-summary-container .flow-info-panel::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.preview-card .steps-summary-container .flow-info-panel .info-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  font-family: "Raleway", sans-serif;
  color: #0f0f0f;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  padding: 4px 12px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: -moz-fit-content;
  min-width: fit-content;
  writing-mode: horizontal-tb;
  text-orientation: mixed;
  direction: ltr;
  transform: none;
}
.preview-card .steps-summary-container .flow-info-panel .info-badge:hover {
  background: #f5f5f5;
}
.preview-card .steps-summary-container .flow-info-panel .info-badge.active {
  background: #5ea1d8;
  color: #fff;
  border-color: #5ea1d8;
  writing-mode: horizontal-tb;
  text-orientation: mixed;
  transform: none;
}
.preview-card .steps-summary-container .flow-info-panel .info-badge.active .info-icon,
.preview-card .steps-summary-container .flow-info-panel .info-badge.active .info-label,
.preview-card .steps-summary-container .flow-info-panel .info-badge.active .info-step-title {
  color: #fff;
  writing-mode: horizontal-tb;
  text-orientation: mixed;
}
.preview-card .steps-summary-container .flow-info-panel .info-badge .info-icon {
  font-size: 14px;
  flex-shrink: 0;
  line-height: 1;
}
.preview-card .steps-summary-container .flow-info-panel .info-badge .info-label {
  font-family: "Raleway", sans-serif;
  flex-shrink: 0;
  font-size: 13px;
}
.preview-card .steps-summary-container .flow-info-panel .info-badge .info-step-title {
  font-size: 11px;
  color: #606060;
  margin-left: 4px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "Raleway", sans-serif;
}
@media (max-width: 768px) {
  .preview-card .steps-summary-container .flow-info-panel .info-badge .info-step-title {
    display: none;
  }
}
.preview-card .selected-step-details .mobile-step-media {
  position: relative;
}
.preview-card .selected-step-details .steps-summary-clickarrow {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0px;
}
.preview-card .selected-step-details .steps-summary-clickarrow .owl-prev,
.preview-card .selected-step-details .steps-summary-clickarrow .owl-next {
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s, transform 0.2s, opacity 0.2s;
  font-size: 22px;
  font-weight: bold;
  padding: 0;
}
.preview-card .selected-step-details .steps-summary-clickarrow .owl-prev span,
.preview-card .selected-step-details .steps-summary-clickarrow .owl-next span {
  line-height: 1;
}
.preview-card .selected-step-details .steps-summary-clickarrow .owl-prev:hover:not(:disabled),
.preview-card .selected-step-details .steps-summary-clickarrow .owl-next:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.85);
  transform: translateY(-1px);
}
.preview-card .selected-step-details .steps-summary-clickarrow .owl-prev:disabled,
.preview-card .selected-step-details .steps-summary-clickarrow .owl-next:disabled {
  opacity: 0.4;
  cursor: default;
}
.preview-card .summary-steps-list-section {
  margin-bottom: 16px;
  padding: 12px;
  background: #f9f9f9;
  border-radius: 8px;
}
.preview-card .summary-steps-list-section .steps-list-title {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 10px 0;
  color: #0f0f0f;
}
.preview-card .summary-steps-list-section .summary-steps-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.preview-card .summary-steps-list-section .summary-step-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: #0f0f0f;
  text-align: left;
  transition: all 0.2s;
  width: 100%;
  height: auto;
  white-space: normal;
  word-break: break-word;
  overflow: visible;
}
.preview-card .summary-steps-list-section .summary-step-chip:hover {
  background: #f5f5f5;
  border-color: #c0c0c0;
}
.preview-card .summary-steps-list-section .summary-step-chip.active {
  background: #5ea1d8;
  color: white;
  border-color: #5ea1d8;
}
.preview-card .summary-steps-list-section .summary-step-chip .step-chip-number {
  font-size: 12px;
  font-weight: 600;
  font-family: "Raleway", sans-serif;
  flex-shrink: 0;
}
.preview-card .summary-steps-list-section .summary-step-chip .step-chip-title {
  font-size: 12px;
  font-weight: 400;
  font-family: "Raleway", sans-serif;
  line-height: 1.4;
  word-wrap: break-word;
  overflow: visible;
  text-overflow: clip;
  display: block;
  flex: 1 1 auto;
  white-space: normal;
}
.preview-card .selected-step-details {
  display: flex;
  flex-direction: column;
  gap: 0;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  background: white;
  height: auto;
  min-height: unset;
  max-height: unset;
  flex-shrink: 1;
  flex-grow: 0;
  box-sizing: border-box;
  width: 100%;
}
.preview-card .selected-step-details .mobile-step-media {
  background: #000;
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  max-height: 200px;
  min-height: unset;
  flex-shrink: 0;
  box-sizing: border-box;
}
.preview-card .selected-step-details .mobile-step-media img,
.preview-card .selected-step-details .mobile-step-media video {
  width: 100%;
  height: auto;
  max-height: 200px;
  object-fit: cover;
  display: block;
}
.preview-card .selected-step-details .mobile-section-body {
  padding: 12px;
  height: auto;
  min-height: unset;
  max-height: unset;
  overflow-y: auto;
  overflow-x: hidden;
  flex-shrink: 1;
  box-sizing: border-box;
}
.preview-card .mobile-steps-view {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.preview-card .mobile-steps-view .mobile-step-media {
  background: #000;
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  min-height: 150px;
}
.preview-card .mobile-steps-view .mobile-step-media img,
.preview-card .mobile-steps-view .mobile-step-media video {
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: block;
}
.preview-card .mobile-steps-view .mobile-step-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.preview-card .mobile-steps-view .mobile-step-header .mobile-step-number {
  align-self: flex-start;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: #e0f2fe;
  color: #0284c7;
  font-weight: 600;
}
.preview-card .mobile-items-view {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.preview-card .mobile-items-view .mobile-items-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
  background-color: #f8f9fa;
  padding: 15px;
}
.preview-card .mobile-items-view .mobile-item-card {
  display: flex;
  gap: 12px;
  padding: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.preview-card .mobile-items-view .mobile-item-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
.preview-card .mobile-items-view .mobile-item-card .mobile-item-avatar {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #475569;
  font-size: 20px;
  flex-shrink: 0;
  overflow: hidden;
  border: 2px solid #e2e8f0;
}
.preview-card .mobile-items-view .mobile-item-card .mobile-item-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.preview-card .mobile-items-view .mobile-item-card .mobile-item-avatar span {
  font-size: 20px;
  text-transform: uppercase;
}
.preview-card .mobile-items-view .mobile-item-card .mobile-item-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: center;
}
.preview-card .mobile-items-view .mobile-item-card .mobile-item-content .mobile-item-name {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #1f2f46;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.preview-card .mobile-items-view .mobile-item-card .mobile-item-content .mobile-item-quantity {
  margin: 0;
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.preview-card .mobile-items-view .mobile-item-card .mobile-item-content .mobile-item-link {
  font-size: 12px;
  color: #2563eb;
  text-decoration: none;
  margin-top: 2px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
}
.preview-card .mobile-items-view .mobile-item-card .mobile-item-content .mobile-item-link:hover {
  text-decoration: underline;
  color: #1d4ed8;
}
.preview-card .mobile-items-view .mobile-item-card.ng-star-inserted {
  padding: 4px;
}
.preview-card .mobile-faqs-view {
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: visible;
  max-height: none;
}
.preview-card .mobile-faqs-view .mobile-faq-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
  overflow: visible;
  max-height: none;
}
.preview-card .mobile-faqs-view .mobile-faq-item {
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  overflow: visible;
  max-height: none;
}
.preview-card .mobile-faqs-view .mobile-faq-item:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
.preview-card .mobile-faqs-view .mobile-faq-item .mobile-faq-question {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  margin-bottom: 12px;
  font-weight: 600;
  color: #1f2f46;
  font-size: 15px;
  line-height: 1.5;
}
.preview-card .mobile-faqs-view .mobile-faq-item .mobile-faq-question mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #2563eb;
  flex-shrink: 0;
  margin-top: 2px;
}
.preview-card .mobile-faqs-view .mobile-faq-item .mobile-faq-question span {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.preview-card .mobile-faqs-view .mobile-faq-item .show-answer-btn {
  background: #f0f4ff;
  color: #2563eb;
  border: 1px solid #2563eb;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  margin-top: 8px;
}
.preview-card .mobile-faqs-view .mobile-faq-item .show-answer-btn:hover {
  background: #2563eb;
  color: #fff;
}
.preview-card .summary-flow-layout {
  display: grid;
  grid-template-columns: minmax(0, 2.2fr) minmax(280px, 1fr);
  gap: 24px;
  margin-top: 16px;
}
@media (max-width: 1100px) {
  .preview-card .summary-flow-layout {
    grid-template-columns: 1fr;
  }
}
.preview-card .summary-main-column,
.preview-card .summary-sidebar-column {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.preview-card .summary-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}
.preview-card .summary-card-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
}
.preview-card .summary-card-header mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: #2563eb;
  margin-top: 2px;
}
.preview-card .summary-card-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
}
.preview-card .summary-card-header p {
  margin: 2px 0 0 0;
  font-size: 13px;
  color: #64748b;
}
.preview-card .summary-cover-preview {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  background: #000;
}
.preview-card .summary-cover-preview img,
.preview-card .summary-cover-preview video {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
}
.preview-card .summary-cover-placeholder {
  border: 1px dashed #d4d8dd;
  border-radius: 12px;
  padding: 40px 16px;
  text-align: center;
  color: #94a3b8;
}
.preview-card .summary-cover-placeholder mat-icon {
  display: block;
  margin: 0 auto 8px auto;
  font-size: 32px;
}
.preview-card .summary-cover-details {
  margin-top: 16px;
}
.preview-card .summary-cover-details h2 {
  margin: 0 0 12px 0;
  font-size: 22px;
  color: #0f172a;
}
.preview-card .summary-info-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 12px;
}
.preview-card .summary-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  font-size: 13px;
  color: #475569;
}
.preview-card .summary-pill mat-icon {
  font-size: 16px;
  color: #2563eb;
}
.preview-card .summary-items-groups {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.preview-card .summary-items-block {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 14px 16px;
  background: #fdfdfd;
}
.preview-card .summary-block-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.preview-card .summary-block-title mat-icon {
  font-size: 20px;
  color: #475569;
}
.preview-card .summary-block-title h4 {
  margin: 0;
  font-size: 15px;
  color: #0f172a;
}
.preview-card .summary-block-title span {
  font-size: 12px;
  color: #94a3b8;
}
.preview-card .summary-item-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.preview-card .summary-item-list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  color: #475569;
  flex-wrap: wrap;
}
.preview-card .summary-item-list .item-info {
  display: flex;
  flex-direction: column;
}
.preview-card .summary-item-list .item-info strong {
  color: #0f172a;
}
.preview-card .summary-item-list a {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #2563eb;
  text-decoration: none;
}
.preview-card .summary-item-list a mat-icon {
  font-size: 16px;
}
.preview-card .summary-step-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.preview-card .summary-step-panel {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px;
  background: #fdfdfd;
}
.preview-card .summary-step-heading {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.preview-card .summary-step-heading h4 {
  margin: 0;
  font-size: 16px;
  color: #0f172a;
}
.preview-card .step-chip {
  padding: 4px 10px;
  border-radius: 999px;
  background: #e0e7ff;
  color: #312e81;
  font-size: 12px;
  font-weight: 600;
}
.preview-card .summary-step-body {
  display: grid;
  grid-template-columns: minmax(0, 240px) 1fr;
  gap: 16px;
}
@media (max-width: 768px) {
  .preview-card .summary-step-body {
    grid-template-columns: 1fr;
  }
}
.preview-card .summary-step-media {
  border-radius: 8px;
  overflow: hidden;
  background: transparent;
  aspect-ratio: 16/9;
}
.preview-card .summary-step-media img,
.preview-card .summary-step-media video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.preview-card .summary-step-description {
  font-size: 13px;
  color: #475569;
  line-height: 1.6;
}
.preview-card .summary-step-description ::ng-deep p {
  margin-bottom: 10px;
}
.preview-card .summary-step-description ::ng-deep p:last-child {
  margin-bottom: 0;
}
.preview-card .summary-faq-collection {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.preview-card .summary-faq-block {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
  background: #fdfdfd;
}
.preview-card .summary-faq-block h4 {
  margin: 0 0 8px 0;
  font-size: 14px;
  color: #0f172a;
}
.preview-card .summary-faq-item {
  border-top: 1px solid #e2e8f0;
  padding-top: 10px;
  margin-top: 10px;
}
.preview-card .summary-faq-item:first-child {
  border-top: 0;
  padding-top: 0;
  margin-top: 0;
}
.preview-card .summary-faq-item .question {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  color: #0f172a;
  margin: 0 0 6px 0;
}
.preview-card .summary-faq-item .question mat-icon {
  font-size: 16px;
  color: #2563eb;
}
.preview-card .summary-faq-item .answer {
  font-size: 13px;
  color: #475569;
  line-height: 1.6;
}
.preview-card .sidebar-card {
  position: sticky;
  top: 24px;
}
.preview-card .summary-step-nav {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.preview-card .summary-step-chip {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 12px;
  background: #fff;
  text-align: left;
  cursor: default;
}
.preview-card .summary-step-chip .chip-index {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #e0e7ff;
  color: #1e1b4b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 13px;
}
.preview-card .summary-step-chip .chip-text {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.preview-card .summary-step-chip .chip-text strong {
  font-size: 13px;
  color: #0f172a;
}
.preview-card .summary-step-chip .chip-text small {
  font-size: 12px;
  color: #94a3b8;
  max-width: 220px;
  display: inline-block;
}
.preview-card .summary-stats-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.preview-card .summary-stats-list li {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #475569;
}
.preview-card .summary-stats-list li strong {
  color: #0f172a;
}
.preview-card .preview-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  color: #9ca3af;
  height: auto;
  min-height: unset;
  max-height: unset;
  flex-shrink: 1;
  box-sizing: border-box;
}
.preview-card .preview-empty mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  margin-bottom: 12px;
  opacity: 0.5;
}
.preview-card .preview-empty p {
  margin: 0;
  font-size: 14px;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #4b5563;
  margin-bottom: 8px;
  align-items: center;
  gap: 8px;
}
.summary-row span:last-child {
  font-weight: 600;
}
.summary-row .meta-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #5ea1d8;
}

.summary-preview {
  margin-top: 16px;
}

.summary-meta {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}

.items-summary,
.steps-summary,
.faqs-summary {
  max-height: 400px;
  overflow-y: auto;
}

.items-group,
.faq-group {
  margin-bottom: 20px;
}
.items-group:last-child,
.faq-group:last-child {
  margin-bottom: 0;
}

.group-title-small {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e4e8f0;
}

.items-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.item-preview {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f9fafb;
  border-radius: 8px;
}
.item-preview .item-preview-image {
  width: 50px;
  height: 50px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
}
.item-preview .item-preview-image.placeholder {
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #6b7280;
  font-size: 18px;
}
.item-preview .item-preview-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
}
.item-preview .item-preview-name {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}
.item-preview .item-preview-quantity {
  font-size: 13px;
  color: #6b7280;
}
.item-preview .item-link {
  font-size: 12px;
  color: #2563eb;
  text-decoration: none;
  margin-top: 4px;
  display: inline-flex;
}
.item-preview .item-link:hover {
  text-decoration: underline;
}

.steps-summary {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.step-preview {
  padding: 16px;
  background: #f9fafb;
  border-radius: 12px;
  border: 1px solid #e4e8f0;
}
.step-preview .step-preview-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.step-preview .step-preview-number {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #5ea1d8;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
}
.step-preview .step-preview-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}
.step-preview .step-preview-media {
  margin-bottom: 12px;
  border-radius: 8px;
  overflow: hidden;
  background: #f3f4f6;
}
.step-preview .step-preview-image {
  width: 100%;
  max-height: 150px;
  object-fit: cover;
  display: block;
}
.step-preview .step-preview-video {
  width: 100%;
  max-height: 150px;
  object-fit: cover;
  display: block;
}
.step-preview .step-preview-description {
  font-size: 13px;
  color: #6b7280;
  line-height: 1.5;
  max-height: 80px;
  overflow: hidden;
}

.faqs-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.faq-preview {
  padding: 12px;
  background: #f9fafb;
  border-radius: 8px;
  border-left: 3px solid #5ea1d8;
}
.faq-preview .faq-preview-question {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;
}
.faq-preview .faq-preview-question .faq-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #5ea1d8;
  flex-shrink: 0;
  margin-top: 2px;
}
.faq-preview .faq-preview-question span {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  line-height: 1.4;
}
.faq-preview .faq-preview-answer {
  font-size: 13px;
  color: #6b7280;
  line-height: 1.5;
  margin-left: 26px;
  max-height: 60px;
  overflow: hidden;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  color: #9ca3af;
}
.empty-state mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  margin-bottom: 12px;
  opacity: 0.5;
}
.empty-state p {
  margin: 0;
  font-size: 14px;
}

.transfer-card mat-slide-toggle {
  width: 100%;
  white-space: normal;
}

.toggle-description {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 12px;
  font-size: 13px;
  color: #4b5563;
}
.toggle-description.warning {
  color: #b45309;
}
.toggle-description .info-icon,
.toggle-description .warning-icon {
  font-size: 18px;
}

.selected-user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
  font-size: 14px;
}
.selected-user-info .user-name {
  font-weight: 600;
}
.selected-user-info .user-email {
  color: #6b7280;
}

.actions-card .publish {
  width: 100%;
  margin-top: 12px;
}

.upload-progress {
  margin: 24px auto;
  max-width: 420px;
  display: flex;
  align-items: center;
  gap: 12px;
  background: #111827;
  color: #fff;
  padding: 12px 18px;
  border-radius: 999px;
}
.upload-progress progress {
  flex: 1;
  height: 8px;
}
.upload-progress.spinner-only {
  justify-content: center;
  background: transparent;
}

.flow-upload-progress-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 12px 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
}
.flow-upload-progress-overlay .flow-progress-bar-container {
  flex: 1;
  height: 3px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  overflow: hidden;
  position: relative;
  max-width: 600px;
  margin: 0 auto;
}
.flow-upload-progress-overlay .flow-progress-bar-container .flow-progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #065fd4 0%, #0d96ff 100%);
  border-radius: 2px;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}
.flow-upload-progress-overlay .flow-progress-bar-container .flow-progress-bar::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  animation: shimmer 1.5s infinite;
}
.flow-upload-progress-overlay .flow-progress-text {
  font-size: 13px;
  font-weight: 500;
  color: #065fd4;
  min-width: 45px;
  text-align: right;
  font-family: "Roboto", sans-serif;
}
.flow-upload-progress-overlay .upload-status-text {
  font-size: 13px;
  color: #666;
  margin-top: 8px;
  text-align: center;
  width: 100%;
  font-family: "Roboto", sans-serif;
}

@media (max-width: 1200px) {
  .upload-body {
    flex-direction: column;
  }
  .secondary-pane {
    flex-direction: row;
    flex-wrap: wrap;
  }
  .summary-card {
    flex: 1 1 320px;
  }
}
@media (max-width: 768px) {
  .upload-backdrop {
    padding: 0;
  }
  .upload-dialog {
    width: 100%;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
  }
  .upload-header,
  .stage-banner {
    padding: 20px;
  }
  .upload-body {
    padding: 0;
    gap: 0;
  }
  .section-card {
    padding: 18px;
  }
  .section-card.journey-card {
    border-radius: 0;
    border-left: none;
    border-right: none;
    border-top: none;
  }
  .journey-progress {
    overflow-x: auto !important;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    padding-top: 8px;
    margin-top: 8px;
    touch-action: pan-x;
  }
  .journey-progress::-webkit-scrollbar {
    display: none;
  }
  .step-connector {
    display: block !important;
    flex: 0 0 16px;
    min-width: 16px;
    height: 2px;
    margin: 0 4px;
    align-self: center;
  }
  .journey-step {
    flex: 0 0 auto;
    padding-right: 8px;
    touch-action: pan-x !important;
  }
  .step-label {
    font-size: 12px;
    letter-spacing: 0.02em;
  }
  .journey-content {
    padding: 16px;
    overflow-x: hidden;
  }
  mat-form-field {
    width: 100%;
    max-width: 100%;
  }
  .cover-form-wrapper,
  .cover-form-wrapper .row,
  .cover-form-wrapper .col-12,
  .cover-form-wrapper [class*=col-] {
    max-width: 100%;
  }
  .cover-form-wrapper .row {
    margin-left: 0;
    margin-right: 0;
  }
  .cover-form-wrapper [class*=col-] {
    padding-left: 0;
    padding-right: 0;
  }
  .upload-dialog {
    height: 100dvh;
    max-height: 100dvh;
  }
  .upload-footer {
    display: flex !important;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10010;
    padding: 8px 12px;
    padding-bottom: max(8px, env(safe-area-inset-bottom));
    gap: 8px;
    flex-wrap: nowrap;
    align-items: center;
  }
}
@media (min-width: 769px) and (max-width: 992px) {
  .upload-footer {
    display: flex !important;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10010;
    padding: 8px 16px;
    padding-bottom: max(8px, env(safe-area-inset-bottom));
    gap: 8px;
    flex-wrap: nowrap;
    align-items: center;
  }
  .upload-body {
    padding-bottom: calc(80px + env(safe-area-inset-bottom));
  }
}
@media (max-width: 768px) {
  .upload-body {
    padding-bottom: calc(80px + env(safe-area-inset-bottom));
  }
  .upload-footer .footer-step,
  .upload-footer .footer-actions {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    flex-wrap: nowrap;
    align-items: stretch;
    gap: 8px;
  }
  .upload-footer .footer-actions .take-public-group,
  .upload-footer .footer-actions .take-public-wrap,
  .upload-footer .footer-actions .publish-wrap {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
  }
  /* Secondary actions sit in the ⋮ menu; the button keeps a fixed square size */
  .upload-footer .footer-actions .footer-more-btn {
    flex: 0 0 40px;
    width: 40px;
    height: 40px;
    padding: 0;
    border-radius: 50%;
    border: 1px solid #d0d7de;
    background: #fff;
    color: #374151;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .upload-footer .footer-actions .footer-more-btn mat-icon {
    font-size: 22px;
    width: 22px;
    height: 22px;
    line-height: 22px;
  }
  /* A reviewer's approve/reject bar takes its own full-width row above the buttons */
  .upload-footer {
    flex-wrap: wrap;
  }
  .upload-footer .footer-actions {
    flex-wrap: wrap;
  }
  .upload-footer .footer-actions .approval-review {
    order: -1;
    flex: 1 1 100%;
  }
  .upload-dialog:has(.upload-footer .approval-review) .upload-body {
    padding-bottom: calc(190px + env(safe-area-inset-bottom));
  }
  :host-context(body.theme-dark) .upload-footer .footer-actions .footer-more-btn {
    background: #1b1f27;
    border-color: #2f3542;
    color: #e2e8f0;
  }
  .upload-footer .footer-step .footer-btn,
  .upload-footer .footer-actions .footer-btn,
  .upload-footer .footer-actions .btn-primary {
    flex: 1 1 0;
    width: 100%;
    min-width: 0;
    min-height: 40px;
    height: 40px;
    padding: 8px 10px;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: none;
    line-height: 1.2;
    border-radius: 999px;
    box-sizing: border-box;
  }
  :host ::ng-deep .standard-tab-group .mat-mdc-tab-header-pagination {
    display: none !important;
  }
  :host ::ng-deep .standard-tab-group .mat-mdc-tab-label-container {
    overflow-x: auto !important;
    overflow-y: hidden !important;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-x;
    scrollbar-width: none;
  }
  :host ::ng-deep .standard-tab-group .mat-mdc-tab-label-container::-webkit-scrollbar {
    display: none;
  }
  :host ::ng-deep .standard-tab-group .mat-mdc-tab-list {
    transform: none !important;
    width: max-content;
  }
  :host ::ng-deep .standard-tab-group .mat-mdc-tab-labels {
    width: max-content;
    flex-wrap: nowrap;
  }
  :host ::ng-deep .standard-tab-group .mdc-tab__text-label > span {
    min-width: 0 !important;
  }
}
#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 10px;
  text-align: center;
  border-radius: 0 0 10px 10px;
}

/* BASIC */
.Login {
  background-color: white;
  min-height: 89vh;
}
.Login > div {
  background: #efeeee !important;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 89vh;
}

.banner {
  margin-top: 200px;
}

html {
  background-color: #56baed;
}

body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

a {
  color: #92badd;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  margin: 40px 8px 10px 8px;
  color: #cccccc;
}

/* STRUCTURE */
.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

#formContent {
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 20px 40px !important;
  width: 90%;
  max-width: 600px;
  width: 100%;
  position: relative;
  padding: 0px;
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
  border: 0.5px solid lightgrey;
}

/* TABS */
h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #5fbae9;
}

/* FORM TYPOGRAPHY*/
input[type=button],
input[type=submit],
input[type=reset] {
  background-color: #56baed;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  transition: all 0.3s ease-in-out;
}

input[type=button]:hover,
input[type=submit]:hover,
input[type=reset]:hover {
  background-color: #39ace7;
}

input[type=button]:active,
input[type=submit]:active,
input[type=reset]:active {
  transform: scale(0.95);
}

input[type=text],
input[type=password] {
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  border-radius: 5px 5px 5px 5px;
}

input[type=text]:focus,
input[type=password]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

input[type=text]:placeholder,
input[type=password] {
  color: #cccccc;
}

/* ANIMATIONS */
/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  animation-name: fadeInDown;
  animation-duration: 1s;
  animation-fill-mode: both;
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
/* Simple CSS3 Fade-in Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fadeIn {
  opacity: 0;
  animation: fadeIn ease-in 1;
  animation-fill-mode: forwards;
  animation-duration: 1s;
}

.fadeIn.first {
  animation-delay: 0.4s;
}

.fadeIn.second {
  animation-delay: 0.6s;
  border: 0.5px solid lightgrey;
}

.fadeIn.third {
  animation-delay: 0.8s;
  border: 0.5px solid lightgrey;
}

.fadeIn.fourth {
  animation-delay: 1s;
  border: 0.5px solid lightgrey;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

/* OTHERS */
*:focus {
  outline: none;
}

#icon {
  width: 60%;
}

.mat-badge-content {
  background: #5ea1d8;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  border: 1px solid #ddd;
}

.mat-cell {
  font-size: 12px;
  font-family: Verdana, Sans-Serif;
  display: table-cell;
  height: 48px;
  vertical-align: middle;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  border-left: 2px solid rgba(0, 0, 0, 0.12);
  border-right: 2px solid rgba(0, 0, 0, 0.12);
}

.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.cdk-drag-placeholder {
  opacity: 0;
}

.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.example-box {
  padding: 15px 10px;
  border-bottom: solid 1px lightgray;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  background: white;
  font-size: 14px;
}
.example-box > div {
  width: 50%;
  display: flex !important;
}
.example-box > div:first-child {
  width: 80%;
}
.example-box > div:last-child {
  width: 17%;
}
.example-box > div > span {
  text-align: left;
  word-break: keep-all;
  display: flex;
  align-items: center;
}
.example-box > div > span:first-child {
  flex: 1;
  width: 50%;
  color: rgba(0, 0, 0, 0.54) !important;
  color: #212427 !important;
  font-weight: 400 !important;
}
.example-box > div > span:last-child {
  width: 50%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: end;
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54) !important;
  color: #212427 !important;
  font-weight: 400 !important;
}

/* my design starts here*/
button.close {
  position: absolute;
  top: -20px;
  right: -20px;
}
button.close span {
  color: rgba(0, 0, 0, 0.54) !important;
  color: #212427 !important;
}

#formContent {
  border: 1px solid #ddd;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  overflow-y: auto;
}
#formContent::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}
#formContent::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
#formContent::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}
#formContent p {
  font-size: 17px !important;
  line-height: 29px;
}
#formContent p:first-of-type {
  font-size: 17px !important;
  font-weight: 600 !important;
}
#formContent .square_btn {
  font-family: "Raleway";
  color: #5ea1d8;
}
#formContent .square_btn:hover {
  color: #fff;
}

.Login {
  height: 100%;
  position: relative;
  background: #efeeee !important;
}

.threedot {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
.threedot .title-text {
  flex: 1;
}
.threedot p {
  text-align: right;
}
.threedot a {
  display: flex;
  align-items: center;
  height: 35px;
  margin-left: 0px;
}
.threedot a:hover {
  background: #5ea1d8 !important;
}

.example-list {
  max-width: 100%;
  border: solid 1px #ccc;
  height: auto;
  display: block;
  background: white;
  border-radius: 4px;
  overflow-y: auto;
}
.example-list.faq-list-container {
  overflow-y: visible;
  overflow-x: visible;
  max-height: none;
  height: auto;
}
@media (max-width: 767px) {
  .example-list.faq-list-container {
    overflow-y: visible;
    overflow-x: visible;
    max-height: none;
  }
}
.example-list .example-box {
  display: flex;
  padding: 15px 10px;
  border-bottom: 1px solid lightgrey;
  background: white !important;
}
.example-list .example-box .item-name,
.example-list .example-box .item-value {
  text-align: left;
  width: 40%;
}
.example-list .example-box .item-name,
.example-list .example-box .item-delete,
.example-list .example-box .item-reorder,
.example-list .example-box .item-value {
  text-align: left;
  padding: 5px;
  font-size: 14px;
  font-weight: 400 !important;
  overflow-wrap: break-word;
}
.example-list .example-box .item-delete,
.example-list .example-box .item-reorder {
  float: right;
  cursor: pointer;
  font-size: 20px;
  width: 10%;
}
.example-list .example-box:last-child {
  border-bottom: 0px;
}
.example-list::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}
.example-list::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.example-list::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

.item-table {
  width: 100%;
  display: block;
  float: left;
}

.c-flow .inner-box {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}
.c-flow .inner-box .title-text {
  float: left;
  font-size: 14px;
  margin-left: 0px;
  line-height: 22px;
  color: #212427;
}
.c-flow .inner-box .threedot .custom-badge {
  background-color: #5ea1d8;
  font-size: 15px;
  width: auto;
  margin-left: 0px;
  float: left;
  cursor: pointer;
  color: white;
  padding: 10px;
}
.c-flow .inner-box .threedot .more-vert {
  cursor: pointer;
  float: right;
  color: gray;
}
.c-flow .inner-box .img-section-1 {
  width: 100%;
  display: block;
  border: 1px solid lightgray;
  padding: 15px;
}
.c-flow .inner-box .img-section-1 .img-and-video-sec {
  height: 100%;
  position: relative;
  overflow: hidden;
  min-height: 300px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.c-flow .inner-box .img-section-1 img.img-display {
  max-width: 100%;
  object-fit: contain;
}
.c-flow .inner-box .img-section-1 video.video-display {
  width: 100%;
  height: 100%;
  max-height: unset !important;
}
.c-flow .inner-box .img-section-1:empty {
  border: 0px;
  padding: 0px;
}
.c-flow .inner-box .edit-cover {
  display: block;
  width: 100%;
  float: left;
  padding: 15px 0;
}
.c-flow .inner-box .edit-cover .description-text {
  color: rgba(0, 0, 0, 0.54);
  color: #212427 !important;
  margin-left: 0px;
  float: left;
  font-size: 14px;
  line-height: 22px;
  width: 100%;
  text-align: left;
  padding-bottom: 15px;
}
.c-flow .inner-box .edit-cover .btn-edit-cover {
  background-color: #5ea1d8;
  float: left;
  color: white;
  border: none;
}
.c-flow .inner-box .img-section-2 {
  margin: 15px 0;
  clear: both;
}
.c-flow .inner-box .img-section-2 .img-and-video-sec {
  border-radius: 5px;
  height: 100%;
  position: relative;
  overflow: hidden;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.c-flow .inner-box .img-section-2 .img-and-video-sec img.img-display {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  object-fit: contain;
}
.c-flow .inner-box .img-section-2 .img-and-video-sec .video-display {
  max-width: 100%;
}
.c-flow .inner-box .img-section-2 .steps-text {
  color: rgba(0, 0, 0, 0.54);
  color: #212427;
  font-weight: bold;
  font-size: 16px;
  padding-bottom: 15px;
  text-align: left;
}
.c-flow .inner-box .img-section-2 .decbox .step-description {
  color: black;
  padding: 15px 15px 0px 0px;
  font-size: 16px;
  text-align: left;
  display: block;
  width: 100%;
}
.c-flow .inner-box .img-section-2 .decbox .btn-delate-edit {
  text-align: left;
  margin: 15px 0px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.c-flow .inner-box .img-section-2 .decbox .btn-delate-edit .btn-primary {
  background-color: #5ea1d8;
  margin-right: 10px;
  cursor: pointer;
  color: white;
  border: none;
}
.c-flow .inner-box .button-section {
  display: block;
  align-items: center;
  flex-direction: column;
}
.c-flow .inner-box .button-section button {
  margin-bottom: 15px;
  white-space: nowrap;
  max-width: 100% !important;
  min-width: 250px;
  width: 75%;
  margin: 10px auto;
}
.c-flow .inner-box .button-section .btn-publish {
  width: 20%;
  background-color: #5ea1d8;
  color: white;
}
.c-flow .inner-box .btn-add-page {
  width: 75%;
  display: block;
  margin: 5px auto;
}
.c-flow .inner-box .btn-add-page + .img-section-1 {
  border: 0;
  padding: 0px;
}
.c-flow .inner-box .btn-add-page + .img-section-1 .edit-cover {
  padding: 0;
}

@media (max-width: 767px) {
  #formContent {
    width: calc(100% - 30px);
    padding: 20px !important;
  }
  .Login > div {
    background: #fff !important;
  }
  button.close {
    position: absolute;
    top: -26px;
    right: -12px;
  }
  #formContent .button-section .mdc-button.btn-publish {
    width: auto !important;
  }
}
@media only screen and (max-width: 767px) and (min-width: 461px) {
  #formContent {
    position: relative;
    top: 20px;
    left: auto;
    transform: none;
  }
}
@media (max-width: 460px) {
  .c-flow .inner-box .img-section-1 .img-and-video-sec {
    min-height: 150px;
  }
  .c-flow .inner-box .img-section-2 .img-and-video-sec {
    min-height: 150px;
  }
  .c-flow .inner-box .img-section-2 .decbox .btn-delate-edit {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin: 0;
    padding: 10px 0;
  }
  .c-flow .inner-box .img-section-2 .decbox .btn-delate-edit .btn-primary {
    margin: 5px;
    cursor: pointer;
  }
  .c-flow .inner-box .btn-add-page {
    width: 83%;
  }
}
.example-stepList {
  max-width: 100%;
  height: auto;
  display: block;
  margin-top: 10px;
  background: white;
  border-radius: 4px;
  overflow-y: auto;
}

.itemremove span:first-child {
  width: 90% !important;
}

.img-div-left {
  position: fixed;
  height: 150px;
  width: 150px;
  overflow: visible;
  margin: auto;
  top: 90%;
  left: 0;
  right: 0;
  margin: 0px auto;
}

.example-box span:first-child {
  width: 90% !important;
}
.example-box span:nth-child(2) {
  width: 40% !important;
}
.example-box span:nth-child(3) {
  width: 40% !important;
}
.example-list.check2 {
  margin-bottom: 20px;
}
.example-list.check2 .example-box .item-name {
  display: flex;
  width: 100% !important;
  padding: 0px;
}
.example-list.check2 .example-box .item-name span {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  word-break: break-all;
}
.example-list.check2 .example-box .item-name span:first-child {
  flex: 1;
}
.example-list.check2 .example-box .item-name span:nth-child(2) {
  flex: 3;
}
.example-list.check2 .example-box .item-name span:last-child {
  flex: 0.5;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.button-section {
  width: 100% !important;
}

.img-section-2 {
  width: 100%;
}

.example-list {
  margin-bottom: 20px;
}
.example-list .example-box {
  border: 1px solid gray;
  display: flex;
  align-items: center;
}
.example-list .example-box span {
  border-right: 1px solid gray;
  display: flex;
  text-align: left;
  padding: 5px 10px 5px 5px;
  align-self: stretch;
  align-items: center;
}
.example-list .example-box span:first-child {
  width: 20%;
}
.example-list .example-box span:nth-child(2) {
  width: 70%;
}
.example-list .example-box span:nth-child(2) span {
  width: 100% !important;
  justify-content: flex-start !important;
}
.example-list .example-box span:nth-child(3) {
  width: 50px;
  justify-content: center;
}
.example-list .example-box span:last-child {
  width: 50px;
  text-align: center;
  border-right: 0px;
  justify-content: center;
}
.example-list .example-box + .example-box {
  border-top: 0px;
}

.item-table .clearfix {
  margin-top: 15px;
}
.item-table .example-list {
  border: 0px;
}

.example-list {
  border-radius: 0px;
  margin-bottom: 20px;
}
.example-list .example-box {
  border: 1px solid gray;
  display: flex;
  align-items: center;
  padding: 0px;
}
.example-list .example-box span {
  border-right: 1px solid gray;
  display: flex;
  text-align: left;
  padding: 5px 10px 5px 5px;
  align-self: stretch;
  align-items: center;
}
.example-list .example-box span:first-child {
  width: 20%;
}
.example-list .example-box span:nth-child(2) {
  width: 70%;
}
.example-list .example-box span:nth-child(3) {
  width: 50px;
  justify-content: center;
}
.example-list .example-box span:last-child {
  width: 50px;
  text-align: center;
  border-right: 0px;
  justify-content: center !important;
}
.example-list .example-box + .example-box {
  border-top: 0px;
}
.example-list .example-box:last-child {
  border-bottom: 1px solid gray;
}

#formContent .button-section .newbuttondesigncreateflow {
  font-family: "Raleway";
  background-color: transparent !important;
  font-size: 15px !important;
  cursor: pointer;
  color: #5ea1d8 !important;
  padding: 10px;
  width: 120px !important;
}
#formContent .button-section .newbuttondesigncreateflow span.mdc-button__label {
  color: #5ea1d8 !important;
}
#formContent .button-section .publish.newbuttondesigncreateflow1 {
  width: 120px !important;
}

.cretebtnwrap {
  display: flex;
  width: 100%;
}

.transfer-toggle-section {
  margin: 20px 0;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}
.transfer-toggle-section .transfer-toggle {
  display: flex;
  align-items: center;
  gap: 12px;
}
.transfer-toggle-section .transfer-toggle .toggle-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  color: #333;
}
.transfer-toggle-section .transfer-toggle .toggle-label .toggle-icon {
  color: #5ea1d8;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.transfer-toggle-section .transfer-toggle:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.transfer-toggle-section .transfer-toggle:disabled .toggle-label {
  color: #999;
}
.transfer-toggle-section .transfer-toggle:disabled .toggle-icon {
  color: #999;
}
.transfer-toggle-section .toggle-description {
  margin-top: 12px;
  padding: 12px;
  background: #e3f2fd;
  border-radius: 6px;
  border-left: 4px solid #5ea1d8;
  display: flex;
  align-items: flex-start;
  gap: 0px;
  font-size: 14px;
  color: #1976d2;
}
.transfer-toggle-section .toggle-description .info-icon {
  color: #5ea1d8;
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin-top: 1px;
}
.transfer-toggle-section .toggle-description.warning {
  border-left-color: #ffc107;
  color: #856404;
}
.transfer-toggle-section .toggle-description.warning .warning-icon {
  color: #ffc107;
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin-top: 1px;
}
.transfer-toggle-section .selected-user-info {
  margin-top: 16px;
  /* add left-right breathing space */
  margin-left: 8px;
  margin-right: 8px;
  padding: 12px 16px;
  background: #e8f5e8;
  border-radius: 6px;
  border-left: 4px solid #28a745;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #155724;
}
.transfer-toggle-section .selected-user-info .user-icon {
  color: #28a745;
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.transfer-toggle-section .selected-user-info .user-name {
  font-weight: 600;
  color: #155724;
}
.transfer-toggle-section .selected-user-info .user-email {
  color: #155724;
}
.transfer-toggle-section .selected-user-info .change-user-wrap {
  display: inline-flex;
  padding: 0;
  margin-left: auto;
  border-radius: 50%;
  overflow: hidden; /* clip hover/ripple strictly */
  height: 32px;
  width: 32px;
  align-items: center;
  justify-content: center;
}
.transfer-toggle-section .selected-user-info .change-user-btn {
  margin-left: 0;
  color: #28a745;
  /* make hover shape circular */
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0px; /* prevent oval from padding */
  line-height: 32px; /* keep label area square */
  overflow: hidden; /* clip ripple/background perfectly */
  /* Force Material icon-button internals to respect circle */
}
.transfer-toggle-section .selected-user-info .change-user-btn.mat-mdc-icon-button {
  min-width: 32px;
  min-height: 32px;
}
.transfer-toggle-section .selected-user-info .change-user-btn .mat-mdc-button-touch-target {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  inset: 0;
}
.transfer-toggle-section .selected-user-info .change-user-btn .mdc-icon-button {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  padding: 0;
}
.transfer-toggle-section .selected-user-info .change-user-btn .mat-mdc-button-persistent-ripple,
.transfer-toggle-section .selected-user-info .change-user-btn .mdc-button__ripple,
.transfer-toggle-section .selected-user-info .change-user-btn .mdc-icon-button__ripple {
  border-radius: 50%;
  inset: 0;
}
.transfer-toggle-section .selected-user-info .change-user-btn .mat-mdc-focus-indicator {
  border-radius: 50%;
}
.transfer-toggle-section .selected-user-info .change-user-btn:hover {
  background: rgba(40, 167, 69, 0.1);
  border-radius: 50%;
}
.transfer-toggle-section .selected-user-info .change-user-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.items-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: bold !important;
  font-size: 16px !important;
  text-align: left !important;
}
.items-container mat-icon {
  margin-left: 5px;
}

.mobile-summary-card .mobile-preview-shell {
  width: 100%;
  background: #050505;
  border-radius: 32px;
  padding: 16px;
  position: relative;
  box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.05), 0 25px 45px rgba(15, 23, 42, 0.25);
}
.mobile-summary-card .mobile-speaker {
  width: 60px;
  height: 6px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 999px;
  margin: 0 auto 12px;
}
.mobile-summary-card .mobile-screen {
  background: #fff;
  border-radius: 24px;
  overflow: hidden;
  min-height: 420px;
  display: flex;
  flex-direction: column;
}
.mobile-summary-card .mobile-cover-preview {
  display: flex;
  flex-direction: column;
}
.mobile-summary-card .mobile-cover-preview .mobile-media {
  width: 100%;
  height: 180px;
  background: #111827;
  position: relative;
}
.mobile-summary-card .mobile-cover-preview .mobile-media img,
.mobile-summary-card .mobile-cover-preview .mobile-media video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.mobile-summary-card .mobile-cover-preview .mobile-media.placeholder {
  color: #9ca3af;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.mobile-summary-card .mobile-cover-preview .mobile-media.placeholder mat-icon {
  font-size: 36px;
}
.mobile-summary-card .mobile-cover-preview .mobile-media.placeholder p {
  margin: 0;
  font-size: 13px;
}
.mobile-summary-card .mobile-cover-preview .mobile-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.mobile-summary-card .mobile-cover-preview .mobile-title {
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
  line-height: 1.4;
}
.mobile-summary-card .mobile-cover-preview .mobile-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.mobile-summary-card .mobile-cover-preview .mobile-meta span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  background: #f1f5f9;
  color: #475569;
}
.mobile-summary-card .mobile-cover-preview .mobile-meta span mat-icon {
  font-size: 14px;
  height: 14px;
  width: 14px;
}
.mobile-summary-card .mobile-cover-preview .mobile-description {
  font-size: 13px;
  color: #475569;
  line-height: 1.5;
  max-height: 90px;
  overflow: hidden;
}
.mobile-summary-card .mobile-section-header {
  padding: 14px 16px;
  border-bottom: 1px solid #edf2f7;
  font-weight: 600;
  font-size: 14px;
  color: #0f172a;
  background: #f8fafc;
}
.mobile-summary-card .mobile-card-list {
  padding: 0 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 360px;
  overflow-y: auto;
}
.mobile-summary-card .mobile-item-card {
  background: #fff;
  border: 1px solid #edf2f7;
  border-radius: 12px;
  padding: 12px;
}
.mobile-summary-card .mobile-item-card .group-label {
  margin: 0 0 8px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #94a3b8;
}
.mobile-summary-card .mobile-item-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-summary-card .mobile-item-row {
  display: flex;
  gap: 10px;
}
.mobile-summary-card .mobile-avatar {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #475569;
  overflow: hidden;
}
.mobile-summary-card .mobile-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.mobile-summary-card .mobile-item-body {
  flex: 1;
  min-width: 0;
}
.mobile-summary-card .mobile-item-body .name {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.mobile-summary-card .mobile-item-body .quantity {
  margin: 2px 0 0;
  font-size: 12px;
  color: #64748b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.mobile-summary-card .mobile-item-body .item-link {
  font-size: 12px;
  color: #2563eb;
  text-decoration: none;
  margin-top: 4px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.mobile-summary-card .mobile-empty {
  padding: 40px 16px;
  text-align: center;
  color: #94a3b8;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
}
.mobile-summary-card .mobile-empty mat-icon {
  font-size: 32px;
}
.mobile-summary-card .mobile-empty p {
  margin: 0;
  font-size: 13px;
}
.mobile-summary-card .mobile-steps-preview {
  padding: 0 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 360px;
  overflow-y: auto;
}
.mobile-summary-card .mobile-step-card {
  border: 1px solid #edf2f7;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}
.mobile-summary-card .mobile-step-media {
  width: 100%;
  height: 150px;
  background: #0f172a;
}
.mobile-summary-card .mobile-step-media img,
.mobile-summary-card .mobile-step-media video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.mobile-summary-card .mobile-step-body {
  padding: 12px;
}
.mobile-summary-card .mobile-step-body .mobile-step-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.mobile-summary-card .mobile-step-body .pill {
  align-self: flex-start;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: #e0f2fe;
  color: #0284c7;
  font-weight: 600;
}
.mobile-summary-card .mobile-step-body .title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}
.mobile-summary-card .mobile-step-body .mobile-step-description {
  margin-top: 8px;
  font-size: 13px;
  color: #475569;
  line-height: 1.5;
}
.mobile-summary-card .mobile-faq-list {
  padding: 0 16px 16px;
  max-height: 360px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.mobile-summary-card .mobile-faq-group {
  border: 1px solid #edf2f7;
  border-radius: 12px;
  background: #fff;
  padding: 12px;
}
.mobile-summary-card .mobile-faq-group .group-label {
  margin: 0 0 8px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #94a3b8;
  font-weight: 600;
}
.mobile-summary-card .mobile-faq-group .mobile-faq-item {
  padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;
}
.mobile-summary-card .mobile-faq-group .mobile-faq-item:last-child {
  border-bottom: none;
}
.mobile-summary-card .mobile-faq-group .mobile-faq-item .question {
  display: flex;
  gap: 8px;
  align-items: center;
  font-weight: 600;
  color: #0f172a;
}
.mobile-summary-card .mobile-faq-group .mobile-faq-item .question mat-icon {
  font-size: 18px;
  color: #2563eb;
}
.mobile-summary-card .mobile-faq-group .mobile-faq-item .answer {
  margin-top: 6px;
  font-size: 13px;
  color: #475569;
  line-height: 1.5;
}

.field-anchor {
  position: relative;
  transition: box-shadow 0.25s ease, border-color 0.25s ease;
  border-radius: 16px;
}

.field-highlight {
  box-shadow: 0 0 0 3px rgba(251, 146, 60, 0.4) inset, 0 12px 24px rgba(15, 23, 42, 0.15);
  animation: fieldPulse 1.2s ease;
}

@keyframes fieldPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(251, 146, 60, 0.4) inset;
  }
  50% {
    box-shadow: 0 0 0 3px rgba(251, 146, 60, 0.55) inset;
  }
  100% {
    box-shadow: 0 0 0 0 rgba(251, 146, 60, 0.2) inset;
  }
}
.flow-thumbnail-section {
  margin-top: 24px;
  padding: 0;
  background: transparent;
}

.thumbnail-section-header {
  margin-bottom: 16px;
}
.thumbnail-section-header h4 {
  font-size: 14px;
  font-weight: 500;
  color: #030303;
  margin: 0 0 4px 0;
  line-height: 20px;
}
.thumbnail-section-header p {
  font-size: 13px;
  color: #606060;
  margin: 0;
  line-height: 18px;
}

.thumbnail-choice-row {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: nowrap;
  align-items: stretch;
  width: 100%;
}
@media (max-width: 767px) {
  .thumbnail-choice-row {
    gap: 8px;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .thumbnail-choice-row::-webkit-scrollbar {
    display: none;
  }
}

.thumbnail-dialog-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: 10010;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.faq-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: 10020;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
@media (max-width: 767px) {
  .faq-modal-backdrop {
    padding: 16px;
    align-items: flex-start;
    padding-top: 40px;
  }
}

.faq-modal-card {
  width: min(600px, 90vw);
  max-height: 90vh;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.3);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
@media (max-width: 767px) {
  .faq-modal-card {
    width: 100%;
    max-height: calc(100vh - 80px);
    border-radius: 16px 16px 0 0;
  }
}

.faq-modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e4e8f0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-shrink: 0;
}
.faq-modal-header h4 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
}
.faq-modal-header .icon-button {
  flex-shrink: 0;
}
@media (max-width: 767px) {
  .faq-modal-header {
    padding: 16px;
  }
}

.faq-modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}
@media (max-width: 767px) {
  .faq-modal-body {
    padding: 16px;
  }
}

.faq-modal-group,
.faq-modal-question,
.faq-modal-answer {
  margin-bottom: 20px;
}
.faq-modal-group:last-child,
.faq-modal-question:last-child,
.faq-modal-answer:last-child {
  margin-bottom: 0;
}

.faq-modal-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 8px;
}

.faq-modal-value {
  display: block;
  font-size: 14px;
  color: #111827;
  line-height: 1.6;
  word-break: break-word;
}
.faq-modal-value.faq-modal-group {
  font-weight: 600;
  color: #2563eb;
}

.faq-modal-question .faq-modal-value {
  font-weight: 600;
  font-size: 16px;
  color: #1f2f46;
}

.faq-modal-answer .faq-modal-value {
  color: #4a5568;
  line-height: 1.8;
}

.faq-modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #e4e8f0;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}
.faq-modal-footer .close-btn {
  min-width: 100px;
}
@media (max-width: 767px) {
  .faq-modal-footer {
    padding: 12px 16px;
  }
}

.thumbnail-dialog-card {
  width: min(960px, 90vw);
  max-height: 90vh;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.3);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.thumbnail-dialog-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e4e8f0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  position: relative;
  z-index: 10011;
}
.thumbnail-dialog-header h4 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}
.thumbnail-dialog-header p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 14px;
  max-width: 480px;
}
.thumbnail-dialog-header .icon-button {
  z-index: 10012;
}

.thumbnail-dialog-body {
  padding: 24px;
  overflow-y: auto;
}
@media (max-width: 768px) {
  .thumbnail-dialog-body {
    padding: 16px;
  }
}

.thumbnail-choice {
  flex: 1;
  min-width: 160px;
  border: 1px dashed #d3d3d3;
  background: #fff;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease;
  font-size: 13px;
  color: #030303;
  flex-shrink: 0;
}
.thumbnail-choice.selected {
  border: 1px solid #065fd4;
  background: rgba(6, 95, 212, 0.05);
}
.thumbnail-choice.disabled {
  opacity: 0.5;
  cursor: default;
}
@media (max-width: 767px) {
  .thumbnail-choice {
    min-width: 140px;
    padding: 10px 12px;
    gap: 8px;
  }
}

.choice-icon {
  font-size: 20px;
  color: #606060;
}

.choice-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}
.choice-text strong {
  font-weight: 500;
  font-size: 13px;
}
.choice-text small {
  font-size: 12px;
  color: #606060;
}

.thumbnail-mode {
  margin-top: 0;
  margin-bottom: 16px;
}
.thumbnail-mode.upload-mode {
  margin-bottom: 24px;
}

.extracted-frames-section {
  margin-bottom: 24px;
  padding: 16px;
  background: #f9f9f9;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}
.extracted-frames-section h6 {
  margin: 0 0 4px 0;
  font-size: 14px;
  font-weight: 500;
  color: #030303;
}
.extracted-frames-section .frames-subtitle {
  margin: 0 0 16px 0;
  font-size: 12px;
  color: #606060;
}

.extracted-frames-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 16px;
}
@media (max-width: 768px) {
  .extracted-frames-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }
}

.extracted-frame-item {
  position: relative;
  aspect-ratio: 16/9;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.2s ease;
  background: #000;
}
.extracted-frame-item:hover {
  border-color: #065fd4;
  transform: scale(1.02);
}
.extracted-frame-item.selected {
  border-color: #065fd4;
  box-shadow: 0 0 0 2px rgba(6, 95, 212, 0.2);
}
.extracted-frame-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.extracted-frame-item .frame-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  font-size: 11px;
  font-weight: 500;
}
.extracted-frame-item .frame-overlay mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #065fd4;
}
.extracted-frame-item .frame-overlay .frame-number {
  font-size: 11px;
}

.use-frame-btn {
  width: 100%;
  justify-content: center;
  background: #065fd4;
  color: #fff;
  border-color: #065fd4;
}
.use-frame-btn:hover {
  background: #0550c4;
  border-color: #0550c4;
}

.frame-extraction-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
  gap: 12px;
}
.frame-extraction-loading p {
  margin: 0;
  font-size: 13px;
  color: #606060;
}

.frame-extraction-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: #fee;
  border: 1px solid #fcc;
  border-radius: 4px;
  color: #c33;
  font-size: 12px;
}
.frame-extraction-error mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.frame-extraction-error p {
  margin: 0;
}

.upload-divider {
  display: flex;
  align-items: center;
  margin: 24px 0;
  text-align: center;
}
.upload-divider::before, .upload-divider::after {
  content: "";
  flex: 1;
  height: 1px;
  background: #e0e0e0;
}
.upload-divider span {
  padding: 0 16px;
  font-size: 12px;
  color: #606060;
  font-weight: 500;
}

.thumbnail-mode-header {
  margin-bottom: 12px;
}
.thumbnail-mode-header h5 {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #030303;
}
.thumbnail-mode-header p {
  margin: 4px 0 0 0;
  font-size: 12px;
  color: #606060;
}

.yt-button {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border: 1px solid #d3d3d3;
  background: #fff;
  color: #030303;
  font-size: 13px;
  border-radius: 2px;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
.yt-button:hover {
  background: #f0f0f0;
}
.yt-button:disabled {
  color: #9e9e9e;
  border-color: #e0e0e0;
  cursor: not-allowed;
}
.yt-button mat-icon {
  font-size: 16px;
}

.video-preview-container {
  margin-bottom: 16px;
}

.video-wrapper {
  position: relative;
  width: 100%;
  max-width: 640px;
  background: #000;
  border-radius: 0;
  overflow: hidden;
  aspect-ratio: 16/9;
}

.thumbnail-video-preview {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.video-controls-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.75), transparent);
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.video-scrubber-container {
  display: flex;
  align-items: center;
  gap: 12px;
}

.video-scrubber {
  flex: 1;
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  outline: none;
  cursor: pointer;
}
.video-scrubber::-webkit-slider-thumb {
  -webkit-appearance: none;
          appearance: none;
  width: 14px;
  height: 14px;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
}
.video-scrubber::-moz-range-thumb {
  width: 14px;
  height: 14px;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
  border: none;
}

.scrubber-time {
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
  min-width: 70px;
  text-align: right;
}

.capture-frame-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.9);
  color: #030303;
  border: none;
  border-radius: 2px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
}
.capture-frame-btn:hover {
  background: #fff;
}
.capture-frame-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.thumbnail-options-row {
  display: flex;
  gap: 16px;
  margin-top: 16px;
  align-items: flex-start;
  padding: 0;
  background: transparent;
}
@media (max-width: 768px) {
  .thumbnail-options-row {
    flex-direction: column;
    gap: 16px;
  }
}

.thumbnail-option-column {
  flex: 1;
  min-width: 0;
}
.thumbnail-option-column h5 {
  font-size: 13px;
  font-weight: 500;
  color: #030303;
  margin: 0 0 8px 0;
  line-height: 18px;
}

.auto-thumbnails-column {
  flex: 1.5;
}

.thumbnails-horizontal-scroll {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 4px;
  scrollbar-width: thin;
  scrollbar-color: #d3d3d3 transparent;
}
.thumbnails-horizontal-scroll::-webkit-scrollbar {
  height: 4px;
}
.thumbnails-horizontal-scroll::-webkit-scrollbar-track {
  background: transparent;
}
.thumbnails-horizontal-scroll::-webkit-scrollbar-thumb {
  background: #d3d3d3;
  border-radius: 2px;
}
.thumbnails-horizontal-scroll::-webkit-scrollbar-thumb:hover {
  background: #b3b3b3;
}

.thumbnail-item-small {
  position: relative;
  width: 120px;
  height: 68px;
  flex-shrink: 0;
  border-radius: 0;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: border-color 0.15s ease;
  background: #000;
}
.thumbnail-item-small:hover {
  border-color: #065fd4;
}
.thumbnail-item-small.selected {
  border-color: #065fd4;
  border-width: 3px;
}
.thumbnail-item-small img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.thumbnail-check-small {
  position: absolute;
  top: 4px;
  right: 4px;
  background: #065fd4;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.thumbnail-check-small mat-icon {
  color: #fff;
  font-size: 12px;
  width: 12px;
  height: 12px;
}

.thumbnails-loading-small {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 0;
  color: #606060;
  font-size: 13px;
}

.no-thumbnails-message {
  padding: 12px 0;
  text-align: left;
  color: #606060;
  font-size: 13px;
}

.custom-thumbnail-column {
  flex: 1;
  max-width: 200px;
}

.custom-thumbnail-upload-compact {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 320px;
}

.upload-preview-compact {
  position: relative;
  width: 320px;
  height: 180px;
  border-radius: 0;
  overflow: hidden;
  background: #f9f9f9;
  border: 1px solid #d3d3d3;
  flex-shrink: 0;
}

.custom-thumbnail-preview-small {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.upload-placeholder-compact {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f9f9f9;
  gap: 8px;
}
.upload-placeholder-compact mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #909090;
}
.upload-placeholder-compact span {
  font-size: 13px;
  color: #606060;
  font-weight: 400;
}

.upload-label-compact {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px;
  cursor: pointer;
  text-align: center;
  transition: opacity 0.15s ease;
}
.upload-label-compact:hover {
  opacity: 0.7;
}
.upload-label-compact mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
  color: #606060;
}
.upload-label-compact span {
  font-size: 12px;
  font-weight: 400;
  color: #030303;
  line-height: 16px;
}

.document-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: nowrap;
}
@media (max-width: 767px) {
  .document-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    flex-wrap: wrap;
  }
}

.document-main {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
}
@media (max-width: 767px) {
  .document-main {
    flex: 1 1 auto;
    min-width: 0;
    max-width: 100%;
    width: 100%;
  }
}

.doc-file-icon {
  font-size: 28px;
  color: #5ea1d8;
}

.doc-text {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  min-width: 0;
  flex: 1;
  overflow: hidden;
  max-width: 100%;
}

.doc-name {
  font-weight: 600;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 100%;
  flex-shrink: 1;
}

.doc-url {
  font-size: 12px;
  color: #6b7280;
  word-break: break-all;
}

.document-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  flex-shrink: 0;
  min-width: -moz-fit-content;
  min-width: fit-content;
}
@media (max-width: 767px) {
  .document-actions {
    flex-wrap: nowrap;
    gap: 6px;
    flex-shrink: 0;
    min-width: -moz-fit-content;
    min-width: fit-content;
    width: 100%;
    justify-content: flex-start;
  }
}

.link-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #d3d3d3;
  border-radius: 999px;
  background: #fff;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
  flex-shrink: 0;
  white-space: nowrap;
}
.link-pill mat-icon {
  font-size: 16px;
  flex-shrink: 0;
}
.link-pill:hover {
  background: #f4f4f4;
}
@media (max-width: 767px) {
  .link-pill {
    padding: 6px 10px;
    font-size: 11px;
    gap: 4px;
  }
}

.icon-only {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #e5e7eb;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
  flex-shrink: 0;
}
.icon-only mat-icon {
  font-size: 18px;
}
.icon-only:hover {
  background: #f3f4f6;
}
@media (max-width: 767px) {
  .icon-only {
    width: 32px;
    height: 32px;
  }
  .icon-only mat-icon {
    font-size: 16px;
  }
}

.url-preview-dialog {
  min-width: 280px;
  max-width: 520px;
}

.url-preview-text {
  font-size: 14px;
  word-break: break-all;
  margin-bottom: 12px;
  padding: 8px 12px;
  background: #f9fafb;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}

.url-preview-open {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #0f62fe;
  text-decoration: none;
}
.url-preview-open mat-icon {
  font-size: 16px;
}

.upload-progress-compact {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #fff;
  font-size: 11px;
  font-weight: 400;
}

.upload-btn-compact {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 500;
  width: 100%;
  background: #065fd4;
  color: #fff;
  border: none;
  border-radius: 2px;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.upload-btn-compact:hover {
  background: #0650c0;
}
.upload-btn-compact:disabled {
  background: #ccc;
  cursor: not-allowed;
}
.upload-btn-compact mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}

.items-list-container {
  margin-top: 32px;
}

.items-group-wrapper {
  margin-bottom: 32px;
}
.items-group-wrapper:last-child {
  margin-bottom: 0;
}

.item-value.group-header {
  margin: 0 0 16px 0;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  padding: 0;
  text-align: left;
}
.item-value.group-header b {
  font-weight: 600;
}

.group-header-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 0px;
  padding: 2px 7px;
  background: linear-gradient(135deg, #eceff4 0%, #f9fafb 100%);
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  text-align: left;
}

.group-title-block {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.group-title-block .group-icon {
  color: #4b5563;
  font-size: 20px;
}
.group-title-block .group-title,
.group-title-block h4 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}

.group-count-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #e5e7eb;
  color: #374151;
  font-size: 13px;
  font-weight: 600;
}

.items-list-modern {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e9ecef;
}

.item-card-modern {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 6px;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  cursor: move;
  touch-action: none;
  -webkit-touch-callout: none;
}
.item-card-modern:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #667eea;
  transform: translateY(-2px);
}
.item-card-modern.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
@media (max-width: 767px) {
  .item-card-modern {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 12px;
    cursor: move;
    touch-action: none;
  }
}

.item-drag-handle {
  display: flex;
  align-items: center;
  color: #adb5bd;
  cursor: grab;
  padding: 4px;
  touch-action: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}
.item-drag-handle:active {
  cursor: grabbing;
}
@media (max-width: 767px) {
  .item-drag-handle {
    padding: 8px;
    cursor: grab;
    touch-action: none;
  }
  .item-drag-handle:active {
    cursor: grabbing;
  }
}
.item-drag-handle mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
@media (max-width: 767px) {
  .item-drag-handle mat-icon {
    font-size: 24px;
    width: 24px;
    height: 24px;
  }
}

.item-image-section {
  flex-shrink: 0;
}
@media (max-width: 767px) {
  .item-image-section {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.item-image-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  overflow: hidden;
  background: #f1f3f5;
  border: 2px solid #e9ecef;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item-image-wrapper:hover {
  border-color: #667eea;
  transform: scale(1.05);
}
@media (max-width: 767px) {
  .item-image-wrapper {
    width: 100%;
    max-width: 100px;
    height: 100px;
    margin: 0 auto;
  }
}
.item-image-wrapper .item-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.item-image-wrapper .item-image-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #adb5bd;
}
.item-image-wrapper .item-image-placeholder mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.item-details-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}
@media (max-width: 767px) {
  .item-details-section {
    width: 100%;
    gap: 10px;
  }
}

.item-detail-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex-wrap: wrap;
}
@media (max-width: 767px) {
  .item-detail-row {
    flex-direction: column;
    gap: 4px;
  }
}

.detail-label {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  min-width: 80px;
  flex-shrink: 0;
}
@media (max-width: 767px) {
  .detail-label {
    min-width: auto;
    font-size: 12px;
  }
}

.detail-value {
  font-size: 14px;
  color: #212529;
  word-break: break-word;
  flex: 1;
}
.detail-value.item-name-value {
  font-weight: 600;
  color: #212529;
  font-size: 15px;
}
.detail-value.quantity-value {
  color: #212529;
  font-weight: 600;
  background: transparent;
  padding: 0;
}
.detail-value.hyperlink-value {
  color: #667eea;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  transition: color 0.2s;
  max-width: 100%;
  overflow: hidden;
}
.detail-value.hyperlink-value .link-text-mobile {
  display: none;
}
.detail-value.hyperlink-value .link-url-desktop {
  display: inline;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
}
@media (max-width: 767px) {
  .detail-value.hyperlink-value .link-text-mobile {
    display: inline;
  }
  .detail-value.hyperlink-value .link-url-desktop {
    display: none;
  }
}
.detail-value.hyperlink-value:hover {
  color: #764ba2;
  text-decoration: underline;
}
.detail-value.hyperlink-value .link-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
.detail-value.empty-state {
  color: #adb5bd;
  font-style: italic;
  font-size: 13px;
}

.item-actions-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-shrink: 0;
}
@media (max-width: 767px) {
  .item-actions-section {
    flex-direction: row;
    justify-content: center;
    gap: 12px;
    width: 100%;
    padding-top: 8px;
    border-top: 1px solid #e9ecef;
  }
}

.action-btn {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  background: #f8f9fa;
  color: #495057;
}
.action-btn.edit-btn:hover {
  background: #e7f5ff;
  color: #1976d2;
}
.action-btn.delete-btn:hover {
  background: #fff5f5;
  color: #dc3545;
}
.action-btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.empty-items-state {
  text-align: center;
  padding: 48px 24px;
  color: #adb5bd;
}
.empty-items-state mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  margin-bottom: 16px;
  color: #ced4da;
}
.empty-items-state p {
  margin: 0;
  font-size: 14px;
  color: #6c757d;
}

.summary-group-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 10px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);
}
.summary-group-header .summary-group-icon {
  color: #fff;
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.summary-group-header .summary-group-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  flex: 1;
}
.summary-group-header .summary-group-count {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

.summary-items-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.summary-item-card-modern {
  display: flex;
  gap: 16px;
  padding: 16px;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}
.summary-item-card-modern:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #667eea;
}

.summary-item-image-modern {
  width: 80px;
  height: 80px;
  border-radius: 12px;
  overflow: hidden;
  background: #f1f3f5;
  border: 2px solid #e9ecef;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.summary-item-image-modern img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.summary-item-image-modern .summary-item-image-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #adb5bd;
}
.summary-item-image-modern .summary-item-image-placeholder mat-icon {
  font-size: 32px;
  width: 32px;
  height: 32px;
}

.summary-item-details-modern {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.summary-detail-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex-wrap: wrap;
}

.summary-detail-label {
  font-size: 12px;
  font-weight: 600;
  color: #495057;
  min-width: 70px;
  flex-shrink: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 11px;
}

.summary-detail-value {
  font-size: 14px;
  color: #212529;
  word-break: break-word;
  flex: 1;
}
.summary-detail-value.summary-hyperlink {
  color: #667eea;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  transition: color 0.2s;
}
.summary-detail-value.summary-hyperlink:hover {
  color: #764ba2;
  text-decoration: underline;
}
.summary-detail-value.summary-hyperlink .link-icon-small {
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.summary-detail-value.summary-hyperlink .link-text {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  opacity: 0.9;
}

.cdk-drag-placeholder {
  opacity: 0.3;
  background: #f8f9fa;
  border: 2px dashed #667eea;
}

.cdk-drop-list-dragging .item-card-modern:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.mobile-group-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding: 8px 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 6px;
}
.mobile-group-header .mobile-group-icon {
  color: #fff;
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.mobile-group-header .mobile-section-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 1;
}
.mobile-group-header .mobile-group-count {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

.mobile-item-card .mobile-item-avatar .mobile-item-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #f1f3f5;
  color: #adb5bd;
}
.mobile-item-card .mobile-item-avatar .mobile-item-placeholder mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.mobile-item-card .mobile-item-content .mobile-item-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}
.mobile-item-card .mobile-item-content .mobile-item-row:last-child {
  margin-bottom: 0;
}
.mobile-item-card .mobile-item-content .mobile-item-row .mobile-label {
  font-size: 11px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 45px;
  flex-shrink: 0;
}
.mobile-item-card .mobile-item-content .mobile-item-row .mobile-item-name {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #1f2f46;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mobile-item-card .mobile-item-content .mobile-item-row .mobile-item-quantity {
  margin: 0;
  font-size: 13px;
  color: #667eea;
  font-weight: 600;
  background: #f0f4ff;
  padding: 2px 8px;
  border-radius: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.mobile-item-card .mobile-item-content .mobile-item-row .mobile-item-link {
  font-size: 12px;
  color: #667eea;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
}
.mobile-item-card .mobile-item-content .mobile-item-row .mobile-item-link:hover {
  text-decoration: underline;
  color: #764ba2;
}
.mobile-item-card .mobile-item-content .mobile-item-row .mobile-item-link .link-icon-tiny {
  font-size: 14px;
  width: 14px;
  height: 14px;
}

.confirm-menu {
  padding: 12px 16px;
  border-bottom: 1px solid #e4e8f0;
}
.confirm-menu h5 {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 600;
}
.confirm-menu p {
  margin: 0;
  font-size: 14px;
  color: #64748b;
}

::ng-deep .upload-backdrop .cdk-overlay-pane {
  z-index: 10030 !important;
}
::ng-deep .upload-backdrop .cdk-overlay-backdrop {
  z-index: 10029 !important;
}
::ng-deep .upload-backdrop .mat-mdc-menu-panel {
  z-index: 10031 !important;
}

::ng-deep .cdk-overlay-container .cdk-overlay-pane[data-mat-menu-panel], ::ng-deep .cdk-overlay-container .cdk-overlay-pane[class*=menu], ::ng-deep .cdk-overlay-container .cdk-overlay-pane:has(.mat-mdc-menu-panel), ::ng-deep .cdk-overlay-container .cdk-overlay-pane:has(.mat-menu-panel) {
  z-index: 10030 !important;
}

::ng-deep body .cdk-overlay-pane:has(.mat-mdc-menu-panel), ::ng-deep body .cdk-overlay-pane:has(.mat-menu-panel) {
  z-index: 10030 !important;
}
::ng-deep body .cdk-overlay-container .cdk-overlay-pane[class*=menu], ::ng-deep body .cdk-overlay-container .cdk-overlay-pane:has(.mat-mdc-menu-panel), ::ng-deep body .cdk-overlay-container .cdk-overlay-pane:has(.mat-menu-panel) {
  z-index: 10030 !important;
}

.thumbnail-dialog-card {
  position: relative;
  z-index: 10011;
}
.thumbnail-dialog-card .thumbnail-dialog-header .icon-button {
  z-index: 10013 !important;
  position: relative;
}

::ng-deep .url-preview-dialog {
  z-index: 10015 !important;
}
::ng-deep .url-preview-dialog .mat-mdc-dialog-container {
  z-index: 10016 !important;
}

.mobile-create-flow {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  background: #000;
  color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  overflow: hidden;
}
.mobile-create-flow .mobile-upload-screen {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.mobile-create-flow .mobile-upload-screen .mobile-upload-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: max(12px, env(safe-area-inset-top));
}
.mobile-create-flow .mobile-upload-screen .mobile-upload-header .mobile-back-btn {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: #fff;
  padding: 8px;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.mobile-create-flow .mobile-upload-screen .mobile-upload-header .mobile-back-btn mat-icon {
  font-size: 24px;
}
.mobile-create-flow .mobile-upload-screen .mobile-upload-header .mobile-upload-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  flex: 1;
  text-align: center;
}
.mobile-create-flow .mobile-upload-screen .mobile-upload-header .mobile-header-spacer {
  width: 40px;
}
.mobile-create-flow .mobile-upload-screen .mobile-upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  max-width: 400px;
  width: 100%;
}
.mobile-create-flow .mobile-upload-screen .mobile-upload-content .mobile-upload-icon {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}
.mobile-create-flow .mobile-upload-screen .mobile-upload-content .mobile-upload-icon mat-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  color: #fff;
}
.mobile-create-flow .mobile-upload-screen .mobile-upload-content .mobile-upload-heading {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  color: #fff;
}
.mobile-create-flow .mobile-upload-screen .mobile-upload-content .mobile-upload-subtitle {
  font-size: 16px;
  color: #aaa;
  margin: 0;
}
.mobile-create-flow .mobile-upload-screen .mobile-upload-content .mobile-upload-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px 32px;
  background: #065fd4;
  color: #fff;
  border-radius: 24px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  border: none;
  width: 100%;
  transition: all 0.2s;
}
.mobile-create-flow .mobile-upload-screen .mobile-upload-content .mobile-upload-button:active {
  background: #0550c1;
  transform: scale(0.98);
}
.mobile-create-flow .mobile-upload-screen .mobile-upload-content .mobile-upload-button .upload-btn-content {
  display: flex;
  align-items: center;
  gap: 12px;
}
.mobile-create-flow .mobile-upload-screen .mobile-upload-content .mobile-upload-button .upload-btn-content mat-icon {
  font-size: 24px;
}
.mobile-create-flow .mobile-main-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.mobile-create-flow .mobile-main-content .mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  padding-top: max(12px, env(safe-area-inset-top));
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.9) 0%, transparent 100%);
  position: relative;
  z-index: 10;
}
.mobile-create-flow .mobile-main-content .mobile-header .mobile-close-btn {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: #fff;
  padding: 8px;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.mobile-create-flow .mobile-main-content .mobile-header .mobile-close-btn mat-icon {
  font-size: 24px;
}
.mobile-create-flow .mobile-main-content .mobile-header .mobile-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  flex: 1;
  text-align: center;
}
.mobile-create-flow .mobile-main-content .mobile-header .mobile-header-spacer {
  width: 40px;
}
.mobile-create-flow .mobile-main-content .mobile-cover-preview-section {
  width: 100%;
  aspect-ratio: 9/16;
  background: #000;
  position: relative;
  overflow: hidden;
}
.mobile-create-flow .mobile-main-content .mobile-cover-preview-section .mobile-media-preview {
  width: 100%;
  height: 100%;
}
.mobile-create-flow .mobile-main-content .mobile-cover-preview-section .mobile-media-preview .mobile-preview-image,
.mobile-create-flow .mobile-main-content .mobile-cover-preview-section .mobile-media-preview .mobile-preview-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.mobile-create-flow .mobile-main-content .mobile-cover-preview-section .mobile-preview-title {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.9) 0%, transparent 100%);
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels {
  flex: 1;
  overflow-y: auto;
  background: #fff;
  color: #000;
  -webkit-overflow-scrolling: touch;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel {
  border-radius: 0 !important;
  box-shadow: none !important;
  border-bottom: 1px solid #e0e0e0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel.mat-expanded {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background: #fff;
  height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel.mat-expanded .mobile-panel-content {
  max-height: none;
  overflow: visible;
  padding-bottom: 100px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel.mat-expanded .mat-expansion-panel-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mat-expansion-panel-header {
  padding: 16px;
  min-height: 64px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mat-expansion-panel-header .mat-expansion-panel-header-title {
  display: flex;
  align-items: center;
  gap: 12px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mat-expansion-panel-header .mat-expansion-panel-header-title .panel-icon {
  color: #065fd4;
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mat-expansion-panel-header .mat-expansion-panel-header-title span {
  font-size: 16px;
  font-weight: 600;
  color: #0f0f0f;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mat-expansion-panel-header .mat-expansion-panel-header-description {
  display: flex;
  align-items: center;
  gap: 8px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mat-expansion-panel-header .mat-expansion-panel-header-description .panel-status {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #065fd4;
  font-size: 14px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mat-expansion-panel-header .mat-expansion-panel-header-description .panel-status .check-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mat-expansion-panel-header .mat-expansion-panel-header-description .panel-error {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #ea4335;
  font-size: 14px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mat-expansion-panel-header .mat-expansion-panel-header-description .panel-error .error-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content {
  padding: 0;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section {
  padding: 16px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-section-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 20px 0;
  color: #0f0f0f;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-section-subtitle {
  font-size: 18px;
  font-weight: 600;
  margin: 24px 0 16px 0;
  color: #0f0f0f;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-form-field {
  width: 100%;
  margin-bottom: 16px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #606060;
  margin-bottom: 8px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-upload-section {
  margin-bottom: 16px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-upload-section .mobile-upload-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 40px 20px;
  border: 2px dashed #d3d3d3;
  border-radius: 12px;
  background: #f9f9f9;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-upload-section .mobile-upload-btn.uploading {
  cursor: not-allowed;
  opacity: 0.7;
  border-color: #065fd4;
  background: #e8f0fe;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-upload-section .mobile-upload-btn:active:not(.uploading) {
  background: #f0f0f0;
  border-color: #065fd4;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-upload-section .mobile-upload-btn .upload-spinner {
  margin: 0 auto;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-upload-section .mobile-upload-btn .upload-spinner ::ng-deep circle {
  stroke: #065fd4;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-upload-section .mobile-upload-btn mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #606060;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-upload-section .mobile-upload-btn span {
  font-size: 16px;
  color: #606060;
  font-weight: 500;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-upload-section .flow-upload-progress {
  width: 100%;
  margin-top: 12px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-upload-section .flow-upload-progress .flow-progress-bar-container {
  width: 100%;
  height: 4px;
  background: #e0e0e0;
  border-radius: 2px;
  overflow: hidden;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-upload-section .flow-upload-progress .flow-progress-bar-container .flow-progress-bar {
  height: 100%;
  background: #065fd4;
  transition: width 0.3s ease;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-upload-section .mobile-item-preview-img,
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-upload-section .mobile-step-preview-img {
  width: 100%;
  max-height: 300px;
  object-fit: contain;
  border-radius: 8px;
  margin-top: 12px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-upload-section .mobile-step-preview-video {
  width: 100%;
  max-height: 300px;
  border-radius: 8px;
  margin-top: 12px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-toggle-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  margin-bottom: 16px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-toggle-section label {
  font-size: 16px;
  color: #0f0f0f;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-add-btn,
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-save-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 16px;
  border: none;
  border-radius: 24px;
  background: #065fd4;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 16px;
  position: relative;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-add-btn:active:not(:disabled),
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-save-btn:active:not(:disabled) {
  background: #0550c1;
  transform: scale(0.98);
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-add-btn:disabled,
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-save-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-add-btn .btn-spinner,
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-save-btn .btn-spinner {
  margin: 0;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-add-btn .btn-spinner ::ng-deep circle,
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-save-btn .btn-spinner ::ng-deep circle {
  stroke: #fff;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-add-btn mat-icon,
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-save-btn mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-items-list {
  margin-top: 24px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-items-list .mobile-group-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 600;
  margin: 24px 0 12px 0;
  color: #0f0f0f;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-items-list .mobile-group-title mat-icon {
  font-size: 20px;
  color: #065fd4;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-items-list .mobile-item-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f9f9f9;
  border-radius: 12px;
  margin-bottom: 8px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-items-list .mobile-item-card .mobile-item-img {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: cover;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-items-list .mobile-item-card .mobile-item-info {
  flex: 1;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-items-list .mobile-item-card .mobile-item-info .mobile-item-name {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 4px 0;
  color: #0f0f0f;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-items-list .mobile-item-card .mobile-item-info .mobile-item-qty {
  font-size: 14px;
  color: #606060;
  margin: 0;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-items-list .mobile-item-card .mobile-item-actions {
  display: flex;
  gap: 8px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-items-list .mobile-item-card .mobile-item-actions .mobile-action-btn {
  background: transparent;
  border: none;
  color: #606060;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-items-list .mobile-item-card .mobile-item-actions .mobile-action-btn:active {
  background: #e0e0e0;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-items-list .mobile-item-card .mobile-item-actions .mobile-action-btn mat-icon {
  font-size: 20px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-steps-list {
  margin-top: 24px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-steps-list .mobile-step-card {
  background: #f9f9f9;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-steps-list .mobile-step-card .mobile-step-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-steps-list .mobile-step-card .mobile-step-header .mobile-step-number {
  font-size: 14px;
  color: #065fd4;
  font-weight: 600;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-steps-list .mobile-step-card .mobile-step-header .mobile-step-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: #0f0f0f;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-steps-list .mobile-step-card .mobile-step-img,
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-steps-list .mobile-step-card .mobile-step-video {
  width: 100%;
  max-height: 300px;
  object-fit: contain;
  border-radius: 8px;
  margin-bottom: 12px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-steps-list .mobile-step-card .mobile-step-description {
  font-size: 14px;
  color: #606060;
  margin-bottom: 12px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-steps-list .mobile-step-card .mobile-step-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-faqs-list {
  margin-top: 24px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-faqs-list .mobile-group-title {
  font-size: 18px;
  font-weight: 600;
  margin: 24px 0 12px 0;
  color: #0f0f0f;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-faqs-list .mobile-faq-card {
  background: #f9f9f9;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-faqs-list .mobile-faq-card .mobile-faq-question {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-faqs-list .mobile-faq-card .mobile-faq-question mat-icon {
  color: #065fd4;
  font-size: 20px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-faqs-list .mobile-faq-card .mobile-faq-question span {
  font-size: 16px;
  font-weight: 600;
  color: #0f0f0f;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-faqs-list .mobile-faq-card .mobile-faq-answer {
  font-size: 14px;
  color: #606060;
  margin-bottom: 12px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-faqs-list .mobile-faq-card .mobile-faq-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-supporting-docs {
  margin-top: 24px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-supporting-docs .mobile-tab-group {
  margin-top: 16px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-supporting-docs .mobile-tab-content {
  padding: 16px 0;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-supporting-docs .mobile-file-name {
  font-size: 14px;
  color: #065fd4;
  margin: 8px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-supporting-docs .mobile-docs-list {
  margin-top: 16px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-supporting-docs .mobile-docs-list .mobile-doc-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f9f9f9;
  border-radius: 8px;
  margin-bottom: 8px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-supporting-docs .mobile-docs-list .mobile-doc-item mat-icon {
  color: #065fd4;
  flex-shrink: 0;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content .mobile-form-section .mobile-supporting-docs .mobile-docs-list .mobile-doc-item span {
  flex: 1;
  font-size: 14px;
  color: #0f0f0f;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content.summary-content .mobile-summary-view {
  padding: 16px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content.summary-content .mobile-summary-view .summary-section {
  margin-bottom: 32px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content.summary-content .mobile-summary-view .summary-section h4 {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 16px 0;
  color: #0f0f0f;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content.summary-content .mobile-summary-view .summary-section h5 {
  font-size: 16px;
  font-weight: 600;
  margin: 16px 0 8px 0;
  color: #0f0f0f;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content.summary-content .mobile-summary-view .summary-section img,
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content.summary-content .mobile-summary-view .summary-section video {
  width: 100%;
  max-height: 400px;
  object-fit: contain;
  border-radius: 8px;
  margin-bottom: 12px;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content.summary-content .mobile-summary-view .summary-section p {
  font-size: 14px;
  color: #606060;
  line-height: 1.6;
  margin: 8px 0;
}
.mobile-create-flow .mobile-main-content .mobile-expansion-panels .mobile-expansion-panel .mobile-panel-content.summary-content .mobile-summary-view .summary-section strong {
  color: #0f0f0f;
}
.mobile-create-flow .mobile-main-content .mobile-footer {
  display: flex;
  gap: 12px;
  padding: 16px;
  padding-bottom: max(16px, env(safe-area-inset-bottom));
  background: #fff;
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}
.mobile-create-flow .mobile-main-content .mobile-footer .mobile-footer-btn {
  flex: 1;
  padding: 14px 20px;
  border: none;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.mobile-create-flow .mobile-main-content .mobile-footer .mobile-footer-btn.secondary {
  background: #f1f1f1;
  color: #0f0f0f;
}
.mobile-create-flow .mobile-main-content .mobile-footer .mobile-footer-btn.secondary:active {
  background: #e0e0e0;
  transform: scale(0.98);
}
.mobile-create-flow .mobile-main-content .mobile-footer .mobile-footer-btn.primary {
  background: #065fd4;
  color: #fff;
}
.mobile-create-flow .mobile-main-content .mobile-footer .mobile-footer-btn.primary:active {
  background: #0550c1;
  transform: scale(0.98);
}
.mobile-create-flow .mobile-main-content .mobile-footer .mobile-footer-btn.primary:disabled {
  background: #ccc;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .upload-dialog.hide-on-mobile {
    display: none !important;
  }
}
.tagged-items-section {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}
.tagged-items-section ::ng-deep .mat-mdc-chip-set {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.tagged-items-section ::ng-deep .mat-mdc-chip {
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #e3f2fd !important;
  color: #1d67a3 !important;
  position: relative;
  padding-right: 8px !important;
}
.tagged-items-section ::ng-deep .mat-mdc-chip:hover {
  background-color: #bbdefb !important;
  transform: scale(1.05);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.tagged-items-section ::ng-deep .mat-mdc-chip .edit-chip-button {
  opacity: 0.7;
  transition: opacity 0.2s ease;
  color: #1d67a3 !important;
  padding: 0 !important;
  margin-left: 4px !important;
}
.tagged-items-section ::ng-deep .mat-mdc-chip .edit-chip-button:hover {
  opacity: 1;
  background-color: rgba(29, 103, 163, 0.1) !important;
}
.tagged-items-section ::ng-deep .mat-mdc-chip .edit-chip-button mat-icon {
  color: #1d67a3 !important;
}

.tagged-items-chips ::ng-deep .mat-mdc-chip {
  position: relative;
  padding-right: 8px !important;
}
.tagged-items-chips ::ng-deep .mat-mdc-chip .edit-chip-button {
  opacity: 0.7;
  transition: opacity 0.2s ease;
  color: #1d67a3 !important;
  padding: 0 !important;
  margin-left: 4px !important;
}
.tagged-items-chips ::ng-deep .mat-mdc-chip .edit-chip-button:hover {
  opacity: 1;
  background-color: rgba(29, 103, 163, 0.1) !important;
}
.tagged-items-chips ::ng-deep .mat-mdc-chip .edit-chip-button mat-icon {
  color: #1d67a3 !important;
}

/* Dark mode readability fixes for Create Flow */
:host-context(body.theme-dark) {
  /* Rephrase / AI action links â€” keep hyperlink appearance in dark mode */
}
:host-context(body.theme-dark) .upload-dialog {
  background: #0f172a !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .upload-header,
:host-context(body.theme-dark) .stage-banner,
:host-context(body.theme-dark) .upload-body,
:host-context(body.theme-dark) .journey-content,
:host-context(body.theme-dark) .section-card,
:host-context(body.theme-dark) .journey-card,
:host-context(body.theme-dark) .preview-card,
:host-context(body.theme-dark) .cover-form-wrapper,
:host-context(body.theme-dark) .flow-main-grid,
:host-context(body.theme-dark) .flow-main-content,
:host-context(body.theme-dark) .flow-sidebar.summary-preview-sidebar,
:host-context(body.theme-dark) .step-navigation,
:host-context(body.theme-dark) .step-panel-body,
:host-context(body.theme-dark) .description-section,
:host-context(body.theme-dark) .video-metadata,
:host-context(body.theme-dark) .channel-info-section {
  background: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog h1,
:host-context(body.theme-dark) .upload-dialog h2,
:host-context(body.theme-dark) .upload-dialog h3,
:host-context(body.theme-dark) .upload-dialog h4,
:host-context(body.theme-dark) .upload-dialog h5,
:host-context(body.theme-dark) .upload-dialog h6,
:host-context(body.theme-dark) .upload-dialog p,
:host-context(body.theme-dark) .upload-dialog span,
:host-context(body.theme-dark) .upload-dialog label,
:host-context(body.theme-dark) .upload-dialog li,
:host-context(body.theme-dark) .upload-dialog strong,
:host-context(body.theme-dark) .upload-dialog .step-title-text,
:host-context(body.theme-dark) .upload-dialog .step-description,
:host-context(body.theme-dark) .upload-dialog .video-title,
:host-context(body.theme-dark) .upload-dialog .video-title-sticky,
:host-context(body.theme-dark) .upload-dialog .channel-name,
:host-context(body.theme-dark) .upload-dialog .channel-meta {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .clickable-text {
  color: #5ea1d8 !important;
  text-decoration: underline !important;
  cursor: pointer;
}
:host-context(body.theme-dark) .upload-dialog .clickable-text:hover {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .upload-dialog .clickable-text .material-icons {
  color: inherit !important;
}
:host-context(body.theme-dark) .upload-dialog .mat-mdc-text-field-wrapper,
:host-context(body.theme-dark) .upload-dialog .mdc-text-field,
:host-context(body.theme-dark) .upload-dialog .mdc-text-field--outlined,
:host-context(body.theme-dark) .upload-dialog .mdc-text-field--filled,
:host-context(body.theme-dark) .upload-dialog input,
:host-context(body.theme-dark) .upload-dialog textarea,
:host-context(body.theme-dark) .upload-dialog select {
  background: #111827 !important;
  color: #f9fafb !important;
}
:host-context(body.theme-dark) .upload-dialog [style*="background-color: #f0f7ff"],
:host-context(body.theme-dark) .upload-dialog [style*="background: #f0f7ff"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color:#f0f7ff"],
:host-context(body.theme-dark) .upload-dialog [style*="background:#f0f7ff"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color: #e3f2fd"],
:host-context(body.theme-dark) .upload-dialog [style*="background: #e3f2fd"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color:#e3f2fd"],
:host-context(body.theme-dark) .upload-dialog [style*="background:#e3f2fd"] {
  background: rgba(30, 41, 59, 0.75) !important;
  background-color: rgba(30, 41, 59, 0.75) !important;
}
:host-context(body.theme-dark) .upload-dialog [style*="color: #333"],
:host-context(body.theme-dark) .upload-dialog [style*="color:#333"],
:host-context(body.theme-dark) .upload-dialog [style*="color: #666"],
:host-context(body.theme-dark) .upload-dialog [style*="color:#666"] {
  color: #f3f4f6 !important;
}

/* Strict no-white surfaces for all create-flow tabs in dark mode */
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-group,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-header,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-body-wrapper,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-body,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-body-content,
:host-context(body.theme-dark) .upload-dialog [role=tabpanel],
:host-context(body.theme-dark) .upload-dialog .quick-create-body,
:host-context(body.theme-dark) .upload-dialog .upload-section,
:host-context(body.theme-dark) .upload-dialog .items-section,
:host-context(body.theme-dark) .upload-dialog .steps-section,
:host-context(body.theme-dark) .upload-dialog .summary-section,
:host-context(body.theme-dark) .upload-dialog .upload-all-placeholder,
:host-context(body.theme-dark) .upload-dialog .cover-upload-placeholder,
:host-context(body.theme-dark) .upload-dialog .cover-preview,
:host-context(body.theme-dark) .upload-dialog .step-preview,
:host-context(body.theme-dark) .upload-dialog .pending-image-preview,
:host-context(body.theme-dark) .upload-dialog .item-card,
:host-context(body.theme-dark) .upload-dialog .faq-card,
:host-context(body.theme-dark) .upload-dialog .step-details-display,
:host-context(body.theme-dark) .upload-dialog .cover-details-display,
:host-context(body.theme-dark) .upload-footer,
:host-context(body.theme-dark) .mobile-footer,
:host-context(body.theme-dark) .upload-dialog .mobile-footer,
:host-context(body.theme-dark) .upload-dialog .upload-footer {
  background: #111827 !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog textarea,
:host-context(body.theme-dark) .upload-dialog .ql-container,
:host-context(body.theme-dark) .upload-dialog .ql-editor,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-form-field-focus-overlay,
:host-context(body.theme-dark) .upload-dialog ::ng-deep .mat-mdc-form-field-focus-overlay {
  background: #111827 !important;
  color: #f9fafb !important;
}
:host-context(body.theme-dark) .upload-dialog [style*="background: #fff"],
:host-context(body.theme-dark) .upload-dialog [style*="background:#fff"],
:host-context(body.theme-dark) .upload-dialog [style*="background: #ffffff"],
:host-context(body.theme-dark) .upload-dialog [style*="background:#ffffff"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color: #fff"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color:#fff"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color: #ffffff"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color:#ffffff"],
:host-context(body.theme-dark) .upload-dialog [style*="background: white"],
:host-context(body.theme-dark) .upload-dialog [style*="background:white"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color: white"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color:white"] {
  background: #111827 !important;
  background-color: #111827 !important;
}

/* Final page-scoped dark-mode hardening (Create Flow) */
:host-context(body.theme-dark) .upload-dialog {
  background: #0f172a !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .upload-header,
:host-context(body.theme-dark) .upload-dialog .stage-banner,
:host-context(body.theme-dark) .upload-dialog .upload-body,
:host-context(body.theme-dark) .upload-dialog .journey-content,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-group,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-header,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-body-wrapper,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-body,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-body-content,
:host-context(body.theme-dark) .upload-dialog [role=tabpanel],
:host-context(body.theme-dark) .upload-dialog .upload-section,
:host-context(body.theme-dark) .upload-dialog .items-section,
:host-context(body.theme-dark) .upload-dialog .steps-section,
:host-context(body.theme-dark) .upload-dialog .summary-section,
:host-context(body.theme-dark) .upload-dialog .flow-main-grid,
:host-context(body.theme-dark) .upload-dialog .flow-main-content,
:host-context(body.theme-dark) .upload-dialog .flow-sidebar.summary-preview-sidebar,
:host-context(body.theme-dark) .upload-dialog .step-navigation,
:host-context(body.theme-dark) .upload-dialog .step-panel-body,
:host-context(body.theme-dark) .upload-dialog .description-section,
:host-context(body.theme-dark) .upload-dialog .video-metadata,
:host-context(body.theme-dark) .upload-dialog .channel-info-section,
:host-context(body.theme-dark) .upload-dialog .upload-footer,
:host-context(body.theme-dark) .upload-dialog .mobile-footer,
:host-context(body.theme-dark) .upload-dialog .upload-all-placeholder,
:host-context(body.theme-dark) .upload-dialog .cover-upload-placeholder,
:host-context(body.theme-dark) .upload-dialog .cover-preview,
:host-context(body.theme-dark) .upload-dialog .step-preview,
:host-context(body.theme-dark) .upload-dialog .pending-image-preview,
:host-context(body.theme-dark) .upload-dialog .item-card,
:host-context(body.theme-dark) .upload-dialog .faq-card,
:host-context(body.theme-dark) .upload-dialog .step-details-display,
:host-context(body.theme-dark) .upload-dialog .cover-details-display {
  background: #111827 !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .upload-dialog textarea,
:host-context(body.theme-dark) .upload-dialog input,
:host-context(body.theme-dark) .upload-dialog select,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-text-field-wrapper,
:host-context(body.theme-dark) .upload-dialog .mdc-text-field,
:host-context(body.theme-dark) .upload-dialog .mdc-text-field--outlined,
:host-context(body.theme-dark) .upload-dialog .mdc-text-field--filled,
:host-context(body.theme-dark) .upload-dialog .ql-container,
:host-context(body.theme-dark) .upload-dialog .ql-toolbar,
:host-context(body.theme-dark) .upload-dialog .ql-editor {
  background: #111827 !important;
  color: #f9fafb !important;
}

/* Manual mode specific dark-mode fixes: price toggle row + mat-label + icon shells + editor/text areas */
:host-context(body.theme-dark) .upload-dialog .form-label-wrapper .form-label,
:host-context(body.theme-dark) .upload-dialog .form-label {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog mat-form-field ::ng-deep .mat-mdc-form-field-label,
:host-context(body.theme-dark) .upload-dialog mat-form-field ::ng-deep .mat-mdc-floating-label,
:host-context(body.theme-dark) .upload-dialog mat-form-field ::ng-deep mat-label {
  color: #94a3b8 !important;
}

:host-context(body.theme-dark) .upload-dialog .icon-circle,
:host-context(body.theme-dark) .upload-dialog .icon-button,
:host-context(body.theme-dark) .upload-dialog .create-type-button,
:host-context(body.theme-dark) .upload-dialog .header-right .icon-button,
:host-context(body.theme-dark) .upload-dialog button.icon-button {
  background: #1f2937 !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .upload-dialog .icon-button:hover,
:host-context(body.theme-dark) .upload-dialog button.icon-button:hover {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .quill-field,
:host-context(body.theme-dark) .upload-dialog .quill-wrapper,
:host-context(body.theme-dark) .upload-dialog .quill-editor,
:host-context(body.theme-dark) .upload-dialog .ql-toolbar,
:host-context(body.theme-dark) .upload-dialog .ql-container,
:host-context(body.theme-dark) .upload-dialog .ql-editor,
:host-context(body.theme-dark) .upload-dialog textarea,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-form-field-textarea-control,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-input-element {
  background: #111827 !important;
  color: #f9fafb !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .upload-dialog ::ng-deep .ql-toolbar button,
:host-context(body.theme-dark) .upload-dialog ::ng-deep .ql-toolbar .ql-stroke {
  color: #e5e7eb !important;
  stroke: #e5e7eb !important;
}
:host-context(body.theme-dark) .upload-dialog ::ng-deep .ql-editor.ql-blank::before {
  color: #94a3b8 !important;
}

/* Dark mode â€“ Items section surfaces (items-list-modern, item-card-modern, group headers) */
:host-context(body.theme-dark) .upload-dialog .items-list-modern {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .item-card-modern {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3) !important;
}
:host-context(body.theme-dark) .upload-dialog .item-card-modern:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4) !important;
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .upload-dialog .item-image-wrapper {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .mobile-item-placeholder {
  background: #1e293b !important;
  color: #64748b !important;
}
:host-context(body.theme-dark) .upload-dialog .mobile-item-name {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .mobile-label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .mobile-item-quantity {
  background: #1e3a5f !important;
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .upload-dialog .group-header-line {
  background: linear-gradient(135deg, #1e293b 0%, #111827 100%) !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .group-title-block .group-icon {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .group-title-block .group-title,
:host-context(body.theme-dark) .upload-dialog .group-title-block h4 {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .group-count-chip {
  background: #1e293b !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .item-value.group-header {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .item-drag-handle {
  color: #4b5563 !important;
}
:host-context(body.theme-dark) .upload-dialog .items-section .section-subtitle {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .items-section .upload-multiple-section {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.4) !important;
}

/* Dark mode â€“ buttons, chips, step nav, action pills, tagged chips (Guided / Create Flow) */
:host-context(body.theme-dark) .upload-dialog .footer-btn.secondary,
:host-context(body.theme-dark) .footer-btn.secondary {
  background: #1e293b !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .upload-dialog .footer-btn.secondary:hover:not(:disabled),
:host-context(body.theme-dark) .footer-btn.secondary:hover:not(:disabled) {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .footer-btn.ghost,
:host-context(body.theme-dark) .footer-btn.ghost {
  color: #7ab8e8 !important;
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .upload-dialog .footer-btn.ghost:hover:not(:disabled),
:host-context(body.theme-dark) .footer-btn.ghost:hover:not(:disabled) {
  background: rgba(94, 161, 216, 0.12) !important;
}
:host-context(body.theme-dark) .upload-dialog .mobile-footer {
  background: #111827 !important;
  border-top-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .mobile-footer .mobile-footer-btn.secondary {
  background: #1e293b !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .mobile-footer .mobile-footer-btn.secondary:active {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .info-badge,
:host-context(body.theme-dark) .info-badge {
  background: #1e293b !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .upload-dialog .info-badge:hover,
:host-context(body.theme-dark) .info-badge:hover {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .info-badge .info-step-title,
:host-context(body.theme-dark) .info-badge .info-step-title {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .step-btn,
:host-context(body.theme-dark) .step-btn {
  background: #1e293b !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .step-btn .step-number,
:host-context(body.theme-dark) .upload-dialog .step-btn .step-title-text,
:host-context(body.theme-dark) .step-btn .step-number,
:host-context(body.theme-dark) .step-btn .step-title-text {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .step-btn:hover:not(.active),
:host-context(body.theme-dark) .step-btn:hover:not(.active) {
  background: #334155 !important;
  border-color: rgba(148, 163, 184, 0.5) !important;
}
:host-context(body.theme-dark) .upload-dialog .tagged-items-section ::ng-deep .mat-mdc-chip,
:host-context(body.theme-dark) .tagged-items-section ::ng-deep .mat-mdc-chip {
  background-color: #1e3a5f !important;
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .upload-dialog .tagged-items-section ::ng-deep .mat-mdc-chip:hover,
:host-context(body.theme-dark) .tagged-items-section ::ng-deep .mat-mdc-chip:hover {
  background-color: #1e4976 !important;
}
:host-context(body.theme-dark) .upload-dialog .tagged-items-section ::ng-deep .mat-mdc-chip .edit-chip-button,
:host-context(body.theme-dark) .tagged-items-section ::ng-deep .mat-mdc-chip .edit-chip-button {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .upload-dialog .tagged-items-section ::ng-deep .mat-mdc-chip .edit-chip-button mat-icon,
:host-context(body.theme-dark) .tagged-items-section ::ng-deep .mat-mdc-chip .edit-chip-button mat-icon {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .upload-dialog .tagged-items-section ::ng-deep .mat-mdc-chip .edit-chip-button:hover,
:host-context(body.theme-dark) .tagged-items-section ::ng-deep .mat-mdc-chip .edit-chip-button:hover {
  background-color: rgba(122, 184, 232, 0.15) !important;
}
:host-context(body.theme-dark) .upload-dialog .tagged-items-chips ::ng-deep .mat-mdc-chip .edit-chip-button,
:host-context(body.theme-dark) .tagged-items-chips ::ng-deep .mat-mdc-chip .edit-chip-button {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .upload-dialog .tagged-items-chips ::ng-deep .mat-mdc-chip .edit-chip-button mat-icon,
:host-context(body.theme-dark) .tagged-items-chips ::ng-deep .mat-mdc-chip .edit-chip-button mat-icon {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .upload-dialog .expand-description-btn,
:host-context(body.theme-dark) .expand-description-btn {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .expand-description-btn:hover,
:host-context(body.theme-dark) .expand-description-btn:hover {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .summary-card {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .journey-step,
:host-context(body.theme-dark) .journey-step {
  background: transparent !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) .upload-dialog .step-connector {
  background: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .upload-dialog .step-connector.fill {
  background: #16a34a !important;
}
:host-context(body.theme-dark) .upload-dialog .journey-step:not(.active):not(.complete) {
  color: #64748b !important;
}
:host-context(body.theme-dark) .upload-dialog .journey-step:not(.active):not(.complete) .step-label {
  border-color: #64748b !important;
  background: transparent !important;
  color: #64748b !important;
}
:host-context(body.theme-dark) .upload-dialog .journey-step:not(.active):not(.complete) .step-count,
:host-context(body.theme-dark) .upload-dialog .journey-step:not(.active):not(.complete) .label-text {
  color: #64748b !important;
}
:host-context(body.theme-dark) .upload-dialog .journey-step.complete,
:host-context(body.theme-dark) .journey-step.complete {
  color: #4ade80 !important;
}
:host-context(body.theme-dark) .upload-dialog .journey-step.complete .step-label,
:host-context(body.theme-dark) .journey-step.complete .step-label {
  background: rgba(22, 163, 74, 0.15) !important;
  color: #4ade80 !important;
  border-color: #16a34a !important;
}
:host-context(body.theme-dark) .upload-dialog .journey-step.complete .step-count,
:host-context(body.theme-dark) .upload-dialog .journey-step.complete .label-text,
:host-context(body.theme-dark) .upload-dialog .journey-step.complete .label-check,
:host-context(body.theme-dark) .journey-step.complete .step-count,
:host-context(body.theme-dark) .journey-step.complete .label-text,
:host-context(body.theme-dark) .journey-step.complete .label-check {
  color: #4ade80 !important;
}
:host-context(body.theme-dark) .upload-dialog .action-item {
  background: #1e293b !important;
}
:host-context(body.theme-dark) .upload-dialog .action-item:hover:not(.disabled) {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .action-item span {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .action-item mat-icon {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .journey-toolbar {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .btn-secondary,
:host-context(body.theme-dark) .btn-secondary {
  background: #1e293b !important;
  color: #f3f4f6 !important;
  border: 1px solid rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .upload-dialog .btn-secondary:hover:not(:disabled),
:host-context(body.theme-dark) .btn-secondary:hover:not(:disabled) {
  background: #334155 !important;
}

/* Dark mode â€“ cover image container (.table-inner) and cover-form-wrapper children */
:host-context(body.theme-dark) .upload-dialog .cover-form-wrapper .table-inner,
:host-context(body.theme-dark) .cover-form-wrapper .table-inner {
  background: #0f172a !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .cover-form-wrapper .table-inner p.text-center,
:host-context(body.theme-dark) .cover-form-wrapper .table-inner p.text-center {
  color: #64748b !important;
}
:host-context(body.theme-dark) .upload-dialog .cover-form-wrapper h3,
:host-context(body.theme-dark) .cover-form-wrapper h3 {
  color: #f3f4f6 !important;
}

/* Dark mode â€“ cover tab: upload button, thumbnail choices, supporting list, placeholders */
:host-context(body.theme-dark) .upload-dialog .cover-meta {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .cover-meta .description-text {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .upload-icon-btn {
  background: #1e3a5f !important;
  color: #7ab8e8 !important;
  box-shadow: inset 0 0 0 1px rgba(122, 184, 232, 0.2) !important;
}
:host-context(body.theme-dark) .upload-dialog .upload-icon-btn.light {
  background: #1e293b !important;
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .upload-icon-btn:hover {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.35) !important;
}
:host-context(body.theme-dark) .upload-dialog .upload-icon-btn mat-icon {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .upload-dialog .supporting-list {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .supporting-list__label {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .supporting-list li {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .upload-dialog .upload-placeholder-compact {
  background: #1e293b !important;
}
:host-context(body.theme-dark) .upload-dialog .upload-placeholder-compact mat-icon {
  color: #64748b !important;
}
:host-context(body.theme-dark) .upload-dialog .upload-placeholder-compact span {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .upload-label-compact mat-icon {
  color: #64748b !important;
}
:host-context(body.theme-dark) .upload-dialog .upload-label-compact span {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .thumbnail-choice {
  background: #1e293b !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .upload-dialog .thumbnail-choice.selected {
  background: rgba(94, 161, 216, 0.1) !important;
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .upload-dialog .thumbnail-choice:hover:not(.disabled) {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .choice-icon {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .choice-text small {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .extracted-frames-section {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .extracted-frames-section h6 {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .extracted-frames-section .frames-subtitle {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .example-list {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .example-box {
  background: #1e293b !important;
  box-shadow: inset 0 0 0 1px rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .upload-dialog .summary-cover-placeholder,
:host-context(body.theme-dark) .summary-cover-placeholder {
  background: #1e293b !important;
  color: #64748b !important;
}
:host-context(body.theme-dark) .upload-dialog .faq-modal-card,
:host-context(body.theme-dark) .faq-modal-card {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .faq-modal-header,
:host-context(body.theme-dark) .faq-modal-header {
  border-bottom-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .faq-modal-header h4,
:host-context(body.theme-dark) .faq-modal-header h4 {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog [style*="background-color: #f0f7ff"],
:host-context(body.theme-dark) .upload-dialog [style*="background:#f0f7ff"] {
  background-color: #1e293b !important;
  border-left-color: #5ea1d8 !important;
}

/* Dark mode â€“ Summary/step/FAQ cards: title-description panels and inner blocks */
:host-context(body.theme-dark) .upload-dialog .summary-card,
:host-context(body.theme-dark) .summary-card {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4) !important;
}
:host-context(body.theme-dark) .upload-dialog .summary-card .summary-card-header h3,
:host-context(body.theme-dark) .summary-card .summary-card-header h3 {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .summary-card .summary-card-header p,
:host-context(body.theme-dark) .summary-card .summary-card-header p {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .summary-items-block,
:host-context(body.theme-dark) .summary-items-block {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .summary-items-block .summary-block-title h4,
:host-context(body.theme-dark) .summary-items-block .summary-block-title h4 {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .summary-items-block .summary-block-title span,
:host-context(body.theme-dark) .summary-items-block .summary-block-title span {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .summary-step-panel,
:host-context(body.theme-dark) .summary-step-panel {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .summary-step-panel .summary-step-heading,
:host-context(body.theme-dark) .summary-step-panel .summary-step-heading {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .step-chip,
:host-context(body.theme-dark) .step-chip {
  background: #1e3a5f !important;
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .upload-dialog .summary-step-chip,
:host-context(body.theme-dark) .summary-step-chip {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .summary-step-chip.active,
:host-context(body.theme-dark) .summary-step-chip.active {
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .upload-dialog .summary-step-chip .step-chip-number,
:host-context(body.theme-dark) .upload-dialog .summary-step-chip .step-chip-title,
:host-context(body.theme-dark) .summary-step-chip .step-chip-number,
:host-context(body.theme-dark) .summary-step-chip .step-chip-title {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .summary-faq-block,
:host-context(body.theme-dark) .summary-faq-block {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .summary-faq-block .summary-faq-header,
:host-context(body.theme-dark) .summary-faq-block .summary-faq-header {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .summary-faq-item,
:host-context(body.theme-dark) .summary-faq-item {
  border-top-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .upload-dialog .mobile-section-title,
:host-context(body.theme-dark) .mobile-section-title {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .mobile-section-description,
:host-context(body.theme-dark) .mobile-section-description {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .upload-dialog .mobile-section-description p, :host-context(body.theme-dark) .upload-dialog .mobile-section-description span, :host-context(body.theme-dark) .upload-dialog .mobile-section-description li, :host-context(body.theme-dark) .upload-dialog .mobile-section-description strong, :host-context(body.theme-dark) .upload-dialog .mobile-section-description em,
:host-context(body.theme-dark) .mobile-section-description p,
:host-context(body.theme-dark) .mobile-section-description span,
:host-context(body.theme-dark) .mobile-section-description li,
:host-context(body.theme-dark) .mobile-section-description strong,
:host-context(body.theme-dark) .mobile-section-description em {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .upload-dialog .selected-step-details,
:host-context(body.theme-dark) .selected-step-details {
  background: transparent !important;
}
:host-context(body.theme-dark) .upload-dialog .selected-step-details .mobile-step-header h3,
:host-context(body.theme-dark) .selected-step-details .mobile-step-header h3 {
  color: #f3f4f6 !important;
}

/* Dark mode â€“ Cover summary, Items summary, FAQ tab, Summary tab surfaces */
:host-context(body.theme-dark) .upload-dialog .summary-info-pills .info-badge,
:host-context(body.theme-dark) .upload-dialog .summary-info-pills .summary-pill,
:host-context(body.theme-dark) .summary-info-pills .info-badge,
:host-context(body.theme-dark) .summary-info-pills .summary-pill {
  background: #1e293b !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .upload-dialog .summary-info-pills.secondary .summary-pill,
:host-context(body.theme-dark) .summary-info-pills.secondary .summary-pill {
  background: #1e3a5f !important;
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .upload-dialog .preview-card,
:host-context(body.theme-dark) .preview-card {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .preview-card .flow-info-panel,
:host-context(body.theme-dark) .preview-card .flow-info-panel {
  background: #0f172a !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
  scrollbar-color: #334155 #0f172a !important;
}
:host-context(body.theme-dark) .upload-dialog .preview-card .flow-info-panel .info-badge,
:host-context(body.theme-dark) .preview-card .flow-info-panel .info-badge {
  background: #1e293b !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .upload-dialog .preview-card .flow-info-panel .info-badge:hover,
:host-context(body.theme-dark) .preview-card .flow-info-panel .info-badge:hover {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .preview-card .flow-info-panel .info-badge.active,
:host-context(body.theme-dark) .preview-card .flow-info-panel .info-badge.active {
  background: #5ea1d8 !important;
  color: #ffffff !important;
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .upload-dialog .preview-card .mobile-section,
:host-context(body.theme-dark) .preview-card .mobile-section {
  background: #0f172a !important;
}
:host-context(body.theme-dark) .upload-dialog .preview-card .mobile-section .mobile-media.placeholder,
:host-context(body.theme-dark) .preview-card .mobile-section .mobile-media.placeholder {
  background: #1e293b !important;
}
:host-context(body.theme-dark) .upload-dialog .preview-card .mobile-items-view .mobile-items-list,
:host-context(body.theme-dark) .preview-card .mobile-items-view .mobile-items-list {
  background: #0f172a !important;
}
:host-context(body.theme-dark) .upload-dialog .preview-card .mobile-item-card,
:host-context(body.theme-dark) .preview-card .mobile-item-card {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .preview-card .mobile-faqs-view .mobile-faq-item,
:host-context(body.theme-dark) .preview-card .mobile-faqs-view .mobile-faq-item {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .preview-card .mobile-faqs-view .mobile-faq-item .mobile-faq-question,
:host-context(body.theme-dark) .preview-card .mobile-faqs-view .mobile-faq-item .mobile-faq-question {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .preview-card .mobile-faqs-view .mobile-faq-item .mobile-faq-question span,
:host-context(body.theme-dark) .preview-card .mobile-faqs-view .mobile-faq-item .mobile-faq-question span {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .preview-card .mobile-faqs-view .mobile-faq-item .mobile-faq-question mat-icon,
:host-context(body.theme-dark) .preview-card .mobile-faqs-view .mobile-faq-item .mobile-faq-question mat-icon {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .upload-dialog .preview-card .mobile-faqs-view .mobile-faq-item .show-answer-btn,
:host-context(body.theme-dark) .preview-card .mobile-faqs-view .mobile-faq-item .show-answer-btn {
  background: #1e3a5f !important;
  color: #7ab8e8 !important;
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .upload-dialog .preview-card .mobile-faqs-view .mobile-faq-item .show-answer-btn:hover,
:host-context(body.theme-dark) .preview-card .mobile-faqs-view .mobile-faq-item .show-answer-btn:hover {
  background: #5ea1d8 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .upload-dialog .group-title-small,
:host-context(body.theme-dark) .group-title-small {
  color: #f3f4f6 !important;
  border-bottom-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .item-preview,
:host-context(body.theme-dark) .item-preview {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .item-preview .item-preview-image.placeholder,
:host-context(body.theme-dark) .item-preview .item-preview-image.placeholder {
  background: #334155 !important;
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .item-preview .item-preview-name,
:host-context(body.theme-dark) .item-preview .item-preview-name {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .item-preview .item-preview-quantity,
:host-context(body.theme-dark) .item-preview .item-preview-quantity {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .summary-item-card-modern,
:host-context(body.theme-dark) .summary-item-card-modern {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .summary-item-card-modern:hover,
:host-context(body.theme-dark) .summary-item-card-modern:hover {
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .upload-dialog .summary-item-image-modern,
:host-context(body.theme-dark) .summary-item-image-modern {
  background: #334155 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .step-nav-chip,
:host-context(body.theme-dark) .step-nav-chip {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .upload-dialog .step-nav-chip .chip-step-title,
:host-context(body.theme-dark) .step-nav-chip .chip-step-title {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .example-list,
:host-context(body.theme-dark) .upload-dialog .example-list.faq-list-container,
:host-context(body.theme-dark) .example-list,
:host-context(body.theme-dark) .example-list.faq-list-container {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .example-list .example-box,
:host-context(body.theme-dark) .example-list .example-box {
  background: #1e293b !important;
  border-bottom-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .upload-dialog .empty-state,
:host-context(body.theme-dark) .empty-state {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .empty-state p,
:host-context(body.theme-dark) .empty-state p {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .transfer-toggle-section,
:host-context(body.theme-dark) .transfer-toggle-section {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .transfer-toggle-section .toggle-label,
:host-context(body.theme-dark) .transfer-toggle-section .toggle-label {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .transfer-toggle-section .toggle-description,
:host-context(body.theme-dark) .transfer-toggle-section .toggle-description {
  background: rgba(94, 161, 216, 0.12) !important;
  border-left-color: #5ea1d8 !important;
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .upload-dialog .transfer-toggle-section .toggle-description .info-icon,
:host-context(body.theme-dark) .transfer-toggle-section .toggle-description .info-icon {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .upload-dialog .transfer-toggle-section .toggle-description.warning,
:host-context(body.theme-dark) .transfer-toggle-section .toggle-description.warning {
  background: rgba(255, 193, 7, 0.1) !important;
  border-left-color: #ffc107 !important;
  color: #fcd34d !important;
}
:host-context(body.theme-dark) .upload-dialog .transfer-toggle-section .selected-user-info,
:host-context(body.theme-dark) .transfer-toggle-section .selected-user-info {
  background: rgba(40, 167, 69, 0.12) !important;
  border-left-color: #28a745 !important;
}
:host-context(body.theme-dark) .upload-dialog .mobile-summary-view .summary-section h4,
:host-context(body.theme-dark) .upload-dialog .mobile-summary-view .summary-section h5,
:host-context(body.theme-dark) .upload-dialog .mobile-summary-view .summary-section strong,
:host-context(body.theme-dark) .mobile-summary-view .summary-section h4,
:host-context(body.theme-dark) .mobile-summary-view .summary-section h5,
:host-context(body.theme-dark) .mobile-summary-view .summary-section strong {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .mobile-summary-view .summary-section p,
:host-context(body.theme-dark) .mobile-summary-view .summary-section p {
  color: #94a3b8 !important;
}

/* Dark mode â€“ Items, FAQ, and Steps tab surfaces */
:host-context(body.theme-dark) .upload-dialog .cdk-drag-placeholder {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .action-btn,
:host-context(body.theme-dark) .action-btn {
  background: #1e293b !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .upload-dialog .action-btn:hover,
:host-context(body.theme-dark) .action-btn:hover {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .example-list .example-box .item-avatar,
:host-context(body.theme-dark) .journey-content .example-list .example-box .item-avatar {
  background: #1e293b !important;
}
:host-context(body.theme-dark) .upload-dialog .example-list .example-box .item-name,
:host-context(body.theme-dark) .journey-content .example-list .example-box .item-name {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .example-list .example-box .item-value,
:host-context(body.theme-dark) .journey-content .example-list .example-box .item-value {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .example-list .example-box .row-actions .icon-button,
:host-context(body.theme-dark) .journey-content .example-list .example-box .row-actions .icon-button {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .example-list .example-box .row-actions .icon-button:hover,
:host-context(body.theme-dark) .journey-content .example-list .example-box .row-actions .icon-button:hover {
  color: #f3f4f6 !important;
  background: rgba(148, 163, 184, 0.12) !important;
}
:host-context(body.theme-dark) .upload-dialog .faq-row .faq-content .faq-question-row .faq-question,
:host-context(body.theme-dark) .faq-row .faq-content .faq-question-row .faq-question {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .faq-modal-value,
:host-context(body.theme-dark) .faq-modal-value {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .upload-dialog .cover-form-wrapper .quill-wrapper,
:host-context(body.theme-dark) .cover-form-wrapper .quill-wrapper {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .cover-form-wrapper .quill-wrapper ::ng-deep .ql-toolbar,
:host-context(body.theme-dark) .cover-form-wrapper .quill-wrapper ::ng-deep .ql-toolbar {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .cover-form-wrapper .quill-wrapper ::ng-deep .ql-container,
:host-context(body.theme-dark) .cover-form-wrapper .quill-wrapper ::ng-deep .ql-container {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .cover-form-wrapper .quill-wrapper ::ng-deep .ql-editor,
:host-context(body.theme-dark) .cover-form-wrapper .quill-wrapper ::ng-deep .ql-editor {
  background: #111827 !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .example-stepList,
:host-context(body.theme-dark) .example-stepList {
  background: #111827 !important;
}
:host-context(body.theme-dark) .upload-dialog .example-stepList .step-card,
:host-context(body.theme-dark) .upload-dialog .step-card,
:host-context(body.theme-dark) .example-stepList .step-card,
:host-context(body.theme-dark) .step-card {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3) !important;
}
:host-context(body.theme-dark) .upload-dialog .example-stepList .step-card .step-header .step-file,
:host-context(body.theme-dark) .example-stepList .step-card .step-header .step-file {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .example-stepList .step-card .step-header .step-title,
:host-context(body.theme-dark) .upload-dialog .step-card .step-title,
:host-context(body.theme-dark) .example-stepList .step-card .step-header .step-title,
:host-context(body.theme-dark) .step-card .step-title {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .example-stepList .step-card .step-description,
:host-context(body.theme-dark) .upload-dialog .step-card .step-description,
:host-context(body.theme-dark) .example-stepList .step-card .step-description,
:host-context(body.theme-dark) .step-card .step-description {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .upload-dialog .example-stepList .step-card .step-actions .square_btn.ghost,
:host-context(body.theme-dark) .upload-dialog .step-card .step-actions .square_btn.ghost,
:host-context(body.theme-dark) .example-stepList .step-card .step-actions .square_btn.ghost,
:host-context(body.theme-dark) .step-card .step-actions .square_btn.ghost {
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .upload-dialog .example-stepList .step-card .step-actions .square_btn.ghost:hover,
:host-context(body.theme-dark) .upload-dialog .step-card .step-actions .square_btn.ghost:hover,
:host-context(body.theme-dark) .example-stepList .step-card .step-actions .square_btn.ghost:hover,
:host-context(body.theme-dark) .step-card .step-actions .square_btn.ghost:hover {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .yt-button,
:host-context(body.theme-dark) .yt-button {
  background: #1e293b !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .upload-dialog .yt-button:hover,
:host-context(body.theme-dark) .yt-button:hover {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .thumbnail-dialog-card,
:host-context(body.theme-dark) .thumbnail-dialog-card {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .thumbnail-dialog-card h4, :host-context(body.theme-dark) .upload-dialog .thumbnail-dialog-card h5, :host-context(body.theme-dark) .upload-dialog .thumbnail-dialog-card h6, :host-context(body.theme-dark) .upload-dialog .thumbnail-dialog-card p, :host-context(body.theme-dark) .upload-dialog .thumbnail-dialog-card span,
:host-context(body.theme-dark) .thumbnail-dialog-card h4,
:host-context(body.theme-dark) .thumbnail-dialog-card h5,
:host-context(body.theme-dark) .thumbnail-dialog-card h6,
:host-context(body.theme-dark) .thumbnail-dialog-card p,
:host-context(body.theme-dark) .thumbnail-dialog-card span {
  color: #f3f4f6 !important;
}

/* Dark mode â€“ Summary tab: items list polished styling */
:host-context(body.theme-dark) .upload-dialog .video-player-section .item,
:host-context(body.theme-dark) .video-player-section .item {
  background: #111827 !important;
}
:host-context(body.theme-dark) .upload-dialog .item-value.group-header,
:host-context(body.theme-dark) .item-value.group-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #1e293b 100%) !important;
  color: #7ab8e8 !important;
  padding: 8px 12px !important;
  border-radius: 8px !important;
  border: 1px solid rgba(94, 161, 216, 0.25) !important;
  margin-bottom: 8px !important;
}
:host-context(body.theme-dark) .upload-dialog .item-value.group-header b,
:host-context(body.theme-dark) .item-value.group-header b {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .upload-dialog .example-list .example-box,
:host-context(body.theme-dark) .example-list .example-box {
  background: #1e293b !important;
  border-bottom-color: rgba(148, 163, 184, 0.15) !important;
  transition: background 0.15s ease;
}
:host-context(body.theme-dark) .upload-dialog .example-list .example-box:hover,
:host-context(body.theme-dark) .example-list .example-box:hover {
  background: #263548 !important;
}
:host-context(body.theme-dark) .upload-dialog .example-list .example-box .item-name, :host-context(body.theme-dark) .upload-dialog .example-list .example-box a, :host-context(body.theme-dark) .upload-dialog .example-list .example-box span:not(.item-value),
:host-context(body.theme-dark) .example-list .example-box .item-name,
:host-context(body.theme-dark) .example-list .example-box a,
:host-context(body.theme-dark) .example-list .example-box span:not(.item-value) {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .example-list .example-box .item-value,
:host-context(body.theme-dark) .example-list .example-box .item-value {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .example-list .example-box img,
:host-context(body.theme-dark) .example-list .example-box img {
  border: 2px solid rgba(148, 163, 184, 0.3) !important;
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .item-table hr,
:host-context(body.theme-dark) .item-table hr {
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .upload-dialog .copy-link-container,
:host-context(body.theme-dark) .copy-link-container {
  background: #1e293b !important;
  border: 1px solid rgba(148, 163, 184, 0.3) !important;
  border-radius: 8px !important;
}
:host-context(body.theme-dark) .upload-dialog .copy-link-container:hover,
:host-context(body.theme-dark) .copy-link-container:hover {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .copy-link-container .copy-link-text,
:host-context(body.theme-dark) .copy-link-container .copy-link-text {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .copy-link-container .share-icon, :host-context(body.theme-dark) .upload-dialog .copy-link-container mat-icon,
:host-context(body.theme-dark) .copy-link-container .share-icon,
:host-context(body.theme-dark) .copy-link-container mat-icon {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .upload-dialog [style*="background: #f3f4f6"],
:host-context(body.theme-dark) .upload-dialog [style*="background:#f3f4f6"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color: #f3f4f6"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color:#f3f4f6"] {
  background: #1e293b !important;
  background-color: #1e293b !important;
}
:host-context(body.theme-dark) .upload-dialog .example-list ::ng-deep .mat-mdc-checkbox .mdc-checkbox__background,
:host-context(body.theme-dark) .example-list ::ng-deep .mat-mdc-checkbox .mdc-checkbox__background {
  background-color: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.5) !important;
}
:host-context(body.theme-dark) .upload-dialog .example-list ::ng-deep .mat-mdc-checkbox.mat-mdc-checkbox-checked .mdc-checkbox__background,
:host-context(body.theme-dark) .example-list ::ng-deep .mat-mdc-checkbox.mat-mdc-checkbox-checked .mdc-checkbox__background {
  background-color: #5ea1d8 !important;
  border-color: #5ea1d8 !important;
}

/* Dark mode â€“ Summary tab left column + FAQ tab missing surfaces */
:host-context(body.theme-dark) .upload-dialog .flow-title-sticky,
:host-context(body.theme-dark) .flow-title-sticky {
  background: #111827 !important;
  border-bottom-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-title-sticky .video-title-sticky,
:host-context(body.theme-dark) .flow-title-sticky .video-title-sticky {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-main-content .flow-info-panel,
:host-context(body.theme-dark) .flow-main-content .flow-info-panel {
  background: #0f172a !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
  scrollbar-color: #334155 #0f172a !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-main-content .flow-info-panel .info-badge,
:host-context(body.theme-dark) .flow-main-content .flow-info-panel .info-badge {
  background: #1e293b !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-main-content .flow-info-panel .info-badge:hover,
:host-context(body.theme-dark) .flow-main-content .flow-info-panel .info-badge:hover {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-main-content .flow-info-panel .info-badge.active,
:host-context(body.theme-dark) .flow-main-content .flow-info-panel .info-badge.active {
  background: #5ea1d8 !important;
  color: #ffffff !important;
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .upload-dialog .group-title,
:host-context(body.theme-dark) .group-title {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .faq-row .show-answer-btn,
:host-context(body.theme-dark) .upload-dialog .faq-content .show-answer-btn,
:host-context(body.theme-dark) .faq-row .show-answer-btn,
:host-context(body.theme-dark) .faq-content .show-answer-btn {
  background: #1e3a5f !important;
  color: #7ab8e8 !important;
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .upload-dialog .faq-row .show-answer-btn:hover,
:host-context(body.theme-dark) .upload-dialog .faq-content .show-answer-btn:hover,
:host-context(body.theme-dark) .faq-row .show-answer-btn:hover,
:host-context(body.theme-dark) .faq-content .show-answer-btn:hover {
  background: #5ea1d8 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .upload-dialog .journey-pane-header p,
:host-context(body.theme-dark) .journey-pane-header p {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-main-content .description-section,
:host-context(body.theme-dark) .flow-main-content .description-section {
  background: #0f172a !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-main-content .description-section h3, :host-context(body.theme-dark) .upload-dialog .flow-main-content .description-section .duration-timer,
:host-context(body.theme-dark) .flow-main-content .description-section h3,
:host-context(body.theme-dark) .flow-main-content .description-section .duration-timer {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-main-content .description-section .description-content,
:host-context(body.theme-dark) .flow-main-content .description-section .description-content {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-main-content .description-section .expand-description-btn,
:host-context(body.theme-dark) .flow-main-content .description-section .expand-description-btn {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-main-content .description-section .expand-description-btn:hover,
:host-context(body.theme-dark) .flow-main-content .description-section .expand-description-btn:hover {
  color: #f3f4f6 !important;
}

/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
   Dark mode â€“ Summary tab: full two-tone UI overhaul
   Color 1 (base):     #111827  â€” main backgrounds, containers
   Color 2 (elevated): #1e293b  â€” cards, buttons, raised surfaces
   â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
:host-context(body.theme-dark) .upload-dialog .video-metadata,
:host-context(body.theme-dark) .video-metadata {
  border-bottom-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .upload-dialog .video-metadata .video-title,
:host-context(body.theme-dark) .video-metadata .video-title {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .video-metadata .s-num,
:host-context(body.theme-dark) .video-metadata .s-num {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .video-metadata .share-icon,
:host-context(body.theme-dark) .video-metadata .share-icon {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .video-metadata .copy-link-container,
:host-context(body.theme-dark) .video-metadata .copy-link-container {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .video-metadata .copy-link-container .copy-link-text,
:host-context(body.theme-dark) .video-metadata .copy-link-container .copy-link-text {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .video-metadata .video-actions-bar .action-buttons .action-item,
:host-context(body.theme-dark) .video-metadata .video-actions-bar .action-buttons .action-item {
  background: #1e293b !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .video-metadata .video-actions-bar .action-buttons .action-item mat-icon,
:host-context(body.theme-dark) .video-metadata .video-actions-bar .action-buttons .action-item mat-icon {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .video-metadata .video-actions-bar .action-buttons .action-item span,
:host-context(body.theme-dark) .video-metadata .video-actions-bar .action-buttons .action-item span {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .video-metadata .video-actions-bar .action-buttons .action-item:hover:not(.disabled),
:host-context(body.theme-dark) .video-metadata .video-actions-bar .action-buttons .action-item:hover:not(.disabled) {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .channel-info-section,
:host-context(body.theme-dark) .channel-info-section {
  border-bottom-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .upload-dialog .channel-info-section .channel-avatar .material-icons,
:host-context(body.theme-dark) .channel-info-section .channel-avatar .material-icons {
  color: #64748b !important;
}
:host-context(body.theme-dark) .upload-dialog .channel-info-section .channel-name,
:host-context(body.theme-dark) .channel-info-section .channel-name {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .channel-info-section .channel-name:hover,
:host-context(body.theme-dark) .channel-info-section .channel-name:hover {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .channel-info-section .channel-meta,
:host-context(body.theme-dark) .channel-info-section .channel-meta {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .channel-info-section .channel-meta mat-icon,
:host-context(body.theme-dark) .channel-info-section .channel-meta mat-icon {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .video-player-section .item,
:host-context(body.theme-dark) .video-player-section .item {
  background: #111827 !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-sidebar .step-btn,
:host-context(body.theme-dark) .flow-sidebar .step-btn {
  background: #1e293b !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-sidebar .step-btn .step-number,
:host-context(body.theme-dark) .flow-sidebar .step-btn .step-number {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-sidebar .step-btn .step-title-text,
:host-context(body.theme-dark) .flow-sidebar .step-btn .step-title-text {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-sidebar .step-btn:hover:not([class*=active]),
:host-context(body.theme-dark) .flow-sidebar .step-btn:hover:not([class*=active]) {
  background: #334155 !important;
  border-color: rgba(148, 163, 184, 0.45) !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-sidebar .step-panel.active .step-btn,
:host-context(body.theme-dark) .flow-sidebar .step-panel.active .step-btn {
  background: #5ea1d8 !important;
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-sidebar .step-panel.active .step-btn .step-number,
:host-context(body.theme-dark) .upload-dialog .flow-sidebar .step-panel.active .step-btn .step-title-text,
:host-context(body.theme-dark) .flow-sidebar .step-panel.active .step-btn .step-number,
:host-context(body.theme-dark) .flow-sidebar .step-panel.active .step-btn .step-title-text {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-sidebar .step-panel-body,
:host-context(body.theme-dark) .flow-sidebar .step-panel-body {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-sidebar .step-panel-body .step-description,
:host-context(body.theme-dark) .upload-dialog .flow-sidebar .step-panel-body .summary-step-description,
:host-context(body.theme-dark) .flow-sidebar .step-panel-body .step-description,
:host-context(body.theme-dark) .flow-sidebar .step-panel-body .summary-step-description {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-sidebar .step-panel-body div[style*="border-left: 4px solid #d32f2f"],
:host-context(body.theme-dark) .flow-sidebar .step-panel-body div[style*="border-left: 4px solid #d32f2f"] {
  background: rgba(211, 47, 47, 0.1) !important;
}
:host-context(body.theme-dark) .upload-dialog .status-pill,
:host-context(body.theme-dark) .status-pill {
  background: #1e3a5f !important;
  color: #7ab8e8 !important;
  border: 1px solid #5ea1d8 !important;
}
:host-context(body.theme-dark) .current-access-pill {
  background: #1a2c3d !important;
  color: #7ec8f0 !important;
}
:host-context(body.theme-dark) .approval-comment-input {
  background: #1b1f27 !important;
  border-color: #2f3542 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .approval-review {
  background: #13202e !important;
  border-color: rgba(94, 161, 216, 0.35) !important;
}
:host-context(body.theme-dark) .approval-review .approval-review__label {
  color: #7ec8f0 !important;
}
:host-context(body.theme-dark) .approval-btn--reject {
  background: transparent !important;
  color: #fda29b !important;
  border-color: rgba(240, 68, 56, 0.45) !important;
}
:host-context(body.theme-dark) .current-access-pill.approval-state-pill[data-state=InReview] {
  background: rgba(181, 71, 8, 0.2) !important;
  color: #fdba74 !important;
}
:host-context(body.theme-dark) .current-access-pill.approval-state-pill[data-state=Approved], :host-context(body.theme-dark) .current-access-pill.approval-state-pill[data-state=Published] {
  background: rgba(18, 183, 106, 0.16) !important;
  color: #75e0a7 !important;
}
:host-context(body.theme-dark) .current-access-pill.approval-state-pill[data-state=Rejected] {
  background: rgba(240, 68, 56, 0.16) !important;
  color: #fda29b !important;
}
:host-context(body.theme-dark) .mobile-current-access-bar {
  background: #1a2c3d !important;
  border-bottom-color: rgba(94, 161, 216, 0.35) !important;
}
:host-context(body.theme-dark) .mobile-access-icon-wrap {
  background: #16324a !important;
}
:host-context(body.theme-dark) .mobile-access-icon-wrap mat-icon {
  color: #7ec8f0 !important;
}
:host-context(body.theme-dark) .mobile-access-copy .mobile-access-kicker {
  color: #7ec8f0 !important;
}
:host-context(body.theme-dark) .mobile-access-copy strong {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-sidebar .step-scroll,
:host-context(body.theme-dark) .flow-sidebar .step-scroll {
  scrollbar-color: #334155 #111827 !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-sidebar .step-scroll::-webkit-scrollbar-track,
:host-context(body.theme-dark) .flow-sidebar .step-scroll::-webkit-scrollbar-track {
  background: #111827 !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-sidebar .step-scroll::-webkit-scrollbar-thumb,
:host-context(body.theme-dark) .flow-sidebar .step-scroll::-webkit-scrollbar-thumb {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-sidebar .step-scroll::-webkit-scrollbar-thumb:hover,
:host-context(body.theme-dark) .flow-sidebar .step-scroll::-webkit-scrollbar-thumb:hover {
  background: #475569 !important;
}

/* Dark mode â€“ FAQ details modal (rendered outside .upload-dialog) */
:host-context(body.theme-dark) .faq-modal-card {
  background: #111827 !important;
  border: 1px solid rgba(148, 163, 184, 0.28) !important;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6) !important;
}
:host-context(body.theme-dark) .faq-modal-header {
  background: #111827 !important;
  border-bottom-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .faq-modal-header h4 {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .faq-modal-header .icon-button {
  background: #1e293b !important;
  color: #f3f4f6 !important;
  border: 1px solid rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .faq-modal-header .icon-button mat-icon {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .faq-modal-header .icon-button:hover {
  background: #334155 !important;
}
:host-context(body.theme-dark) .faq-modal-body {
  background: #111827 !important;
}
:host-context(body.theme-dark) .faq-modal-label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .faq-modal-value {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .faq-modal-question .faq-modal-value {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .faq-modal-answer .faq-modal-value {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .faq-modal-answer .faq-modal-value p, :host-context(body.theme-dark) .faq-modal-answer .faq-modal-value span, :host-context(body.theme-dark) .faq-modal-answer .faq-modal-value li, :host-context(body.theme-dark) .faq-modal-answer .faq-modal-value strong, :host-context(body.theme-dark) .faq-modal-answer .faq-modal-value em, :host-context(body.theme-dark) .faq-modal-answer .faq-modal-value a {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .faq-modal-group .faq-modal-value {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .faq-modal-footer {
  background: #111827 !important;
  border-top-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .faq-modal-footer .close-btn {
  background: #1e293b !important;
  color: #f3f4f6 !important;
  border: 1px solid rgba(148, 163, 184, 0.35) !important;
  border-radius: 8px !important;
}
:host-context(body.theme-dark) .faq-modal-footer .close-btn:hover {
  background: #334155 !important;
}

.duration-input-group {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  width: 100%;
}
.duration-input-group .duration-unit-field {
  width: 120px;
  flex-shrink: 0;
}
.duration-input-group .duration-value-field {
  flex: 1;
}

/* Dark mode â€“ Supporting doc added: edit / delete / view-link buttons */
:host-context(body.theme-dark) .doc-name {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .doc-url {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .link-pill {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .link-pill mat-icon {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .link-pill:hover {
  background: #334155 !important;
}
:host-context(body.theme-dark) .icon-only {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .icon-only mat-icon {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .icon-only:hover {
  background: #334155 !important;
}
:host-context(body.theme-dark) .icon-only:hover mat-icon {
  color: #e2e8f0 !important;
}

::ng-deep .access-menu-current {
  margin-left: 8px;
  font-size: 11px;
  font-weight: 600;
  color: #1976d2;
}

.journey-access-type-row {
  margin-bottom: 16px;
  text-align: left;
  width: 100%;
  max-width: 100%;
}

.journey-access-option-list {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  margin-top: 10px;
  width: 100%;
  max-width: 100%;
}
@media (min-width: 992px) {
  .journey-access-option-list {
    flex-direction: row;
    align-items: stretch;
    gap: 10px;
  }
}

.journey-access-option {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  text-align: left;
  border: 1px solid #d7dee8;
  border-radius: 12px;
  background: #fff;
  color: #1e293b;
  padding: 14px 16px;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}
.journey-access-option:hover:not(:disabled) {
  border-color: #93c5e8;
  background: #f8fbfe;
}
.journey-access-option.selected {
  border-color: #5ea1d8;
  background: #eef6fc;
  box-shadow: inset 0 0 0 1px #5ea1d8;
}
.journey-access-option:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
@media (min-width: 992px) {
  .journey-access-option {
    flex: 1 1 0;
    min-width: 0;
    align-items: center;
    gap: 8px;
    padding: 12px 14px;
  }
}

.journey-access-option-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  font-size: 24px;
  line-height: 24px;
  overflow: visible;
  color: #5ea1d8;
  margin-top: 0;
}

.journey-access-option-copy {
  flex: 1 1 auto;
  min-width: 0;
}
.journey-access-option-copy strong {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  line-height: 24px;
}
.journey-access-option-copy p {
  margin: 4px 0 0;
  font-size: 13px;
  line-height: 1.4;
  color: #64748b;
}
@media (min-width: 992px) {
  .journey-access-option-copy strong {
    font-size: 13px;
    line-height: 24px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .journey-access-option-copy p {
    display: none;
  }
}

.journey-access-option-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  font-size: 22px;
  line-height: 22px;
  overflow: visible;
  color: #5ea1d8;
  margin-top: 0;
}

.journey-restricted-panel {
  margin-top: 16px;
  width: 100%;
  max-width: 100%;
  text-align: left;
  max-height: none;
  overflow: visible;
  padding-bottom: 24px;
}

.access-journey-card .journey-content {
  width: 100%;
}
.access-journey-card .cover-form-wrapper.journey-access-type-row,
.access-journey-card .journey-restricted-panel,
.access-journey-card app-enhanced-restricted-access {
  display: block;
  width: 100%;
  max-width: 100%;
}

.viewer-features-panel {
  margin-top: 24px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
}
.viewer-features-panel h5 {
  margin: 0 0 6px;
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
}
.viewer-features-panel .viewer-features-hint {
  margin: 0 0 14px;
  font-size: 13px;
  line-height: 1.45;
  color: #64748b;
}
.viewer-features-panel .viewer-features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 10px 16px;
}
.viewer-features-panel .viewer-features-grid mat-slide-toggle {
  font-size: 13px;
}

.preview-card .mobile-section.access-summary-preview,
.access-summary-preview {
  overflow: visible;
}
.preview-card .mobile-section.access-summary-preview .access-summary-badge,
.access-summary-preview .access-summary-badge {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.preview-card .mobile-section.access-summary-preview .access-summary-badge .access-summary-kicker,
.access-summary-preview .access-summary-badge .access-summary-kicker {
  display: block;
  margin-bottom: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94a3b8;
}
.preview-card .mobile-section.access-summary-preview .access-summary-badge .access-summary-title-row,
.access-summary-preview .access-summary-badge .access-summary-title-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
  min-height: 22px;
}
.preview-card .mobile-section.access-summary-preview .access-summary-badge .access-summary-title-row mat-icon,
.access-summary-preview .access-summary-badge .access-summary-title-row mat-icon {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  flex: 0 0 20px;
  width: 20px !important;
  height: 20px !important;
  font-size: 20px !important;
  line-height: 20px !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: visible;
  color: #5ea1d8;
  /* Optical nudge: Material glyphs sit slightly high next to text */
  transform: translateY(1px);
}
.preview-card .mobile-section.access-summary-preview .access-summary-badge .access-summary-title-row strong,
.access-summary-preview .access-summary-badge .access-summary-title-row strong {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #0f172a;
}
.preview-card .mobile-section.access-summary-preview .access-summary-badge mat-icon,
.access-summary-preview .access-summary-badge mat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  font-size: 20px;
  line-height: 20px;
  overflow: visible;
  color: #5ea1d8;
}
.preview-card .mobile-section.access-summary-preview .access-summary-badge strong,
.access-summary-preview .access-summary-badge strong {
  display: block;
  min-width: 0;
  font-size: 14px;
  line-height: 20px;
  color: #0f172a;
}
.preview-card .mobile-section.access-summary-preview .access-summary-badge p,
.access-summary-preview .access-summary-badge p {
  margin: 2px 0 0;
  font-size: 13px;
  color: #64748b;
  line-height: 1.4;
}
.preview-card .mobile-section.access-summary-preview .access-summary-original,
.access-summary-preview .access-summary-original {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #e2e8f0;
}
.preview-card .mobile-section.access-summary-preview .access-summary-original .access-summary-kicker,
.access-summary-preview .access-summary-original .access-summary-kicker {
  display: block;
  margin-bottom: 2px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94a3b8;
}
.preview-card .mobile-section.access-summary-preview .access-summary-original strong,
.access-summary-preview .access-summary-original strong {
  display: block;
  font-size: 13px;
  color: #334155;
}
.preview-card .mobile-section.access-summary-preview .access-summary-original p,
.access-summary-preview .access-summary-original p {
  margin: 4px 0 0;
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
}
.preview-card .mobile-section.access-summary-preview .access-summary-original .access-restore-btn,
.access-summary-preview .access-summary-original .access-restore-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  padding: 6px 12px;
  border: 1px solid #5ea1d8;
  border-radius: 6px;
  background: transparent;
  color: #5ea1d8;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.preview-card .mobile-section.access-summary-preview .access-summary-original .access-restore-btn mat-icon,
.access-summary-preview .access-summary-original .access-restore-btn mat-icon {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  flex: 0 0 16px;
  width: 16px !important;
  height: 16px !important;
  font-size: 16px !important;
  line-height: 16px !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: visible;
  transform: translateY(0.5px);
}
.preview-card .mobile-section.access-summary-preview .access-summary-original .access-restore-btn:hover,
.access-summary-preview .access-summary-original .access-restore-btn:hover {
  background: #5ea1d8;
  color: #fff;
}
.preview-card .mobile-section.access-summary-preview .access-summary-meta,
.access-summary-preview .access-summary-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}
.preview-card .mobile-section.access-summary-preview .access-summary-meta span,
.access-summary-preview .access-summary-meta span {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  background: #eef6fc;
  color: #1e4d72;
  font-size: 12px;
  font-weight: 600;
}

.flows-sequence-hint.muted {
  margin-top: 8px;
  color: #6b7280;
  font-size: 13px;
  text-align: left;
}

.access-original-inline {
  margin-top: 16px;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
}
.access-original-inline .access-summary-kicker {
  display: block;
  margin-bottom: 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94a3b8;
}
.access-original-inline .access-summary-title-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
}
.access-original-inline .access-summary-title-row mat-icon {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  flex: 0 0 20px;
  width: 20px !important;
  height: 20px !important;
  font-size: 20px !important;
  line-height: 20px !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: visible;
  color: #5ea1d8;
  transform: translateY(1px);
}
.access-original-inline .access-summary-title-row strong {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #0f172a;
}
.access-original-inline > p {
  margin: 4px 0 0;
  font-size: 13px;
  line-height: 1.4;
  color: #64748b;
}
.access-original-inline .access-summary-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}
.access-original-inline .access-summary-meta span {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  background: #eef6fc;
  color: #1e4d72;
  font-size: 12px;
  font-weight: 600;
}
.access-original-inline .access-restore-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  padding: 8px 14px;
  border: 1px solid #5ea1d8;
  border-radius: 6px;
  background: transparent;
  color: #5ea1d8;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.access-original-inline .access-restore-btn mat-icon {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  flex: 0 0 16px;
  width: 16px !important;
  height: 16px !important;
  font-size: 16px !important;
  line-height: 16px !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: visible;
  transform: translateY(0.5px);
}
.access-original-inline .access-restore-btn:hover {
  background: #5ea1d8;
  color: #fff;
}

.creator-access-notice .upgrade-free-link {
  margin-left: 4px;
  border: none;
  background: none;
  padding: 0;
  color: #5ea1d8;
  font-weight: 700;
  font-size: 0.85rem;
  cursor: pointer;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/create-flow/create-flow.component.scss","webpack://./src/app/shared/styles/_publishing-state.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,cAAA;AAEF;;AACA;;EAEE,oBAAA;EACA,mBAAA;EACA,mBAAA;AAEF;;AACA;EACE,qBAAA;EACA,cAAA;EACA,kCAAA;AAEF;;AACA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAEF;;AACA;EACE,eAAA;EACA,oBAAA;AAEF;;AACA;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EAEA,8DAAA;EAEA,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,YAAA;EAEA,kEAAA;AACF;;AAEA;EACE,sBAAA;EACA,eAAA;EAEA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,oCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAAF;AACE;EACE,sBAAA;AACJ;AAEE;EACE,8BAAA;EACA,yBAAA;AAAJ;;AAIA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AADF;;AAIA;EACE,UAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4CAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AADF;;AAIA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADF;AAEE;EACE,cAAA;EACA,eAAA;AAAJ;;AAIA;EACE,YAAA;AADF;AAEE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AAAJ;AAEE;EACE,eAAA;EACA,cAAA;AAAJ;;AAIA;EACE,aAAA;AADF;;AAIA;EACE;IACE,aAAA;IACA,mBAAA;IACA,SAAA;IACA,WAAA;IACA,sBAAA;IACA,SAAA;IACA,kBAAA;IACA,mBAAA;IACA,iDAAA;EADF;EAIA;IACE,WAAA;IACA,YAAA;IACA,mBAAA;IACA,mBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,cAAA;EAFF;EAIE;IACE,cAAA;IACA,oBAAA;IACA,mBAAA;IACA,uBAAA;IACA,eAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;IACA,iBAAA;EAFJ;EAMA;IACE,YAAA;IACA,aAAA;IACA,sBAAA;IACA,QAAA;EAJF;EAME;IACE,eAAA;IACA,gBAAA;IACA,sBAAA;IACA,yBAAA;IACA,cAAA;EAJJ;EAOE;IACE,cAAA;IACA,eAAA;IACA,gBAAA;IACA,cAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;EALJ;AACF;AASA;EACE,YAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,qDAAA;EACA,kBAAA;EACA,cAAA;AAPF;AAQE;EACE,eAAA;AANJ;AAQE;EACE,mBAAA;EACA,2BAAA;AANJ;;AAUA;EACE,iBAAA;AAPF;;AAYE;EACE,cAAA;AATJ;AAYE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAVJ;AAYI;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAVN;AAaI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;AAXN;AAaM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AAXR;AAcM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAZR;AAgBI;EACE,6BAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,oBAAA;EACA,UAAA;EACA,uBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,6CAAA;EACA,oBAAA;AAdN;AAiBI;EACE,mBAAA;AAfN;;AAoBA;EACE,qBAAA;EACA,gBAAA;EACA,gCAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AAjBF;AAkBE;EACE,eAAA;EACA,cAAA;AAhBJ;;AAoBA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;AAjBF;AAoBE;EACE,UAAA;AAlBJ;AAqBE;EACE,mBAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,mBAAA;EACA,kBAAA;AApBJ;AAsBI;EACE,mBAAA;AApBN;;AA2BA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAxBF;AA0BE;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;AAxBJ;;AA4BA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAzBF;;AA4BA;EACE,0BAAA;EACA,iBAAA;AAzBF;;AA4BA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAzBF;;AA4BA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAzBF;AA2BE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAzBJ;;AA6BA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA1BF;AA4BE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AA1BJ;;AAgCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA7BF;;AAgCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBAAA;EACA,gDAAA;AA7BF;AA+BE;EACE,qBAAA;EACA,6CAAA;AA7BJ;AAgCE;EACE,mBAAA;AA9BJ;;AAkCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,2BAAA;AA/BF;;AAkCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6DAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;AA/BF;;AAkCA;EACE,OAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA/BF;;AAkCA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA/BF;;AAkCA;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iCAAA;AA/BF;;AAkCA;EACE;IAAO,UAAA;IAAY,2BAAA;EA7BnB;EA8BA;IAAO,UAAA;IAAY,wBAAA;EA1BnB;AACF;AA4BA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AA1BF;AA4BE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA1BJ;AA6BE;EAAkB,mBAAA;EAAqB,cAAA;AAzBzC;AA0BE;EAAkB,mBAAA;EAAqB,cAAA;AAtBzC;AAuBE;EAAkB,mBAAA;EAAqB,cAAA;AAnBzC;AAoBE;EAAkB,mBAAA;EAAqB,cAAA;AAhBzC;;AAmBA;EACE,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,cAAA;EACA,WAAA;AAhBF;AAkBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAhBJ;AAmBE;EAAU,cAAA;AAhBZ;;AAqBE;EACE,mBAAA;EACA,qBAAA;AAlBJ;AAoBI;EAAU,qBAAA;EAAuB,8CAAA;AAhBrC;AAmBE;EAAyB,cAAA;AAhB3B;AAiBE;EAAyB,cAAA;AAd3B;AAiBI;EAAkB,mBAAA;EAAqB,cAAA;AAb3C;AAcI;EAAkB,mBAAA;EAAqB,cAAA;AAV3C;AAWI;EAAkB,mBAAA;EAAqB,cAAA;AAP3C;AAQI;EAAkB,mBAAA;EAAqB,cAAA;AAJ3C;AAOE;EAAuB,cAAA;AAJzB;AAIyC;EAAU,cAAA;AADnD;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AAHF;AAKE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAHJ;;AASA;EACE,kBAAA;AANF;;AASA;EACE,kBAAA;EACA,sBAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yCAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,4BAAA;AANF;AAQE;EAAe,mBAAA;AALjB;AAME;EAAU,mBAAA;AAHZ;AAKE;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AAHJ;;AAOA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAJF;AAME;EACE,eAAA;EACA,cAAA;AAJJ;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AALF;;AAQA;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;AALF;;AAQA;EACE,eAAA;EACA,WAAA;AALF;;AAQA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AALF;;AAQA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AALF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAPF;AASE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;AAPJ;AAUE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AARJ;AAWE;EACE,eAAA;EACA,cAAA;AATJ;AAYE;EACE,eAAA;EACA,WAAA;EACA,kBAAA;AAVJ;AAaE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAXJ;AAaI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAXN;AAeE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;AAbJ;AAgBE;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AAdJ;AAgBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;AAdN;AAkBE;EACE,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,cAAA;EACA,cAAA;AAhBJ;AAkBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAhBN;;AAyBE;;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;AArBJ;AAwBE;;EACE,aAAA;EACA,mBAAA;AArBJ;AAwBE;;EACE,eAAA;AArBJ;;AA0BE;EACE,oCAAA;EACA,sCAAA;EACA,cAAA;AAvBJ;AA0BE;EACE,qCAAA;EACA,sCAAA;EACA,cAAA;AAxBJ;AA0BI;EACE,cAAA;AAxBN;AA4BE;EACE,mCAAA;EACA,oCAAA;EACA,cAAA;AA1BJ;AA6BE;EACE,sBAAA;AA3BJ;AA8BE;EACE,mBAAA;EACA,kBAAA;EACA,yCAAA;AA5BJ;AA8BI;EACE,4BAAA;AA5BN;AA6BM;EAAU,mBAAA;AA1BhB;AA8BE;EAAsB,cAAA;AA3BxB;AA4BE;EAAuB,cAAA;AAzBzB;AA0BE;EAAqB,cAAA;AAvBvB;AAyBE;EACE,mBAAA;AAvBJ;AAwBI;EAAW,cAAA;AArBf;AAwBE;EACE,mCAAA;EACA,oCAAA;AAtBJ;AAwBI;EAAoB,cAAA;AArBxB;AAsBI;EAAqB,cAAA;AAnBzB;AAoBI;EAAoB,cAAA;AAjBxB;;AC75BA;EACE,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;ADg6BF;AC95BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;ADg6BJ;AC95BI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;ADg6BN;AC75BI;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AD+5BN;AC95BM;EAAW,cAAA;ADi6BjB;AC95BI;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;ADg6BN;AC/5BM;EAAW,cAAA;ADk6BjB;AC95BE;EAAU,OAAA;ADi6BZ;AC/5BE;EACE,cAAA;EACA,eAAA;EACA,YAAA;ADi6BJ;AC95BE;EACE,iBAAA;EACA,8BAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;ADg6BJ;AC95BI;EAAa,YAAA;EAAc,eAAA;ADk6B/B;;AC75BA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;ADg6BF;AC95BE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;ADg6BJ;AC75BE;EAEE,kCAAA;AD85BJ;;AC15BA;EACE,cAAA;AD65BF;;ACz5BE;EACE,mCAAA;EACA,qCAAA;EACA,cAAA;AD45BJ;AC35BI;EAAW,cAAA;AD85Bf;AC55BE;EACE,mCAAA;EACA,qCAAA;EACA,cAAA;AD85BJ;AC75BI;EAAW,cAAA;ADg6Bf;;AAlFA;EACE,oBAAA;AAqFF;AAnFE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAqFJ;AAnFI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAqFN;AAlFI;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AAoFN;AAnFM;EAAW,cAAA;AAsFjB;AAnFI;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AAqFN;AApFM;EAAW,cAAA;AAuFjB;AApFI;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AAsFN;AArFM;EAAW,cAAA;AAwFjB;;AAjFE;EACE,oCAAA;EACA,sCAAA;EACA,cAAA;AAoFJ;AAnFI;EAAW,cAAA;AAsFf;AApFE;EACE,mCAAA;EACA,qCAAA;EACA,cAAA;AAsFJ;AArFI;EAAW,cAAA;AAwFf;AAtFE;EACE,mCAAA;EACA,qCAAA;EACA,cAAA;AAwFJ;AAvFI;EAAW,cAAA;AA0Ff;;AArFA;EACE,kBAAA;EACA,6BAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,8CAAA;EACA,cAAA;AAwFF;AAtFE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAwFJ;;AApFA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;AAuFF;;AApFA,yFAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAuFF;;AApFA;;EAEE,oBAAA;AAuFF;;AApFA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAuFF;AArFE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAuFJ;AApFE;EAEE,cAAA;EACA,mCAAA;AAqFJ;;AAjFA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAoFF;AAlFE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAoFJ;AAlFI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAoFN;;AA/EA;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;AAkFF;AAhFE;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAkFJ;;AA9EA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,oFAAA;AAiFF;AA/EE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAiFJ;AA9EE;EACE,mBAAA;EACA,WAAA;AAgFJ;AA9EI;EACE,mBAAA;EACA,6CAAA;AAgFN;AA5EE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AA8EJ;AA5EI;EACE,mBAAA;EACA,qBAAA;AA8EN;AA1EE;EACE,YAAA;EACA,mBAAA;AA4EJ;;AAvEE;EACE,mBAAA;EACA,cAAA;AA0EJ;AAvEE;EAEE,mBAAA;EACA,cAAA;AAwEJ;AArEE;EACE,mBAAA;EACA,cAAA;AAuEJ;;AAnEA;EACE;IACE,eAAA;IACA,WAAA;IACA,sBAAA;EAsEF;EApEE;IACE,cAAA;IACA,eAAA;IACA,QAAA;EAsEJ;EAnEE;IACE,WAAA;IACA,QAAA;EAqEJ;AACF;AAjEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAmEF;AAjEE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AAmEJ;;AA/DA;EACE,kBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,sBAAA;AAkEF;AAhEE;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AAkEJ;AAhEI;EACE,mBAAA;AAkEN;AA9DE;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAgEJ;AA9DI;EACE,mBAAA;AAgEN;AA5DE;EACE,uBAAA;EACA,cAAA;EACA,qBAAA;AA8DJ;AA5DI;EACE,oCAAA;AA8DN;AA1DE;EACE,aAAA;EACA,mBAAA;AA4DJ;;AAxDA;EACE,qBAAA;EACA,cAAA;AA2DF;AAzDE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA2DJ;AAxDE;EACE,mCAAA;AA0DJ;;AAtDA;EACE,gBAAA;EACA,oBAAA;EACA,iBAAA;AAyDF;;AAtDA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AAyDF;AAvDE;EACE,cAAA;EACA,eAAA;AAyDJ;AArDE;EACE,aAAA;EACA,YAAA;EACA,eAAA;AAuDJ;;AAnDA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAsDF;AApDE;EACE,eAAA;EACA,gBAAA;AAsDJ;;AAlDA;EACE,WAAA;EACA,UAAA;EACA,SAAA;AAqDF;AAnDE;EACE,aAAA;EACA,2CAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;AAqDJ;AAnDI;EARF;IASI,iBAAA;IACA,cAAA;IACA,kBAAA;EAsDJ;AACF;AApDI;EAdF;IAeI,0BAAA;IACA,SAAA;IACA,aAAA;EAuDJ;AACF;AArDI;EApBF;IAqBI,aAAA;IACA,SAAA;EAwDJ;AACF;;AApDA;EACE,YAAA;AAuDF;AArDE;EACE,mBAAA;EACA,gCAAA;EACA,qBAAA;EACA,kBAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,8BAAA;AAuDJ;AArDI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,kCAAA;EACA,OAAA;EACA,YAAA;AAuDN;AAnDE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,qBAAA;EACA,6BAAA;AAqDJ;AAnDI;EACE,WAAA;AAqDN;AAlDI;EACE,mBAAA;EACA,kBAAA;AAoDN;AAjDI;EACE,gBAAA;EACA,kBAAA;AAmDN;AAjDM;EACE,gBAAA;AAmDR;AA/CI;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,2BAAA;EAAA,sBAAA;AAiDN;AA/CM;EACE,mBAAA;EACA,qBAAA;AAiDR;AA9CM;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AAgDR;AA9CQ;;;EAGE,WAAA;AAgDV;AA5CM;EACE,eAAA;EACA,cAAA;EACA,cAAA;AA8CR;AA3CM;EACE,kCAAA;EACA,cAAA;EACA,eAAA;AA6CR;AA1CM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kCAAA;AA4CR;AA1CQ;EAVF;IAWI,aAAA;EA6CR;AACF;AAzCI;EA/FF;IAgGI,QAAA;IACA,kBAAA;EA4CJ;EA1CI;IACE,eAAA;IACA,iBAAA;IACA,kCAAA;EA4CN;EA1CM;IACE,eAAA;EA4CR;AACF;AAvCE;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAyCJ;AAvCI;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AAyCN;AAvCM;;EAEE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AAyCR;AAtCM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAwCR;AArCM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,mBAAA;EACA,gBAAA;AAuCR;AAnCI;EACE,aAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AAqCN;AAlCI;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AAoCN;AAlCM;;EAEE,mBAAA;EACA,+BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,2CAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,0CAAA;EACA,SAAA;AAoCR;AAlCQ;;EACE,8BAAA;EACA,2BAAA;AAqCV;AAlCQ;;;EAEE,aAAA;AAqCV;AAlCQ;;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AAqCV;AAjCM;EACE,kBAAA;EACA,cAAA;AAmCR;AAhCM;EACE,iBAAA;EACA,eAAA;AAkCR;AAzBQ;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AA2BV;AAzBU;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AA2BZ;;AAnBA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AAsBF;AApBE;;EAEE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAsBJ;AAnBE;EACE,eAAA;AAqBJ;AApBI;EACE,mBAAA;EACA,cAAA;AAsBN;;AAjBA,gFAAA;AAEA;EACE,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,QAAA;AAmBF;AAjBE;EACE,eAAA;AAmBJ;;AAfA,2EAAA;AACA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAkBF;AAhBE;EAVF;IAWI,WAAA;IACA,eAAA;IACA,eAAA;EAmBF;AACF;AAjBE;EACE,mBAAA;EACA,cAAA;EACA,aAAA;AAmBJ;AAjBI;EAEE,uEAAA;EAcA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AAKN;AAnBM;EANF;IAOI,qBAAA;EAsBN;AACF;AAlBM;EAZF;IAaI,yCAAA;EAqBN;AACF;AAbM;EACE,UAAA;AAeR;AAZM;EACE,mBAAA;EACA,kBAAA;AAcR;AAXM;EACE,gBAAA;EACA,kBAAA;AAaR;AAXQ;EACE,gBAAA;AAaV;AARI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,oBAAA;AAUN;AAPI;EACE,cAAA;EACA,WAAA;AASN;AANI;EACE,WAAA;AAQN;AALI;EACE,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;AAON;AALM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;AAOR;AAJM;EACE,gBAAA;AAMR;AAHM;EACE,OAAA;EACA,gBAAA;AAKR;AAFM;EACE,mBAAA;EACA,qBAAA;AAIR;AAAI;EACE,8BAAA;EACA,yBAAA;EACA,uBAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;EACA,8BAAA;EACA,wBAAA;EACA,2BAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;AAEN;AAAM;;EAEE,yBAAA;AAER;AACM;EACE,8BAAA;EACA,uBAAA;EACA,wBAAA;EACA,2BAAA;AACR;;AAKA,sDAAA;AACA;EACE,eAAA;EACA,gCAAA;EACA,mBAAA;AAFF;AAIE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;AAFJ;AAII;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AAFN;AAKI;EACE,cAAA;AAHN;AAMI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AAJN;AAOI;EACE,eAAA;EACA,cAAA;EACA,cAAA;AALN;AASE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;AAPJ;AASI;EACE,WAAA;AAPN;AAUI;EACE,8BAAA;EACA,kBAAA;AARN;AAWI;EACE,8BAAA;AATN;AAYI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;AAVN;AAYM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;AAVR;AAYQ;EACE,mBAAA;AAVV;AAaQ;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;AAXV;AAcQ;EACE,eAAA;AAZV;;AAmBA,oDAAA;AACA;EACE,eAAA;EACA,gCAAA;EACA,mBAAA;AAhBF;AAkBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAhBJ;AAkBI;EACE,cAAA;AAhBN;AAkBM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAhBR;AAmBM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAjBR;AAqBI;EACE,OAAA;EACA,YAAA;AAnBN;AAqBM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAnBR;AAqBQ;EACE,cAAA;AAnBV;AAuBM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AArBR;AAuBQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;AArBV;AAwBQ;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAtBV;AAyBQ;EACE,gBAAA;EACA,cAAA;AAvBV;AA4BI;EACE,aAAA;EACA,eAAA;EACA,SAAA;AA1BN;AA4BM;;EAEE,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AA1BR;AA6BM;EACE,mBAAA;EACA,WAAA;AA3BR;AA8BM;EACE,mBAAA;EACA,WAAA;AA5BR;;AAkCA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AA/BF;AAiCE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;AA/BJ;AAiCI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AA/BN;AAmCE;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;AAjCJ;AAmCI;EACE,gBAAA;AAjCN;AAoCI;EACE,gBAAA;AAlCN;AAoCM;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;AAlCR;AAoCQ;EACE,0BAAA;AAlCV;AAwCE;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AAtCJ;AAwCI;EACE,cAAA;AAtCN;;AA2CA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,8CAAA;AAxCF;AA0CE;EAGE,mBAAA;AA1CJ;AA6CE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AA3CJ;AA6CI;EACE,cAAA;AA3CN;AA8CI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AA5CN;AA+CI;EACE,eAAA;EACA,cAAA;EACA,eAAA;AA7CN;;AAkDA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA/CF;AAiDE;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AA/CJ;AAiDI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AA/CN;AAiDM;EACE,SAAA;EACA,eAAA;AA/CR;AAkDM;EACE,cAAA;EACA,eAAA;AAhDR;AAoDI;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAlDN;AAoDM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AAlDR;AAoDQ;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,qBAAA;AAlDV;;AAyDA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAtDF;AAwDE;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;AAtDJ;AAwDI;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;AAtDN;AAwDM;EACE,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAtDR;AAyDM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAvDR;AA2DI;EACE,cAAA;AAzDN;AA2DM;;EAEE,mBAAA;EACA,WAAA;EACA,cAAA;AAzDR;AA6DI;EACE,eAAA;EACA,cAAA;AA3DN;;AAgEA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AA7DF;;AAgEA;EACE,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AA7DF;AA+DE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AA7DJ;AAgEE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA9DJ;AAiEE;EACE,qBAAA;EACA,mBAAA;AA/DJ;AAiEI;EACE,cAAA;AA/DN;AAkEI;EACE,cAAA;AAhEN;;AAqEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,aAAA;EACA,0BAAA;EACA,mBAAA;EACA,cAAA;AAlEF;;AAqEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAlEF;AAoEE;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;AAlEJ;AAoEI;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAlEN;AAqEI;EACE,6BAAA;EACA,eAAA;AAnEN;AAqEM;EACE,gBAAA;EACA,cAAA;AAnER;AAsEM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;AApER;AAuEM;EACE,eAAA;EACA,cAAA;EACA,eAAA;AArER;;AA2EA;EACE,gBAAA;EACA,SAAA;EACA,wBAAA;EAAA,mBAAA;AAxEF;AA0EE;EACE,mBAAA;EACA,cAAA;EACA,aAAA;AAxEJ;AA0EI;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAxEN;AA2EM;EACE,UAAA;AAzER;AA4EM;EACE,mBAAA;EACA,kBAAA;AA1ER;AA6EM;EACE,mBAAA;EACA,kBAAA;AA3ER;AA6EQ;EACE,mBAAA;AA3EV;AAgFI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA9EN;AAiFI;EACE,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AA/EN;AAiFM;EACE,eAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AA/ER;AAkFM;EACE,mBAAA;EACA,WAAA;AAhFR;AAmFM;EACE,gBAAA;AAjFR;AAoFM;EACE,OAAA;EACA,gBAAA;AAlFR;;AAyFE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAtFJ;AAwFI;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,cAAA;AAtFN;AAwFM;EACE,cAAA;AAtFR;;AA4FA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EASA,aAAA;EACA,8CAAA;AAjGF;AAyFE;EACE,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AAvFJ;AA4FE;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AA1FJ;;AA8FA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;AA3FF;AA4FE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AA1FJ;AA4FE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AA1FJ;;AA8FA;EACE,cAAA;EACA,yBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AA3FF;;AA8FA;EACE,0BAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;AA3FF;AA4FE;EACE,eAAA;EACA,cAAA;AA1FJ;AA4FE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AA1FJ;AA4FE;EACE,eAAA;EACA,cAAA;AA1FJ;;AA8FA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AA3FF;;AA8FA;EACE,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AA3FF;AA4FE;;EAEE,WAAA;EACA,YAAA;EACA,cAAA;AA1FJ;;AA8FA;EACE,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AA3FF;AA4FE;EACE,gBAAA;EACA,kBAAA;AA1FJ;AA4FE;EACE,cAAA;EACA,gBAAA;AA1FJ;AA4FE;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;AA1FJ;;AA8FA;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;AA3FF;;AA8FA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AA3FF;;AA8FA;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AA3FF;;AA8FA;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,mCAAA;AA3FF;;AA8FA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AA3FF;AA4FE;;EAEE,aAAA;EACA,mBAAA;EACA,QAAA;AA1FJ;AA2FI;;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAxFN;AA2FE;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;AAzFJ;;AA6FA;EACE,aAAA;EACA,mBAAA;EACA,MAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AA1FF;;AA6FA;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,MAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,2BAAA;EACA,mBAAA;EAEA,kBAAA;AA3FF;AA4FE;EACE,eAAA;EACA,mCAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;AA1FJ;AA6FE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;AA3FJ;;AA+FA;EACE,cAAA;AA5FF;AA6FE;EACE,qBAAA;EACA,mCAAA;EACA,cAAA;AA3FJ;;AA+FA;EACE,cAAA;AA5FF;AA6FE;EACE,qBAAA;EACA,kCAAA;EACA,cAAA;AA3FJ;;AA+FA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AA5FF;AA6FE;EACE,eAAA;AA3FJ;;AA+FA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;AA5FF;;AA+FA;EACE,OAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AA5FF;;AA+FA;EACE,mBAAA;AA5FF;;AA+FA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;AA5FF;AA+FE;EACE,UAAA;AA7FJ;AAgGE;EACE,mBAAA;EACA,kBAAA;AA9FJ;AAiGE;EACE,mBAAA;EACA,kBAAA;AA/FJ;AAiGI;EACE,mBAAA;AA/FN;;AAqGA;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;AAlGF;AAoGE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,iBAAA;AAlGJ;AAqGE;EACE,gBAAA;EACA,aAAA;EACA,UAAA;AAnGJ;AAqGI;EACE,cAAA;EACA,eAAA;AAnGN;AAwGM;EACE,aAAA;AAtGR;AAyGM;EACE,aAAA;AAvGR;AA4GE;EACE,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;AA1GJ;AA4GI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AA1GN;AA6GI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;AA3GN;AA6GM;EACE,eAAA;AA3GR;AAgHE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mCAAA;EACA,0CAAA;AA9GJ;AAgHI;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;AA9GN;AAiHI;EACE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,0BAAA;AA/GN;AAkHI;EACE,SAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAhHN;AAmHI;EACE,SAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAjHN;AAoHI;EACE,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AAlHN;AAsHE;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;AApHJ;AAwHM;EACE,kBAAA;AAtHR;AAyHM;EACE,0BAAA;AAvHR;AA0HM;EACE,0BAAA;AAxHR;AA4HM;EACE,kBAAA;AA1HR;AA6HM;;EAEE,kBAAA;AA3HR;AA+HM;;;EAGE,yBAAA;EACA,gBAAA;EACA,eAAA;AA7HR;AAgIM;EACE,cAAA;AA9HR;AAmIE;EACE,eAAA;EACA,mBAAA;AAjIJ;AAmII;EACE,aAAA;EACA,gBAAA;EACA,UAAA;AAjIN;AAoII;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;AAlIN;AAoIM;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AAlIR;AAoIQ;EACE,cAAA;AAlIV;AAqIQ;EACE,eAAA;AAnIV;AAyIE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AAvIJ;AAyII;EACE,wBAAA;EACA,2BAAA;AAvIN;AA0IQ;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;AAxIV;AA2IQ;EACE,aAAA;EACA,iBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;AAzIV;AA4IQ;EACE,iBAAA;EACA,WAAA;EACA,SAAA;AA1IV;AA6IQ;EACE,aAAA;AA3IV;AAgJI;EACE,eAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;AA9IN;AAgJM;EACE,gBAAA;EACA,YAAA;AA9IR;AAiJM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AA/IR;AAiJQ;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AA/IV;AAiJU;EACE,cAAA;AA/IZ;AAkJU;EACE,eAAA;AAhJZ;AAwJE;;EAEE,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAtJJ;AAyJE;EACE,cAAA;EACA,eAAA;AAvJJ;AA0JE;EACE,mBAAA;AAxJJ;AA0JI;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAxJN;AA0JM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAxJR;AA2JM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAzJR;AA4JM;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AA1JR;AA+JE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AA7JJ;AA+JI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;AA7JN;AAgKI;EACE,aAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;AA9JN;AAgKM;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AA9JR;AAkKI;EACE,aAAA;EACA,cAAA;AAhKN;AAmKI;EACE,OAAA;EACA,YAAA;EACA,cAAA;AAjKN;AAoKI;EA5CF;IA6CI,sBAAA;IACA,oBAAA;IACA,iBAAA;IACA,mBAAA;IACA,SAAA;EAjKJ;EAmKI;IACE,mBAAA;IACA,mBAAA;IACA,mBAAA;IACA,2BAAA;IACA,SAAA;IACA,WAAA;EAjKN;EAoKI;IACE,YAAA;IACA,OAAA;IACA,gBAAA;EAlKN;EAoKM;IACE,SAAA;EAlKR;EAsKI;IACE,WAAA;IACA,YAAA;EApKN;EAuKI;IACE,WAAA;IACA,wBAAA;EArKN;AACF;AAyKE;EACE,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAvKJ;AAwKI;EACE,YAAA;EACA,WAAA;AAtKN;AA2KE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AAzKJ;AA2KI;EACE,OAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAzKN;AA2KM;EACE,YAAA;EACA,4DAAA;EACA,kBAAA;EACA,mDAAA;EACA,kBAAA;EACA,gBAAA;AAzKR;AA2KQ;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,sFAAA;EAMA,gCAAA;AA9KV;AAmLI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;AAjLN;AAqLE;EACE;IACE,4BAAA;EAnLJ;EAqLE;IACE,2BAAA;EAnLJ;AACF;AAsLE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,2CAAA;EACA,kDAAA;AApLJ;AAsLI;EACE,mBAAA;EACA,cAAA;EACA,kDAAA;AApLN;AAuLI;EACE,2BAAA;EACA,+CAAA;AArLN;AAwLI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAtLN;AAyLI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AAvLN;AA2LE;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAzLJ;AA2LI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AAzLN;AA4LI;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA1LN;AA6LI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AA3LN;AA6LM;EACE,eAAA;EACA,cAAA;AA3LR;AA8LM;EACE,cAAA;EACA,qBAAA;EACA,sBAAA;AA5LR;AA8LQ;EACE,0BAAA;AA5LV;AAkME;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;AAhMJ;AAkMI;EACE,cAAA;EACA,eAAA;AAhMN;AAoME;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;AAlMJ;AAqME;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,8CAAA;AAnMJ;AAqMI;EACE,qBAAA;EACA,6BAAA;AAnMN;AAsMI;EACE,qBAAA;AApMN;AAuMI;EACE,YAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;AArMN;AAwMI;EACE,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mDAAA;AAtMN;AAyMI;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;AAvMN;AA0MI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AAxMN;AA4ME;EACE,mBAAA;AA1MJ;AA4MI;EACE,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AA1MN;AA6MI;EACE,iBAAA;AA3MN;AA8MI;EACE,iBAAA;AA5MN;AA+MI;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iBAAA;EACA,2BAAA;AA7MN;AA+MM;EACE,2BAAA;EACA,iBAAA;AA7MR;AAgNM;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AA9MR;AAkNI;EACE,2BAAA;AAhNN;AAmNI;EACE,2BAAA;AAjNN;AAoNI;EACE,cAAA;EACA,gBAAA;AAlNN;AAqNI;EACE,iBAAA;AAnNN;AAsNI;EACE,eAAA;AApNN;AAsNM;EACE,mBAAA;AApNR;AAuNU;EACE,kBAAA;AArNZ;AAwNU;EACE,0BAAA;AAtNZ;AAyNU;EACE,0BAAA;AAvNZ;AA0NU;EACE,kBAAA;AAxNZ;AA2NU;;EAEE,kBAAA;AAzNZ;AA8NM;EACE,aAAA;EACA,uBAAA;AA5NR;AA+NM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;AA7NR;AA+NQ;EACE,SAAA;EACA,mBAAA;AA7NV;AAgOQ;EACE,SAAA;AA9NV;AAoOI;EACE,aAAA;EACA,uBAAA;AAlON;AAoOM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;AAlOR;AAoOQ;EACE,SAAA;EACA,mBAAA;AAlOV;AAqOQ;EACE,SAAA;AAnOV;AA0OE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;AAxOJ;AA0OI;EACE,SAAA;EACA,mBAAA;AAxON;AA2OI;EACE,SAAA;AAzON;AA6OE;EACE,aAAA;EACA,uBAAA;AA3OJ;AA6OI;EACE,eAAA;AA3ON;AA6OM;EACE,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AA3OR;AA6OQ;EACE,mBAAA;EACA,cAAA;AA3OV;AAgPI;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AA9ON;AAgPM;EACE,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;AA9OR;AAgPQ;EACE,mBAAA;AA9OV;AAiPQ;;EAEE,eAAA;EACA,cAAA;AA/OV;AAkPQ;EACE,cAAA;EACA,sBAAA;AAhPV;AAkPU;EACE,cAAA;AAhPZ;;AAwPA;EACE,mBAAA;EACA,mBAAA;EACA,kBAAA;AArPF;AAuPE;EACE,iBAAA;EACA,0BAAA;EACA,uBAAA;AArPJ;AAwPE;EACE,cAAA;AAtPJ;AAyPE;EACE,cAAA;EACA,gBAAA;AAvPJ;AA0PE;EACE,qBAAA;EACA,qBAAA;EACA,yBAAA;AAxPJ;;AA4PA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;AAzPF;AA4PI;EACE,sBAAA;AA1PN;AA6PI;EACE,yBAAA;AA3PN;AA8PI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA5PN;;AAiQA;;EAEE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,iBAAA;AA9PF;AAgQE;;EACE,mBAAA;AA7PJ;AAgQE;;EACE,YAAA;EACA,mBAAA;AA7PJ;;AAiQA;;EAEE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,iBAAA;AA9PF;AAgQE;;EACE,mBAAA;AA7PJ;AAgQE;;EACE,YAAA;EACA,mBAAA;AA7PJ;;AAkQA;EACE,gBAAA;EACA,kBAAA;AA/PF;;AAmQA;EACE,eAAA;EACA,gBAAA;AAhQF;AAkQE;EACE,gBAAA;AAhQJ;;AAsQE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,gCAAA;AAnQJ;AAsQE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AApQJ;AAsQI;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,8CAAA;EACA,YAAA;AApQN;AAsQM;EACE,wCAAA;EACA,qBAAA;AApQR;AAuQM;EACE,gBAAA;AArQR;AAwQM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAtQR;AAwQQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAtQV;AA0QM;EACE,OAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AAxQR;AA0QQ;EACE,cAAA;AAxQV;AA4QM;EACE,OAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AA1QR;AA4QQ;EACE,cAAA;EACA,qBAAA;AA1QV;AA4QU;EACE,0BAAA;AA1QZ;AA+QM;EACE,aAAA;EACA,QAAA;EACA,cAAA;AA7QR;AA+QQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;AA7QV;AA+QU;EACE,mBAAA;EACA,cAAA;AA7QZ;AAgRU;EACE,eAAA;AA9QZ;;AAuRA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AApRF;AAsRE;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,8CAAA;AApRJ;AAsRI;EACE,wCAAA;EACA,qBAAA;AApRN;AAuRI;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AArRN;AAuRM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AArRR;AAwRM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAtRR;AAyRM;EACE,eAAA;EACA,cAAA;EACA,SAAA;AAvRR;AA2RI;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAzRN;AA2RM;;EAEE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AAzRR;AA6RI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AA3RN;AA8RI;EACE,aAAA;EACA,SAAA;EACA,yBAAA;AA5RN;AA8RM;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;AA5RR;AA8RQ;EACE,uBAAA;EACA,qBAAA;EACA,cAAA;AA5RV;AA8RU;EACE,mBAAA;EACA,qBAAA;AA5RZ;AAgSQ;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;AA9RV;AAgSU;EACE,mBAAA;EACA,qBAAA;AA9RZ;;AAwSE;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AArSJ;AAuSI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;AArSN;AAuSM;EACE,OAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AArSR;AAwSM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAtSR;AA0SI;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;AAxSN;AA0SM;EACE,mBAAA;EACA,WAAA;AAxSR;;AA+SA;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AA5SF;AA8SE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AA5SJ;AA+SE;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AA7SJ;AAgTE;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AA9SJ;AAgTI;EACE,mBAAA;AA9SN;;AAmTA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAhTF;AAiTE;EACE,SAAA;AA/SJ;AAiTE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AA/SJ;;AAmTA;EACE,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAhTF;AAiTE;EACE,eAAA;EACA,cAAA;AA/SJ;;AAmTA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAhTF;;AAmTA;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mCAAA;AAhTF;;AAmTA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAhTF;;AAmTA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAlTF;;AAqTA;EACE,SAAA;EACA,gBAAA;AAlTF;;AAqTA;EACE,SAAA;EACA,cAAA;EACA,eAAA;AAlTF;;AAqTA;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;AAlTF;;AAqTA;EACE,gBAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;AAlTF;;AAqTA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,mCAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AAlTF;AAoTE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAlTJ;AAqTE;EACE,iBAAA;EACA,gBAAA;EACA,sBAAA;AAnTJ;AAsTE;EACE,gBAAA;AApTJ;;AAwTA;EACE,uBAAA;EACA,qBAAA;EACA,cAAA;AArTF;;AAwTA;EACE,uBAAA;AArTF;;AAwTA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AArTF;AAuTE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;AArTJ;AAuTI;EACE,OAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AArTN;AAwTI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAtTN;AA0TE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;AAxTJ;AA0TI;EACE,mBAAA;EACA,WAAA;AAxTN;;AA6TA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AA1TF;;AA6TA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,8CAAA;AA1TF;AA4TE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AA1TJ;AA6TE;EACE,gBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AA3TJ;;AAiUE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,qBAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AA9TJ;AAgUI;EACE,WAAA;AA9TN;AAiUI;EACE,mBAAA;EACA,kBAAA;AA/TN;AAkUI;EACE,gBAAA;EACA,kBAAA;AAhUN;AAkUM;EACE,gBAAA;AAhUR;AAoUI;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,2BAAA;EAAA,sBAAA;AAlUN;AAoUM;EACE,mBAAA;EACA,qBAAA;AAlUR;AAqUM;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;AAnUR;AAqUQ;;;EAGE,YAAA;AAnUV;AAuUM;EACE,eAAA;EACA,cAAA;EACA,cAAA;AArUR;AAwUM;EACE,kCAAA;EACA,cAAA;EACA,eAAA;AAtUR;AAyUM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kCAAA;AAvUR;AAyUQ;EAVF;IAWI,aAAA;EAtUR;AACF;AA0UI;EAnGF;IAoGI,QAAA;IACA,kBAAA;EAvUJ;EAyUI;IACE,eAAA;IACA,iBAAA;IACA,kCAAA;EAvUN;EAyUM;IACE,eAAA;EAvUR;AACF;AA4UE;EACE,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AA1UJ;AA4UI;EACE,UAAA;AA1UN;AA6UI;EACE,mBAAA;EACA,kBAAA;AA3UN;AA8UI;EACE,mBAAA;EACA,kBAAA;AA5UN;AA8UM;EACE,mBAAA;AA5UR;AAkVE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AAhVJ;AAoVE;EACE,mBAAA;EACA,mBAAA;EACD,6CAAA;EACC,gBAAA;EACA,mBAAA;AAlVJ;AAoVI;EACE,gBAAA;AAlVN;AAqVI;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAnVN;AAqVM;;EAEE,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AAnVR;AAsVM;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AApVR;AAsVQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;AApVV;AAuVQ;EACE,SAAA;EACA,eAAA;AArVV;AA0VI;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAxVN;AA2VI;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AAzVN;AA4VI;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AA1VN;AA4VM;EACE,mBAAA;AA1VR;AA4VQ;EACE,gBAAA;AA1VV;AA+VI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;AA7VN;AA+VM;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AA7VR;AA+VQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA7VV;AAoWE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;AAlWJ;AAoWI;EACE,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,qBAAA;EACA,6BAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AAlWN;AAoWM;EAtBF;IAuBI,eAAA;EAjWN;AACF;AAmWM;EACE,WAAA;AAjWR;AAoWM;EACE,mBAAA;EACA,kBAAA;AAlWR;AAqWM;EACE,gBAAA;EACA,kBAAA;AAnWR;AAqWQ;EACE,gBAAA;AAnWV;AAuWM;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,2BAAA;EAAA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AArWR;AAuWQ;EACE,mBAAA;AArWV;AAyWQ;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,2BAAA;EACA,uBAAA;EACA,eAAA;AAvWV;AAyWU;;;EAGE,WAAA;EACA,2BAAA;EACA,uBAAA;AAvWZ;AA2WQ;EACE,eAAA;EACA,cAAA;EACA,cAAA;AAzWV;AA4WQ;EACE,kCAAA;EACA,cAAA;EACA,eAAA;AA1WV;AA6WQ;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kCAAA;AA3WV;AA6WU;EAVF;IAWI,aAAA;EA1WV;AACF;AAkXI;EACE,kBAAA;AAhXN;AAmXI;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;AAjXN;AAmXM;;EAEE,+BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yDAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;AAjXR;AAmXQ;;EACE,cAAA;AAhXV;AAmXQ;;EACE,+BAAA;EACA,2BAAA;AAhXV;AAmXQ;;EACE,YAAA;EACA,eAAA;AAhXV;AAsXE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AApXJ;AAsXI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AApXN;AAuXI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AArXN;AAwXI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;AAtXN;AAwXM;EACE,mBAAA;EACA,qBAAA;AAtXR;AAyXM;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;AAvXR;AA0XM;EACE,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,cAAA;AAxXR;AA2XM;EACE,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;AAzXR;AA8XE;EACE,aAAA;EACA,sBAAA;EACA,MAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;AA5XJ;AA8XI;EACE,gBAAA;EACA,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;AA5XN;AA8XM;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AA5XR;AAgYI;EACE,aAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;AA9XN;AAkYE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAhYJ;AAkYI;EACE,gBAAA;EACA,4BAAA;EACA,gBAAA;EACA,iBAAA;AAhYN;AAkYM;;EAEE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;AAhYR;AAoYI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AAlYN;AAoYM;EACE,sBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AAlYR;AAwYE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAtYJ;AAwYI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;AAtYN;AAyYI;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yCAAA;AAvYN;AAyYM;EACE,qBAAA;EACA,yCAAA;AAvYR;AA0YM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;AAxYR;AA0YQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAxYV;AA2YQ;EACE,eAAA;EACA,yBAAA;AAzYV;AA6YM;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;AA3YR;AA6YQ;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AA3YV;AA8YQ;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AA5YV;AA+YQ;EACE,eAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AA7YV;AA+YU;EACE,0BAAA;EACA,cAAA;AA7YZ;AAmZI;EACE,YAAA;AAjZN;AAsZE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;AApZJ;AAsZI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AApZN;AAuZI;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yCAAA;EACA,iBAAA;EACA,gBAAA;AArZN;AAuZM;EACE,qBAAA;EACA,yCAAA;AArZR;AAwZM;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAtZR;AAwZQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AAtZV;AAyZQ;EACE,OAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAvZV;AA2ZM;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;AAzZR;AA2ZQ;EACE,mBAAA;EACA,WAAA;AAzZV;AA+ZE;EACE,aAAA;EACA,0DAAA;EACA,SAAA;EACA,gBAAA;AA7ZJ;AA+ZI;EANF;IAOI,0BAAA;EA5ZJ;AACF;AA+ZE;;EAEE,aAAA;EACA,sBAAA;EACA,SAAA;AA7ZJ;AAgaE;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,4CAAA;AA9ZJ;AAiaE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AA/ZJ;AAiaI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AA/ZN;AAkaI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAhaN;AAmaI;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AAjaN;AAqaE;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAnaJ;AAqaI;;EAEE,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AAnaN;AAuaE;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAraJ;AAuaI;EACE,cAAA;EACA,uBAAA;EACA,eAAA;AAraN;AAyaE;EACE,gBAAA;AAvaJ;AAyaI;EACE,kBAAA;EACA,eAAA;EACA,cAAA;AAvaN;AA2aE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AAzaJ;AA4aE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;AA1aJ;AA4aI;EACE,eAAA;EACA,cAAA;AA1aN;AA8aE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA5aJ;AA+aE;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AA7aJ;AAgbE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AA9aJ;AAgbI;EACE,eAAA;EACA,cAAA;AA9aN;AAibI;EACE,SAAA;EACA,eAAA;EACA,cAAA;AA/aN;AAkbI;EACE,eAAA;EACA,cAAA;AAhbN;AAobE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAlbJ;AAobI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAlbN;AAqbI;EACE,aAAA;EACA,sBAAA;AAnbN;AAqbM;EACE,cAAA;AAnbR;AAubI;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;AArbN;AAubM;EACE,eAAA;AArbR;AA0bE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAxbJ;AA2bE;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAzbJ;AA4bE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AA1bJ;AA4bI;EACE,SAAA;EACA,eAAA;EACA,cAAA;AA1bN;AA8bE;EACE,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA5bJ;AA+bE;EACE,aAAA;EACA,2CAAA;EACA,SAAA;AA7bJ;AA+bI;EALF;IAMI,0BAAA;EA5bJ;AACF;AA+bE;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AA7bJ;AA+bI;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;AA7bN;AAicE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AA/bJ;AAicI;EACE,mBAAA;AA/bN;AAgcM;EACE,gBAAA;AA9bR;AAmcE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAjcJ;AAocE;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAlcJ;AAocI;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AAlcN;AAscE;EACE,6BAAA;EACA,iBAAA;EACA,gBAAA;AApcJ;AAscI;EACE,aAAA;EACA,cAAA;EACA,aAAA;AApcN;AAucI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AArcN;AAucM;EACE,eAAA;EACA,cAAA;AArcR;AAycI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAvcN;AA2cE;EACE,gBAAA;EACA,SAAA;AAzcJ;AA4cE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA1cJ;AA6cE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AA3cJ;AA6cI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AA3cN;AA8cI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA5cN;AA8cM;EACE,eAAA;EACA,cAAA;AA5cR;AA+cM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AA7cR;AAkdE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAhdJ;AAkdI;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,cAAA;AAhdN;AAkdM;EACE,cAAA;AAhdR;AAqdE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;AAndJ;AAqdI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AAndN;AAsdI;EACE,SAAA;EACA,eAAA;AApdN;;AAydA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;AAtdF;AAudE;EACE,gBAAA;AArdJ;AAudE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AArdJ;;AAydA;EACE,gBAAA;AAtdF;;AAydA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AAtdF;;AAydA;;;EAGE,iBAAA;EACA,gBAAA;AAtdF;;AAydA;;EAEE,mBAAA;AAtdF;AAudE;;EACE,gBAAA;AApdJ;;AAwdA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCAAA;AArdF;;AAwdA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AArdF;;AAwdA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AArdF;AAsdE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AApdJ;AAsdI;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AApdN;AAudE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;AArdJ;AAudE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AArdJ;AAudE;EACE,eAAA;EACA,cAAA;AArdJ;AAudE;EACE,eAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,oBAAA;AArdJ;AAudI;EACE,0BAAA;AArdN;;AA0dA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAvdF;;AA0dA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AAvdF;AAwdE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAtdJ;AAwdE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAtdJ;AAwdE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAtdJ;AAwdE;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAtdJ;AAwdE;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AAtdJ;AAwdE;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AAtdJ;AAwdE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAtdJ;;AA0dA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAvdF;;AA0dA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;AAvdF;AAwdE;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;AAtdJ;AAudI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AArdN;AAudI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AArdN;AAwdE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAtdJ;;AA0dA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAvdF;AAwdE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AAtdJ;AAwdE;EACE,SAAA;EACA,eAAA;AAtdJ;;AA2dE;EACE,WAAA;EACA,mBAAA;AAxdJ;;AA4dA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAzdF;AA0dE;EACE,cAAA;AAxdJ;AA0dE;;EAEE,eAAA;AAxdJ;;AA4dA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;AAzdF;AA0dE;EACE,gBAAA;AAxdJ;AA0dE;EACE,cAAA;AAxdJ;;AA4dA;EACE,WAAA;EACA,gBAAA;AAzdF;;AA4dA;EACE,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;AAzdF;AA0dE;EACE,OAAA;EACA,WAAA;AAxdJ;AA0dE;EACE,uBAAA;EACA,uBAAA;AAxdJ;;AA6dA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,qCAAA;EACA,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kCAAA;UAAA,0BAAA;AA1dF;AA4dE;EACE,OAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA1dJ;AA4dI;EACE,YAAA;EACA,4DAAA;EACA,kBAAA;EACA,mDAAA;EACA,kBAAA;EACA,gBAAA;AA1dN;AA4dM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,sFAAA;EAMA,gCAAA;AA/dR;AAoeE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;AAleJ;AAqeE;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,iCAAA;AAneJ;;AAueA;EACE;IACE,sBAAA;EApeF;EAseA;IACE,mBAAA;IACA,eAAA;EApeF;EAseA;IACE,eAAA;EApeF;AACF;AAueA;EACE;IACE,UAAA;EAreF;EAueA;IACE,WAAA;IACA,aAAA;IACA,iBAAA;IACA,gBAAA;EAreF;EAueA;;IAEE,aAAA;EAreF;EAueA;IACE,UAAA;IACA,MAAA;EAreF;EAueA;IACE,aAAA;EAreF;EAyeA;IACE,gBAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;EAveF;EA2eA;IACE,2BAAA;IACA,kBAAA;IACA,iCAAA;IACA,qBAAA;IACA,gBAAA;IACA,eAAA;IACA,mBAAA;EAzeF;EA2eE;IACE,aAAA;EAzeJ;EA8eA;IACE,yBAAA;IACA,cAAA;IACA,eAAA;IACA,WAAA;IACA,aAAA;IACA,kBAAA;EA5eF;EA+eA;IACE,cAAA;IACA,kBAAA;IAEA,8BAAA;EA9eF;EAifA;IACE,eAAA;IACA,sBAAA;EA/eF;EAmfA;IACE,aAAA;IACA,kBAAA;EAjfF;EAofA;IACE,WAAA;IACA,eAAA;EAlfF;EAqfA;;;;IAIE,eAAA;EAnfF;EAufA;IACE,cAAA;IACA,eAAA;EArfF;EAufA;IACE,eAAA;IACA,gBAAA;EArfF;EA0fA;IACE,cAAA;IACA,kBAAA;EAxfF;EA2fA;IAEE,wBAAA;IACA,eAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IACA,cAAA;IACA,iBAAA;IACA,qDAAA;IACA,QAAA;IACA,iBAAA;IACA,mBAAA;EA1fF;AACF;AA8fA;EACE;IACE,wBAAA;IACA,eAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IACA,cAAA;IACA,iBAAA;IACA,qDAAA;IACA,QAAA;IACA,iBAAA;IACA,mBAAA;EA5fF;EA+fA;IACE,wDAAA;EA7fF;AACF;AAggBA;EAEE;IACE,wDAAA;EA/fF;EAmgBA;;IAEE,WAAA;IACA,YAAA;IACA,aAAA;IACA,iBAAA;IACA,oBAAA;IACA,QAAA;EAjgBF;EAogBA;;;IAGE,WAAA;IACA,YAAA;IACA,aAAA;EAlgBF;EAqgBA,8EAAA;EACA;IACE,cAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;IACA,kBAAA;IACA,yBAAA;IACA,gBAAA;IACA,cAAA;IACA,oBAAA;IACA,mBAAA;IACA,uBAAA;IACA,eAAA;EAngBF;EAqgBE;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;EAngBJ;EAugBA,mFAAA;EACA;IACE,eAAA;EArgBF;EAwgBA;IACE,eAAA;EAtgBF;EAygBA;IACE,SAAA;IACA,cAAA;EAvgBF;EA0gBA;IACE,yDAAA;EAxgBF;EA2gBA;IACE,mBAAA;IACA,qBAAA;IACA,cAAA;EAzgBF;EA4gBA;;;IAGE,WAAA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,oBAAA;IACA,gBAAA;IACA,oBAAA;IACA,sBAAA;EA1gBF;EAmhBE;IACE,wBAAA;EAjhBJ;EAohBE;IACE,2BAAA;IACA,6BAAA;IACA,iCAAA;IACA,mBAAA;IACA,qBAAA;EAlhBJ;EAohBI;IACE,aAAA;EAlhBN;EAuhBE;IACE,0BAAA;IACA,kBAAA;EArhBJ;EAwhBE;IACE,kBAAA;IACA,iBAAA;EAthBJ;EA0hBE;IACE,uBAAA;EAxhBJ;AACF;AA4hBA;EACE,yBAAA;EACA,6BAAA;EACA,aAAA;EACA,kBAAA;EAEA,4BAAA;AA1hBF;;AA6hBA,UAAA;AAEA;EACE,uBAAA;EACA,gBAAA;AA3hBF;AA4hBE;EACE,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AA1hBJ;;AA6hBA;EACE,iBAAA;AA1hBF;;AA4hBA;EACE,yBAAA;AAzhBF;;AA4hBA;EACE,kCAAA;EACA,aAAA;AAzhBF;;AA4hBA;EACE,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;AAzhBF;;AA4hBA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;AAzhBF;;AA4hBA,cAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AA1hBF;;AA6hBA;EAEE,kCAAA;EACA,gBAAA;EACA,6BAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EAEA,4CAAA;EACA,kBAAA;EACA,6BAAA;AA1hBF;;AA6hBA,SAAA;AAEA;EACE,cAAA;AA3hBF;;AA8hBA;EACE,cAAA;EACA,gCAAA;AA3hBF;;AA8hBA,mBAAA;AAEA;;;EAGE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;EAEA,iDAAA;EAEA,8BAAA;EACA,0BAAA;EAKA,gCAAA;AA5hBF;;AA+hBA;;;EAGE,yBAAA;AA5hBF;;AA+hBA;;;EAOE,sBAAA;AA5hBF;;AA+hBA;;EAGE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EAKA,gCAAA;EAEA,8BAAA;AA7hBF;;AAgiBA;;EAEE,sBAAA;EACA,gCAAA;AA7hBF;;AAgiBA;;EAEE,cAAA;AA7hBF;;AAgiBA,eAAA;AAEA,uCAAA;AACA;EAEE,0BAAA;EAEA,sBAAA;EAEA,yBAAA;AA9hBF;AA8iBA;EACE;IACE,UAAA;IAEA,mCAAA;EA/hBF;EAiiBA;IACE,UAAA;IAEA,eAAA;EA/hBF;AACF;AAkiBA,kCAAA;AAiBA;EACE;IACE,UAAA;EAhiBF;EAkiBA;IACE,UAAA;EAhiBF;AACF;AAmiBA;EACE,UAAA;EAGA,2BAAA;EAIA,6BAAA;EAIA,sBAAA;AAniBF;;AAsiBA;EAGE,qBAAA;AAniBF;;AAsiBA;EAGE,qBAAA;EACA,6BAAA;AAniBF;;AAsiBA;EAGE,qBAAA;EACA,6BAAA;AAniBF;;AAsiBA;EAGE,mBAAA;EACA,6BAAA;AAniBF;;AAsiBA,kCAAA;AACA;EACE,cAAA;EACA,OAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;AAniBF;;AAsiBA;EACE,cAAA;AAniBF;;AAsiBA;EACE,WAAA;AAniBF;;AAsiBA,WAAA;AAEA;EACE,aAAA;AApiBF;;AAuiBA;EACE,UAAA;AApiBF;;AAsiBA;EACE,mBAAA;AAniBF;;AAsiBA;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;AAniBF;;AAsiBA;EACE,eAAA;EACA,gCAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,4CAAA;EACA,yCAAA;EACA,0CAAA;EACA,2CAAA;AAniBF;;AAsiBA;EACE,sBAAA;EACA,kBAAA;EACA,qHAAA;AAniBF;;AAuiBA;EACE,UAAA;AApiBF;;AAuiBA;EACE,sDAAA;AApiBF;;AAuiBA;EACE,kBAAA;EACA,kCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AApiBF;AAqiBE;EACE,UAAA;EACA,wBAAA;AAniBJ;AAoiBI;EACE,UAAA;AAliBN;AAoiBI;EACE,UAAA;AAliBN;AAoiBI;EAEE,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;AAniBN;AAqiBM;EACE,OAAA;EACA,UAAA;EACA,qCAAA;EACA,yBAAA;EACA,2BAAA;AAniBR;AAqiBM;EACE,UAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qCAAA;EACA,yBAAA;EACA,2BAAA;AAniBR;;AAyiBA,yBAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;AAtiBF;AAuiBE;EACE,qCAAA;EACA,yBAAA;AAriBJ;;AAwiBA;EACE,sBAAA;EACA,iDAAA;EAEA,gBAAA;AAtiBF;AAuiBE;EACE,UAAA;EACA,aAAA;AAriBJ;AAuiBE;EACE,oDAAA;AAriBJ;AAuiBE;EACE,yBAAA;EACA,0BAAA;AAriBJ;AAuiBE;EACE,0BAAA;EACA,iBAAA;AAriBJ;AAsiBI;EACE,0BAAA;EACA,2BAAA;AApiBN;AAuiBE;EAGE,sBAAA;EACA,cAAA;AAviBJ;AAwiBI;EACE,WAAA;AAtiBN;;AA0iBA;EACE,YAAA;EACA,kBAAA;EACA,8BAAA;AAviBF;;AAyiBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;AAtiBF;AAuiBE;EACE,OAAA;AAriBJ;AAuiBE;EAEE,iBAAA;AAtiBJ;AAwiBE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AAtiBJ;AAuiBI;EACE,8BAAA;AAriBN;;AA0iBA;EACE,eAAA;EACA,sBAAA;EAEA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAxiBF;AA2iBE;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AAziBJ;AA2iBI;EANF;IAOI,mBAAA;IACA,mBAAA;IACA,gBAAA;EAxiBJ;AACF;AA0iBE;EACE,aAAA;EACA,kBAAA;EACA,kCAAA;EACA,4BAAA;AAxiBJ;AAyiBI;;EAEE,gBAAA;EACA,UAAA;AAviBN;AA0iBI;;;;EAIE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;AAxiBN;AA0iBI;;EAEE,YAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;AAxiBN;AA0iBI;EACE,kBAAA;AAxiBN;AA2iBE;EACE,UAAA;EACA,aAAA;AAziBJ;AA2iBE;EACE,oDAAA;AAziBJ;AA2iBE;EACE,yBAAA;EACA,0BAAA;AAziBJ;;AA4iBA;EACE,WAAA;EACA,cAAA;EACA,WAAA;AAziBF;;AA6iBE;EACE,UAAA;EACA,aAAA;EACA,eAAA;AA1iBJ;AA2iBI;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAziBN;AA4iBM;EACE,yBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;AA1iBR;AA4iBM;EACE,eAAA;EACA,YAAA;EACA,WAAA;AA1iBR;AA6iBI;EACE,WAAA;EACA,cAAA;EAEA,2BAAA;EACA,aAAA;AA5iBN;AA6iBM;EAEE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AA7iBR;AAgjBM;EACE,eAAA;EAEA,mBAAA;AA/iBR;AAijBM;EACE,WAAA;EACA,YAAA;EACA,4BAAA;AA/iBR;AAijBM;EACE,WAAA;EACA,YAAA;AA/iBR;AAkjBI;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;AAhjBN;AAijBM;EACE,0BAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;AA/iBR;AAijBM;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AA/iBR;AAmjBI;EACE,cAAA;EACA,WAAA;AAjjBN;AAojBM;EACE,kBAAA;EAEA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AApjBR;AAsjBQ;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EAEA,mBAAA;AArjBV;AAwjBQ;EACE,eAAA;AAtjBV;AA0jBM;EACE,0BAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;AAxjBR;AA4jBQ;EACE,YAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;AA1jBV;AA4jBQ;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;AA1jBV;AA2jBU;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;AAzjBZ;AA+jBI;EACE,cAAA;EACA,mBAAA;EACA,sBAAA;AA7jBN;AA8jBM;EACE,mBAAA;EACA,mBAAA;EACA,0BAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;AA5jBR;AA8jBM;EACE,UAAA;EACA,yBAAA;EACA,YAAA;AA5jBR;AA+jBI;EACE,UAAA;EACA,cAAA;EACA,gBAAA;AA7jBN;AA+jBI;EACE,SAAA;EACA,YAAA;AA7jBN;AA8jBM;EACE,UAAA;AA5jBR;;AAqkBA;EACE;IACE,wBAAA;IACA,wBAAA;EAlkBF;EAokBA;IACE,2BAAA;EAlkBF;EAokBA;IACE,kBAAA;IACA,UAAA;IACA,YAAA;EAlkBF;EAokBA;IACE,sBAAA;EAlkBF;AACF;AAokBA;EACE;IACE,kBAAA;IACA,SAAA;IACA,UAAA;IACA,eAAA;EAlkBF;AACF;AAqkBA;EAGM;IACE,iBAAA;EArkBN;EAykBI;IACE,iBAAA;EAvkBN;EAykBI;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,eAAA;IACA,SAAA;IACA,eAAA;EAvkBN;EAwkBM;IACE,WAAA;IACA,eAAA;EAtkBR;EA2kBA;IACE,UAAA;EAzkBF;AACF;AA4kBA;EACE,eAAA;EAEA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AA3kBF;;AAglBI;EACE,qBAAA;AA7kBN;;AAklBA;EACE,eAAA;EAEA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EAEA,gBAAA;AAjlBF;;AAslBI;EACE,qBAAA;AAnlBN;AAslBI;EACE,qBAAA;AAplBN;AAslBI;EACE,qBAAA;AAplBN;AA6lBE;EACE,mBAAA;AA3lBJ;AA6lBM;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA3lBR;AA4lBQ;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;AA1lBV;AA2lBU;EACE,OAAA;AAzlBZ;AA2lBU;EACE,OAAA;AAzlBZ;AA2lBU;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAzlBZ;;AAgmBA;EACE,sBAAA;AA7lBF;;AA+lBA;EACE,WAAA;AA5lBF;;AA8lBA;EAEE,mBAAA;AA5lBF;AA6lBE;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;AA3lBJ;AA4lBI;EAEE,4BAAA;EACA,aAAA;EAEA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AA5lBN;AA6lBM;EACE,UAAA;AA3lBR;AA6lBM;EACE,UAAA;AA3lBR;AA4lBQ;EACE,sBAAA;EACA,sCAAA;AA1lBV;AA6lBM;EACE,WAAA;EACA,uBAAA;AA3lBR;AA6lBM;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;AA3lBR;AA8lBI;EACE,eAAA;AA5lBN;;AAimBE;EACE,gBAAA;AA9lBJ;AAgmBE;EACE,WAAA;AA9lBJ;;AAimBA;EAGE,kBAAA;EACA,mBAAA;AAhmBF;AAimBE;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AA/lBJ;AAgmBI;EAEE,4BAAA;EACA,aAAA;EAEA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAhmBN;AAimBM;EACE,UAAA;AA/lBR;AAimBM;EACE,UAAA;AA/lBR;AAimBM;EACE,WAAA;EACA,uBAAA;AA/lBR;AAimBM;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kCAAA;AA/lBR;AAkmBI;EACE,eAAA;AAhmBN;AAkmBI;EACE,6BAAA;AAhmBN;;AAumBI;EACE,sBAAA;EACA,wCAAA;EACA,0BAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;AApmBN;AAqmBM;EACE,yBAAA;AAnmBR;AAsmBI;EACE,uBAAA;AApmBN;;AAwmBA;EACE,aAAA;EACA,WAAA;AArmBF;;AAwmBA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AArmBF;AAumBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AArmBJ;AAumBI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;AArmBN;AAumBM;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AArmBR;AAymBI;EACE,YAAA;EACA,mBAAA;AAvmBN;AAymBM;EACE,WAAA;AAvmBR;AA0mBM;EACE,WAAA;AAxmBR;AA6mBE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AA3mBJ;AA6mBI;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AA3mBN;AA8mBI;EACE,0BAAA;EACA,cAAA;AA5mBN;AA8mBM;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AA5mBR;AAinBE;EACE,gBAAA;EACA,mCAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AA/mBJ;AAinBI;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AA/mBN;AAknBI;EACE,gBAAA;EACA,cAAA;AAhnBN;AAmnBI;EACE,cAAA;AAjnBN;AAonBI;EACE,oBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA,EAAA,+BAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;AAlnBN;AAqnBI;EACE,cAAA;EACA,cAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA,EAAA,8BAAA;EACA,iBAAA,EAAA,2BAAA;EACA,gBAAA,EAAA,qCAAA;EAEA,2DAAA;AApnBN;AAqnBM;EACE,eAAA;EACA,gBAAA;AAnnBR;AAqnBM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;AAnnBR;AAqnBM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AAnnBR;AAqnBM;;;EAGE,kBAAA;EACA,QAAA;AAnnBR;AAqnBM;EACE,kBAAA;AAnnBR;AAsnBM;EACE,kCAAA;EACA,kBAAA;AApnBR;AAunBM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AArnBR;;AA2nBA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;AAxnBF;AAynBE;EACE,gBAAA;AAvnBJ;;AA4nBE;EACE,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,yFAAA;AAznBJ;AA6nBE;EACE,WAAA;EACA,WAAA;EACA,oCAAA;EACA,oBAAA;EACA,mBAAA;AA3nBJ;AA8nBE;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AA5nBJ;AA+nBE;EACE,aAAA;EACA,sBAAA;AA7nBJ;AA+nBI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AA7nBN;AA+nBM;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AA7nBR;AAgoBM;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AA9nBR;AA+nBQ;EACE,eAAA;AA7nBV;AA+nBQ;EACE,SAAA;EACA,eAAA;AA7nBV;AAkoBI;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAhoBN;AAmoBI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AAjoBN;AAooBI;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAloBN;AAmoBM;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AAjoBR;AAkoBQ;EACE,eAAA;EACA,YAAA;EACA,WAAA;AAhoBV;AAqoBI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAnoBN;AAuoBE;EACE,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAroBJ;AAwoBE;EACE,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;AAtoBJ;AAyoBE;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;AAvoBJ;AAwoBI;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAtoBN;AA0oBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAxoBJ;AA2oBE;EACE,aAAA;EACA,SAAA;AAzoBJ;AA4oBE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA1oBJ;AA2oBI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAzoBN;AA6oBE;EACE,OAAA;EACA,YAAA;AA3oBJ;AA4oBI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AA1oBN;AA4oBI;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AA1oBN;AA4oBI;EACE,eAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AA1oBN;AA8oBE;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AA5oBJ;AA6oBI;EACE,eAAA;AA3oBN;AA6oBI;EACE,SAAA;EACA,eAAA;AA3oBN;AA+oBE;EACE,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;AA7oBJ;AAgpBE;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AA9oBJ;AAipBE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;AA/oBJ;AAgpBI;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AA9oBN;AAkpBE;EACE,aAAA;AAhpBJ;AAipBI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA/oBN;AAipBI;EACE,sBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AA/oBN;AAipBI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA/oBN;AAipBI;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA/oBN;AAmpBE;EACE,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAjpBJ;AAopBE;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AAlpBJ;AAmpBI;EACE,eAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AAjpBN;AAmpBI;EACE,eAAA;EACA,gCAAA;AAjpBN;AAkpBM;EACE,mBAAA;AAhpBR;AAkpBM;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAhpBR;AAipBQ;EACE,eAAA;EACA,cAAA;AA/oBV;AAkpBM;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAhpBR;;AAspBA;EACE,kBAAA;EACA,0DAAA;EACA,mBAAA;AAnpBF;;AAspBA;EACE,uFAAA;EAEA,+BAAA;AAppBF;;AAupBA;EACE;IACE,iDAAA;EAppBF;EAspBA;IACE,oDAAA;EAppBF;EAspBA;IACE,iDAAA;EAppBF;AACF;AAwpBA;EACE,gBAAA;EACA,UAAA;EACA,uBAAA;AAtpBF;;AAypBA;EACE,mBAAA;AAtpBF;AAwpBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AAtpBJ;AAypBE;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;AAvpBJ;;AA2pBA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;AAxpBF;AA0pBE;EARF;IASI,QAAA;IACA,iBAAA;IACA,gBAAA;IACA,iCAAA;IACA,qBAAA;EAvpBF;EAypBE;IACE,aAAA;EAvpBJ;AACF;;AA2pBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAxpBF;;AA4pBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,iCAAA;AAzpBF;AA2pBE;EAfF;IAgBI,aAAA;IACA,uBAAA;IACA,iBAAA;EAxpBF;AACF;;AA2pBA;EACE,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6CAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAxpBF;AA0pBE;EAVF;IAWI,WAAA;IACA,8BAAA;IACA,4BAAA;EAvpBF;AACF;;AA0pBA;EACE,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;AAvpBF;AAypBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAvpBJ;AA0pBE;EACE,cAAA;AAxpBJ;AA2pBE;EApBF;IAqBI,aAAA;EAxpBF;AACF;;AA2pBA;EACE,aAAA;EACA,gBAAA;EACA,OAAA;EACA,aAAA;AAxpBF;AA0pBE;EANF;IAOI,aAAA;EAvpBF;AACF;;AA0pBA;;;EAGE,mBAAA;AAvpBF;AAypBE;;;EACE,gBAAA;AArpBJ;;AAypBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AAtpBF;;AAypBA;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AAtpBF;AAwpBE;EACE,gBAAA;EACA,cAAA;AAtpBJ;;AA0pBA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAvpBF;;AA0pBA;EACE,cAAA;EACA,gBAAA;AAvpBF;;AA0pBA;EACE,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;AAvpBF;AAypBE;EACE,gBAAA;AAvpBJ;AA0pBE;EAXF;IAYI,kBAAA;EAvpBF;AACF;;AA0pBA;EACE,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6CAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAvpBF;;AA0pBA;EACE,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;AAvpBF;AAypBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AAvpBJ;AA0pBE;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAxpBJ;AA2pBE;EACE,cAAA;AAzpBJ;;AA6pBA;EACE,aAAA;EACA,gBAAA;AA1pBF;AA4pBE;EAJF;IAKI,aAAA;EAzpBF;AACF;;AA4pBA;EACE,OAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,8DAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AAzpBF;AA2pBE;EACE,yBAAA;EACA,kCAAA;AAzpBJ;AA4pBE;EACE,YAAA;EACA,eAAA;AA1pBJ;AA6pBE;EA1BF;IA2BI,gBAAA;IACA,kBAAA;IACA,QAAA;EA1pBF;AACF;;AA6pBA;EACE,eAAA;EACA,cAAA;AA1pBF;;AA6pBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AA1pBF;AA4pBE;EACE,gBAAA;EACA,eAAA;AA1pBJ;AA6pBE;EACE,eAAA;EACA,cAAA;AA3pBJ;;AA+pBA;EACE,aAAA;EACA,mBAAA;AA5pBF;AA8pBE;EACE,mBAAA;AA5pBJ;;AAiqBA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AA9pBF;AAgqBE;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA9pBJ;AAiqBE;EACE,kBAAA;EACA,eAAA;EACA,cAAA;AA/pBJ;;AAmqBA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AAhqBF;AAkqBE;EANF;IAOI,qCAAA;IACA,QAAA;EA/pBF;AACF;;AAkqBA;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,yBAAA;EACA,gBAAA;AA/pBF;AAiqBE;EACE,qBAAA;EACA,sBAAA;AA/pBJ;AAkqBE;EACE,qBAAA;EACA,2CAAA;AAhqBJ;AAmqBE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAjqBJ;AAoqBE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,oEAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAlqBJ;AAoqBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAlqBN;AAqqBI;EACE,eAAA;AAnqBN;;AAwqBA;EACE,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;AArqBF;AAuqBE;EACE,mBAAA;EACA,qBAAA;AArqBJ;;AAyqBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;AAtqBF;AAwqBE;EACE,SAAA;EACA,eAAA;EACA,cAAA;AAtqBJ;;AA0qBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAvqBF;AAyqBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAvqBJ;AA0qBE;EACE,SAAA;AAxqBJ;;AA4qBA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAzqBF;AA2qBE;EAEE,WAAA;EACA,OAAA;EACA,WAAA;EACA,mBAAA;AA1qBJ;AA6qBE;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA3qBJ;;AA+qBA;EACE,mBAAA;AA5qBF;AA8qBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA5qBJ;AA+qBE;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AA7qBJ;;AAirBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,8DAAA;AA9qBF;AAgrBE;EACE,mBAAA;AA9qBJ;AAirBE;EACE,cAAA;EACA,qBAAA;EACA,mBAAA;AA/qBJ;AAkrBE;EACE,eAAA;AAhrBJ;;AAqrBA;EACE,mBAAA;AAlrBF;;AAqrBA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAlrBF;;AAqrBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AAlrBF;;AAqrBA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,qEAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAlrBF;;AAqrBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAlrBF;;AAqrBA;EACE,OAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AAlrBF;AAorBE;EACE,wBAAA;UAAA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAlrBJ;AAqrBE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAnrBJ;;AAurBA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAprBF;;AAurBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oCAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;AAprBF;AAsrBE;EACE,gBAAA;AAprBJ;AAurBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AArrBJ;;AA0rBA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;EACA,uBAAA;AAvrBF;AAyrBE;EARF;IASI,sBAAA;IACA,SAAA;EAtrBF;AACF;;AAyrBA;EACE,OAAA;EACA,YAAA;AAtrBF;AAwrBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AAtrBJ;;AA2rBA;EACE,SAAA;AAxrBF;;AA2rBA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,oCAAA;AAxrBF;AA0rBE;EACE,WAAA;AAxrBJ;AA2rBE;EACE,uBAAA;AAzrBJ;AA4rBE;EACE,mBAAA;EACA,kBAAA;AA1rBJ;AA4rBI;EACE,mBAAA;AA1rBN;;AA+rBA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,mCAAA;EACA,gBAAA;AA5rBF;AA8rBE;EACE,qBAAA;AA5rBJ;AA+rBE;EACE,qBAAA;EACA,iBAAA;AA7rBJ;AAgsBE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AA9rBJ;;AAksBA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA/rBF;AAisBE;EACE,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AA/rBJ;;AAmsBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAhsBF;;AAmsBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAhsBF;;AAosBA;EACE,OAAA;EACA,gBAAA;AAjsBF;;AAosBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAjsBF;;AAosBA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;AAjsBF;;AAosBA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAjsBF;;AAosBA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AAjsBF;AAmsBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAjsBJ;AAosBE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAlsBJ;;AAssBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;AAnsBF;AAqsBE;EACE,YAAA;AAnsBJ;AAssBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AApsBJ;AAusBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AArsBJ;;AAysBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;AAtsBF;AAwsBE;EAPF;IAQI,sBAAA;IACA,uBAAA;IACA,SAAA;IACA,eAAA;EArsBF;AACF;;AAwsBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AArsBF;AAusBE;EARF;IASI,cAAA;IACA,YAAA;IACA,eAAA;IACA,WAAA;EApsBF;AACF;;AAusBA;EACE,eAAA;EACA,cAAA;AApsBF;;AAusBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,OAAA;EACA,gBAAA;EACA,eAAA;AApsBF;;AAusBA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;AApsBF;;AAusBA;EACE,eAAA;EACA,cAAA;EACA,qBAAA;AApsBF;;AAusBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,cAAA;EACA,2BAAA;EAAA,sBAAA;AApsBF;AAssBE;EARF;IASI,iBAAA;IACA,QAAA;IACA,cAAA;IACA,2BAAA;IAAA,sBAAA;IACA,WAAA;IACA,2BAAA;EAnsBF;AACF;;AAssBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,wDAAA;EACA,cAAA;EACA,mBAAA;AAnsBF;AAqsBE;EACE,eAAA;EACA,cAAA;AAnsBJ;AAssBE;EACE,mBAAA;AApsBJ;AAusBE;EAvBF;IAwBI,iBAAA;IACA,eAAA;IACA,QAAA;EApsBF;AACF;;AAusBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,wDAAA;EACA,cAAA;AApsBF;AAssBE;EACE,eAAA;AApsBJ;AAusBE;EACE,mBAAA;AArsBJ;AAwsBE;EArBF;IAsBI,WAAA;IACA,YAAA;EArsBF;EAusBE;IACE,eAAA;EArsBJ;AACF;;AAysBA;EACE,gBAAA;EACA,gBAAA;AAtsBF;;AAysBA;EACE,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAtsBF;;AAysBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;AAtsBF;AAwsBE;EACE,eAAA;AAtsBJ;;AA0sBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAvsBF;;AA0sBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,uCAAA;AAvsBF;AAysBE;EACE,mBAAA;AAvsBJ;AA0sBE;EACE,gBAAA;EACA,mBAAA;AAxsBJ;AA2sBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAzsBJ;;AA8sBA;EACE,gBAAA;AA3sBF;;AA8sBA;EACE,mBAAA;AA3sBF;AA6sBE;EACE,gBAAA;AA3sBJ;;AAgtBA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AA7sBF;AA+sBE;EACE,gBAAA;AA7sBJ;;AAktBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,6DAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AA/sBF;;AAktBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AA/sBF;AAitBE;EACE,cAAA;EACA,eAAA;AA/sBJ;AAktBE;;EAEE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAhtBJ;;AAotBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAjtBF;;AAotBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AAjtBF;;AAotBA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yCAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;AAjtBF;AAmtBE;EACE,yCAAA;EACA,qBAAA;EACA,2BAAA;AAjtBJ;AAotBE;EACE,sDAAA;AAltBJ;AAqtBE;EAxBF;IAyBI,sBAAA;IACA,oBAAA;IACA,SAAA;IACA,aAAA;IACA,YAAA;IACA,kBAAA;EAltBF;AACF;;AAqtBA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,iBAAA;AAltBF;AAotBE;EACE,gBAAA;AAltBJ;AAqtBE;EAfF;IAgBI,YAAA;IACA,YAAA;IACA,kBAAA;EAltBF;EAotBE;IACE,gBAAA;EAltBJ;AACF;AAqtBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAntBJ;AAqtBI;EALF;IAMI,eAAA;IACA,WAAA;IACA,YAAA;EAltBJ;AACF;;AAstBA;EACE,cAAA;AAntBF;AAqtBE;EAHF;IAII,WAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;EAltBF;AACF;;AAqtBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAltBF;AAotBE;EACE,qBAAA;EACA,sBAAA;AAltBJ;AAqtBE;EAlBF;IAmBI,WAAA;IACA,gBAAA;IACA,aAAA;IACA,cAAA;EAltBF;AACF;AAotBE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAltBJ;AAqtBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAntBJ;AAqtBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAntBN;;AAwtBA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AArtBF;AAutBE;EAPF;IAQI,WAAA;IACA,SAAA;EAptBF;AACF;;AAutBA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AAptBF;AAstBE;EANF;IAOI,sBAAA;IACA,QAAA;EAntBF;AACF;;AAstBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAntBF;AAqtBE;EAPF;IAQI,eAAA;IACA,eAAA;EAltBF;AACF;;AAqtBA;EACE,eAAA;EACA,cAAA;EACA,sBAAA;EACA,OAAA;AAltBF;AAotBE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAltBJ;AAqtBE;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;AAntBJ;AAstBE;EACE,cAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AAptBJ;AAstBI;EACE,aAAA;AAptBN;AAutBI;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AArtBN;AAwtBI;EACE;IACE,eAAA;EAttBN;EAytBI;IACE,aAAA;EAvtBN;AACF;AA0tBI;EACE,cAAA;EACA,0BAAA;AAxtBN;AA2tBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAztBN;AA6tBE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AA3tBJ;;AA+tBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;AA5tBF;AA8tBE;EANF;IAOI,mBAAA;IACA,uBAAA;IACA,SAAA;IACA,WAAA;IACA,gBAAA;IACA,6BAAA;EA3tBF;AACF;;AA8tBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AA3tBF;AA8tBI;EACE,mBAAA;EACA,cAAA;AA5tBN;AAiuBI;EACE,mBAAA;EACA,cAAA;AA/tBN;AAmuBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAjuBJ;;AAquBA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;AAluBF;AAouBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AAluBJ;AAquBE;EACE,SAAA;EACA,eAAA;EACA,cAAA;AAnuBJ;;AAwuBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,6DAAA;EACA,kBAAA;EACA,8CAAA;AAruBF;AAuuBE;EACE,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAruBJ;AAwuBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,OAAA;AAtuBJ;AAyuBE;EACE,eAAA;EACA,+BAAA;EACA,gBAAA;AAvuBJ;;AA2uBA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,mBAAA;AAxuBF;;AA2uBA;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yCAAA;EACA,yBAAA;AAxuBF;AA0uBE;EACE,yCAAA;EACA,qBAAA;AAxuBJ;;AA4uBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAzuBF;AA2uBE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAzuBJ;AA4uBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA1uBJ;AA4uBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA1uBN;;AA+uBA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AA5uBF;;AA+uBA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AA5uBF;;AA+uBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;AA5uBF;;AA+uBA;EACE,eAAA;EACA,cAAA;EACA,sBAAA;EACA,OAAA;AA5uBF;AA8uBE;EACE,cAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,sBAAA;AA5uBJ;AA8uBI;EACE,cAAA;EACA,0BAAA;AA5uBN;AA+uBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA7uBN;AAgvBI;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA9uBN;;AAovBA;EACE,sBAAA;EACA,mBAAA;EACA,0CAAA;EACA,YAAA;AAjvBF;;AAovBA;EACE,YAAA;EACA,mBAAA;EACA,0BAAA;AAjvBF;;AAovBA;EACE,sDAAA;AAjvBF;;AAqvBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,iBAAA;EACA,6DAAA;EACA,kBAAA;AAlvBF;AAovBE;EACE,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAlvBJ;AAqvBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,OAAA;AAnvBJ;AAsvBE;EACE,eAAA;EACA,+BAAA;EACA,gBAAA;AApvBJ;;AA0vBI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AAvvBN;AAyvBM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAvvBR;AA6vBI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AA3vBN;AA6vBM;EACE,gBAAA;AA3vBR;AA8vBM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;AA5vBR;AA+vBM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA7vBR;AAgwBM;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AA9vBR;AAiwBM;EACE,eAAA;EACA,cAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AA/vBR;AAiwBQ;EACE,0BAAA;EACA,cAAA;AA/vBV;AAkwBQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAhwBV;;AAwwBA;EACE,kBAAA;EACA,gCAAA;AArwBF;AAuwBE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AArwBJ;AAwwBE;EACE,SAAA;EACA,eAAA;EACA,cAAA;AAtwBJ;;AA4wBE;EACE,yBAAA;AAzwBJ;AA4wBE;EACE,yBAAA;AA1wBJ;AA6wBE;EACE,yBAAA;AA3wBJ;;AAkxBI;EAIE,yBAAA;AAlxBN;;AA0xBI;EAEE,yBAAA;AAxxBN;AA8xBM;EAGE,yBAAA;AA9xBR;;AAqyBA;EACE,kBAAA;EACA,cAAA;AAlyBF;AAqyBI;EACE,yBAAA;EACA,kBAAA;AAnyBN;;AAyyBA;EACE,yBAAA;AAtyBF;AAwyBE;EACE,yBAAA;AAtyBJ;;AA2yBA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,gBAAA;AAxyBF;AA2yBE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAzyBJ;AA2yBI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,gDAAA;AAzyBN;AA2yBM;EACE,oCAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAzyBR;AA2yBQ;EACE,eAAA;AAzyBV;AA6yBM;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,OAAA;EACA,kBAAA;AA3yBR;AA8yBM;EACE,WAAA;AA5yBR;AAgzBI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;AA9yBN;AAgzBM;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA9yBR;AAgzBQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AA9yBV;AAkzBM;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;AAhzBR;AAmzBM;EACE,eAAA;EACA,WAAA;EACA,SAAA;AAjzBR;AAozBM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;AAlzBR;AAozBQ;EACE,mBAAA;EACA,sBAAA;AAlzBV;AAqzBQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAnzBV;AAqzBU;EACE,eAAA;AAnzBZ;AA2zBE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AAzzBJ;AA2zBI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gDAAA;EACA,4EAAA;EAKA,kBAAA;EACA,WAAA;AA7zBN;AA+zBM;EACE,oCAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AA7zBR;AA+zBQ;EACE,eAAA;AA7zBV;AAi0BM;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,OAAA;EACA,kBAAA;AA/zBR;AAk0BM;EACE,WAAA;AAh0BR;AAo0BI;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAl0BN;AAo0BM;EACE,WAAA;EACA,YAAA;AAl0BR;AAo0BQ;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;AAl0BV;AAs0BM;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,0EAAA;EAKA,eAAA;EACA,gBAAA;EACA,WAAA;AAx0BR;AA60BI;EACE,OAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,iCAAA;AA30BN;AA60BM;EACE,2BAAA;EACA,2BAAA;EACA,gCAAA;EACA,iDAAA;AA30BR;AA60BQ;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,iCAAA;AA30BV;AA60BU;EACE,gBAAA;EACA,iBAAA;EACA,qBAAA;AA30BZ;AA80BU;EACE,gBAAA;EACA,MAAA;EACA,WAAA;EACA,gBAAA;EACA,gCAAA;EACA,wCAAA;AA50BZ;AAg1BQ;EACE,aAAA;EACA,gBAAA;AA90BV;AAg1BU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA90BZ;AAg1BY;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AA90Bd;AAi1BY;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA/0Bd;AAm1BU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAj1BZ;AAm1BY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AAj1Bd;AAm1Bc;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAj1BhB;AAq1BY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AAn1Bd;AAq1Bc;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAn1BhB;AAy1BQ;EACE,UAAA;EACA,aAAA;EACA,gBAAA;EACA,oCAAA;AAv1BV;AAy1BU;EACE,aAAA;AAv1BZ;AAy1BY;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAv1Bd;AA01BY;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AAx1Bd;AA21BY;EACE,WAAA;EACA,mBAAA;AAz1Bd;AA41BY;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA11Bd;AA61BY;EACE,mBAAA;AA31Bd;AA61Bc;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;AA31BhB;AA61BgB;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;AA31BlB;AA81BgB;EACE,mBAAA;EACA,qBAAA;AA51BlB;AA+1BgB;EACE,cAAA;AA71BlB;AA+1BkB;EACE,eAAA;AA71BpB;AAi2BgB;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA/1BlB;AAk2BgB;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAh2BlB;AAo2Bc;EACE,WAAA;EACA,gBAAA;AAl2BhB;AAo2BgB;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAl2BlB;AAo2BkB;EACE,YAAA;EACA,mBAAA;EACA,2BAAA;AAl2BpB;AAu2Bc;;EAEE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAr2BhB;AAw2Bc;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAt2BhB;AA02BY;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;AAx2Bd;AA02Bc;EACE,eAAA;EACA,cAAA;AAx2BhB;AA42BY;;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;AA12Bd;AA42Bc;;EACE,mBAAA;EACA,sBAAA;AAz2BhB;AA42Bc;;EACE,gBAAA;EACA,mBAAA;EACA,YAAA;AAz2BhB;AA42Bc;;EACE,SAAA;AAz2BhB;AA22BgB;;EACE,YAAA;AAx2BlB;AA42Bc;;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAz2BhB;AA82BY;EACE,gBAAA;AA52Bd;AA82Bc;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AA52BhB;AA82BgB;EACE,eAAA;EACA,cAAA;AA52BlB;AAg3Bc;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AA92BhB;AAg3BgB;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AA92BlB;AAi3BgB;EACE,OAAA;AA/2BlB;AAi3BkB;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AA/2BpB;AAk3BkB;EACE,eAAA;EACA,cAAA;EACA,SAAA;AAh3BpB;AAo3BgB;EACE,aAAA;EACA,QAAA;AAl3BlB;AAo3BkB;EACE,uBAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAl3BpB;AAo3BoB;EACE,mBAAA;AAl3BtB;AAq3BoB;EACE,eAAA;AAn3BtB;AA23BY;EACE,gBAAA;AAz3Bd;AA23Bc;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAz3BhB;AA23BgB;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAz3BlB;AA23BkB;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAz3BpB;AA43BkB;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;AA13BpB;AA83BgB;;EAEE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AA53BlB;AA+3BgB;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AA73BlB;AAg4BgB;EACE,aAAA;EACA,QAAA;EACA,yBAAA;AA93BlB;AAo4BY;EACE,gBAAA;AAl4Bd;AAo4Bc;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AAl4BhB;AAq4Bc;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAn4BhB;AAq4BgB;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;AAn4BlB;AAq4BkB;EACE,cAAA;EACA,eAAA;AAn4BpB;AAs4BkB;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAp4BpB;AAw4BgB;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AAt4BlB;AAy4BgB;EACE,aAAA;EACA,QAAA;EACA,yBAAA;AAv4BlB;AA64BY;EACE,gBAAA;AA34Bd;AA64Bc;EACE,gBAAA;AA34BhB;AA84Bc;EACE,eAAA;AA54BhB;AA+4Bc;EACE,eAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AA74BhB;AAg5Bc;EACE,gBAAA;AA94BhB;AAg5BgB;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AA94BlB;AAg5BkB;EACE,cAAA;EACA,cAAA;AA94BpB;AAi5BkB;EACE,OAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA/4BpB;AAw5BY;EACE,aAAA;AAt5Bd;AAw5Bc;EACE,mBAAA;AAt5BhB;AAw5BgB;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAt5BlB;AAy5BgB;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;AAv5BlB;AA05BgB;;EAEE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAx5BlB;AA25BgB;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;AAz5BlB;AA45BgB;EACE,cAAA;AA15BlB;AAo6BI;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,sDAAA;EACA,gBAAA;EACA,6BAAA;EACA,0CAAA;AAl6BN;AAo6BM;EACE,OAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAl6BR;AAo6BQ;EACE,mBAAA;EACA,cAAA;AAl6BV;AAo6BU;EACE,mBAAA;EACA,sBAAA;AAl6BZ;AAs6BQ;EACE,mBAAA;EACA,WAAA;AAp6BV;AAs6BU;EACE,mBAAA;EACA,sBAAA;AAp6BZ;AAu6BU;EACE,gBAAA;EACA,mBAAA;AAr6BZ;;AA86BA;EACE;IACE,wBAAA;EA36BF;AACF;AA+6BA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AA76BF;AAg7BI;EACE,aAAA;EACA,eAAA;EACA,QAAA;AA96BN;AAi7BI;EACE,eAAA;EACA,yBAAA;EACA,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,6BAAA;AA/6BN;AAi7BM;EACE,oCAAA;EACA,sBAAA;EACA,wCAAA;AA/6BR;AAk7BM;EACE,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,qBAAA;EACA,2BAAA;AAh7BR;AAk7BQ;EACE,UAAA;EACA,oDAAA;AAh7BV;AAm7BQ;EACE,yBAAA;AAj7BV;;AA27BI;EACE,kBAAA;EACA,6BAAA;AAx7BN;AA07BM;EACE,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,qBAAA;EACA,2BAAA;AAx7BR;AA07BQ;EACE,UAAA;EACA,oDAAA;AAx7BV;AA27BQ;EACE,yBAAA;AAz7BV;;AAg8BA,gDAAA;AACA;EA+CE,0EAAA;AA3+BF;AA67BE;EACE,8BAAA;EACA,yBAAA;AA37BJ;AA87BE;;;;;;;;;;;;;;;;EAgBE,8BAAA;EACA,yBAAA;EACA,kDAAA;AA57BJ;AA+7BE;;;;;;;;;;;;;;;;;EAiBE,yBAAA;AA77BJ;AAi8BE;EACE,yBAAA;EACA,qCAAA;EACA,eAAA;AA/7BJ;AAi8BI;EACE,yBAAA;AA/7BN;AAk8BI;EACE,yBAAA;AAh8BN;AAo8BE;;;;;;;EAOE,8BAAA;EACA,yBAAA;AAl8BJ;AAq8BE;;;;;;;;EAQE,6CAAA;EACA,mDAAA;AAn8BJ;AAs8BE;;;;EAIE,yBAAA;AAp8BJ;;AAw8BA,mEAAA;AAEE;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAt8BJ;AAy8BE;;;;;EAKE,8BAAA;EACA,yBAAA;AAv8BJ;AA08BE;;;;;;;;;;;;EAYE,8BAAA;EACA,oCAAA;AAx8BJ;;AA48BA,wDAAA;AAEE;EACE,8BAAA;EACA,yBAAA;AA18BJ;AA68BE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiCE,8BAAA;EACA,yBAAA;EACA,iDAAA;AA38BJ;AA88BE;;;;;;;;;;EAUE,8BAAA;EACA,yBAAA;AA58BJ;;AAg9BA,yGAAA;AAEE;;EAEE,yBAAA;AA98BJ;AAi9BE;;;EAGE,yBAAA;AA/8BJ;;AAo9BE;;;;;EAKE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAj9BJ;AAo9BE;;EAEE,8BAAA;AAl9BJ;AAq9BE;;;;;;;;;EASE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAn9BJ;AAs9BE;;EAEE,yBAAA;EACA,0BAAA;AAp9BJ;AAu9BE;EACE,yBAAA;AAr9BJ;;AAy9BA,8FAAA;AAEE;EACE,8BAAA;EACA,kDAAA;AAv9BJ;AA09BE;EACE,8BAAA;EACA,kDAAA;EACA,mDAAA;AAx9BJ;AA09BI;EACE,oDAAA;EACA,gCAAA;AAx9BN;AA49BE;EACE,8BAAA;EACA,kDAAA;AA19BJ;AA69BE;EACE,8BAAA;EACA,yBAAA;AA39BJ;AA89BE;EACE,yBAAA;AA59BJ;AA+9BE;EACE,yBAAA;AA79BJ;AAg+BE;EACE,8BAAA;EACA,yBAAA;AA99BJ;AAi+BE;EACE,wEAAA;EACA,kDAAA;AA/9BJ;AAk+BE;EACE,yBAAA;AAh+BJ;AAm+BE;;EAEE,yBAAA;AAj+BJ;AAo+BE;EACE,8BAAA;EACA,yBAAA;AAl+BJ;AAq+BE;EACE,yBAAA;AAn+BJ;AAs+BE;EACE,yBAAA;AAp+BJ;AAu+BE;EACE,yBAAA;AAr+BJ;AAw+BE;EACE,8BAAA;EACA,iDAAA;AAt+BJ;;AA0+BA,8FAAA;AAGE;;EAEE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAz+BJ;AA2+BI;;EACE,8BAAA;AAx+BN;AA4+BE;;EAEE,yBAAA;EACA,gCAAA;AA1+BJ;AA4+BI;;EACE,+CAAA;AAz+BN;AA8+BE;EACE,8BAAA;EACA,sDAAA;AA5+BJ;AA8+BI;EACE,8BAAA;EACA,yBAAA;AA5+BN;AA8+BM;EACE,8BAAA;AA5+BR;AAk/BE;;EAEE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAh/BJ;AAk/BI;;EACE,8BAAA;AA/+BN;AAk/BI;;EACE,yBAAA;AA/+BN;AAo/BE;;EAEE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAl/BJ;AAo/BI;;;;EAEE,yBAAA;AAh/BN;AAm/BI;;EACE,8BAAA;EACA,iDAAA;AAh/BN;AAq/BE;;EAEE,oCAAA;EACA,yBAAA;AAn/BJ;AAq/BI;;EACE,oCAAA;AAl/BN;AAq/BI;;EACE,yBAAA;AAl/BN;AAo/BM;;EACE,yBAAA;AAj/BR;AAo/BM;;EACE,sDAAA;AAj/BR;AAs/BE;;EAEE,yBAAA;AAp/BJ;AAs/BI;;EACE,yBAAA;AAn/BN;AAw/BE;;EAEE,yBAAA;AAt/BJ;AAw/BI;;EACE,yBAAA;AAr/BN;AA0/BE;EACE,8BAAA;EACA,kDAAA;AAx/BJ;AA4/BE;;EAEE,kCAAA;EACA,2BAAA;AA1/BJ;AA8/BE;EACE,+CAAA;AA5/BJ;AAggCE;EACE,8BAAA;AA9/BJ;AAkgCE;EACE,yBAAA;AAhgCJ;AAkgCI;EACE,gCAAA;EACA,kCAAA;EACA,yBAAA;AAhgCN;AAmgCI;;EAEE,yBAAA;AAjgCN;AAsgCE;;EAEE,yBAAA;AApgCJ;AAsgCI;;EACE,8CAAA;EACA,yBAAA;EACA,gCAAA;AAngCN;AAsgCI;;;;;;EAGE,yBAAA;AAjgCN;AAsgCE;EACE,8BAAA;AApgCJ;AAsgCI;EACE,8BAAA;AApgCN;AAugCI;EACE,yBAAA;AArgCN;AAwgCI;EACE,yBAAA;AAtgCN;AA2gCE;EACE,8BAAA;EACA,kDAAA;AAzgCJ;AA6gCE;;EAEE,8BAAA;EACA,yBAAA;EACA,sDAAA;AA3gCJ;AA6gCI;;EACE,8BAAA;AA1gCN;;AA+gCA,uFAAA;AAEE;;EAEE,8BAAA;EACA,kDAAA;AA7gCJ;AA+gCI;;EACE,yBAAA;AA5gCN;AAghCE;;EAEE,yBAAA;AA9gCJ;;AAkhCA,6FAAA;AAGE;EACE,8BAAA;EACA,kDAAA;AAjhCJ;AAmhCI;EACE,yBAAA;AAjhCN;AAshCE;EACE,8BAAA;EACA,yBAAA;EACA,+DAAA;AAphCJ;AAshCI;EACE,8BAAA;EACA,yBAAA;AAphCN;AAuhCI;EACE,sDAAA;AArhCN;AAwhCI;EACE,yBAAA;AAthCN;AA2hCE;EACE,8BAAA;EACA,kDAAA;AAzhCJ;AA2hCI;EACE,yBAAA;AAzhCN;AA4hCI;EACE,yBAAA;AA1hCN;AA+hCE;EACE,8BAAA;AA7hCJ;AA+hCI;EACE,yBAAA;AA7hCN;AAgiCI;EACE,yBAAA;AA9hCN;AAmiCI;EACE,yBAAA;AAjiCN;AAoiCI;EACE,yBAAA;AAliCN;AAuiCE;EACE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAriCJ;AAuiCI;EACE,8CAAA;EACA,gCAAA;AAriCN;AAwiCI;EACE,8BAAA;AAtiCN;AA0iCE;EACE,yBAAA;AAxiCJ;AA2iCE;EACE,yBAAA;AAziCJ;AA6iCE;EACE,8BAAA;EACA,kDAAA;AA3iCJ;AA6iCI;EACE,yBAAA;AA3iCN;AA8iCI;EACE,yBAAA;AA5iCN;AAijCE;EACE,8BAAA;EACA,kDAAA;AA/iCJ;AAkjCE;EACE,8BAAA;EACA,+DAAA;AAhjCJ;AAojCE;;EAEE,8BAAA;EACA,yBAAA;AAljCJ;AAsjCE;;EAEE,8BAAA;EACA,kDAAA;AApjCJ;AAujCE;;EAEE,yDAAA;AArjCJ;AAujCI;;EACE,yBAAA;AApjCN;AAyjCE;;EAEE,oCAAA;EACA,qCAAA;AAvjCJ;;AA2jCA,oFAAA;AAKE;;EAEE,8BAAA;EACA,kDAAA;EACA,oDAAA;AA5jCJ;AA+jCE;;EAEE,yBAAA;AA7jCJ;AAgkCE;;EAEE,yBAAA;AA9jCJ;AAmkCE;;EAEE,8BAAA;EACA,kDAAA;AAjkCJ;AAokCE;;EAEE,yBAAA;AAlkCJ;AAqkCE;;EAEE,yBAAA;AAnkCJ;AAwkCE;;EAEE,8BAAA;EACA,kDAAA;AAtkCJ;AAykCE;;EAEE,yBAAA;AAvkCJ;AA2kCE;;EAEE,8BAAA;EACA,yBAAA;AAzkCJ;AA4kCE;;EAEE,8BAAA;EACA,kDAAA;EACA,yBAAA;AA1kCJ;AA4kCI;;EACE,gCAAA;AAzkCN;AA4kCI;;;;EAEE,yBAAA;AAxkCN;AA8kCE;;EAEE,8BAAA;EACA,kDAAA;AA5kCJ;AA+kCE;;EAEE,yBAAA;AA7kCJ;AAglCE;;EAEE,qDAAA;AA9kCJ;AAmlCE;;EAEE,yBAAA;AAjlCJ;AAolCE;;EAEE,yBAAA;AAllCJ;AAqlCI;;;;;;EACE,yBAAA;AA9kCN;AAklCE;;EAEE,kCAAA;AAhlCJ;AAmlCM;;EACE,yBAAA;AAhlCR;;AAslCA,8EAAA;AAKE;;;;EAIE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAvlCJ;AA0lCE;;EAEE,8BAAA;EACA,yBAAA;AAxlCJ;AA6lCE;;EAEE,8BAAA;EACA,kDAAA;AA3lCJ;AA8lCE;;EAEE,8BAAA;EACA,kDAAA;EACA,2CAAA;AA5lCJ;AA+lCE;;EAEE,8BAAA;EACA,yBAAA;EACA,kDAAA;AA7lCJ;AA+lCI;;EACE,8BAAA;AA5lCN;AAgmCE;;EAEE,8BAAA;EACA,yBAAA;EACA,gCAAA;AA9lCJ;AAkmCE;;EAEE,8BAAA;AAhmCJ;AAmmCE;;EAEE,8BAAA;AAjmCJ;AAqmCE;;EAEE,8BAAA;AAnmCJ;AAsmCE;;EAEE,8BAAA;EACA,kDAAA;AApmCJ;AAwmCE;;EAEE,8BAAA;EACA,kDAAA;AAtmCJ;AAymCE;;EAEE,yBAAA;AAvmCJ;AAymCI;;EACE,yBAAA;AAtmCN;AAymCI;;EACE,yBAAA;AAtmCN;AA0mCE;;EAEE,8BAAA;EACA,yBAAA;EACA,gCAAA;AAxmCJ;AA0mCI;;EACE,8BAAA;EACA,yBAAA;AAvmCN;AA6mCE;;EAEE,yBAAA;EACA,yDAAA;AA3mCJ;AA8mCE;;EAEE,8BAAA;EACA,kDAAA;AA5mCJ;AA+mCE;;EAEE,8BAAA;EACA,yBAAA;AA7mCJ;AAgnCE;;EAEE,yBAAA;AA9mCJ;AAinCE;;EAEE,yBAAA;AA/mCJ;AAmnCE;;EAEE,8BAAA;EACA,kDAAA;AAjnCJ;AAmnCI;;EACE,gCAAA;AAhnCN;AAonCE;;EAEE,8BAAA;EACA,kDAAA;AAlnCJ;AAsnCE;;EAEE,8BAAA;EACA,kDAAA;AApnCJ;AAunCE;;EAEE,yBAAA;AArnCJ;AA0nCE;;;;EAIE,8BAAA;EACA,kDAAA;AAxnCJ;AA2nCE;;EAEE,8BAAA;EACA,wDAAA;AAznCJ;AA6nCE;;EAEE,8BAAA;EACA,kDAAA;AA3nCJ;AA6nCI;;EACE,yBAAA;AA1nCN;AAgoCE;;EAEE,8BAAA;EACA,kDAAA;AA9nCJ;AAgoCI;;EACE,yBAAA;AA7nCN;AAioCE;;EAEE,+CAAA;EACA,qCAAA;EACA,yBAAA;AA/nCJ;AAioCI;;EACE,yBAAA;AA9nCN;AAioCI;;EACE,6CAAA;EACA,qCAAA;EACA,yBAAA;AA9nCN;AAkoCE;;EAEE,8CAAA;EACA,qCAAA;AAhoCJ;AAqoCE;;;;;;EAME,yBAAA;AAnoCJ;AAsoCE;;EAEE,yBAAA;AApoCJ;;AAwoCA,qDAAA;AAME;EACE,8BAAA;EACA,kDAAA;AA1oCJ;AA8oCE;;EAEE,8BAAA;EACA,yBAAA;EACA,kDAAA;AA5oCJ;AA8oCI;;EACE,8BAAA;AA3oCN;AAgpCE;;EAEE,8BAAA;AA9oCJ;AAipCE;;EAEE,yBAAA;AA/oCJ;AAkpCE;;EAEE,yBAAA;AAhpCJ;AAmpCE;;EAEE,yBAAA;AAjpCJ;AAmpCI;;EACE,yBAAA;EACA,gDAAA;AAhpCN;AAupCE;;EAEE,yBAAA;AArpCJ;AAypCE;;EAEE,yBAAA;AAvpCJ;AA2pCE;;EAEE,8BAAA;EACA,kDAAA;AAzpCJ;AA2pCI;;EACE,8BAAA;EACA,kDAAA;AAxpCN;AA2pCI;;EACE,8BAAA;EACA,kDAAA;AAxpCN;AA2pCI;;EACE,8BAAA;EACA,yBAAA;AAxpCN;AA+pCE;;EAEE,8BAAA;AA7pCJ;AAiqCE;;;;EAIE,8BAAA;EACA,kDAAA;EACA,mDAAA;AA/pCJ;AAmqCE;;EAEE,yBAAA;AAjqCJ;AAoqCE;;;;EAIE,yBAAA;AAlqCJ;AAqqCE;;;;EAIE,yBAAA;AAnqCJ;AAuqCE;;;;EAIE,yBAAA;EACA,kDAAA;AArqCJ;AAuqCI;;;;EACE,8BAAA;AAlqCN;AAuqCE;;EAEE,8BAAA;EACA,yBAAA;EACA,kDAAA;AArqCJ;AAuqCI;;EACE,8BAAA;AApqCN;AAyqCE;;EAEE,8BAAA;EACA,kDAAA;AAvqCJ;AAyqCI;;;;;;EACE,yBAAA;AAlqCN;;AAuqCA,2DAAA;AAKE;;EAEE,8BAAA;AAxqCJ;AA6qCE;;EAEE,wEAAA;EACA,yBAAA;EACA,4BAAA;EACA,6BAAA;EACA,qDAAA;EACA,6BAAA;AA3qCJ;AA6qCI;;EACE,yBAAA;AA1qCN;AAgrCE;;EAEE,8BAAA;EACA,yDAAA;EACA,iCAAA;AA9qCJ;AAgrCI;;EACE,8BAAA;AA7qCN;AAirCI;;;;EACE,yBAAA;AA5qCN;AAgrCI;;EACE,yBAAA;AA7qCN;AAirCI;;EACE,qDAAA;EACA,8BAAA;AA9qCN;AAorCE;;EAEE,iDAAA;AAlrCJ;AAurCE;;EAEE,8BAAA;EACA,qDAAA;EACA,6BAAA;AArrCJ;AAurCI;;EACE,8BAAA;AAprCN;AAurCI;;EACE,yBAAA;AAprCN;AAurCI;;;EACE,yBAAA;AAnrCN;AAyrCE;;;;EAIE,8BAAA;EACA,oCAAA;AAvrCJ;AA4rCE;;EAEE,oCAAA;EACA,iDAAA;AA1rCJ;AA6rCE;;EAEE,oCAAA;EACA,gCAAA;AA3rCJ;;AA+rCA,qEAAA;AAIE;;EAEE,8BAAA;EACA,yDAAA;AA/rCJ;AAisCI;;EACE,yBAAA;AA9rCN;AAmsCE;;EAEE,8BAAA;EACA,kDAAA;EACA,2CAAA;AAjsCJ;AAmsCI;;EACE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAhsCN;AAksCM;;EACE,8BAAA;AA/rCR;AAksCM;;EACE,8BAAA;EACA,yBAAA;EACA,gCAAA;AA/rCR;AAqsCE;;EAEE,yBAAA;AAnsCJ;AAusCE;;;;EAIE,8BAAA;EACA,yBAAA;EACA,gCAAA;AArsCJ;AAusCI;;;;EACE,8BAAA;EACA,yBAAA;AAlsCN;AAusCE;;EAEE,yBAAA;AArsCJ;AAysCE;;EAEE,8BAAA;EACA,kDAAA;AAvsCJ;AAysCI;;;EACE,yBAAA;AArsCN;AAwsCI;;EACE,yBAAA;AArsCN;AAwsCI;;EACE,yBAAA;AArsCN;AAusCM;;EACE,yBAAA;AApsCR;;AA0sCA;;;;sOAAA;AASE;;EAEE,wDAAA;AA3sCJ;AA6sCI;;EACE,yBAAA;AA1sCN;AA6sCI;;EACE,yBAAA;AA1sCN;AA6sCI;;EACE,yBAAA;AA1sCN;AA6sCI;;EACE,yBAAA;AA1sCN;AA4sCM;;EACE,yBAAA;AAzsCR;AA8sCI;;EACE,8BAAA;EACA,yBAAA;AA3sCN;AA6sCM;;EACE,yBAAA;AA1sCR;AA6sCM;;EACE,yBAAA;AA1sCR;AA6sCM;;EACE,8BAAA;AA1sCR;AAitCE;;EAEE,wDAAA;AA/sCJ;AAitCI;;EACE,yBAAA;AA9sCN;AAitCI;;EACE,yBAAA;AA9sCN;AAgtCM;;EACE,yBAAA;AA7sCR;AAitCI;;EACE,yBAAA;AA9sCN;AAgtCM;;EACE,yBAAA;AA7sCR;AAotCE;;EAEE,8BAAA;EACA,yBAAA;AAltCJ;AAutCE;;EAEE,8BAAA;EACA,yBAAA;EACA,kDAAA;AArtCJ;AAutCI;;EACE,yBAAA;AAptCN;AAutCI;;EACE,yBAAA;AAptCN;AAutCI;;EACE,8BAAA;EACA,kDAAA;AAptCN;AAytCE;;EAEE,8BAAA;EACA,gCAAA;AAvtCJ;AAytCI;;;;EAEE,yBAAA;AArtCN;AA2tCE;;EAEE,8BAAA;EACA,kDAAA;EACA,yBAAA;AAztCJ;AA2tCI;;;;EAEE,yBAAA;AAvtCN;AA2tCI;;EACE,6CAAA;AAxtCN;AA8tCE;;EAEE,8BAAA;EACA,yBAAA;EACA,oCAAA;AA5tCJ;AA+tCE;EACE,8BAAA;EACA,yBAAA;AA7tCJ;AAguCE;EACE,8BAAA;EACA,gCAAA;EACA,yBAAA;AA9tCJ;AAiuCE;EACE,8BAAA;EACA,iDAAA;AA/tCJ;AAiuCI;EACE,yBAAA;AA/tCN;AAmuCE;EACE,kCAAA;EACA,yBAAA;EACA,gDAAA;AAjuCJ;AAquCI;EACE,4CAAA;EACA,yBAAA;AAnuCN;AAsuCI;EAEE,+CAAA;EACA,yBAAA;AAruCN;AAwuCI;EACE,8CAAA;EACA,yBAAA;AAtuCN;AA0uCE;EACE,8BAAA;EACA,wDAAA;AAxuCJ;AA2uCE;EACE,8BAAA;AAzuCJ;AA2uCI;EACE,yBAAA;AAzuCN;AA6uCE;EACE,yBAAA;AA3uCJ;AA8uCE;EACE,yBAAA;AA5uCJ;AAivCE;;EAEE,2CAAA;AA/uCJ;AAivCI;;EACE,8BAAA;AA9uCN;AAivCI;;EACE,8BAAA;AA9uCN;AAgvCM;;EACE,8BAAA;AA7uCR;;AAmvCA,sEAAA;AAIE;EACE,8BAAA;EACA,sDAAA;EACA,qDAAA;AAnvCJ;AAuvCE;EACE,8BAAA;EACA,wDAAA;AArvCJ;AAuvCI;EACE,yBAAA;AArvCN;AAyvCI;EACE,8BAAA;EACA,yBAAA;EACA,sDAAA;AAvvCN;AAyvCM;EACE,yBAAA;AAvvCR;AA0vCM;EACE,8BAAA;AAxvCR;AA8vCE;EACE,8BAAA;AA5vCJ;AAgwCE;EACE,yBAAA;AA9vCJ;AAkwCE;EACE,yBAAA;AAhwCJ;AAmwCE;EACE,yBAAA;AAjwCJ;AAowCE;EACE,yBAAA;AAlwCJ;AAqwCI;EACE,yBAAA;AAnwCN;AAuwCE;EACE,yBAAA;AArwCJ;AAywCE;EACE,8BAAA;EACA,qDAAA;AAvwCJ;AAywCI;EACE,8BAAA;EACA,yBAAA;EACA,sDAAA;EACA,6BAAA;AAvwCN;AAywCM;EACE,8BAAA;AAvwCR;;AA6wCA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,WAAA;AA1wCF;AA4wCE;EACE,YAAA;EACA,cAAA;AA1wCJ;AA6wCE;EACE,OAAA;AA3wCJ;;AA+wCA,0EAAA;AAEE;EACE,yBAAA;AA7wCJ;AAgxCE;EACE,yBAAA;AA9wCJ;AAixCE;EACE,8BAAA;EACA,kDAAA;EACA,yBAAA;AA/wCJ;AAixCI;EACE,yBAAA;AA/wCN;AAkxCI;EACE,8BAAA;AAhxCN;AAoxCE;EACE,8BAAA;EACA,iDAAA;AAlxCJ;AAoxCI;EACE,yBAAA;AAlxCN;AAqxCI;EACE,8BAAA;AAnxCN;AAqxCM;EACE,yBAAA;AAnxCR;;AAyxCA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAtxCF;;AA0xCA;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAvxCF;;AA0xCA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAvxCF;AAyxCE;EATF;IAUI,mBAAA;IACA,oBAAA;IACA,SAAA;EAtxCF;AACF;;AAyxCA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,iFAAA;AAtxCF;AAwxCE;EACE,qBAAA;EACA,mBAAA;AAtxCJ;AAyxCE;EACE,qBAAA;EACA,mBAAA;EACA,mCAAA;AAvxCJ;AA0xCE;EACE,aAAA;EACA,mBAAA;AAxxCJ;AA2xCE;EA9BF;IA+BI,WAAA;IACA,YAAA;IACA,mBAAA;IACA,QAAA;IACA,kBAAA;EAxxCF;AACF;;AA2xCA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;AAxxCF;;AA2xCA;EACE,cAAA;EACA,YAAA;AAxxCF;AA0xCE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAxxCJ;AA2xCE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAzxCJ;AA4xCE;EACE;IACE,eAAA;IACA,iBAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;EA1xCJ;EA6xCE;IACE,aAAA;EA3xCJ;AACF;;AA+xCA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;AA5xCF;;AA+xCA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AA5xCF;;AAgyCE;EACE,WAAA;AA7xCJ;AAgyCE;;;EAGE,cAAA;EACA,WAAA;EACA,eAAA;AA9xCJ;;AAkyCA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AA/xCF;AAiyCE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA/xCJ;AAkyCE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAhyCJ;AAmyCE;EACE,aAAA;EACA,4DAAA;EACA,cAAA;AAjyCJ;AAmyCI;EACE,eAAA;AAjyCN;;AAsyCA;;EAEE,iBAAA;AAnyCF;AAqyCE;;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AAlyCJ;AAoyCI;;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAjyCN;AAoyCI;;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAjyCN;AAmyCM;;EACE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,kEAAA;EACA,0BAAA;AAhyCR;AAmyCM;;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAhyCR;AAoyCI;;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AAjyCN;AAoyCI;;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAjyCN;AAoyCI;;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAjyCN;AAqyCE;;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AAlyCJ;AAoyCI;;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAjyCN;AAoyCI;;EACE,cAAA;EACA,eAAA;EACA,cAAA;AAjyCN;AAoyCI;;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAjyCN;AAoyCI;;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,yCAAA;AAjyCN;AAmyCM;;EACE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,4BAAA;AAhyCR;AAmyCM;;EACE,mBAAA;EACA,WAAA;AAhyCR;AAqyCE;;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;AAlyCJ;AAoyCI;;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAjyCN;;AAsyCA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAnyCF;;AAsyCA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AAnyCF;AAqyCE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAnyCJ;AAsyCE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;AApyCJ;AAsyCI;EACE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,0BAAA;AApyCN;AAuyCI;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAryCN;AAyyCE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAvyCJ;AA0yCE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;AAxyCJ;AA0yCI;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAxyCN;AA4yCE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,yCAAA;AA1yCJ;AA4yCI;EACE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,4BAAA;AA1yCN;AA6yCI;EACE,mBAAA;EACA,WAAA;AA3yCN;;AAizCE;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;AA9yCJ","sourcesContent":[".step-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  line-height: 1.2;\n  white-space: nowrap;\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  padding: 8px 16px;\n  border-radius: 35px;\n  border: 2px solid currentColor;\n  background: transparent;\n  flex-shrink: 0;\n}\n\n.step-label .step-count,\n.step-label .label-text {\n  display: inline-flex;\n  align-items: center;\n  white-space: nowrap;\n}\n\n.step-label.complete {\n  border-color: #16a34a;\n  color: #16a34a;\n  background: rgba(22, 163, 74, 0.1);\n}\n\n.step-label .label-check {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n}\n\n.step-label.complete .label-check {\n  font-size: 18px;\n  margin-left: 0.15rem;\n}\n\n.square_btn {\n  text-align: center;\n  padding: 7px 20px;\n  border-radius: 25px;\n  border: 1px solid #5ea1d8;\n  text-decoration: none;\n  color: #5ea1d8;\n  background-image: -webkit-linear-gradient(45deg, white 0%, white 100%);\n  background-image: linear-gradient(45deg, white 0%, white 100%);\n\n  transition: 0.4s;\n  font-family: \"Raleway\";\n}\n\n.square_btn:hover {\n  color: white;\n  background-image: -webkit-linear-gradient(45deg, #5ea1d8 0%, #5ea1d8 100%);\n  background-image: linear-gradient(45deg, #5ea1d8 0%, #5ea1d8 100%);\n}\n\n.publish {\n  font-family: \"Raleway\";\n  cursor: pointer;\n\n  text-align: center;\n  padding: 4px 20px;\n  border-radius: 25px;\n  border: 1px solid #5ea1d8;\n  text-decoration: none;\n  background-color: #5ea1d8 !important;\n  color: white;\n  height: 40px;\n  transition: 0.4s;\n  span {\n    color: #fff !important;\n  }\n\n  &:hover {\n    background: #5ea1d8 !important;\n    border: 1px solid #5ea1d8;\n  }\n}\n\n.upload-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  overflow: hidden;\n}\n\n.upload-dialog {\n  width: 90%;\n  max-width: 1380px;\n  height: 90vh;\n  max-height: 90vh;\n  background: #fff;\n  border-radius: 22px;\n  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin: auto;\n  z-index: 10000;\n}\n\n.upload-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 5px 10px;\n  background: #fff;\n  color: #111827;\n  border-bottom: 1px solid #e4e8f0;\n  position: relative;\n  z-index: 10008;\n  isolation: isolate;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.header-right {\n  position: relative;\n  z-index: 10009;\n  isolation: isolate;\n}\n\n.icon-circle {\n  width: 54px;\n  height: 54px;\n  border-radius: 50%;\n  background: #f3f4f6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  mat-icon {\n    color: #5ea1d8;\n    font-size: 24px;\n  }\n}\n\n.header-copy {\n  min-width: 0;\n  p {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 600;\n  }\n  span {\n    font-size: 14px;\n    color: #6b7280;\n  }\n}\n\n.mobile-current-access-bar {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .mobile-current-access-bar {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    width: 100%;\n    box-sizing: border-box;\n    margin: 0;\n    padding: 10px 16px;\n    background: #eef6fc;\n    border-bottom: 1px solid rgba(94, 161, 216, 0.35);\n  }\n\n  .mobile-access-icon-wrap {\n    width: 36px;\n    height: 36px;\n    border-radius: 10px;\n    background: #d7ebf8;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n\n    mat-icon {\n      color: #1565c0;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n      line-height: 20px;\n      overflow: visible;\n    }\n  }\n\n  .mobile-access-copy {\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n\n    .mobile-access-kicker {\n      font-size: 10px;\n      font-weight: 700;\n      letter-spacing: 0.06em;\n      text-transform: uppercase;\n      color: #1976d2;\n    }\n\n    strong {\n      display: block;\n      font-size: 14px;\n      font-weight: 600;\n      color: #0f172a;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n}\n\n.icon-button {\n  border: none;\n  background: #f3f4f6;\n  color: inherit;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.2s ease;\n  position: relative;\n  z-index: 10007;\n  mat-icon {\n    font-size: 22px;\n  }\n  &:hover {\n    background: #e5e7eb;\n    transform: translateY(-1px);\n  }\n}\n\n.create-type-button {\n  margin-right: 8px;\n}\n\n// Create Type Menu Styles\n::ng-deep .create-type-menu {\n  .mat-mdc-menu-content {\n    padding: 8px 0;\n  }\n\n  .mat-mdc-menu-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 16px;\n    padding-right: 100px;\n    min-height: auto;\n    height: auto;\n    position: relative;\n\n    mat-icon {\n      color: #5ea1d8;\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n    }\n\n    .menu-item-content {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n      flex: 1;\n\n      .menu-item-title {\n        font-size: 14px;\n        font-weight: 600;\n        color: #111827;\n        line-height: 1.2;\n        display: block;\n      }\n\n      .menu-item-description {\n        font-size: 12px;\n        color: #6b7280;\n        line-height: 1.2;\n      }\n    }\n\n    .menu-badge.paid {\n      position: absolute !important;\n      top: 10px !important;\n      right: 10px !important;\n      left: auto !important;\n      margin: 0 !important;\n      z-index: 2;\n      padding: 0.2rem 0.55rem;\n      border-radius: 999px;\n      font-size: 0.6rem;\n      font-weight: 700;\n      text-transform: uppercase;\n      letter-spacing: 0.03em;\n      background: #e83e8c !important;\n      color: #ffffff !important;\n      border: none;\n      line-height: 1.2;\n      box-shadow: 0 1px 4px rgba(232, 62, 140, 0.3);\n      pointer-events: none;\n    }\n\n    &:hover {\n      background: #f3f4f6;\n    }\n  }\n}\n\n.stage-banner {\n  padding: 1px 10px 1px;\n  background: #fff;\n  border-bottom: 1px solid #edf1f7;\n  flex-shrink: 0;\n}\n\n.status-badges {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.status-pill {\n  background: #e8f0fe;\n  color: #0f62fe;\n  border-radius: 999px;\n  padding: 6px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.stage-title-row {\n  margin-top: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.stage-title-block {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  flex-wrap: wrap;\n}\n\n.stage-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.stage-meta {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  color: #4a5568;\n  mat-icon {\n    font-size: 20px;\n    color: #1a73e8;\n  }\n}\n\n.helper-text {\n  margin: 10px 0 0;\n  color: #5f6368;\n  font-size: 14px;\n}\n\n.upload-body {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 24px;\n  padding: 10px;\n  background: #fdfdff;\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-height: 0;\n  flex: 1 1 auto;\n\n  // Custom scrollbar styling\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 4px;\n\n    &:hover {\n      background: #a8a8a8;\n    }\n  }\n}\n\n// â”€â”€â”€ Sponsored & Collaboration â€” Cover tab fields â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n.sponsored-label-group {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n\n  .field-prefix-icon {\n    font-size: 18px;\n    height: 18px;\n    width: 18px;\n    color: #888;\n  }\n}\n\n.field-hint {\n  font-size: 12px;\n  color: #777;\n  margin-top: 4px;\n  line-height: 1.4;\n}\n\n.collab-section {\n  border-top: 1px solid #eee;\n  padding-top: 16px;\n}\n\n.collab-fields {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.collab-info-strip {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  background: #e3f2fd;\n  border: 1px solid #90caf9;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 12px;\n  color: #0d47a1;\n  line-height: 1.5;\n\n  mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n    margin-top: 1px;\n  }\n}\n\n.collab-visibility-notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  background: #fff8e1;\n  border: 1px solid #ffe082;\n  border-radius: 8px;\n  padding: 8px 12px;\n  margin-top: 8px;\n  font-size: 12px;\n  color: #e65100;\n  line-height: 1.5;\n\n  mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n    margin-top: 1px;\n    color: #f57c00;\n  }\n}\n\n// â”€â”€â”€ Collaborator badge chips â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n.collab-invitees-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.collab-invitee-badge {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #fff;\n  border: 1.5px solid #e0e0e0;\n  border-radius: 40px;\n  padding: 6px 10px 6px 6px;\n  transition: border-color 0.18s, box-shadow 0.18s;\n\n  &:hover {\n    border-color: #90caf9;\n    box-shadow: 0 2px 8px rgba(33,150,243,0.10);\n  }\n\n  &.badge-expanded {\n    border-radius: 14px;\n  }\n}\n\n.collab-badge-avatar {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n  border: 1.5px solid #e0e0e0;\n}\n\n.collab-badge-initial {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  letter-spacing: 0;\n}\n\n.collab-badge-body {\n  flex: 1;\n  min-width: 0;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.collab-badge-username {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1a1a1a;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.collab-badge-email {\n  font-size: 11px;\n  color: #666;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  animation: fadeSlideIn 0.15s ease;\n}\n\n@keyframes fadeSlideIn {\n  from { opacity: 0; transform: translateY(-3px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.collab-badge-status-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  border-radius: 20px;\n  padding: 2px 8px 2px 5px;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n  flex-shrink: 0;\n\n  mat-icon {\n    font-size: 13px;\n    width: 13px;\n    height: 13px;\n  }\n\n  &.pill-new      { background: #e8eaf6; color: #5c6bc0; }\n  &.pill-pending  { background: #fff8e1; color: #f57f17; }\n  &.pill-accepted { background: #e8f5e9; color: #2e7d32; }\n  &.pill-rejected { background: #fce4ec; color: #c62828; }\n}\n\n.collab-badge-remove {\n  width: 24px !important;\n  height: 24px !important;\n  line-height: 24px !important;\n  flex-shrink: 0;\n  color: #aaa;\n\n  mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    line-height: 16px;\n  }\n\n  &:hover { color: #e53935; }\n}\n\n// dark-mode overrides for the badge chips\n:host-context(body.theme-dark) {\n  .collab-invitee-badge {\n    background: #1e293b;\n    border-color: #334155;\n\n    &:hover { border-color: #60a5fa; box-shadow: 0 2px 8px rgba(96,165,250,0.15); }\n  }\n\n  .collab-badge-username { color: #e2e8f0; }\n  .collab-badge-email    { color: #94a3b8; }\n\n  .collab-badge-status-pill {\n    &.pill-new      { background: #1e1b4b; color: #818cf8; }\n    &.pill-pending  { background: #451a03; color: #fbbf24; }\n    &.pill-accepted { background: #052e16; color: #4ade80; }\n    &.pill-rejected { background: #450a0a; color: #f87171; }\n  }\n\n  .collab-badge-remove { color: #475569; &:hover { color: #f87171; } }\n}\n\n// â”€â”€â”€ Sent-invite chip â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n.collab-sent-chip {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: #e8f5e9;\n  border: 1px solid #a5d6a7;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 13px;\n  color: #1b5e20;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    color: #43a047;\n  }\n}\n\n// â”€â”€â”€ Collab user picker â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n.collab-search-wrapper {\n  position: relative;\n}\n\n.collab-search-results {\n  position: absolute;\n  top: calc(100% - 20px);\n  left: 0;\n  right: 0;\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.10);\n  z-index: 200;\n  max-height: 260px;\n  overflow-y: auto;\n}\n\n.collab-user-result {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  cursor: pointer;\n  border-bottom: 1px solid #f5f5f5;\n  transition: background 0.15s;\n\n  &:last-child { border-bottom: none; }\n  &:hover { background: #f0f7ff; }\n\n  .collab-result-approval {\n    margin-left: auto;\n    font-size: 16px;\n    color: #f59e0b;\n  }\n}\n\n.collab-user-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n  border: 1px solid #e0e0e0;\n}\n\n.collab-user-avatar-placeholder {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #e8eaf6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n\n  mat-icon {\n    font-size: 20px;\n    color: #7986cb;\n  }\n}\n\n.collab-user-info {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-width: 0;\n}\n\n.collab-result-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1a1a1a;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.collab-result-username {\n  font-weight: 400;\n  color: #666;\n  margin-left: 4px;\n}\n\n.collab-result-email {\n  font-size: 11px;\n  color: #888;\n}\n\n.collab-result-bio {\n  font-size: 11px;\n  color: #aaa;\n  font-style: italic;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 200px;\n}\n\n.collab-no-results {\n  padding: 14px;\n  text-align: center;\n  font-size: 13px;\n  color: #999;\n}\n\n// â”€â”€â”€ Selected user chip â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n.collab-selected-user {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #e8f5e9;\n  border: 1px solid #a5d6a7;\n  border-radius: 10px;\n  padding: 10px 12px;\n\n  .collab-user-details {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    flex: 1;\n    min-width: 0;\n  }\n\n  .collab-user-name {\n    font-size: 13px;\n    font-weight: 700;\n    color: #1b5e20;\n  }\n\n  .collab-user-email {\n    font-size: 12px;\n    color: #388e3c;\n  }\n\n  .collab-user-bio {\n    font-size: 11px;\n    color: #555;\n    font-style: italic;\n  }\n\n  .collab-approval-note {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 11px;\n    color: #e65100;\n    margin-top: 4px;\n\n    mat-icon {\n      font-size: 13px;\n      width: 13px;\n      height: 13px;\n    }\n  }\n\n  .collab-card-actions {\n    display: flex;\n    align-items: center;\n    gap: 2px;\n    flex-shrink: 0;\n    margin-left: auto;\n  }\n\n  .collab-add-btn {\n    height: 32px;\n    line-height: 30px;\n    padding: 0 10px;\n    font-size: 13px;\n    white-space: nowrap;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n      margin-right: 2px;\n      vertical-align: middle;\n    }\n  }\n\n  .collab-clear-btn {\n    width: 32px !important;\n    height: 32px !important;\n    line-height: 32px !important;\n    color: #388e3c;\n    flex-shrink: 0;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n}\n\n// â”€â”€â”€ Summary panel cards â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n.sponsored-summary-card,\n.collab-summary-card {\n  .card-header-icon {\n    font-size: 18px;\n    height: 18px;\n    width: 18px;\n    vertical-align: middle;\n    margin-right: 4px;\n    color: #555;\n  }\n\n  h5 {\n    display: flex;\n    align-items: center;\n  }\n\n  .collab-summary-body {\n    margin-top: 8px;\n  }\n}\n\n:host-context(body.theme-dark) {\n  .collab-info-strip {\n    background: rgba(144, 202, 249, 0.1);\n    border-color: rgba(144, 202, 249, 0.3);\n    color: #90caf9;\n  }\n\n  .collab-visibility-notice {\n    background: rgba(255, 224, 130, 0.08);\n    border-color: rgba(255, 224, 130, 0.3);\n    color: #ffcc80;\n\n    mat-icon {\n      color: #ffa726;\n    }\n  }\n\n  .collab-sent-chip {\n    background: rgba(67, 160, 71, 0.12);\n    border-color: rgba(67, 160, 71, 0.3);\n    color: #a5d6a7;\n  }\n\n  .collab-section {\n    border-top-color: #333;\n  }\n\n  .collab-search-results {\n    background: #1e1e2e;\n    border-color: #333;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);\n\n    .collab-user-result {\n      border-bottom-color: #2a2a3a;\n      &:hover { background: #1a2744; }\n    }\n  }\n\n  .collab-result-name { color: #e2e8f0; }\n  .collab-result-email { color: #94a3b8; }\n  .collab-result-bio { color: #64748b; }\n\n  .collab-user-avatar-placeholder {\n    background: #2a2a4a;\n    mat-icon { color: #7986cb; }\n  }\n\n  .collab-selected-user {\n    background: rgba(67, 160, 71, 0.12);\n    border-color: rgba(67, 160, 71, 0.3);\n\n    .collab-user-name { color: #a5d6a7; }\n    .collab-user-email { color: #81c784; }\n    .collab-clear-btn { color: #81c784; }\n  }\n}\n\n// â”€â”€â”€ Collaboration publish status banner â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n@import \"../../shared/styles/publishing-state\";\n\n.collab-publish-banner {\n  padding: 0 32px 12px;\n\n  .collab-banner {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 16px;\n    border-radius: 10px;\n    font-size: 13px;\n    line-height: 1.5;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      flex-shrink: 0;\n    }\n\n    &--pending {\n      background: #fff8e1;\n      border: 1px solid #ffe082;\n      color: #7c5a00;\n      mat-icon { color: #f59e0b; }\n    }\n\n    &--accepted {\n      background: #e8f5e9;\n      border: 1px solid #a5d6a7;\n      color: #1b5e20;\n      mat-icon { color: #43a047; }\n    }\n\n    &--denied {\n      background: #fce4ec;\n      border: 1px solid #f48fb1;\n      color: #880e4f;\n      mat-icon { color: #e91e63; }\n    }\n  }\n}\n\n// Dark-mode overrides for the banner\n:host-context(body.theme-dark) .collab-publish-banner {\n  .collab-banner--pending {\n    background: rgba(245, 158, 11, 0.12);\n    border-color: rgba(245, 158, 11, 0.35);\n    color: #fde68a;\n    mat-icon { color: #fbbf24; }\n  }\n  .collab-banner--accepted {\n    background: rgba(67, 160, 71, 0.12);\n    border-color: rgba(67, 160, 71, 0.35);\n    color: #a5d6a7;\n    mat-icon { color: #6ee7a8; }\n  }\n  .collab-banner--denied {\n    background: rgba(233, 30, 99, 0.12);\n    border-color: rgba(233, 30, 99, 0.35);\n    color: #f48fb1;\n    mat-icon { color: #f472b6; }\n  }\n}\n// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n.upload-footer {\n  padding: 20px 32px;\n  border-top: 1px solid #e4e8f0;\n  background: #fff;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 0 -6px 18px rgba(15, 23, 42, 0.05);\n  flex-shrink: 0;\n\n  .footer-step {\n    flex: 1 1 220px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n}\n\n.footer-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  justify-content: flex-end;\n  flex: 2 1 320px;\n  align-items: center;\n}\n\n/* Disabled buttons swallow hover, so the tooltip with the reason lives on this wrapper */\n.take-public-group {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.take-public-wrap,\n.publish-wrap {\n  display: inline-flex;\n}\n\n.take-public-info {\n  flex: 0 0 auto;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  color: #6b7280;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    line-height: 20px;\n  }\n\n  &:hover,\n  &:focus-visible {\n    color: #5ea1d8;\n    background: rgba(94, 161, 216, 0.1);\n  }\n}\n\n.approval-review {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 6px 6px 12px;\n  border: 1px solid #c7ddef;\n  border-radius: 12px;\n  background: #f5faff;\n\n  &__label {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 13px;\n    font-weight: 600;\n    color: #1565c0;\n    white-space: nowrap;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n}\n\n.approval-comment-input {\n  min-width: 200px;\n  max-width: 280px;\n  height: 38px;\n  padding: 0 12px;\n  border: 1px solid #d0d7de;\n  border-radius: 8px;\n  background: #fff;\n  color: #1f2328;\n  font-size: 13px;\n  box-sizing: border-box;\n\n  &:focus {\n    outline: none;\n    border-color: #5ea1d8;\n    box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.2);\n  }\n}\n\n.approval-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  height: 38px;\n  padding: 0 16px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  font-size: 14px;\n  font-weight: 600;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background-color 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n\n  &--approve {\n    background: #12b76a;\n    color: #fff;\n\n    &:hover:not(:disabled) {\n      background: #039855;\n      box-shadow: 0 2px 6px rgba(18, 183, 106, 0.3);\n    }\n  }\n\n  &--reject {\n    background: #fff;\n    color: #b42318;\n    border-color: #fda29b;\n\n    &:hover:not(:disabled) {\n      background: #fef3f2;\n      border-color: #f97066;\n    }\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n.current-access-pill.approval-state-pill {\n  &[data-state=\"InReview\"] {\n    background: #fff4e5;\n    color: #b54708;\n  }\n\n  &[data-state=\"Approved\"],\n  &[data-state=\"Published\"] {\n    background: #e8f7ee;\n    color: #067647;\n  }\n\n  &[data-state=\"Rejected\"] {\n    background: #fdecec;\n    color: #b42318;\n  }\n}\n\n@media (max-width: 767px) {\n  .approval-review {\n    flex-wrap: wrap;\n    width: 100%;\n    box-sizing: border-box;\n\n    .approval-comment-input {\n      flex: 1 1 100%;\n      max-width: none;\n      order: 1;\n    }\n\n    .approval-btn {\n      flex: 1 1 0;\n      order: 2;\n    }\n  }\n}\n\n.current-access-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  max-width: 240px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  background: #eef6fc;\n  color: #1565c0;\n  font-size: 12px;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  mat-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    line-height: 18px;\n    overflow: visible;\n  }\n}\n\n.footer-btn {\n  border-radius: 8px;\n  border: 1px solid transparent;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0;\n  text-transform: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-height: 44px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  white-space: nowrap;\n  box-sizing: border-box;\n\n  &.primary {\n    background: #5ea1d8;\n    color: #fff;\n    border-color: #5ea1d8;\n\n    &:hover:not(:disabled) {\n      background: #4c8ec2;\n    }\n  }\n\n  &.secondary {\n    background: #f4f6fb;\n    color: #1f2937;\n    border-color: #d1d5db;\n\n    &:hover:not(:disabled) {\n      background: #e8edf5;\n    }\n  }\n\n  &.ghost {\n    background: transparent;\n    color: #5ea1d8;\n    border-color: #5ea1d8;\n\n    &:hover:not(:disabled) {\n      background: rgba(94, 161, 216, 0.08);\n    }\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.preview-btn {\n  border-color: #5ea1d8;\n  color: #5ea1d8;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n\n  &:hover:not(:disabled) {\n    background: rgba(94, 161, 216, 0.1);\n  }\n}\n\n.next-label {\n  font-weight: 500;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.primary-pane {\n  flex: 2 1 640px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  min-height: 0;\n  max-height: 100%;\n  overflow: hidden;\n\n  &.full-width {\n    flex: 1 1 100%;\n    max-width: 100%;\n  }\n\n  // Access tab: give the left pane most of the dialog width\n  &.access-primary-pane {\n    flex: 3.2 1 0;\n    min-width: 0;\n    max-width: none;\n  }\n}\n\n.secondary-pane {\n  flex: 1 1 320px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n\n  &.access-secondary-pane {\n    flex: 0 0 280px;\n    max-width: 300px;\n  }\n}\n\n.flow-layout-container {\n  width: 100%;\n  padding: 0;\n  margin: 0;\n\n  .flow-main-grid {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 402px;\n    gap: 24px;\n    max-width: 100%;\n    margin: 0;\n    padding: 16px 24px;\n\n    @media (min-width: 1920px) {\n      max-width: 1920px;\n      margin: 0 auto;\n      padding: 24px 48px;\n    }\n\n    @media (max-width: 1024px) {\n      grid-template-columns: 1fr;\n      gap: 16px;\n      padding: 16px;\n    }\n\n    @media (max-width: 768px) {\n      padding: 12px;\n      gap: 12px;\n    }\n  }\n}\n\n.flow-main-content {\n  min-width: 0;\n\n  .flow-title-sticky {\n    background: #ffffff;\n    border-bottom: 1px solid #e0e0e0;\n    padding: 16px 0 8px 0;\n    margin-bottom: 8px;\n    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n    justify-content: space-between;\n\n    .video-title-sticky {\n      font-size: 20px;\n      font-weight: 600;\n      line-height: 1.3;\n      color: #0f0f0f;\n      margin: 4px;\n      font-family: \"Raleway\", sans-serif;\n      flex: 1;\n      min-width: 0;\n    }\n  }\n\n  .flow-info-panel {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 12px 16px;\n    background: #f9f9f9;\n    border-radius: 8px;\n    margin-bottom: 16px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: thin;\n    scrollbar-color: #888 #f1f1f1;\n\n    &::-webkit-scrollbar {\n      height: 6px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: #f1f1f1;\n      border-radius: 3px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #888;\n      border-radius: 3px;\n\n      &:hover {\n        background: #555;\n      }\n    }\n\n    .info-badge {\n      display: inline-flex;\n      align-items: center;\n      gap: 6px;\n      font-size: 13px;\n      font-weight: 500;\n      font-family: \"Raleway\", sans-serif;\n      color: #0f0f0f;\n      background: #fff;\n      border: 1px solid #e0e0e0;\n      border-radius: 16px;\n      padding: 4px 12px;\n      cursor: pointer;\n      transition: all 0.2s;\n      white-space: nowrap;\n      flex-shrink: 0;\n      min-width: fit-content;\n\n      &:hover {\n        background: #f5f5f5;\n        border-color: #5ea1d8;\n      }\n\n      &.active {\n        background: #5ea1d8;\n        color: #fff;\n        border-color: #5ea1d8;\n\n        .info-icon,\n        .info-label,\n        .info-step-title {\n          color: #fff;\n        }\n      }\n\n      .info-icon {\n        font-size: 14px;\n        flex-shrink: 0;\n        line-height: 1;\n      }\n\n      .info-label {\n        font-family: \"Raleway\", sans-serif;\n        flex-shrink: 0;\n        font-size: 13px;\n      }\n\n      .info-step-title {\n        font-size: 11px;\n        color: #606060;\n        margin-left: 4px;\n        max-width: 120px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        font-family: \"Raleway\", sans-serif;\n\n        @media (max-width: 768px) {\n          display: none;\n        }\n      }\n    }\n\n    @media (max-width: 768px) {\n      gap: 6px;\n      padding: 10px 12px;\n\n      .info-badge {\n        font-size: 12px;\n        padding: 3px 10px;\n        font-family: \"Raleway\", sans-serif;\n\n        .info-icon {\n          font-size: 12px;\n        }\n      }\n    }\n  }\n\n  .video-player-section {\n    background: #000;\n    border-radius: 12px;\n    overflow: hidden;\n    margin-bottom: 16px;\n    position: relative;\n\n    .img-wrap {\n      width: 100%;\n      position: relative;\n      padding-bottom: 56.25%; // Standard 16:9 video aspect ratio\n      height: 0;\n      overflow: hidden;\n      background: #000;\n\n      img,\n      video {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        object-fit: contain; // Maintains video aspect ratio\n        background: #000;\n      }\n\n      .video-wrapper {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: #000;\n      }\n\n      .main-video-player {\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n        object-fit: contain;\n        background: #000;\n      }\n    }\n\n    .item {\n      padding: 20px;\n      background: #fff;\n      width: 100%;\n      min-height: 400px;\n    }\n\n    .clickarrow {\n      position: absolute;\n      top: 50%;\n      left: 0;\n      right: 0;\n      transform: translateY(-50%);\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 0 16px;\n      pointer-events: none;\n\n      .owl-prev,\n      .owl-next {\n        pointer-events: all;\n        background: rgba(0, 0, 0, 0.65);\n        color: #fff;\n        border: none;\n        border-radius: 50%;\n        width: 48px;\n        height: 48px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        transition: background 0.2s, transform 0.2s;\n        font-size: 26px;\n        font-weight: bold;\n        padding: 0;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\n        margin: 0;\n\n        &:hover:not(:disabled) {\n          background: rgba(0, 0, 0, 0.8);\n          transform: translateY(-1px);\n        }\n\n        &:disabled,\n        &[hidden] {\n          display: none;\n        }\n\n        span {\n          font-size: 30px;\n          line-height: 1;\n          font-weight: bold;\n        }\n      }\n\n      .owl-prev {\n        margin-right: auto;\n        margin-left: 0;\n      }\n\n      .owl-next {\n        margin-left: auto;\n        margin-right: 0;\n      }\n    }\n  }\n\n  // Ensure video-wrapper in summary matches viewflow\n  .flow-main-content {\n    .video-player-section {\n      .img-wrap {\n        .video-wrapper {\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 100%;\n          height: 100%;\n          background: #000;\n\n          video {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            object-fit: contain;\n            background: #000;\n          }\n        }\n      }\n    }\n  }\n}\n\n.summary-info-pills {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n\n  .info-badge,\n  .summary-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 12px;\n    border-radius: 999px;\n    background: #f3f4f6;\n    color: #111827;\n    font-size: 13px;\n    font-weight: 500;\n  }\n\n  &.secondary {\n    margin-top: 8px;\n    .summary-pill {\n      background: #eef2ff;\n      color: #1f2937;\n    }\n  }\n}\n\n/* Legacy summary-specific styles kept for other parts of the create-flow page */\n\n.summary-cover-placeholder {\n  min-height: 220px;\n  border-radius: 12px;\n  background: #f5f5f5;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #9ca3af;\n  gap: 8px;\n\n  mat-icon {\n    font-size: 40px;\n  }\n}\n\n/* Match viewflow sidebar + step navigation styles for summary right menu */\n.flow-sidebar {\n  width: 402px;\n  min-width: 402px;\n  max-width: 402px;\n  position: relative;\n  z-index: 10;\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 1024px) {\n    width: 100%;\n    min-width: 100%;\n    max-width: 100%;\n  }\n\n  .step-navigation {\n    margin-bottom: 24px;\n    flex: 0 0 auto;\n    min-height: 0;\n\n    .step-scroll {\n      // Copy behaviour from viewflow: tall scroll area aligned with video area\n      max-height: calc(\n        (100vw - 240px - 48px - 402px - 24px) * 0.5625 + 80px\n      );\n\n      @media (min-width: 1920px) {\n        max-height: calc(\n          (1920px - 240px - 96px - 402px - 24px) * 0.5625 + 80px\n        );\n      }\n\n      @media (max-width: 1024px) {\n        max-height: calc((100vw - 32px) * 0.5625);\n      }\n\n      overflow-y: auto;\n      overflow-x: hidden;\n      display: block;\n      width: 100%;\n      padding-right: 8px;\n\n      &::-webkit-scrollbar {\n        width: 8px;\n      }\n\n      &::-webkit-scrollbar-track {\n        background: #f1f1f1;\n        border-radius: 4px;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background: #888;\n        border-radius: 4px;\n\n        &:hover {\n          background: #555;\n        }\n      }\n    }\n\n    .steps-list {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n      width: 100%;\n      align-items: stretch;\n    }\n\n    .step-panel {\n      display: block;\n      width: 100%;\n    }\n\n    .step-panel .step-btn {\n      width: 100%;\n    }\n\n    .step-btn {\n      padding-block: 1em;\n      padding-inline: 1.125em;\n      border: 1px solid #e0e0e0;\n      border-radius: 6px;\n      background: white;\n      cursor: pointer;\n      font-size: 13px;\n      font-weight: 500;\n      color: #0f0f0f;\n      text-align: left;\n      transition: all 0.2s;\n      display: flex;\n      flex-direction: row;\n      align-items: flex-start;\n      gap: 8px;\n      width: 100%;\n      height: auto;\n      min-height: auto;\n      white-space: normal;\n      word-break: break-word;\n      overflow: visible;\n\n      .step-text-block {\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n        flex: 1 1 auto;\n        min-width: 0;\n      }\n\n      .step-number {\n        font-weight: 600;\n      }\n\n      .step-title-text {\n        flex: 1;\n        text-align: left;\n      }\n\n      &:hover:not(.active) {\n        background: #f9f9f9;\n        border-color: #c0c0c0;\n      }\n    }\n\n    .step-panel.active .step-btn {\n      background: #5ea1d8 !important;\n      color: #0f0f0f !important;\n      border: none !important;\n      border-top: none !important;\n      border-left: none !important;\n      border-right: none !important;\n      border-bottom: none !important;\n      outline: none !important;\n      box-shadow: none !important;\n      transition: none !important;\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n\n      .step-number,\n      .step-title-text {\n        color: #0f0f0f !important;\n      }\n\n      &:hover {\n        background: #5ea1d8 !important;\n        border: none !important;\n        outline: none !important;\n        box-shadow: none !important;\n      }\n    }\n  }\n}\n\n/* Match viewflow video metadata + actions bar style */\n.video-metadata {\n  padding: 16px 0;\n  border-bottom: 1px solid #e0e0e0;\n  margin-bottom: 16px;\n\n  .step-header {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n    margin-bottom: 12px;\n    flex-wrap: wrap;\n    justify-content: space-between;\n\n    .step-header-main {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      flex: 1;\n      min-width: 0;\n    }\n\n    .s-num {\n      flex-shrink: 0;\n    }\n\n    .video-title {\n      font-size: 20px;\n      font-weight: 500;\n      line-height: 28px;\n      color: #0f0f0f;\n      margin: 0;\n      flex: 1;\n      min-width: 0;\n    }\n\n    .share-icon {\n      cursor: pointer;\n      color: #606060;\n      flex-shrink: 0;\n    }\n  }\n\n  .video-actions-bar {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n\n    &::-webkit-scrollbar {\n      height: 6px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: rgba(0, 0, 0, 0.2);\n      border-radius: 4px;\n    }\n\n    &::-webkit-scrollbar-thumb:hover {\n      background: rgba(0, 0, 0, 0.3);\n    }\n\n    .action-buttons {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      flex-wrap: nowrap;\n      width: max-content;\n\n      .action-item {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        padding: 8px 16px;\n        border-radius: 18px;\n        cursor: pointer;\n        transition: background 0.2s;\n        background: #f2f2f2;\n        flex: 0 0 auto;\n\n        &:hover:not(.disabled) {\n          background: #e5e5e5;\n        }\n\n        &.disabled {\n          opacity: 0.5;\n          cursor: not-allowed;\n          pointer-events: none;\n        }\n\n        mat-icon {\n          font-size: 18px;\n        }\n      }\n    }\n  }\n}\n\n/* Match viewflow channel info + description style */\n.channel-info-section {\n  padding: 16px 0;\n  border-bottom: 1px solid #e0e0e0;\n  margin-bottom: 16px;\n\n  .channel-header {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n\n    .channel-avatar {\n      flex-shrink: 0;\n\n      img {\n        width: 48px;\n        height: 48px;\n        border-radius: 50%;\n        object-fit: cover;\n        cursor: pointer;\n      }\n\n      .material-icons {\n        font-size: 48px;\n        width: 48px;\n        height: 48px;\n        color: #606060;\n        cursor: pointer;\n      }\n    }\n\n    .channel-details {\n      flex: 1;\n      min-width: 0;\n\n      .channel-name {\n        font-size: 16px;\n        font-weight: 500;\n        color: #0f0f0f;\n        cursor: pointer;\n        margin-bottom: 4px;\n\n        &:hover {\n          color: #606060;\n        }\n      }\n\n      .channel-meta {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        flex-wrap: wrap;\n        font-size: 14px;\n        color: #606060;\n\n        mat-icon {\n          font-size: 16px;\n          width: 16px;\n          height: 16px;\n        }\n\n        .price-tag {\n          font-weight: 600;\n          color: #d32f2f;\n          cursor: pointer;\n        }\n\n        .purchased-tag {\n          font-weight: 600;\n          color: #16a34a;\n        }\n      }\n    }\n\n    .channel-actions {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 12px;\n\n      .follow-btn,\n      .purchase-btn {\n        border-radius: 999px;\n        padding: 6px 16px;\n        font-size: 14px;\n        font-weight: 500;\n        border: none;\n        cursor: pointer;\n      }\n\n      .follow-btn {\n        background: #5ea1d8;\n        color: #fff;\n      }\n\n      .purchase-btn {\n        background: #111827;\n        color: #fff;\n      }\n    }\n  }\n}\n\n.description-section {\n  padding: 16px;\n  background: #f9f9f9;\n  border-radius: 12px;\n  margin-bottom: 16px;\n\n  .description-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: -16px !important;\n\n    h3 {\n      font-size: 16px;\n      font-weight: 500;\n      color: #0f0f0f;\n      margin: 0;\n    }\n  }\n\n  .description-content {\n    font-size: 14px;\n    line-height: 20px;\n    color: #0f0f0f;\n    max-height: 60px;\n    overflow: hidden;\n    transition: max-height 0.3s ease;\n\n    &.expanded {\n      max-height: none;\n    }\n\n    .supporting-docs-link {\n      margin-top: 12px;\n\n      a {\n        color: #5ea1d8;\n        text-decoration: none;\n        font-weight: 500;\n\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n\n  .expand-description-btn {\n    margin-top: 8px;\n    background: none;\n    border: none;\n    color: #606060;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    padding: 0;\n\n    &:hover {\n      color: #0f0f0f;\n    }\n  }\n}\n\n.summary-card {\n  background: #fff;\n  border-radius: 18px;\n  border: 1px solid #e4e8f0;\n  padding: 24px;\n  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);\n\n  &.summary-items-card,\n  &.summary-steps-card,\n  &.summary-faqs-card {\n    margin-bottom: 20px;\n  }\n\n  .summary-card-header {\n    display: flex;\n    gap: 12px;\n    margin-bottom: 16px;\n\n    mat-icon {\n      color: #5ea1d8;\n    }\n\n    h3 {\n      margin: 0;\n      font-size: 18px;\n      font-weight: 600;\n    }\n\n    p {\n      margin: 4px 0 0;\n      color: #64748b;\n      font-size: 14px;\n    }\n  }\n}\n\n.summary-items-groups {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  .summary-items-block {\n    border: 1px solid #eceff5;\n    border-radius: 14px;\n    padding: 16px;\n    background: #fbfbff;\n\n    .summary-block-title {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      margin-bottom: 10px;\n\n      h4 {\n        margin: 0;\n        font-size: 16px;\n      }\n\n      span {\n        color: #94a3b8;\n        font-size: 14px;\n      }\n    }\n\n    .summary-item-list {\n      list-style: none;\n      margin: 0;\n      padding: 0;\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n\n      li {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 12px;\n        font-size: 14px;\n\n        a {\n          display: inline-flex;\n          align-items: center;\n          gap: 6px;\n          color: #2563eb;\n          text-decoration: none;\n        }\n      }\n    }\n  }\n}\n\n.summary-step-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  .summary-step-panel {\n    border: 1px solid #eceff5;\n    border-radius: 14px;\n    padding: 16px;\n\n    .summary-step-heading {\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n\n      .step-chip {\n        background: #eef2ff;\n        color: #4338ca;\n        border-radius: 999px;\n        padding: 4px 12px;\n        font-size: 13px;\n        font-weight: 600;\n      }\n\n      h4 {\n        margin: 0;\n        font-size: 16px;\n        font-weight: 600;\n        color: #0f172a;\n      }\n    }\n\n    .summary-step-media {\n      margin: 12px 0;\n\n      img,\n      video {\n        border-radius: 12px;\n        width: 100%;\n        display: block;\n      }\n    }\n\n    .summary-step-description {\n      font-size: 14px;\n      color: #475569;\n    }\n  }\n}\n\n.summary-step-nav {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.step-nav-chip {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  padding: 10px 14px;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  cursor: pointer;\n  min-width: 160px;\n  transition: all 0.2s ease;\n\n  .chip-step-number {\n    font-size: 12px;\n    font-weight: 600;\n    color: #6b7280;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n\n  .chip-step-title {\n    font-size: 14px;\n    font-weight: 600;\n    color: #111827;\n  }\n\n  &.active {\n    border-color: #4c6ef5;\n    background: #eef2ff;\n\n    .chip-step-number {\n      color: #4338ca;\n    }\n\n    .chip-step-title {\n      color: #1d2b53;\n    }\n  }\n}\n\n.empty-steps-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 32px;\n  border: 1px dashed #d1d5db;\n  border-radius: 12px;\n  color: #94a3b8;\n}\n\n.summary-faq-collection {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n  .summary-faq-block {\n    border: 1px solid #eceff5;\n    border-radius: 14px;\n    padding: 16px;\n\n    h4 {\n      margin: 0 0 10px;\n      font-size: 16px;\n      color: #0f172a;\n    }\n\n    .summary-faq-item {\n      border-top: 1px solid #f1f5f9;\n      padding: 12px 0;\n\n      &:first-child {\n        border-top: none;\n        padding-top: 0;\n      }\n\n      .question {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-weight: 600;\n        color: #0f172a;\n      }\n\n      .answer {\n        margin-top: 6px;\n        color: #475569;\n        font-size: 14px;\n      }\n    }\n  }\n}\n\n.flow-sidebar.summary-preview-sidebar {\n  position: sticky;\n  top: 24px;\n  height: fit-content;\n\n  .step-navigation {\n    margin-bottom: 24px;\n    flex: 0 0 auto;\n    min-height: 0;\n\n    .step-scroll {\n      max-height: 320px;\n      overflow-y: auto;\n      overflow-x: hidden;\n      padding-right: 8px;\n      \n      // Custom scrollbar styling\n      &::-webkit-scrollbar {\n        width: 6px;\n      }\n\n      &::-webkit-scrollbar-track {\n        background: #f1f1f1;\n        border-radius: 3px;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background: #c1c1c1;\n        border-radius: 3px;\n\n        &:hover {\n          background: #a8a8a8;\n        }\n      }\n    }\n\n    .steps-list {\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n    }\n\n    .step-btn {\n      border: none;\n      background: rgba(240, 240, 240, 0.8);\n      padding: 10px 16px;\n      border-radius: 999px;\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      cursor: pointer;\n\n      .step-icon {\n        font-size: 14px;\n        line-height: 1;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n      }\n\n      &.active {\n        background: #5ea1d8;\n        color: #fff;\n      }\n\n      .step-number {\n        font-weight: 600;\n      }\n\n      .step-title-text {\n        flex: 1;\n        text-align: left;\n      }\n    }\n  }\n}\n\n.summary-card.sidebar-card.meta-card {\n  .summary-stats-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n\n    li {\n      display: flex;\n      justify-content: space-between;\n      font-size: 14px;\n      color: #475569;\n\n      strong {\n        color: #0f172a;\n      }\n    }\n  }\n}\n\n.section-card {\n  background: #fff;\n  border-radius: 18px;\n  border: 1px solid #e4e8f0;\n\n  &.full-screen-summary {\n    border-radius: 0;\n    border: none;\n    background: transparent;\n    padding: 0;\n    box-shadow: none;\n  }\n  padding: 24px;\n  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);\n\n  &.journey-card {\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0;\n    max-height: 100%;\n    overflow: hidden;\n  }\n}\n\n.section-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  h5 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n  }\n  p {\n    margin: 4px 0 0;\n    color: #6b7280;\n    font-size: 14px;\n  }\n}\n\n.link-btn {\n  color: #065fd4;\n  text-transform: uppercase;\n  font-size: 12px;\n  letter-spacing: 0.08em;\n  border: none;\n  background: transparent;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.drop-zone {\n  border: 2px dashed #cdd7f8;\n  border-radius: 18px;\n  min-height: 220px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 6px;\n  background: #f8fafd;\n  color: #4a5568;\n  mat-icon {\n    font-size: 50px;\n    color: #1a73e8;\n  }\n  p {\n    font-size: 18px;\n    font-weight: 600;\n    margin: 8px 0 0;\n  }\n  span {\n    font-size: 13px;\n    color: #6b7280;\n  }\n}\n\n.cover-preview {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 24px;\n}\n\n.media-frame {\n  flex: 1 1 360px;\n  background: #0f0f0f;\n  border-radius: 16px;\n  overflow: hidden;\n  .img-display,\n  .video-display {\n    width: 100%;\n    height: auto;\n    display: block;\n  }\n}\n\n.cover-meta {\n  flex: 1 1 260px;\n  background: #f8fafc;\n  border-radius: 16px;\n  padding: 16px 20px;\n  .file-name {\n    font-weight: 600;\n    margin-bottom: 4px;\n  }\n  .price {\n    color: #0f6bff;\n    font-weight: 600;\n  }\n  .description-text {\n    margin-top: 12px;\n    text-align: left;\n    color: #4b5563;\n  }\n}\n\n.group-title {\n  margin: 24px 0 12px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.item-avatar img {\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.upload-dialog .example-list {\n  border: 1px solid #edf1f9;\n  border-radius: 14px;\n  padding: 6px;\n  background: #fff;\n}\n\n.upload-dialog .example-box {\n  background: #fdfdff;\n  border-radius: 12px;\n  margin: 6px 0;\n  padding: 14px 16px;\n  box-shadow: inset 0 0 0 1px #edf0f7;\n}\n\n.journey-toolbar {\n  display: flex;\n  gap: 12px;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e4e8f0;\n  background: #fafbfc;\n  flex-wrap: wrap;\n  align-items: center;\n  flex-shrink: 0; // Prevent toolbar from shrinking\n  button,\n  a {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n    }\n  }\n  a {\n    text-transform: uppercase;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.08em;\n    color: #2563eb;\n  }\n}\n\n.journey-progress {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  padding: 16px 0 0;\n  margin-top: 12px;\n  flex-shrink: 0; // Prevent progress bar from shrinking\n  overflow-x: hidden;\n  flex-wrap: nowrap;\n  width: 100%;\n  position: relative;\n}\n\n.journey-step {\n  background: transparent;\n  border: none;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0;\n  min-width: auto;\n  flex-shrink: 0;\n  cursor: pointer;\n  color: #9ca3af;\n  transition: color 0.2s ease;\n  white-space: nowrap;\n  // Ensure button aligns properly with connector\n  align-self: center;\n  .tab-count {\n    font-size: 11px;\n    background: rgba(37, 99, 235, 0.08);\n    color: #2563eb;\n    border-radius: 999px;\n    padding: 2px 8px;\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n    pointer-events: auto; // allow tooltip\n  }\n}\n\n.journey-step.active {\n  color: #5ea1d8;\n  .step-label {\n    border-color: #5ea1d8;\n    background: rgba(94, 161, 216, 0.1);\n    color: #5ea1d8;\n  }\n}\n\n.journey-step.complete {\n  color: #16a34a;\n  .step-label {\n    border-color: #16a34a;\n    background: rgba(22, 163, 74, 0.1);\n    color: #16a34a;\n  }\n}\n\n.step-indicator {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 2px solid currentColor;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 14px;\n  flex-shrink: 0;\n  mat-icon {\n    font-size: 20px;\n  }\n}\n\n.step-label {\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  white-space: nowrap;\n}\n\n.step-connector {\n  flex: 1;\n  min-width: 20px;\n  height: 2px;\n  background: #e5e7eb;\n  flex-shrink: 0;\n  align-self: center;\n  margin: 0;\n  position: relative;\n  z-index: 0;\n  top: -10px;\n}\n\n.step-connector.fill {\n  background: #16a34a;\n}\n\n.journey-content {\n  padding: 24px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1 1 0;\n  min-height: 0;\n  max-height: 100%;\n\n  // Custom scrollbar styling\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 4px;\n\n    &:hover {\n      background: #a8a8a8;\n    }\n  }\n}\n\n// Flow-style cover form\n.cover-form-wrapper {\n  background: #fff;\n  border-radius: 0;\n  padding: 0;\n  max-width: 100%;\n\n  h3 {\n    font-size: 14px;\n    font-weight: 400;\n    color: #030303;\n    margin: 0 0 8px 0;\n    padding: 0;\n    border: none;\n    text-transform: none;\n    letter-spacing: 0;\n    line-height: 20px;\n  }\n\n  .example-form {\n    margin-bottom: 0;\n    margin-top: 0;\n    padding: 0;\n\n    &.field-anchor {\n      margin-left: 0;\n      margin-right: 0;\n    }\n\n    // First form in the wrapper should not have top margin\n    &:first-child {\n      mat-form-field {\n        margin-top: 0;\n      }\n\n      .form-label-wrapper {\n        margin-top: 0;\n      }\n    }\n  }\n\n  .form-label-wrapper {\n    margin-top: 20px;\n    margin-bottom: 10px;\n    padding: 0;\n    margin-left: 0;\n    margin-right: 0;\n\n    &.label-with-toggle {\n      display: flex;\n      align-items: center;\n      gap: 16px;\n      flex-wrap: wrap;\n    }\n\n    .form-label {\n      font-size: 16px;\n      font-weight: 500;\n      color: #000000;\n      display: block;\n      margin-bottom: 0;\n      margin-top: 0;\n      padding: 0;\n      line-height: 1.5;\n\n      &.font16 {\n        font-size: 16px;\n      }\n    }\n  }\n\n  .creator-paid-only-notice {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    margin-top: 0.75rem;\n    padding: 0.85rem 1rem;\n    border-radius: 10px;\n    background: rgba(94, 161, 216, 0.1);\n    border: 1px solid rgba(94, 161, 216, 0.28);\n\n    .notice-title-row {\n      display: inline-flex;\n      align-items: center;\n      gap: 8px;\n      min-width: 0;\n      max-width: 100%;\n    }\n\n    .notice-icon {\n      display: inline-flex !important;\n      align-items: center;\n      justify-content: center;\n      flex: 0 0 18px;\n      width: 18px !important;\n      height: 18px !important;\n      font-size: 18px !important;\n      line-height: 18px !important;\n      margin: 0 !important;\n      padding: 0 !important;\n      overflow: visible;\n      color: #5ea1d8;\n      transform: translateY(1px);\n    }\n\n    .notice-lead {\n      margin: 0;\n      min-width: 0;\n      font-size: 14px;\n      font-weight: 400;\n      line-height: 20px;\n      color: #334155;\n    }\n\n    .notice-detail {\n      margin: 0;\n      padding-left: 26px;\n      font-size: 14px;\n      line-height: 20px;\n      color: #334155;\n    }\n\n    .upgrade-free-link {\n      display: inline-block;\n      margin-top: 0.35rem;\n      margin-left: 26px;\n      border: none;\n      background: none;\n      padding: 0;\n      color: #5ea1d8;\n      font-weight: 700;\n      font-size: 0.85rem;\n      line-height: 1.3;\n      cursor: pointer;\n      text-decoration: underline;\n    }\n  }\n\n  mat-form-field {\n    width: 100%;\n    margin-top: 20px;\n    margin-bottom: 10px;\n\n    ::ng-deep {\n      // Make input boxes rounded on all corners\n      .mdc-notched-outline {\n        border-radius: 8px;\n      }\n\n      .mdc-notched-outline__leading {\n        border-radius: 8px 0 0 8px;\n      }\n\n      .mdc-notched-outline__trailing {\n        border-radius: 0 8px 8px 0;\n      }\n\n      // Ensure the input field itself has rounded corners\n      .mat-mdc-text-field-input-wrapper {\n        border-radius: 8px;\n      }\n\n      input.mat-mdc-input-element,\n      input[matInput] {\n        border-radius: 8px;\n      }\n\n      // Make mat-label black and properly aligned\n      .mat-mdc-form-field-label,\n      .mat-mdc-floating-label,\n      mat-label {\n        color: #000000 !important;\n        font-weight: 500;\n        font-size: 16px;\n      }\n\n      .mat-mdc-form-field-label-wrapper {\n        padding-top: 0;\n      }\n    }\n  }\n\n  .commonlintbtn-wrapper {\n    margin-top: 8px;\n    margin-bottom: 24px;\n\n    &.title-rephrase-wrapper {\n      margin-top: 0;\n      margin-bottom: 0;\n      padding: 0;\n    }\n\n    .commonlintbtn-parent {\n      display: flex;\n      gap: 16px;\n      align-items: center;\n      justify-content: flex-end;\n\n      .clickable-text {\n        display: inline-flex;\n        align-items: center;\n        gap: 6px;\n        color: #065fd4;\n        font-size: 14px;\n        cursor: pointer;\n        font-weight: 500;\n        transition: color 0.2s;\n        margin-right: 13px;\n\n        &:hover {\n          color: #0d47a1;\n        }\n\n        .material-icons {\n          font-size: 18px;\n        }\n      }\n    }\n  }\n\n  .title-field-container {\n    position: relative;\n    width: 100%;\n    margin-bottom: 0;\n    margin-top: 0;\n\n    .title-field-with-rephrase {\n      margin-top: 0 !important;\n      margin-bottom: 0 !important;\n\n      ::ng-deep {\n        .mat-mdc-form-field-subscript-wrapper {\n          margin-top: 0;\n          padding-bottom: 0;\n          min-height: auto;\n          display: flex;\n          flex-direction: column;\n          align-items: flex-end;\n        }\n\n        .mat-mdc-form-field-hint-wrapper {\n          margin-top: 0;\n          padding-bottom: 0;\n          order: 1;\n          width: 100%;\n          display: flex;\n          justify-content: flex-end;\n        }\n\n        .mat-mdc-form-field-hint {\n          text-align: right;\n          width: auto;\n          margin: 0;\n        }\n\n        .mat-mdc-form-field-hint-spacer {\n          display: none;\n        }\n      }\n    }\n\n    .title-rephrase-wrapper-inline {\n      margin-top: 4px;\n      margin-bottom: 0;\n      padding: 0;\n      padding-left: 0;\n      padding-right: 0;\n      display: flex;\n      flex-direction: column;\n      align-items: flex-end;\n      gap: 4px;\n      width: 100%;\n\n      .title-rephrase-progress {\n        margin-bottom: 0;\n        width: 200px;\n      }\n\n      .title-rephrase-buttons {\n        display: flex;\n        gap: 16px;\n        align-items: center;\n        justify-content: flex-end;\n        flex-wrap: wrap;\n\n        .clickable-text {\n          display: inline-flex;\n          align-items: center;\n          gap: 6px;\n          color: #065fd4;\n          font-size: 14px;\n          cursor: pointer;\n          font-weight: 500;\n          transition: color 0.2s;\n          margin-right: 13px;\n\n          &:hover {\n            color: #0d47a1;\n          }\n\n          .material-icons {\n            font-size: 18px;\n          }\n        }\n      }\n    }\n  }\n\n  // Ensure consistent alignment for all form fields\n  form,\n  .example-form {\n    margin-left: 0;\n    margin-right: 0;\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  mat-form-field {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  .table-wrapper {\n    margin-bottom: 24px;\n\n    .table-inner {\n      border: 1px solid #e0e0e0;\n      border-radius: 4px;\n      background: #f9f9f9;\n      min-height: 200px;\n      max-height: 400px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: relative;\n      overflow: hidden;\n\n      img.img-display {\n        max-width: 100%;\n        max-height: 100%;\n        object-fit: contain;\n      }\n\n      video.video-display {\n        width: 100%;\n        height: 100%;\n        max-height: 400px;\n        object-fit: contain;\n      }\n\n      p.text-center {\n        color: #606060;\n        font-size: 13px;\n        text-align: center;\n        padding: 20px;\n        margin: 0;\n      }\n    }\n  }\n\n  .upload-icon-row {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 16px;\n    margin-top: 20px;\n    margin-bottom: 10px;\n    flex-wrap: nowrap;\n    width: 100%;\n\n    .upload-icon-stack {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      gap: 4px;\n      flex-shrink: 0;\n    }\n\n    .form-label-wrapper {\n      margin-top: 0;\n      margin-bottom: 0;\n      padding: 0;\n      flex-shrink: 0;\n\n      .required-hint {\n        display: block;\n        font-size: 11px;\n        color: #b45309; // amber-700\n        margin-top: 2px;\n      }\n    }\n\n    .upload-icon-btn {\n      margin-top: 0;\n      flex-shrink: 0;\n    }\n\n    .flow-upload-progress {\n      flex: 1;\n      min-width: 0;\n      flex-shrink: 1;\n    }\n\n    @media (max-width: 767px) {\n      flex-direction: column;\n      align-items: stretch;\n      flex-wrap: nowrap;\n      overflow-x: visible;\n      gap: 12px;\n\n      .upload-icon-stack {\n        flex-direction: row;\n        align-items: center;\n        align-self: stretch;\n        justify-content: flex-start;\n        gap: 12px;\n        width: 100%;\n      }\n\n      .form-label-wrapper {\n        min-width: 0;\n        flex: 1;\n        text-align: left;\n\n        .form-label {\n          margin: 0;\n        }\n      }\n\n      .flow-upload-progress {\n        width: 100%;\n        min-width: 0;\n      }\n\n      .media-size-recommendation {\n        width: 100%;\n        margin-top: 0 !important;\n      }\n    }\n  }\n\n  .upload-progress-inline {\n    font-size: 13px;\n    color: #64748b;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    progress {\n      width: 120px;\n      height: 6px;\n    }\n  }\n\n  // Flow-style upload progress\n  .flow-upload-progress {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 8px 0;\n    min-width: 200px;\n\n    .flow-progress-bar-container {\n      flex: 1;\n      height: 4px;\n      background-color: rgba(0, 0, 0, 0.1);\n      border-radius: 2px;\n      overflow: hidden;\n      position: relative;\n      min-width: 120px;\n      max-width: 300px;\n\n      .flow-progress-bar {\n        height: 100%;\n        background: linear-gradient(90deg, #065fd4 0%, #0d96ff 100%);\n        border-radius: 2px;\n        transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n        position: relative;\n        overflow: hidden;\n\n        &::after {\n          content: \"\";\n          position: absolute;\n          top: 0;\n          left: 0;\n          bottom: 0;\n          right: 0;\n          background: linear-gradient(\n            90deg,\n            transparent,\n            rgba(255, 255, 255, 0.3),\n            transparent\n          );\n          animation: shimmer 1.5s infinite;\n        }\n      }\n    }\n\n    .flow-progress-text {\n      font-size: 12px;\n      font-weight: 500;\n      color: #065fd4;\n      min-width: 40px;\n      text-align: right;\n      font-family: \"Roboto\", sans-serif;\n    }\n  }\n\n  @keyframes shimmer {\n    0% {\n      transform: translateX(-100%);\n    }\n    100% {\n      transform: translateX(100%);\n    }\n  }\n\n  .upload-icon-btn {\n    width: 56px;\n    height: 56px;\n    border-radius: 20px;\n    background: #e0f2fe;\n    color: #0369a1;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    position: relative;\n    transition: transform 0.2s, box-shadow 0.2s;\n    box-shadow: inset 0 0 0 1px rgba(3, 105, 161, 0.1);\n\n    &.light {\n      background: #f8fafc;\n      color: #475569;\n      box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.08);\n    }\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 10px 20px rgba(3, 105, 161, 0.15);\n    }\n\n    mat-icon {\n      font-size: 28px;\n      width: 28px;\n      height: 28px;\n    }\n\n    input {\n      position: absolute;\n      inset: 0;\n      opacity: 0;\n      cursor: pointer;\n    }\n  }\n\n  .supporting-list {\n    margin-bottom: 16px;\n    padding: 16px;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    background: #f8fafc;\n\n    &__label {\n      font-size: 13px;\n      font-weight: 600;\n      color: #0f172a;\n      margin: 0 0 12px;\n      text-transform: uppercase;\n      letter-spacing: 0.05em;\n    }\n\n    ul {\n      list-style: none;\n      margin: 0;\n      padding: 0;\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n    }\n\n    li {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      font-size: 13px;\n      color: #0f172a;\n\n      mat-icon {\n        font-size: 18px;\n        color: #64748b;\n      }\n\n      .item-text {\n        color: #0f172a;\n        text-decoration: none;\n        word-break: break-word;\n\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n\n  .quill-field {\n    width: 100%;\n    margin-bottom: 0;\n    margin-top: 0;\n    padding: 0;\n\n    &.field-anchor {\n      margin-left: 0;\n      margin-right: 0;\n    }\n  }\n\n  .quill-label {\n    display: block;\n    color: #000000;\n    font-size: 16px;\n    font-weight: 500;\n    margin-top: 20px;\n    margin-bottom: 10px;\n    padding: 0;\n    line-height: 1.5;\n  }\n\n  .quill-wrapper {\n    margin: 10px 0px;\n    border: 1px solid #dadce0;\n    border-radius: 8px;\n    background: #fff;\n    overflow: hidden;\n    transition: border-color 0.2s, box-shadow 0.2s;\n\n    &:focus-within {\n      border-color: #1a73e8;\n      box-shadow: 0 0 0 1px #1a73e8;\n    }\n\n    &:hover:not(:focus-within) {\n      border-color: #80868b;\n    }\n\n    ::ng-deep .ql-toolbar {\n      border: none;\n      border-bottom: 1px solid #e0e0e0;\n      background: #fff;\n      padding: 10px 12px;\n    }\n\n    ::ng-deep .ql-container {\n      border: none !important;\n      font-size: 14px;\n      min-height: 220px;\n      background: #fff;\n      font-family: \"Roboto\", \"Helvetica Neue\", sans-serif;\n    }\n\n    ::ng-deep .ql-editor {\n      min-height: 220px;\n      font-size: 14px;\n      color: #030303;\n      line-height: 20px;\n      padding: 16px;\n    }\n\n    ::ng-deep .ql-editor.ql-blank::before {\n      color: #80868b;\n      font-style: normal;\n      font-size: 14px;\n    }\n  }\n\n  mat-tab-group {\n    margin-bottom: 24px;\n\n    ::ng-deep .mat-mdc-tab-header {\n      border-bottom: 1px solid #e0e0e0;\n      margin-bottom: 0;\n      position: relative;\n      overflow: visible;\n    }\n\n    ::ng-deep .mat-mdc-tab-label-container {\n      overflow: visible;\n    }\n\n    ::ng-deep .mat-mdc-tab-list {\n      overflow: visible;\n    }\n\n    ::ng-deep .mat-mdc-tab-label {\n      color: #606060;\n      font-weight: 500;\n      min-width: 140px;\n      width: 140px;\n      font-size: 14px;\n      text-transform: none;\n      letter-spacing: 0;\n      padding: 12px 16px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      transition: none !important;\n      will-change: auto;\n      contain: layout style paint;\n\n      .mdc-tab__content {\n        transition: none !important;\n        will-change: auto;\n      }\n\n      .mdc-tab__text-label {\n        display: inline-block;\n        min-width: 120px;\n        text-align: left;\n        will-change: auto;\n      }\n    }\n\n    ::ng-deep .mat-mdc-tab-header-pagination {\n      transition: none !important;\n    }\n\n    ::ng-deep .mat-mdc-tab-body {\n      transition: none !important;\n    }\n\n    ::ng-deep .mat-mdc-tab-label-active {\n      color: #065fd4;\n      font-weight: 500;\n    }\n\n    ::ng-deep .mat-mdc-tab-body-wrapper {\n      min-height: 200px;\n    }\n\n    .tab-design-wrapper {\n      padding: 20px 0;\n\n      mat-form-field {\n        margin-bottom: 12px;\n\n        ::ng-deep {\n          .mdc-notched-outline {\n            border-radius: 8px;\n          }\n\n          .mdc-notched-outline__leading {\n            border-radius: 8px 0 0 8px;\n          }\n\n          .mdc-notched-outline__trailing {\n            border-radius: 0 8px 8px 0;\n          }\n\n          .mat-mdc-text-field-input-wrapper {\n            border-radius: 8px;\n          }\n\n          input.mat-mdc-input-element,\n          input[matInput] {\n            border-radius: 8px;\n          }\n        }\n      }\n\n      .upload-field-inline {\n        display: flex;\n        align-items: flex-start;\n      }\n\n      .upload-label-inline {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: 12px;\n        margin-top: 0;\n        margin-bottom: 0;\n        padding: 0;\n\n        label {\n          margin: 0;\n          white-space: nowrap;\n        }\n\n        .upload-icon-btn {\n          margin: 0;\n        }\n      }\n    }\n\n    // Apply same styling for Items tab\n    .upload-field-inline {\n      display: flex;\n      align-items: flex-start;\n\n      .upload-label-inline {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: 12px;\n        margin-top: 0;\n        margin-bottom: 0;\n        padding: 0;\n\n        label {\n          margin: 0;\n          white-space: nowrap;\n        }\n\n        .upload-icon-btn {\n          margin: 0;\n        }\n      }\n    }\n  }\n\n  // General upload label inline styling for all tabs\n  .upload-label-inline {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 12px;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding: 0;\n\n    label {\n      margin: 0;\n      white-space: nowrap;\n    }\n\n    .upload-icon-btn {\n      margin: 0;\n    }\n  }\n\n  .upload-field-inline {\n    display: flex;\n    align-items: flex-start;\n\n    .addbtn {\n      margin-top: 8px;\n\n      button {\n        background: #065fd4;\n        color: #fff;\n        border-radius: 18px;\n        padding: 8px 24px;\n        font-weight: 500;\n\n        &:disabled {\n          background: #e0e0e0;\n          color: #909090;\n        }\n      }\n    }\n\n    .example-list {\n      margin-top: 16px;\n      border: 1px solid #e0e0e0;\n      border-radius: 8px;\n      overflow: hidden;\n\n      .example-box {\n        border: none;\n        border-bottom: 1px solid #e0e0e0;\n        padding: 12px 16px;\n        background: #fff;\n\n        &:last-child {\n          border-bottom: none;\n        }\n\n        .document,\n        .link {\n          font-size: 14px;\n          color: #030303;\n        }\n\n        .material-icons {\n          color: #606060;\n          transition: color 0.2s;\n\n          &:hover {\n            color: #030303;\n          }\n        }\n      }\n    }\n  }\n}\n\n.standard-tab-group {\n  background: #f5f5f5;\n  border-radius: 12px;\n  padding: 4px 8px 0;\n\n  ::ng-deep .mat-mdc-tab {\n    margin-right: 6px;\n    border-radius: 8px 8px 0 0;\n    background: transparent;\n  }\n\n  ::ng-deep .mat-mdc-tab:not(.mdc-tab--active) .mdc-tab__text-label {\n    color: #6b7280;\n  }\n\n  ::ng-deep .mdc-tab--active .mdc-tab__text-label {\n    color: #111827;\n    font-weight: 600;\n  }\n\n  ::ng-deep .mat-mdc-tab-indicator .mdc-tab-indicator__content--underline {\n    border-top-width: 3px;\n    border-color: #9ca3af;\n    background-color: #9ca3af;\n  }\n}\n\n.label-button {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 0;\n  margin-top: 0;\n  padding: 0;\n  margin-left: 0;\n  margin-right: 0;\n  background: transparent;\n  border-radius: 0;\n\n  ::ng-deep .mat-mdc-slide-toggle {\n    .mdc-switch__track {\n      background-color: #ccc;\n    }\n\n    &.mat-checked .mdc-switch__track {\n      background-color: #065fd4;\n    }\n\n    .mdc-form-field label {\n      font-size: 14px;\n      font-weight: 500;\n      color: #000000;\n      margin-left: 8px;\n    }\n  }\n}\n\nbutton.btn-primary,\n.btn-primary {\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  background: #5ea1d8;\n  color: #ffffff;\n  text-transform: none;\n  letter-spacing: 0;\n\n  &:hover:not(:disabled) {\n    background: #4a8fc4;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\nbutton.btn-secondary,\n.btn-secondary {\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  background: #f3f4f6;\n  color: #374151;\n  text-transform: none;\n  letter-spacing: 0;\n\n  &:hover:not(:disabled) {\n    background: #e5e7eb;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n// Additional styling for sections\n.cam-icon {\n  margin-top: 24px;\n  margin-bottom: 8px;\n}\n\n// File upload section\n.col-12 {\n  margin-top: 8px;\n  margin-bottom: 0;\n\n  &:has(.fileExplorer) {\n    margin-top: 12px;\n  }\n}\n\n// Items tab styling\n.journey-content {\n  .group-title {\n    font-size: 14px;\n    font-weight: 500;\n    color: #030303;\n    margin: 24px 0 12px 0;\n    padding-bottom: 8px;\n    border-bottom: 1px solid #e0e0e0;\n  }\n\n  .example-list {\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    background: #fff;\n    padding: 8px;\n    margin-bottom: 16px;\n\n    .example-box {\n      background: #fff;\n      border: 1px solid #e0e0e0;\n      border-radius: 8px;\n      padding: 12px 16px;\n      margin-bottom: 8px;\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      transition: box-shadow 0.2s, border-color 0.2s;\n      cursor: move;\n\n      &:hover {\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n        border-color: #c0c0c0;\n      }\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n\n      .item-avatar {\n        width: 48px;\n        height: 48px;\n        border-radius: 8px;\n        overflow: hidden;\n        flex-shrink: 0;\n        background: #f9f9f9;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          cursor: pointer;\n        }\n      }\n\n      .item-name {\n        flex: 1;\n        font-size: 14px;\n        font-weight: 500;\n        color: #030303;\n        min-width: 0;\n\n        &.highlight {\n          color: #065fd4;\n        }\n      }\n\n      .item-value {\n        flex: 1;\n        font-size: 14px;\n        color: #606060;\n        min-width: 0;\n\n        a {\n          color: #065fd4;\n          text-decoration: none;\n\n          &:hover {\n            text-decoration: underline;\n          }\n        }\n      }\n\n      .row-actions {\n        display: flex;\n        gap: 4px;\n        flex-shrink: 0;\n\n        .icon-button {\n          width: 36px;\n          height: 36px;\n          border-radius: 50%;\n          border: none;\n          background: transparent;\n          color: #606060;\n          cursor: pointer;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          transition: background-color 0.2s;\n\n          &:hover {\n            background: #f0f0f0;\n            color: #030303;\n          }\n\n          mat-icon {\n            font-size: 20px;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Steps tab styling\n.example-stepList {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  .step-card {\n    background: #fff;\n    border: 1px solid #e0e0e0;\n    border-radius: 12px;\n    padding: 20px;\n    transition: box-shadow 0.2s, border-color 0.2s;\n\n    &:hover {\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n      border-color: #c0c0c0;\n    }\n\n    .step-header {\n      display: flex;\n      align-items: flex-start;\n      gap: 16px;\n      margin-bottom: 16px;\n\n      .step-number {\n        width: 32px;\n        height: 32px;\n        border-radius: 50%;\n        background: #065fd4;\n        color: #fff;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-weight: 600;\n        font-size: 14px;\n        flex-shrink: 0;\n      }\n\n      .step-file {\n        font-size: 14px;\n        font-weight: 500;\n        color: #030303;\n        margin: 0 0 4px 0;\n      }\n\n      .step-title {\n        font-size: 13px;\n        color: #606060;\n        margin: 0;\n      }\n    }\n\n    .img-and-video-sec {\n      border: 1px solid #e0e0e0;\n      border-radius: 8px;\n      overflow: hidden;\n      margin-bottom: 16px;\n      background: #000;\n      min-height: 200px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      img.img-display,\n      video.video-display {\n        max-width: 100%;\n        max-height: 400px;\n        object-fit: contain;\n        cursor: pointer;\n      }\n    }\n\n    .step-description {\n      font-size: 14px;\n      color: #030303;\n      line-height: 1.5;\n      margin-bottom: 16px;\n    }\n\n    .step-actions {\n      display: flex;\n      gap: 12px;\n      justify-content: flex-end;\n\n      .square_btn {\n        padding: 8px 16px;\n        border-radius: 18px;\n        font-size: 14px;\n        font-weight: 500;\n        cursor: pointer;\n        transition: all 0.2s;\n        border: 1px solid;\n\n        &.ghost {\n          background: transparent;\n          border-color: #e0e0e0;\n          color: #030303;\n\n          &:hover {\n            background: #f9f9f9;\n            border-color: #c0c0c0;\n          }\n        }\n\n        &:not(.ghost) {\n          background: #065fd4;\n          border-color: #065fd4;\n          color: #fff;\n\n          &:hover {\n            background: #0d47a1;\n            border-color: #0d47a1;\n          }\n        }\n      }\n    }\n  }\n}\n\n// FAQs tab styling\n.faq-row {\n  .faq-content {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    .faq-question-row {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 12px;\n      width: 100%;\n\n      .faq-question {\n        flex: 1;\n        min-width: 0;\n        display: block;\n        font-size: 14px;\n        font-weight: 500;\n        color: #030303;\n        margin-bottom: 0;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n\n      .row-actions {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n        flex-shrink: 0;\n      }\n    }\n\n    .show-answer-btn {\n      background: #f0f4ff;\n      color: #2563eb;\n      border: 1px solid #2563eb;\n      border-radius: 6px;\n      padding: 6px 12px;\n      font-size: 12px;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      align-self: flex-start;\n      margin-top: 4px;\n\n      &:hover {\n        background: #2563eb;\n        color: #fff;\n      }\n    }\n  }\n}\n\n// Empty state styling\n.empty-state {\n  border: 2px dashed #e0e0e0;\n  border-radius: 12px;\n  padding: 48px 24px;\n  text-align: center;\n  background: #f9f9f9;\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n    color: #909090;\n    margin-bottom: 16px;\n  }\n\n  p {\n    font-size: 14px;\n    color: #606060;\n    margin: 0 0 24px 0;\n  }\n\n  .square_btn {\n    background: #065fd4;\n    color: #fff;\n    border: none;\n    border-radius: 18px;\n    padding: 10px 24px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s;\n\n    &:hover {\n      background: #0d47a1;\n    }\n  }\n}\n\n.journey-pane-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n  h5 {\n    margin: 0;\n  }\n  p {\n    margin: 4px 0 0;\n    color: #6b7280;\n    font-size: 14px;\n  }\n}\n\n.empty-state {\n  border: 1px dashed #dbe2f5;\n  border-radius: 16px;\n  padding: 32px;\n  text-align: center;\n  color: #6b7280;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  mat-icon {\n    font-size: 36px;\n    color: #94a3b8;\n  }\n}\n\n.row-actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.step-card {\n  background: #f9fafb;\n  border-radius: 16px;\n  padding: 18px;\n  margin-bottom: 16px;\n  box-shadow: inset 0 0 0 1px #e5e7eb;\n}\n\n.step-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.step-number {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  // background: #111827;\n  // color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n}\n\n.step-file {\n  margin: 0;\n  font-weight: 600;\n}\n\n.step-title {\n  margin: 0;\n  color: #4b5563;\n  font-size: 14px;\n}\n\n.step-description {\n  margin-top: 12px;\n  text-align: left;\n  color: #374151;\n}\n\n.step-actions {\n  margin-top: 16px;\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.question-count-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 10px;\n  padding: 3px 10px;\n  border-radius: 999px;\n  border: 1px solid #5ea1d8;\n  background: rgba(94, 161, 216, 0.1);\n  color: #1d67a3;\n  font-family: \"Raleway\";\n  font-size: 12px;\n  font-weight: 500;\n\n  mat-icon {\n    font-size: 15px;\n    width: 15px;\n    height: 15px;\n  }\n\n  &--inline {\n    margin: 0 0 0 8px;\n    padding: 1px 8px;\n    vertical-align: middle;\n  }\n\n  &--end {\n    margin: 12px 0 0;\n  }\n}\n\n.square_btn.ghost {\n  background: transparent;\n  border-color: #d1d5db;\n  color: #374151;\n}\n\n.faq-row {\n  align-items: flex-start;\n}\n\n.faq-content {\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  .faq-question-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    width: 100%;\n\n    .faq-question {\n      flex: 1;\n      min-width: 0;\n      display: block;\n      font-weight: 600;\n      margin-bottom: 0;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    .row-actions {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      flex-shrink: 0;\n    }\n  }\n\n  .show-answer-btn {\n    background: #f0f4ff;\n    color: #2563eb;\n    border: 1px solid #2563eb;\n    border-radius: 6px;\n    padding: 6px 12px;\n    font-size: 12px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    align-self: flex-start;\n    margin-top: 4px;\n\n    &:hover {\n      background: #2563eb;\n      color: #fff;\n    }\n  }\n}\n\n.quick-actions .actions-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.summary-card {\n  background: #fff;\n  border-radius: 18px;\n  border: 1px solid #e4e8f0;\n  padding: 24px;\n  box-shadow: 0 15px 35px rgba(15, 23, 42, 0.09);\n  \n  &.preview-card {\n    display: flex;\n    flex-direction: column;\n    height: auto;\n    min-height: unset;\n    max-height: unset;\n    box-sizing: border-box;\n    overflow: visible;\n  }\n  \n  h5 {\n    margin: 0 0 12px;\n    font-size: 17px;\n    height: 24px;\n    min-height: 24px;\n    max-height: 24px;\n    flex-shrink: 0;\n    line-height: 24px;\n    box-sizing: border-box;\n  }\n}\n\n.preview-card {\n  // Ensure flow-info-panel works in preview card with full styles\n  .flow-info-panel {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 12px 16px;\n    background: #f9f9f9;\n    border-radius: 8px;\n    margin-bottom: 16px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: thin;\n    scrollbar-color: #888 #f1f1f1;\n    height: 60px;\n    min-height: 60px;\n    max-height: 60px;\n    flex-shrink: 0;\n\n    &::-webkit-scrollbar {\n      height: 6px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: #f1f1f1;\n      border-radius: 3px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #888;\n      border-radius: 3px;\n\n      &:hover {\n        background: #555;\n      }\n    }\n\n    .info-badge {\n      display: inline-flex;\n      align-items: center;\n      gap: 6px;\n      font-size: 13px;\n      font-weight: 500;\n      font-family: \"Raleway\", sans-serif;\n      color: #0f0f0f;\n      background: white;\n      border: 1px solid #e0e0e0;\n      border-radius: 16px;\n      padding: 4px 12px;\n      cursor: pointer;\n      transition: all 0.2s;\n      white-space: nowrap;\n      flex-shrink: 0;\n      min-width: fit-content;\n\n      &:hover {\n        background: #f5f5f5;\n        border-color: #5ea1d8;\n      }\n\n      &.active {\n        background: #5ea1d8;\n        color: white;\n        border-color: #5ea1d8;\n\n        .info-icon,\n        .info-label,\n        .info-step-title {\n          color: white;\n        }\n      }\n\n      .info-icon {\n        font-size: 14px;\n        flex-shrink: 0;\n        line-height: 1;\n      }\n\n      .info-label {\n        font-family: \"Raleway\", sans-serif;\n        flex-shrink: 0;\n        font-size: 13px;\n      }\n\n      .info-step-title {\n        font-size: 11px;\n        color: #606060;\n        margin-left: 4px;\n        max-width: 120px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        font-family: \"Raleway\", sans-serif;\n\n        @media (max-width: 768px) {\n          display: none;\n        }\n      }\n    }\n\n    @media (max-width: 768px) {\n      gap: 6px;\n      padding: 10px 12px;\n\n      .info-badge {\n        font-size: 12px;\n        padding: 3px 10px;\n        font-family: \"Raleway\", sans-serif;\n\n        .info-icon {\n          font-size: 12px;\n        }\n      }\n    }\n  }\n\n  .preview-content {\n    height: auto;\n    min-height: unset;\n    max-height: unset;\n    overflow-y: visible;\n    flex-shrink: 1;\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n\n    &::-webkit-scrollbar {\n      width: 6px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: #f1f1f1;\n      border-radius: 3px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #c1c1c1;\n      border-radius: 3px;\n\n      &:hover {\n        background: #a8a8a8;\n      }\n    }\n  }\n\n  // Mobile view wrapper\n  .mobile-preview-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    height: auto;\n    min-height: unset;\n    max-height: unset;\n    flex-shrink: 1;\n    overflow: visible;\n    box-sizing: border-box;\n  }\n\n  // Mobile section style (like view flow)\n  .mobile-section {\n    background: #ffffff;\n    border-radius: 16px;\n   box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);\n    overflow: hidden;\n    margin-bottom: 16px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    .mobile-media {\n      background: #000;\n      width: 100%;\n      min-height: 180px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: relative;\n\n      img,\n      video {\n        width: 100%;\n        max-height: 260px;\n        object-fit: cover;\n        display: block;\n      }\n\n      &.placeholder {\n        color: #9ca3af;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 8px;\n        background: #f3f4f6;\n\n        mat-icon {\n          font-size: 48px;\n          width: 48px;\n          height: 48px;\n        }\n\n        p {\n          margin: 0;\n          font-size: 14px;\n        }\n      }\n    }\n\n    .mobile-section-body {\n      padding: 20px;\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n    }\n\n    .mobile-section-title {\n      font-size: 20px;\n      font-weight: 600;\n      margin: 0;\n      color: #1f2f46;\n      line-height: 1.4;\n    }\n\n    .mobile-section-description {\n      color: #4a5568;\n      line-height: 1.6;\n      font-size: 14px;\n\n      p {\n        margin-bottom: 12px;\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n    }\n\n    .mobile-meta-row {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      flex-wrap: wrap;\n      margin-top: 8px;\n\n      .info-badge {\n        display: inline-flex;\n        align-items: center;\n        gap: 4px;\n        padding: 4px 12px;\n        border-radius: 999px;\n        background: #f1f5f9;\n        color: #475569;\n        font-size: 13px;\n\n        mat-icon {\n          font-size: 18px;\n          width: 18px;\n          height: 18px;\n          color: #5ea1d8;\n        }\n      }\n    }\n  }\n\n  // Mobile steps view\n  .steps-summary-container {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    height: auto;\n    min-height: unset;\n    max-height: unset;\n    flex-shrink: 1;\n    overflow: visible;\n    box-sizing: border-box;\n    width: 100%;\n    position: relative;\n\n    .flow-info-panel {\n      overflow-x: auto;\n      overflow-y: hidden;\n      -webkit-overflow-scrolling: touch;\n      scrollbar-width: thin;\n      scrollbar-color: #888 #f1f1f1;\n      flex-direction: row;\n      writing-mode: horizontal-tb;\n      text-orientation: mixed;\n      direction: ltr;\n      padding: 12px 16px;\n      gap: 8px;\n      align-items: center;\n      max-width: 520px;\n      width: 100%;\n      box-sizing: border-box;\n      height: 60px;\n      min-height: 60px;\n      max-height: 60px;\n      flex-shrink: 0;\n      flex-grow: 0;\n      \n      @media (max-width: 767px) {\n        max-width: 100%;\n      }\n\n      &::-webkit-scrollbar {\n        height: 6px;\n      }\n\n      &::-webkit-scrollbar-track {\n        background: #f1f1f1;\n        border-radius: 3px;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background: #888;\n        border-radius: 3px;\n\n        &:hover {\n          background: #555;\n        }\n      }\n\n      .info-badge {\n        display: inline-flex;\n        align-items: center;\n        gap: 6px;\n        font-size: 13px;\n        font-weight: 500;\n        font-family: \"Raleway\", sans-serif;\n        color: #0f0f0f;\n        background: #fff;\n        border: 1px solid #e0e0e0;\n        border-radius: 16px;\n        padding: 4px 12px;\n        cursor: pointer;\n        transition: all 0.2s;\n        white-space: nowrap;\n        flex-shrink: 0;\n        min-width: fit-content;\n        writing-mode: horizontal-tb;\n        text-orientation: mixed;\n        direction: ltr;\n        transform: none;\n\n        &:hover {\n          background: #f5f5f5;\n          // border-color: #5ea1d8;\n        }\n\n        &.active {\n          background: #5ea1d8;\n          color: #fff;\n          border-color: #5ea1d8;\n          writing-mode: horizontal-tb;\n          text-orientation: mixed;\n          transform: none;\n\n          .info-icon,\n          .info-label,\n          .info-step-title {\n            color: #fff;\n            writing-mode: horizontal-tb;\n            text-orientation: mixed;\n          }\n        }\n\n        .info-icon {\n          font-size: 14px;\n          flex-shrink: 0;\n          line-height: 1;\n        }\n\n        .info-label {\n          font-family: \"Raleway\", sans-serif;\n          flex-shrink: 0;\n          font-size: 13px;\n        }\n\n        .info-step-title {\n          font-size: 11px;\n          color: #606060;\n          margin-left: 4px;\n          max-width: 120px;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          font-family: \"Raleway\", sans-serif;\n\n          @media (max-width: 768px) {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n\n  // Overlay next/prev arrows on the step media (summary tab) - left & right center of media\n  .selected-step-details {\n    .mobile-step-media {\n      position: relative;\n    }\n\n    .steps-summary-clickarrow {\n      position: absolute;\n      top: 50%;\n      left: 0;\n      right: 0;\n      transform: translateY(-50%);\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 0 0px;\n\n      .owl-prev,\n      .owl-next {\n        background: rgba(0, 0, 0, 0.65);\n        color: #fff;\n        border: none;\n        border-radius: 50%;\n        width: 36px;\n        height: 36px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        transition: background 0.2s, transform 0.2s, opacity 0.2s;\n        font-size: 22px;\n        font-weight: bold;\n        padding: 0;\n\n        span {\n          line-height: 1;\n        }\n\n        &:hover:not(:disabled) {\n          background: rgba(0, 0, 0, 0.85);\n          transform: translateY(-1px);\n        }\n\n        &:disabled {\n          opacity: 0.4;\n          cursor: default;\n        }\n      }\n    }\n  }\n\n  .summary-steps-list-section {\n    margin-bottom: 16px;\n    padding: 12px;\n    background: #f9f9f9;\n    border-radius: 8px;\n\n    .steps-list-title {\n      font-size: 14px;\n      font-weight: 600;\n      margin: 0 0 10px 0;\n      color: #0f0f0f;\n    }\n\n    .summary-steps-list {\n      display: flex;\n      flex-direction: column;\n      gap: 6px;\n    }\n\n    .summary-step-chip {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      padding: 8px 12px;\n      border: 1px solid #e0e0e0;\n      border-radius: 6px;\n      background: white;\n      cursor: pointer;\n      font-size: 12px;\n      font-weight: 500;\n      color: #0f0f0f;\n      text-align: left;\n      transition: all 0.2s;\n      width: 100%;\n      height: auto;\n      white-space: normal;\n      word-break: break-word;\n      overflow: visible;\n\n      &:hover {\n        background: #f5f5f5;\n        border-color: #c0c0c0;\n      }\n\n      &.active {\n        background: #5ea1d8;\n        color: white;\n        border-color: #5ea1d8;\n      }\n\n      .step-chip-number {\n        font-size: 12px;\n        font-weight: 600;\n        font-family: \"Raleway\", sans-serif;\n        flex-shrink: 0;\n      }\n\n      .step-chip-title {\n        font-size: 12px;\n        font-weight: 400;\n        font-family: \"Raleway\", sans-serif;\n        line-height: 1.4;\n        word-wrap: break-word;\n        overflow: visible;\n        text-overflow: clip;\n        display: block;\n        flex: 1 1 auto;\n        white-space: normal;\n      }\n    }\n  }\n\n  .selected-step-details {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    border: 1px solid #e5e7eb;\n    border-radius: 12px;\n    overflow: hidden;\n    background: white;\n    height: auto;\n    min-height: unset;\n    max-height: unset;\n    flex-shrink: 1;\n    flex-grow: 0;\n    box-sizing: border-box;\n    width: 100%;\n\n    .mobile-step-media {\n      background: #000;\n      border-radius: 12px 12px 0 0;\n      overflow: hidden;\n      max-height: 200px;\n      min-height: unset;\n      flex-shrink: 0;\n      box-sizing: border-box;\n\n      img,\n      video {\n        width: 100%;\n        height: auto;\n        max-height: 200px;\n        object-fit: cover;\n        display: block;\n      }\n    }\n\n    .mobile-section-body {\n      padding: 12px;\n      height: auto;\n      min-height: unset;\n      max-height: unset;\n      overflow-y: auto;\n      overflow-x: hidden;\n      flex-shrink: 1;\n      box-sizing: border-box;\n    }\n  }\n\n  .mobile-steps-view {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n\n    .mobile-step-media {\n      background: #000;\n      border-radius: 12px 12px 0 0;\n      overflow: hidden;\n      min-height: 150px;\n\n      img,\n      video {\n        width: 100%;\n        height: 200px;\n        object-fit: cover;\n        display: block;\n      }\n    }\n\n    .mobile-step-header {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n      margin-bottom: 12px;\n\n      .mobile-step-number {\n        align-self: flex-start;\n        padding: 4px 12px;\n        border-radius: 999px;\n        font-size: 12px;\n        text-transform: uppercase;\n        letter-spacing: 0.05em;\n        background: #e0f2fe;\n        color: #0284c7;\n        font-weight: 600;\n      }\n    }\n  }\n\n  // Mobile items view\n  .mobile-items-view {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n\n    .mobile-items-list {\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      margin-top: 12px;\n      background-color: #f8f9fa;\n      padding: 15px;\n    }\n\n    .mobile-item-card {\n      display: flex;\n      gap: 12px;\n      padding: 14px;\n      border: 1px solid #e2e8f0;\n      border-radius: 12px;\n      background: #fff;\n      transition: all 0.2s ease;\n      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n\n      &:hover {\n        border-color: #cbd5e1;\n        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n      }\n\n      .mobile-item-avatar {\n        width: 56px;\n        height: 56px;\n        border-radius: 12px;\n        background: #f1f5f9;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-weight: 600;\n        color: #475569;\n        font-size: 20px;\n        flex-shrink: 0;\n        overflow: hidden;\n        border: 2px solid #e2e8f0;\n\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n        }\n\n        span {\n          font-size: 20px;\n          text-transform: uppercase;\n        }\n      }\n\n      .mobile-item-content {\n        flex: 1;\n        min-width: 0;\n        display: flex;\n        flex-direction: column;\n        gap: 6px;\n        justify-content: center;\n\n        .mobile-item-name {\n          margin: 0;\n          font-size: 15px;\n          font-weight: 600;\n          color: #1f2f46;\n          line-height: 1.4;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          max-width: 100%;\n        }\n\n        .mobile-item-quantity {\n          margin: 0;\n          font-size: 13px;\n          color: #64748b;\n          font-weight: 500;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          max-width: 100%;\n        }\n\n        .mobile-item-link {\n          font-size: 12px;\n          color: #2563eb;\n          text-decoration: none;\n          margin-top: 2px;\n          display: inline-flex;\n          align-items: center;\n          gap: 4px;\n          font-weight: 500;\n\n          &:hover {\n            text-decoration: underline;\n            color: #1d4ed8;\n          }\n        }\n      }\n    }\n\n    .mobile-item-card.ng-star-inserted {\n      padding: 4px;\n    }\n  }\n\n  // Mobile FAQs view\n  .mobile-faqs-view {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    overflow: visible;\n    max-height: none;\n\n    .mobile-faq-list {\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n      margin-top: 12px;\n      overflow: visible;\n      max-height: none;\n    }\n\n    .mobile-faq-item {\n      padding: 16px;\n      border: 1px solid #e2e8f0;\n      border-radius: 12px;\n      background: #fff;\n      transition: all 0.2s ease;\n      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n      overflow: visible;\n      max-height: none;\n\n      &:hover {\n        border-color: #cbd5e1;\n        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n      }\n\n      .mobile-faq-question {\n        display: flex;\n        gap: 10px;\n        align-items: flex-start;\n        margin-bottom: 12px;\n        font-weight: 600;\n        color: #1f2f46;\n        font-size: 15px;\n        line-height: 1.5;\n\n        mat-icon {\n          font-size: 20px;\n          width: 20px;\n          height: 20px;\n          color: #2563eb;\n          flex-shrink: 0;\n          margin-top: 2px;\n        }\n\n        span {\n          flex: 1;\n          min-width: 0;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n      }\n\n      .show-answer-btn {\n        background: #f0f4ff;\n        color: #2563eb;\n        border: 1px solid #2563eb;\n        border-radius: 6px;\n        padding: 8px 16px;\n        font-size: 13px;\n        font-weight: 500;\n        cursor: pointer;\n        transition: all 0.2s ease;\n        width: 100%;\n        margin-top: 8px;\n\n        &:hover {\n          background: #2563eb;\n          color: #fff;\n        }\n      }\n    }\n  }\n\n  .summary-flow-layout {\n    display: grid;\n    grid-template-columns: minmax(0, 2.2fr) minmax(280px, 1fr);\n    gap: 24px;\n    margin-top: 16px;\n\n    @media (max-width: 1100px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .summary-main-column,\n  .summary-sidebar-column {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .summary-card {\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 12px;\n    padding: 20px;\n    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);\n  }\n\n  .summary-card-header {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    margin-bottom: 16px;\n\n    mat-icon {\n      font-size: 22px;\n      width: 22px;\n      height: 22px;\n      color: #2563eb;\n      margin-top: 2px;\n    }\n\n    h3 {\n      margin: 0;\n      font-size: 16px;\n      font-weight: 600;\n      color: #0f172a;\n    }\n\n    p {\n      margin: 2px 0 0 0;\n      font-size: 13px;\n      color: #64748b;\n    }\n  }\n\n  .summary-cover-preview {\n    width: 100%;\n    border-radius: 12px;\n    overflow: hidden;\n    background: #000;\n\n    img,\n    video {\n      width: 100%;\n      height: auto;\n      display: block;\n      object-fit: contain;\n    }\n  }\n\n  .summary-cover-placeholder {\n    border: 1px dashed #d4d8dd;\n    border-radius: 12px;\n    padding: 40px 16px;\n    text-align: center;\n    color: #94a3b8;\n\n    mat-icon {\n      display: block;\n      margin: 0 auto 8px auto;\n      font-size: 32px;\n    }\n  }\n\n  .summary-cover-details {\n    margin-top: 16px;\n\n    h2 {\n      margin: 0 0 12px 0;\n      font-size: 22px;\n      color: #0f172a;\n    }\n  }\n\n  .summary-info-pills {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-bottom: 12px;\n  }\n\n  .summary-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 12px;\n    border-radius: 999px;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    font-size: 13px;\n    color: #475569;\n\n    mat-icon {\n      font-size: 16px;\n      color: #2563eb;\n    }\n  }\n\n  .summary-items-groups {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .summary-items-block {\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    padding: 14px 16px;\n    background: #fdfdfd;\n  }\n\n  .summary-block-title {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 10px;\n\n    mat-icon {\n      font-size: 20px;\n      color: #475569;\n    }\n\n    h4 {\n      margin: 0;\n      font-size: 15px;\n      color: #0f172a;\n    }\n\n    span {\n      font-size: 12px;\n      color: #94a3b8;\n    }\n  }\n\n  .summary-item-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n\n    li {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: 12px;\n      font-size: 13px;\n      color: #475569;\n      flex-wrap: wrap;\n    }\n\n    .item-info {\n      display: flex;\n      flex-direction: column;\n\n      strong {\n        color: #0f172a;\n      }\n    }\n\n    a {\n      display: inline-flex;\n      align-items: center;\n      gap: 4px;\n      font-size: 12px;\n      color: #2563eb;\n      text-decoration: none;\n\n      mat-icon {\n        font-size: 16px;\n      }\n    }\n  }\n\n  .summary-step-stack {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .summary-step-panel {\n    border: 1px solid #e5e7eb;\n    border-radius: 12px;\n    padding: 16px;\n    background: #fdfdfd;\n  }\n\n  .summary-step-heading {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 12px;\n\n    h4 {\n      margin: 0;\n      font-size: 16px;\n      color: #0f172a;\n    }\n  }\n\n  .step-chip {\n    padding: 4px 10px;\n    border-radius: 999px;\n    background: #e0e7ff;\n    color: #312e81;\n    font-size: 12px;\n    font-weight: 600;\n  }\n\n  .summary-step-body {\n    display: grid;\n    grid-template-columns: minmax(0, 240px) 1fr;\n    gap: 16px;\n\n    @media (max-width: 768px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .summary-step-media {\n    border-radius: 8px;\n    overflow: hidden;\n    background: transparent;\n    aspect-ratio: 16/9;\n\n    img,\n    video {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n\n  .summary-step-description {\n    font-size: 13px;\n    color: #475569;\n    line-height: 1.6;\n\n    ::ng-deep p {\n      margin-bottom: 10px;\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  .summary-faq-collection {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .summary-faq-block {\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    padding: 14px 16px;\n    background: #fdfdfd;\n\n    h4 {\n      margin: 0 0 8px 0;\n      font-size: 14px;\n      color: #0f172a;\n    }\n  }\n\n  .summary-faq-item {\n    border-top: 1px solid #e2e8f0;\n    padding-top: 10px;\n    margin-top: 10px;\n\n    &:first-child {\n      border-top: 0;\n      padding-top: 0;\n      margin-top: 0;\n    }\n\n    .question {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      font-weight: 600;\n      color: #0f172a;\n      margin: 0 0 6px 0;\n\n      mat-icon {\n        font-size: 16px;\n        color: #2563eb;\n      }\n    }\n\n    .answer {\n      font-size: 13px;\n      color: #475569;\n      line-height: 1.6;\n    }\n  }\n\n  .sidebar-card {\n    position: sticky;\n    top: 24px;\n  }\n\n  .summary-step-nav {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .summary-step-chip {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    width: 100%;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    padding: 10px 12px;\n    background: #fff;\n    text-align: left;\n    cursor: default;\n\n    .chip-index {\n      width: 28px;\n      height: 28px;\n      border-radius: 50%;\n      background: #e0e7ff;\n      color: #1e1b4b;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      font-weight: 600;\n      font-size: 13px;\n    }\n\n    .chip-text {\n      display: flex;\n      flex-direction: column;\n      gap: 3px;\n\n      strong {\n        font-size: 13px;\n        color: #0f172a;\n      }\n\n      small {\n        font-size: 12px;\n        color: #94a3b8;\n        max-width: 220px;\n        display: inline-block;\n      }\n    }\n  }\n\n  .summary-stats-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n\n    li {\n      display: flex;\n      justify-content: space-between;\n      font-size: 13px;\n      color: #475569;\n\n      strong {\n        color: #0f172a;\n      }\n    }\n  }\n\n  .preview-empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 40px 20px;\n    text-align: center;\n    color: #9ca3af;\n    height: auto;\n    min-height: unset;\n    max-height: unset;\n    flex-shrink: 1;\n    box-sizing: border-box;\n\n    mat-icon {\n      font-size: 48px;\n      width: 48px;\n      height: 48px;\n      margin-bottom: 12px;\n      opacity: 0.5;\n    }\n\n    p {\n      margin: 0;\n      font-size: 14px;\n    }\n  }\n}\n\n.summary-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px;\n  color: #4b5563;\n  margin-bottom: 8px;\n  align-items: center;\n  gap: 8px;\n  span:last-child {\n    font-weight: 600;\n  }\n  .meta-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    color: #5ea1d8;\n  }\n}\n\n.summary-preview {\n  margin-top: 16px;\n}\n\n.summary-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.items-summary,\n.steps-summary,\n.faqs-summary {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.items-group,\n.faq-group {\n  margin-bottom: 20px;\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.group-title-small {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n  margin: 0 0 12px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #e4e8f0;\n}\n\n.items-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.item-preview {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  background: #f9fafb;\n  border-radius: 8px;\n  .item-preview-image {\n    width: 50px;\n    height: 50px;\n    border-radius: 8px;\n    object-fit: cover;\n    flex-shrink: 0;\n\n    &.placeholder {\n      background: #f3f4f6;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-weight: 600;\n      color: #6b7280;\n      font-size: 18px;\n    }\n  }\n  .item-preview-content {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    flex: 1;\n    min-width: 0;\n  }\n  .item-preview-name {\n    font-size: 14px;\n    font-weight: 600;\n    color: #111827;\n  }\n  .item-preview-quantity {\n    font-size: 13px;\n    color: #6b7280;\n  }\n  .item-link {\n    font-size: 12px;\n    color: #2563eb;\n    text-decoration: none;\n    margin-top: 4px;\n    display: inline-flex;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.steps-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.step-preview {\n  padding: 16px;\n  background: #f9fafb;\n  border-radius: 12px;\n  border: 1px solid #e4e8f0;\n  .step-preview-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 12px;\n  }\n  .step-preview-number {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    background: #5ea1d8;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    font-weight: 600;\n    flex-shrink: 0;\n  }\n  .step-preview-title {\n    font-size: 15px;\n    font-weight: 600;\n    color: #111827;\n  }\n  .step-preview-media {\n    margin-bottom: 12px;\n    border-radius: 8px;\n    overflow: hidden;\n    background: #f3f4f6;\n  }\n  .step-preview-image {\n    width: 100%;\n    max-height: 150px;\n    object-fit: cover;\n    display: block;\n  }\n  .step-preview-video {\n    width: 100%;\n    max-height: 150px;\n    object-fit: cover;\n    display: block;\n  }\n  .step-preview-description {\n    font-size: 13px;\n    color: #6b7280;\n    line-height: 1.5;\n    max-height: 80px;\n    overflow: hidden;\n  }\n}\n\n.faqs-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.faq-preview {\n  padding: 12px;\n  background: #f9fafb;\n  border-radius: 8px;\n  border-left: 3px solid #5ea1d8;\n  .faq-preview-question {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    margin-bottom: 8px;\n    .faq-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      color: #5ea1d8;\n      flex-shrink: 0;\n      margin-top: 2px;\n    }\n    span {\n      font-size: 14px;\n      font-weight: 600;\n      color: #111827;\n      line-height: 1.4;\n    }\n  }\n  .faq-preview-answer {\n    font-size: 13px;\n    color: #6b7280;\n    line-height: 1.5;\n    margin-left: 26px;\n    max-height: 60px;\n    overflow: hidden;\n  }\n}\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  text-align: center;\n  color: #9ca3af;\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n    margin-bottom: 12px;\n    opacity: 0.5;\n  }\n  p {\n    margin: 0;\n    font-size: 14px;\n  }\n}\n\n.transfer-card {\n  mat-slide-toggle {\n    width: 100%;\n    white-space: normal;\n  }\n}\n\n.toggle-description {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-top: 12px;\n  font-size: 13px;\n  color: #4b5563;\n  &.warning {\n    color: #b45309;\n  }\n  .info-icon,\n  .warning-icon {\n    font-size: 18px;\n  }\n}\n\n.selected-user-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 14px;\n  font-size: 14px;\n  .user-name {\n    font-weight: 600;\n  }\n  .user-email {\n    color: #6b7280;\n  }\n}\n\n.actions-card .publish {\n  width: 100%;\n  margin-top: 12px;\n}\n\n.upload-progress {\n  margin: 24px auto;\n  max-width: 420px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: #111827;\n  color: #fff;\n  padding: 12px 18px;\n  border-radius: 999px;\n  progress {\n    flex: 1;\n    height: 8px;\n  }\n  &.spinner-only {\n    justify-content: center;\n    background: transparent;\n  }\n}\n\n// Overlay progress (for global upload indicator)\n.flow-upload-progress-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 10000;\n  background: rgba(255, 255, 255, 0.98);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 12px 24px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  backdrop-filter: blur(8px);\n\n  .flow-progress-bar-container {\n    flex: 1;\n    height: 3px;\n    background-color: rgba(0, 0, 0, 0.1);\n    border-radius: 2px;\n    overflow: hidden;\n    position: relative;\n    max-width: 600px;\n    margin: 0 auto;\n\n    .flow-progress-bar {\n      height: 100%;\n      background: linear-gradient(90deg, #065fd4 0%, #0d96ff 100%);\n      border-radius: 2px;\n      transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n      position: relative;\n      overflow: hidden;\n\n      &::after {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        background: linear-gradient(\n          90deg,\n          transparent,\n          rgba(255, 255, 255, 0.3),\n          transparent\n        );\n        animation: shimmer 1.5s infinite;\n      }\n    }\n  }\n\n  .flow-progress-text {\n    font-size: 13px;\n    font-weight: 500;\n    color: #065fd4;\n    min-width: 45px;\n    text-align: right;\n    font-family: \"Roboto\", sans-serif;\n  }\n\n  .upload-status-text {\n    font-size: 13px;\n    color: #666;\n    margin-top: 8px;\n    text-align: center;\n    width: 100%;\n    font-family: \"Roboto\", sans-serif;\n  }\n}\n\n@media (max-width: 1200px) {\n  .upload-body {\n    flex-direction: column;\n  }\n  .secondary-pane {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n  .summary-card {\n    flex: 1 1 320px;\n  }\n}\n\n@media (max-width: 768px) {\n  .upload-backdrop {\n    padding: 0;\n  }\n  .upload-dialog {\n    width: 100%;\n    height: 100vh;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n  .upload-header,\n  .stage-banner {\n    padding: 20px;\n  }\n  .upload-body {\n    padding: 0;\n    gap: 0;\n  }\n  .section-card {\n    padding: 18px;\n  }\n  // On mobile the dialog is full-screen, so the journey card should\n  // extend edge-to-edge with no rounded corners or side borders.\n  .section-card.journey-card {\n    border-radius: 0;\n    border-left: none;\n    border-right: none;\n    border-top: none;\n  }\n\n  // Mobile: make the top journey step list horizontally scrollable\n  .journey-progress {\n    overflow-x: auto !important;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none; // Firefox\n    padding-top: 8px;\n    margin-top: 8px;\n    touch-action: pan-x;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  // Mobile: show connectors with fixed width for better mobile experience\n  .step-connector {\n    display: block !important;\n    flex: 0 0 16px; // Fixed width instead of flex: 1 for mobile\n    min-width: 16px;\n    height: 2px;\n    margin: 0 4px;\n    align-self: center; // Ensure proper vertical alignment\n  }\n\n  .journey-step {\n    flex: 0 0 auto;\n    padding-right: 8px;\n    // Disabled tabs get `touch-action: none` inline from MDC; override so user can swipe-scroll.\n    touch-action: pan-x !important;\n  }\n\n  .step-label {\n    font-size: 12px;\n    letter-spacing: 0.02em;\n  }\n\n  // Mobile: prevent horizontal overflow in forms/fields\n  .journey-content {\n    padding: 16px;\n    overflow-x: hidden;\n  }\n\n  mat-form-field {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .cover-form-wrapper,\n  .cover-form-wrapper .row,\n  .cover-form-wrapper .col-12,\n  .cover-form-wrapper [class*=\"col-\"] {\n    max-width: 100%;\n  }\n\n  // Avoid nested grid padding causing horizontal scroll\n  .cover-form-wrapper .row {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .cover-form-wrapper [class*=\"col-\"] {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  // Mobile: keep footer actions visible (pin to bottom) + account for safe area\n  // Also fix mobile browser \"vh\" quirks by using dynamic viewport height.\n  .upload-dialog {\n    height: 100dvh;\n    max-height: 100dvh;\n  }\n\n  .upload-footer {\n    // Override global mobile CSS in `styles.scss` that hides all `footer` elements.\n    display: flex !important;\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 10010;\n    padding: 8px 12px;\n    padding-bottom: max(8px, env(safe-area-inset-bottom));\n    gap: 8px;\n    flex-wrap: nowrap;\n    align-items: center;\n  }\n}\n\n// Tablet range (769-992px): global styles.scss hides `footer` but â‰¤768px override doesn't cover this range.\n@media (min-width: 769px) and (max-width: 992px) {\n  .upload-footer {\n    display: flex !important;\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 10010;\n    padding: 8px 16px;\n    padding-bottom: max(8px, env(safe-area-inset-bottom));\n    gap: 8px;\n    flex-wrap: nowrap;\n    align-items: center;\n  }\n\n  .upload-body {\n    padding-bottom: calc(20px + 60px + env(safe-area-inset-bottom));\n  }\n}\n\n@media (max-width: 768px) {\n  // Prevent content from being hidden behind the fixed footer\n  .upload-body {\n    padding-bottom: calc(20px + 60px + env(safe-area-inset-bottom));\n  }\n\n  // Mobile footer: Previous, Next, Save Draft share the same size\n  .upload-footer .footer-step,\n  .upload-footer .footer-actions {\n    flex: 1 1 0;\n    min-width: 0;\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: stretch;\n    gap: 8px;\n  }\n\n  .upload-footer .footer-actions .take-public-group,\n  .upload-footer .footer-actions .take-public-wrap,\n  .upload-footer .footer-actions .publish-wrap {\n    flex: 1 1 0;\n    min-width: 0;\n    display: flex;\n  }\n\n  /* Secondary actions sit in the ⋮ menu; the button keeps a fixed square size */\n  .upload-footer .footer-actions .footer-more-btn {\n    flex: 0 0 40px;\n    width: 40px;\n    height: 40px;\n    padding: 0;\n    border-radius: 50%;\n    border: 1px solid #d0d7de;\n    background: #fff;\n    color: #374151;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n\n    mat-icon {\n      font-size: 22px;\n      width: 22px;\n      height: 22px;\n      line-height: 22px;\n    }\n  }\n\n  /* A reviewer's approve/reject bar takes its own full-width row above the buttons */\n  .upload-footer {\n    flex-wrap: wrap;\n  }\n\n  .upload-footer .footer-actions {\n    flex-wrap: wrap;\n  }\n\n  .upload-footer .footer-actions .approval-review {\n    order: -1;\n    flex: 1 1 100%;\n  }\n\n  .upload-dialog:has(.upload-footer .approval-review) .upload-body {\n    padding-bottom: calc(20px + 170px + env(safe-area-inset-bottom));\n  }\n\n  :host-context(body.theme-dark) .upload-footer .footer-actions .footer-more-btn {\n    background: #1b1f27;\n    border-color: #2f3542;\n    color: #e2e8f0;\n  }\n\n  .upload-footer .footer-step .footer-btn,\n  .upload-footer .footer-actions .footer-btn,\n  .upload-footer .footer-actions .btn-primary {\n    flex: 1 1 0;\n    width: 100%;\n    min-width: 0;\n    min-height: 40px;\n    height: 40px;\n    padding: 8px 10px;\n    font-size: 13px;\n    font-weight: 600;\n    letter-spacing: 0;\n    text-transform: none;\n    line-height: 1.2;\n    border-radius: 999px;\n    box-sizing: border-box;\n  }\n\n  // Mobile: Angular Material tab headers (Attachments / HyperLink) should scroll horizontally\n  // instead of overflowing out of the box.\n  //\n  // NOTE: MatTabGroup renders its header inside Angular Material templates, so we need\n  // ::ng-deep here to pierce view encapsulation.\n  :host ::ng-deep .standard-tab-group {\n    .mat-mdc-tab-header-pagination {\n      display: none !important;\n    }\n\n    .mat-mdc-tab-label-container {\n      overflow-x: auto !important;\n      overflow-y: hidden !important;\n      -webkit-overflow-scrolling: touch;\n      touch-action: pan-x;\n      scrollbar-width: none;\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n    }\n\n    // Material uses translateX(...) for pagination; disable it so native scroll works.\n    .mat-mdc-tab-list {\n      transform: none !important;\n      width: max-content;\n    }\n\n    .mat-mdc-tab-labels {\n      width: max-content;\n      flex-wrap: nowrap;\n    }\n\n    // Your tab label template uses inline `min-width: 120px`; override on mobile so it can fit.\n    .mdc-tab__text-label > span {\n      min-width: 0 !important;\n    }\n  }\n}\n\n#formFooter {\n  background-color: #f6f6f6;\n  border-top: 1px solid #dce8f1;\n  padding: 10px;\n  text-align: center;\n  -webkit-border-radius: 0 0 10px 10px;\n  border-radius: 0 0 10px 10px;\n}\n\n/* BASIC */\n\n.Login {\n  background-color: white;\n  min-height: 89vh;\n  & > div {\n    background: #efeeee !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 89vh;\n  }\n}\n.banner {\n  margin-top: 200px;\n}\nhtml {\n  background-color: #56baed;\n}\n\nbody {\n  font-family: \"Poppins\", sans-serif;\n  height: 100vh;\n}\n\na {\n  color: #92badd;\n  display: inline-block;\n  text-decoration: none;\n  font-weight: 400;\n}\n\nh2 {\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  text-transform: uppercase;\n  display: inline-block;\n  margin: 40px 8px 10px 8px;\n  color: #cccccc;\n}\n\n/* STRUCTURE */\n\n.wrapper {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  min-height: 100%;\n  padding: 20px;\n}\n\n#formContent {\n  -webkit-border-radius: 10px 10px 10px 10px;\n  border-radius: 10px 10px 10px 10px;\n  background: #fff;\n  padding: 20px 40px !important;\n  width: 90%;\n  max-width: 600px;\n  width: 100%;\n  position: relative;\n  padding: 0px;\n  -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);\n  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);\n  text-align: center;\n  border: 0.5px solid lightgrey;\n}\n\n/* TABS */\n\nh2.inactive {\n  color: #cccccc;\n}\n\nh2.active {\n  color: #0d0d0d;\n  border-bottom: 2px solid #5fbae9;\n}\n\n/* FORM TYPOGRAPHY*/\n\ninput[type=\"button\"],\ninput[type=\"submit\"],\ninput[type=\"reset\"] {\n  background-color: #56baed;\n  border: none;\n  color: white;\n  padding: 15px 80px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  text-transform: uppercase;\n  font-size: 13px;\n  -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);\n  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);\n  -webkit-border-radius: 5px 5px 5px 5px;\n  border-radius: 5px 5px 5px 5px;\n  margin: 5px 20px 40px 20px;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n\ninput[type=\"button\"]:hover,\ninput[type=\"submit\"]:hover,\ninput[type=\"reset\"]:hover {\n  background-color: #39ace7;\n}\n\ninput[type=\"button\"]:active,\ninput[type=\"submit\"]:active,\ninput[type=\"reset\"]:active {\n  -moz-transform: scale(0.95);\n  -webkit-transform: scale(0.95);\n  -o-transform: scale(0.95);\n  -ms-transform: scale(0.95);\n  transform: scale(0.95);\n}\n\ninput[type=\"text\"],\ninput[type=\"password\"] {\n  // background-color: #f6f6f6;\n  border: none;\n  color: #0d0d0d;\n  padding: 15px 32px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  margin: 5px;\n  width: 85%;\n  border: 2px solid #f6f6f6;\n  -webkit-transition: all 0.5s ease-in-out;\n  -moz-transition: all 0.5s ease-in-out;\n  -ms-transition: all 0.5s ease-in-out;\n  -o-transition: all 0.5s ease-in-out;\n  transition: all 0.5s ease-in-out;\n  -webkit-border-radius: 5px 5px 5px 5px;\n  border-radius: 5px 5px 5px 5px;\n}\n\ninput[type=\"text\"]:focus,\ninput[type=\"password\"]:focus {\n  background-color: #fff;\n  border-bottom: 2px solid #5fbae9;\n}\n\ninput[type=\"text\"]:placeholder,\ninput[type=\"password\"] {\n  color: #cccccc;\n}\n\n/* ANIMATIONS */\n\n/* Simple CSS3 Fade-in-down Animation */\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n/* Simple CSS3 Fade-in Animation */\n@-webkit-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@-moz-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.fadeIn {\n  opacity: 0;\n  -webkit-animation: fadeIn ease-in 1;\n  -moz-animation: fadeIn ease-in 1;\n  animation: fadeIn ease-in 1;\n\n  -webkit-animation-fill-mode: forwards;\n  -moz-animation-fill-mode: forwards;\n  animation-fill-mode: forwards;\n\n  -webkit-animation-duration: 1s;\n  -moz-animation-duration: 1s;\n  animation-duration: 1s;\n}\n\n.fadeIn.first {\n  -webkit-animation-delay: 0.4s;\n  -moz-animation-delay: 0.4s;\n  animation-delay: 0.4s;\n}\n\n.fadeIn.second {\n  -webkit-animation-delay: 0.6s;\n  -moz-animation-delay: 0.6s;\n  animation-delay: 0.6s;\n  border: 0.5px solid lightgrey;\n}\n\n.fadeIn.third {\n  -webkit-animation-delay: 0.8s;\n  -moz-animation-delay: 0.8s;\n  animation-delay: 0.8s;\n  border: 0.5px solid lightgrey;\n}\n\n.fadeIn.fourth {\n  -webkit-animation-delay: 1s;\n  -moz-animation-delay: 1s;\n  animation-delay: 1s;\n  border: 0.5px solid lightgrey;\n}\n\n/* Simple CSS3 Fade-in Animation */\n.underlineHover:after {\n  display: block;\n  left: 0;\n  bottom: -10px;\n  width: 0;\n  height: 2px;\n  background-color: #56baed;\n  content: \"\";\n  transition: width 0.2s;\n}\n\n.underlineHover:hover {\n  color: #0d0d0d;\n}\n\n.underlineHover:hover:after {\n  width: 100%;\n}\n\n/* OTHERS */\n\n*:focus {\n  outline: none;\n}\n\n#icon {\n  width: 60%;\n}\n.mat-badge-content {\n  background: #5ea1d8;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n  width: 100%;\n  border: 1px solid #ddd;\n}\n\n.mat-cell {\n  font-size: 12px;\n  font-family: Verdana, Sans-Serif;\n  display: table-cell;\n  height: 48px;\n  vertical-align: middle;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n  border-top: 1px solid rgba(0, 0, 0, 0.12);\n  border-left: 2px solid rgba(0, 0, 0, 0.12);\n  border-right: 2px solid rgba(0, 0, 0, 0.12);\n}\n\n.cdk-drag-preview {\n  box-sizing: border-box;\n  border-radius: 4px;\n  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),\n    0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);\n}\n\n.cdk-drag-placeholder {\n  opacity: 0;\n}\n\n.cdk-drag-animating {\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.example-box {\n  padding: 15px 10px;\n  border-bottom: solid 1px lightgray;\n  color: rgba(0, 0, 0, 0.87);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  cursor: move;\n  background: white;\n  font-size: 14px;\n  & > div {\n    width: 50%;\n    display: flex !important;\n    &:first-child {\n      width: 80%;\n    }\n    &:last-child {\n      width: 17%;\n    }\n    & > span {\n      // width:48%;\n      text-align: left;\n      word-break: keep-all;\n      display: flex;\n      align-items: center;\n\n      &:first-child {\n        flex: 1;\n        width: 50%;\n        color: rgba(0, 0, 0, 0.54) !important;\n        color: #212427 !important;\n        font-weight: 400 !important;\n      }\n      &:last-child {\n        width: 50%;\n        text-align: center;\n        display: flex;\n        align-items: center;\n        justify-content: end;\n        white-space: nowrap;\n        color: rgba(0, 0, 0, 0.54) !important;\n        color: #212427 !important;\n        font-weight: 400 !important;\n      }\n    }\n  }\n}\n\n/* my design starts here*/\nbutton.close {\n  position: absolute;\n  top: -20px;\n  right: -20px;\n  span {\n    color: rgba(0, 0, 0, 0.54) !important;\n    color: #212427 !important;\n  }\n}\n#formContent {\n  border: 1px solid #ddd;\n  box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n  //max-height: 530px;\n  overflow-y: auto;\n  &::-webkit-scrollbar {\n    width: 4px;\n    height: 100px;\n  }\n  &::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: #5ea1d8;\n    outline: 1px solid #5ea1d8;\n  }\n  p {\n    font-size: 17px !important;\n    line-height: 29px;\n    &:first-of-type {\n      font-size: 17px !important;\n      font-weight: 600 !important;\n    }\n  }\n  .square_btn {\n    // max-width:70%;\n    // width:100%;\n    font-family: \"Raleway\";\n    color: #5ea1d8;\n    &:hover {\n      color: #fff;\n    }\n  }\n}\n.Login {\n  height: 100%;\n  position: relative;\n  background: #efeeee !important;\n}\n.threedot {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n  .title-text {\n    flex: 1;\n  }\n  p {\n    //  flex: 1;\n    text-align: right;\n  }\n  a {\n    display: flex;\n    align-items: center;\n    height: 35px;\n    margin-left: 0px;\n    &:hover {\n      background: #5ea1d8 !important;\n    }\n  }\n}\n\n.example-list {\n  max-width: 100%;\n  border: solid 1px #ccc;\n  // min-height: 246px;\n  height: auto;\n  display: block;\n  background: white;\n  border-radius: 4px;\n  overflow-y: auto;\n\n  // Remove scroll for FAQ lists\n  &.faq-list-container {\n    overflow-y: visible;\n    overflow-x: visible;\n    max-height: none;\n    height: auto;\n\n    @media (max-width: 767px) {\n      overflow-y: visible;\n      overflow-x: visible;\n      max-height: none;\n    }\n  }\n  .example-box {\n    display: flex;\n    padding: 15px 10px;\n    border-bottom: 1px solid lightgrey;\n    background: white !important;\n    .item-name,\n    .item-value {\n      text-align: left;\n      width: 40%;\n    }\n\n    .item-name,\n    .item-delete,\n    .item-reorder,\n    .item-value {\n      text-align: left;\n      padding: 5px;\n      font-size: 14px;\n      font-weight: 400 !important;\n      overflow-wrap: break-word;\n    }\n    .item-delete,\n    .item-reorder {\n      float: right;\n      cursor: pointer;\n      font-size: 20px;\n      width: 10%;\n    }\n    &:last-child {\n      border-bottom: 0px;\n    }\n  }\n  &::-webkit-scrollbar {\n    width: 4px;\n    height: 100px;\n  }\n  &::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: #5ea1d8;\n    outline: 1px solid #5ea1d8;\n  }\n}\n.item-table {\n  width: 100%;\n  display: block;\n  float: left;\n}\n\n.c-flow {\n  .inner-box {\n    padding: 0;\n    display: flex;\n    flex-wrap: wrap;\n    .title-text {\n      float: left;\n      font-size: 14px;\n      margin-left: 0px;\n      line-height: 22px;\n      color: #212427;\n    }\n    .threedot {\n      .custom-badge {\n        background-color: #5ea1d8;\n        font-size: 15px;\n        width: auto;\n        margin-left: 0px;\n        float: left;\n        cursor: pointer;\n        color: white;\n        padding: 10px;\n      }\n      .more-vert {\n        cursor: pointer;\n        float: right;\n        color: gray;\n      }\n    }\n    .img-section-1 {\n      width: 100%;\n      display: block;\n      //float: left;\n      border: 1px solid lightgray;\n      padding: 15px;\n      .img-and-video-sec {\n        //max-height: 300px;\n        height: 100%;\n        position: relative;\n        overflow: hidden;\n        min-height: 300px;\n        // border: 1px solid lightgray;\n        border-radius: 5px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n      }\n\n      img.img-display {\n        max-width: 100%;\n\n        object-fit: contain;\n      }\n      video.video-display {\n        width: 100%;\n        height: 100%;\n        max-height: unset !important;\n      }\n      &:empty {\n        border: 0px;\n        padding: 0px;\n      }\n    }\n    .edit-cover {\n      display: block;\n      width: 100%;\n      float: left;\n      padding: 15px 0;\n      .description-text {\n        color: rgba(0, 0, 0, 0.54);\n        color: #212427 !important;\n        margin-left: 0px;\n        float: left;\n        font-size: 14px;\n        line-height: 22px;\n        width: 100%;\n        text-align: left;\n        padding-bottom: 15px;\n      }\n      .btn-edit-cover {\n        background-color: #5ea1d8;\n        float: left;\n        color: white;\n        border: none;\n      }\n    }\n\n    .img-section-2 {\n      margin: 15px 0;\n      clear: both;\n      // .example-stepList{ border: 1px solid lightgray;}\n\n      .img-and-video-sec {\n        border-radius: 5px;\n\n        height: 100%;\n        position: relative;\n        overflow: hidden;\n        min-height: 300px;\n\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        img.img-display {\n          position: absolute;\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n          width: 100%;\n          //height: 100%;\n          object-fit: contain;\n        }\n\n        .video-display {\n          max-width: 100%;\n          //max-height: 250px;\n        }\n      }\n      .steps-text {\n        color: rgba(0, 0, 0, 0.54);\n        color: #212427;\n        font-weight: bold;\n        font-size: 16px;\n        padding-bottom: 15px;\n        text-align: left;\n      }\n\n      .decbox {\n        .step-description {\n          color: black;\n          padding: 15px 15px 0px 0px;\n          font-size: 16px;\n          text-align: left;\n          display: block;\n          width: 100%;\n        }\n        .btn-delate-edit {\n          text-align: left;\n          margin: 15px 0px;\n          display: flex;\n          justify-content: space-between;\n          cursor: pointer;\n          .btn-primary {\n            background-color: #5ea1d8;\n            margin-right: 10px;\n            cursor: pointer;\n            color: white;\n            border: none;\n          }\n        }\n      }\n    }\n\n    .button-section {\n      display: block;\n      align-items: center;\n      flex-direction: column;\n      button {\n        margin-bottom: 15px;\n        white-space: nowrap;\n        max-width: 100% !important;\n        min-width: 250px;\n        width: 75%;\n        margin: 10px auto;\n      }\n      .btn-publish {\n        width: 20%;\n        background-color: #5ea1d8;\n        color: white;\n      }\n    }\n    .btn-add-page {\n      width: 75%;\n      display: block;\n      margin: 5px auto;\n    }\n    .btn-add-page + .img-section-1 {\n      border: 0;\n      padding: 0px;\n      .edit-cover {\n        padding: 0;\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 1024px) and (min-width: 768px) {\n}\n\n@media (max-width: 767px) {\n  #formContent {\n    width: calc(100% - 30px);\n    padding: 20px !important;\n  }\n  .Login > div {\n    background: #fff !important;\n  }\n  button.close {\n    position: absolute;\n    top: -26px;\n    right: -12px;\n  }\n  #formContent .button-section .mdc-button.btn-publish {\n    width: auto !important;\n  }\n}\n@media only screen and (max-width: 767px) and (min-width: 461px) {\n  #formContent {\n    position: relative;\n    top: 20px;\n    left: auto;\n    transform: none;\n  }\n}\n\n@media (max-width: 460px) {\n  .c-flow .inner-box {\n    .img-section-1 {\n      .img-and-video-sec {\n        min-height: 150px;\n      }\n    }\n    .img-section-2 {\n      .img-and-video-sec {\n        min-height: 150px;\n      }\n      .decbox .btn-delate-edit {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        margin: 0;\n        padding: 10px 0;\n        .btn-primary {\n          margin: 5px;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n  .c-flow .inner-box .btn-add-page {\n    width: 83%;\n  }\n}\n\n.example-stepList {\n  max-width: 100%;\n\n  height: auto;\n  display: block;\n  margin-top: 10px;\n  background: white;\n  border-radius: 4px;\n  overflow-y: auto;\n}\n\n.itemremove {\n  span {\n    &:first-child {\n      width: 90% !important;\n    }\n  }\n}\n\n.img-div-left {\n  position: fixed;\n\n  height: 150px;\n  width: 150px;\n  overflow: visible;\n  margin: auto;\n  top: 90%;\n  left: 0;\n  right: 0;\n\n  margin: 0px auto;\n}\n\n.example-box {\n  span {\n    &:first-child {\n      width: 90% !important;\n      // width: 10% !important;\n    }\n    &:nth-child(2) {\n      width: 40% !important;\n    }\n    &:nth-child(3) {\n      width: 40% !important;\n    }\n    &:last-child {\n      // width: 10% !important;\n    }\n  }\n}\n\n.example-list {\n  &.check2 {\n    margin-bottom: 20px;\n    .example-box {\n      .item-name {\n        display: flex;\n        width: 100% !important;\n        padding: 0px;\n        span {\n          display: flex;\n          align-items: center;\n          justify-content: flex-start;\n          word-break: break-all;\n          &:first-child {\n            flex: 1;\n          }\n          &:nth-child(2) {\n            flex: 3;\n          }\n          &:last-child {\n            flex: 0.5;\n            display: flex;\n            align-items: center;\n            justify-content: flex-end;\n          }\n        }\n      }\n    }\n  }\n}\n.button-section {\n  width: 100% !important;\n}\n.img-section-2 {\n  width: 100%;\n}\n.example-list {\n  // border:1px solid gray;\n  margin-bottom: 20px;\n  .example-box {\n    border: 1px solid gray;\n    display: flex;\n    align-items: center;\n    span {\n      // flex: 2;\n      border-right: 1px solid gray;\n      display: flex;\n      // height: 100%;\n      text-align: left;\n      padding: 5px 10px 5px 5px;\n      align-self: stretch;\n      align-items: center;\n      &:first-child {\n        width: 20%;\n      }\n      &:nth-child(2) {\n        width: 70%;\n        span {\n          width: 100% !important;\n          justify-content: flex-start !important;\n        }\n      }\n      &:nth-child(3) {\n        width: 50px;\n        justify-content: center;\n      }\n      &:last-child {\n        width: 50px;\n        text-align: center;\n        border-right: 0px;\n        justify-content: center;\n      }\n    }\n    & + .example-box {\n      border-top: 0px;\n    }\n  }\n}\n.item-table {\n  .clearfix {\n    margin-top: 15px;\n  }\n  .example-list {\n    border: 0px;\n  }\n}\n.example-list {\n  // border:1px solid gray;\n  // border-bottom: 1px solid gray;\n  border-radius: 0px;\n  margin-bottom: 20px;\n  .example-box {\n    border: 1px solid gray;\n    display: flex;\n    align-items: center;\n    padding: 0px;\n    span {\n      // flex: 2;\n      border-right: 1px solid gray;\n      display: flex;\n      // height: 100%;\n      text-align: left;\n      padding: 5px 10px 5px 5px;\n      align-self: stretch;\n      align-items: center;\n      &:first-child {\n        width: 20%;\n      }\n      &:nth-child(2) {\n        width: 70%;\n      }\n      &:nth-child(3) {\n        width: 50px;\n        justify-content: center;\n      }\n      &:last-child {\n        width: 50px;\n        text-align: center;\n        border-right: 0px;\n        justify-content: center !important;\n      }\n    }\n    & + .example-box {\n      border-top: 0px;\n    }\n    &:last-child {\n      border-bottom: 1px solid gray;\n    }\n  }\n}\n\n#formContent {\n  .button-section {\n    .newbuttondesigncreateflow {\n      font-family: \"Raleway\";\n      background-color: transparent !important;\n      font-size: 15px !important;\n      cursor: pointer;\n      color: #5ea1d8 !important;\n      padding: 10px;\n      width: 120px !important;\n      span.mdc-button__label {\n        color: #5ea1d8 !important;\n      }\n    }\n    .publish.newbuttondesigncreateflow1 {\n      width: 120px !important;\n    }\n  }\n}\n.cretebtnwrap {\n  display: flex;\n  width: 100%;\n}\n\n.transfer-toggle-section {\n  margin: 20px 0;\n  padding: 16px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n\n  .transfer-toggle {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    .toggle-label {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      font-weight: 500;\n      color: #333;\n\n      .toggle-icon {\n        color: #5ea1d8;\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n      }\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n\n      .toggle-label {\n        color: #999;\n      }\n\n      .toggle-icon {\n        color: #999;\n      }\n    }\n  }\n\n  .toggle-description {\n    margin-top: 12px;\n    padding: 12px;\n    background: #e3f2fd;\n    border-radius: 6px;\n    border-left: 4px solid #5ea1d8;\n    display: flex;\n    align-items: flex-start;\n    gap: 0px;\n    font-size: 14px;\n    color: #1976d2;\n\n    .info-icon {\n      color: #5ea1d8;\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      margin-top: 1px;\n    }\n\n    &.warning {\n      border-left-color: #ffc107;\n      color: #856404;\n\n      .warning-icon {\n        color: #ffc107;\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n        margin-top: 1px;\n      }\n    }\n  }\n\n  .selected-user-info {\n    margin-top: 16px;\n    /* add left-right breathing space */\n    margin-left: 8px;\n    margin-right: 8px;\n    padding: 12px 16px;\n    background: #e8f5e8;\n    border-radius: 6px;\n    border-left: 4px solid #28a745;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    color: #155724;\n\n    .user-icon {\n      color: #28a745;\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n\n    .user-name {\n      font-weight: 600;\n      color: #155724;\n    }\n\n    .user-email {\n      color: #155724;\n    }\n\n    .change-user-wrap {\n      display: inline-flex;\n      padding: 0;\n      margin-left: auto;\n      border-radius: 50%;\n      overflow: hidden; /* clip hover/ripple strictly */\n      height: 32px;\n      width: 32px;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .change-user-btn {\n      margin-left: 0;\n      color: #28a745;\n      /* make hover shape circular */\n      width: 32px;\n      height: 32px;\n      border-radius: 50%;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      padding: 0px; /* prevent oval from padding */\n      line-height: 32px; /* keep label area square */\n      overflow: hidden; /* clip ripple/background perfectly */\n\n      /* Force Material icon-button internals to respect circle */\n      &.mat-mdc-icon-button {\n        min-width: 32px;\n        min-height: 32px;\n      }\n      .mat-mdc-button-touch-target {\n        width: 32px;\n        height: 32px;\n        border-radius: 50%;\n        inset: 0;\n      }\n      .mdc-icon-button {\n        width: 32px;\n        height: 32px;\n        border-radius: 50%;\n        padding: 0;\n      }\n      .mat-mdc-button-persistent-ripple,\n      .mdc-button__ripple,\n      .mdc-icon-button__ripple {\n        border-radius: 50%;\n        inset: 0;\n      }\n      .mat-mdc-focus-indicator {\n        border-radius: 50%;\n      }\n\n      &:hover {\n        background: rgba(40, 167, 69, 0.1);\n        border-radius: 50%;\n      }\n\n      mat-icon {\n        font-size: 16px;\n        width: 16px;\n        height: 16px;\n      }\n    }\n  }\n}\n\n.items-container {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  font-weight: bold !important;\n  font-size: 16px !important;\n  text-align: left !important;\n  mat-icon {\n    margin-left: 5px;\n  }\n}\n\n.mobile-summary-card {\n  .mobile-preview-shell {\n    width: 100%;\n    background: #050505;\n    border-radius: 32px;\n    padding: 16px;\n    position: relative;\n    box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.05),\n      0 25px 45px rgba(15, 23, 42, 0.25);\n  }\n\n  .mobile-speaker {\n    width: 60px;\n    height: 6px;\n    background: rgba(255, 255, 255, 0.2);\n    border-radius: 999px;\n    margin: 0 auto 12px;\n  }\n\n  .mobile-screen {\n    background: #fff;\n    border-radius: 24px;\n    overflow: hidden;\n    min-height: 420px;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .mobile-cover-preview {\n    display: flex;\n    flex-direction: column;\n\n    .mobile-media {\n      width: 100%;\n      height: 180px;\n      background: #111827;\n      position: relative;\n\n      img,\n      video {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        display: block;\n      }\n\n      &.placeholder {\n        color: #9ca3af;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 8px;\n        mat-icon {\n          font-size: 36px;\n        }\n        p {\n          margin: 0;\n          font-size: 13px;\n        }\n      }\n    }\n\n    .mobile-content {\n      padding: 16px;\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n    }\n\n    .mobile-title {\n      font-size: 16px;\n      font-weight: 600;\n      color: #0f172a;\n      margin: 0;\n      line-height: 1.4;\n    }\n\n    .mobile-meta {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 8px;\n      span {\n        display: inline-flex;\n        align-items: center;\n        gap: 4px;\n        padding: 4px 10px;\n        border-radius: 999px;\n        font-size: 12px;\n        background: #f1f5f9;\n        color: #475569;\n        mat-icon {\n          font-size: 14px;\n          height: 14px;\n          width: 14px;\n        }\n      }\n    }\n\n    .mobile-description {\n      font-size: 13px;\n      color: #475569;\n      line-height: 1.5;\n      max-height: 90px;\n      overflow: hidden;\n    }\n  }\n\n  .mobile-section-header {\n    padding: 14px 16px;\n    border-bottom: 1px solid #edf2f7;\n    font-weight: 600;\n    font-size: 14px;\n    color: #0f172a;\n    background: #f8fafc;\n  }\n\n  .mobile-card-list {\n    padding: 0 16px 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    max-height: 360px;\n    overflow-y: auto;\n  }\n\n  .mobile-item-card {\n    background: #fff;\n    border: 1px solid #edf2f7;\n    border-radius: 12px;\n    padding: 12px;\n    .group-label {\n      margin: 0 0 8px;\n      font-size: 12px;\n      font-weight: 600;\n      text-transform: uppercase;\n      letter-spacing: 0.05em;\n      color: #94a3b8;\n    }\n  }\n\n  .mobile-item-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .mobile-item-row {\n    display: flex;\n    gap: 10px;\n  }\n\n  .mobile-avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 10px;\n    background: #f1f5f9;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 600;\n    color: #475569;\n    overflow: hidden;\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n\n  .mobile-item-body {\n    flex: 1;\n    min-width: 0;\n    .name {\n      margin: 0;\n      font-size: 14px;\n      font-weight: 600;\n      color: #0f172a;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      max-width: 100%;\n    }\n    .quantity {\n      margin: 2px 0 0;\n      font-size: 12px;\n      color: #64748b;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      max-width: 100%;\n    }\n    .item-link {\n      font-size: 12px;\n      color: #2563eb;\n      text-decoration: none;\n      margin-top: 4px;\n      display: inline-flex;\n      align-items: center;\n      gap: 4px;\n    }\n  }\n\n  .mobile-empty {\n    padding: 40px 16px;\n    text-align: center;\n    color: #94a3b8;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    align-items: center;\n    mat-icon {\n      font-size: 32px;\n    }\n    p {\n      margin: 0;\n      font-size: 13px;\n    }\n  }\n\n  .mobile-steps-preview {\n    padding: 0 16px 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    max-height: 360px;\n    overflow-y: auto;\n  }\n\n  .mobile-step-card {\n    border: 1px solid #edf2f7;\n    border-radius: 12px;\n    overflow: hidden;\n    background: #fff;\n  }\n\n  .mobile-step-media {\n    width: 100%;\n    height: 150px;\n    background: #0f172a;\n    img,\n    video {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      display: block;\n    }\n  }\n\n  .mobile-step-body {\n    padding: 12px;\n    .mobile-step-header {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n    }\n    .pill {\n      align-self: flex-start;\n      padding: 2px 10px;\n      border-radius: 999px;\n      font-size: 11px;\n      text-transform: uppercase;\n      letter-spacing: 0.05em;\n      background: #e0f2fe;\n      color: #0284c7;\n      font-weight: 600;\n    }\n    .title {\n      margin: 0;\n      font-size: 14px;\n      font-weight: 600;\n      color: #0f172a;\n    }\n    .mobile-step-description {\n      margin-top: 8px;\n      font-size: 13px;\n      color: #475569;\n      line-height: 1.5;\n    }\n  }\n\n  .mobile-faq-list {\n    padding: 0 16px 16px;\n    max-height: 360px;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .mobile-faq-group {\n    border: 1px solid #edf2f7;\n    border-radius: 12px;\n    background: #fff;\n    padding: 12px;\n    .group-label {\n      margin: 0 0 8px;\n      font-size: 12px;\n      text-transform: uppercase;\n      letter-spacing: 0.05em;\n      color: #94a3b8;\n      font-weight: 600;\n    }\n    .mobile-faq-item {\n      padding: 10px 0;\n      border-bottom: 1px solid #f1f5f9;\n      &:last-child {\n        border-bottom: none;\n      }\n      .question {\n        display: flex;\n        gap: 8px;\n        align-items: center;\n        font-weight: 600;\n        color: #0f172a;\n        mat-icon {\n          font-size: 18px;\n          color: #2563eb;\n        }\n      }\n      .answer {\n        margin-top: 6px;\n        font-size: 13px;\n        color: #475569;\n        line-height: 1.5;\n      }\n    }\n  }\n}\n\n.field-anchor {\n  position: relative;\n  transition: box-shadow 0.25s ease, border-color 0.25s ease;\n  border-radius: 16px;\n}\n\n.field-highlight {\n  box-shadow: 0 0 0 3px rgba(251, 146, 60, 0.4) inset,\n    0 12px 24px rgba(15, 23, 42, 0.15);\n  animation: fieldPulse 1.2s ease;\n}\n\n@keyframes fieldPulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(251, 146, 60, 0.4) inset;\n  }\n  50% {\n    box-shadow: 0 0 0 3px rgba(251, 146, 60, 0.55) inset;\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(251, 146, 60, 0.2) inset;\n  }\n}\n\n// Thumbnail selection section\n.flow-thumbnail-section {\n  margin-top: 24px;\n  padding: 0;\n  background: transparent;\n}\n\n.thumbnail-section-header {\n  margin-bottom: 16px;\n\n  h4 {\n    font-size: 14px;\n    font-weight: 500;\n    color: #030303;\n    margin: 0 0 4px 0;\n    line-height: 20px;\n  }\n\n  p {\n    font-size: 13px;\n    color: #606060;\n    margin: 0;\n    line-height: 18px;\n  }\n}\n\n.thumbnail-choice-row {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 16px;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  width: 100%;\n\n  @media (max-width: 767px) {\n    gap: 8px;\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n}\n\n.thumbnail-dialog-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.65);\n  z-index: 10010;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n}\n\n// FAQ Modal Styles\n.faq-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.65);\n  z-index: 10020;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n\n  @media (max-width: 767px) {\n    padding: 16px;\n    align-items: flex-start;\n    padding-top: 40px;\n  }\n}\n\n.faq-modal-card {\n  width: min(600px, 90vw);\n  max-height: 90vh;\n  background: #fff;\n  border-radius: 18px;\n  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.3);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n\n  @media (max-width: 767px) {\n    width: 100%;\n    max-height: calc(100vh - 80px);\n    border-radius: 16px 16px 0 0;\n  }\n}\n\n.faq-modal-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid #e4e8f0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  flex-shrink: 0;\n\n  h4 {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 600;\n    color: #111827;\n  }\n\n  .icon-button {\n    flex-shrink: 0;\n  }\n\n  @media (max-width: 767px) {\n    padding: 16px;\n  }\n}\n\n.faq-modal-body {\n  padding: 24px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n\n  @media (max-width: 767px) {\n    padding: 16px;\n  }\n}\n\n.faq-modal-group,\n.faq-modal-question,\n.faq-modal-answer {\n  margin-bottom: 20px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.faq-modal-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 8px;\n}\n\n.faq-modal-value {\n  display: block;\n  font-size: 14px;\n  color: #111827;\n  line-height: 1.6;\n  word-break: break-word;\n\n  &.faq-modal-group {\n    font-weight: 600;\n    color: #2563eb;\n  }\n}\n\n.faq-modal-question .faq-modal-value {\n  font-weight: 600;\n  font-size: 16px;\n  color: #1f2f46;\n}\n\n.faq-modal-answer .faq-modal-value {\n  color: #4a5568;\n  line-height: 1.8;\n}\n\n.faq-modal-footer {\n  padding: 16px 24px;\n  border-top: 1px solid #e4e8f0;\n  display: flex;\n  justify-content: flex-end;\n  flex-shrink: 0;\n\n  .close-btn {\n    min-width: 100px;\n  }\n\n  @media (max-width: 767px) {\n    padding: 12px 16px;\n  }\n}\n\n.thumbnail-dialog-card {\n  width: min(960px, 90vw);\n  max-height: 90vh;\n  background: #fff;\n  border-radius: 18px;\n  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.3);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.thumbnail-dialog-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid #e4e8f0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  position: relative;\n  z-index: 10011;\n\n  h4 {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 600;\n  }\n\n  p {\n    margin: 4px 0 0;\n    color: #64748b;\n    font-size: 14px;\n    max-width: 480px;\n  }\n\n  .icon-button {\n    z-index: 10012;\n  }\n}\n\n.thumbnail-dialog-body {\n  padding: 24px;\n  overflow-y: auto;\n\n  @media (max-width: 768px) {\n    padding: 16px;\n  }\n}\n\n.thumbnail-choice {\n  flex: 1;\n  min-width: 160px;\n  border: 1px dashed #d3d3d3;\n  background: #fff;\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: border-color 0.2s ease, background-color 0.2s ease;\n  font-size: 13px;\n  color: #030303;\n  flex-shrink: 0;\n\n  &.selected {\n    border: 1px solid #065fd4;\n    background: rgba(6, 95, 212, 0.05);\n  }\n\n  &.disabled {\n    opacity: 0.5;\n    cursor: default;\n  }\n\n  @media (max-width: 767px) {\n    min-width: 140px;\n    padding: 10px 12px;\n    gap: 8px;\n  }\n}\n\n.choice-icon {\n  font-size: 20px;\n  color: #606060;\n}\n\n.choice-text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n\n  strong {\n    font-weight: 500;\n    font-size: 13px;\n  }\n\n  small {\n    font-size: 12px;\n    color: #606060;\n  }\n}\n\n.thumbnail-mode {\n  margin-top: 0;\n  margin-bottom: 16px;\n\n  &.upload-mode {\n    margin-bottom: 24px;\n  }\n}\n\n// Extracted frames section\n.extracted-frames-section {\n  margin-bottom: 24px;\n  padding: 16px;\n  background: #f9f9f9;\n  border-radius: 4px;\n  border: 1px solid #e0e0e0;\n\n  h6 {\n    margin: 0 0 4px 0;\n    font-size: 14px;\n    font-weight: 500;\n    color: #030303;\n  }\n\n  .frames-subtitle {\n    margin: 0 0 16px 0;\n    font-size: 12px;\n    color: #606060;\n  }\n}\n\n.extracted-frames-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  margin-bottom: 16px;\n\n  @media (max-width: 768px) {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 8px;\n  }\n}\n\n.extracted-frame-item {\n  position: relative;\n  aspect-ratio: 16/9;\n  border-radius: 4px;\n  overflow: hidden;\n  cursor: pointer;\n  border: 2px solid transparent;\n  transition: all 0.2s ease;\n  background: #000;\n\n  &:hover {\n    border-color: #065fd4;\n    transform: scale(1.02);\n  }\n\n  &.selected {\n    border-color: #065fd4;\n    box-shadow: 0 0 0 2px rgba(6, 95, 212, 0.2);\n  }\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n  }\n\n  .frame-overlay {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);\n    padding: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 500;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      color: #065fd4;\n    }\n\n    .frame-number {\n      font-size: 11px;\n    }\n  }\n}\n\n.use-frame-btn {\n  width: 100%;\n  justify-content: center;\n  background: #065fd4;\n  color: #fff;\n  border-color: #065fd4;\n\n  &:hover {\n    background: #0550c4;\n    border-color: #0550c4;\n  }\n}\n\n.frame-extraction-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 32px;\n  gap: 12px;\n\n  p {\n    margin: 0;\n    font-size: 13px;\n    color: #606060;\n  }\n}\n\n.frame-extraction-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px;\n  background: #fee;\n  border: 1px solid #fcc;\n  border-radius: 4px;\n  color: #c33;\n  font-size: 12px;\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n\n  p {\n    margin: 0;\n  }\n}\n\n.upload-divider {\n  display: flex;\n  align-items: center;\n  margin: 24px 0;\n  text-align: center;\n\n  &::before,\n  &::after {\n    content: \"\";\n    flex: 1;\n    height: 1px;\n    background: #e0e0e0;\n  }\n\n  span {\n    padding: 0 16px;\n    font-size: 12px;\n    color: #606060;\n    font-weight: 500;\n  }\n}\n\n.thumbnail-mode-header {\n  margin-bottom: 12px;\n\n  h5 {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 500;\n    color: #030303;\n  }\n\n  p {\n    margin: 4px 0 0 0;\n    font-size: 12px;\n    color: #606060;\n  }\n}\n\n.yt-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 6px 12px;\n  border: 1px solid #d3d3d3;\n  background: #fff;\n  color: #030303;\n  font-size: 13px;\n  border-radius: 2px;\n  cursor: pointer;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n\n  &:hover {\n    background: #f0f0f0;\n  }\n\n  &:disabled {\n    color: #9e9e9e;\n    border-color: #e0e0e0;\n    cursor: not-allowed;\n  }\n\n  mat-icon {\n    font-size: 16px;\n  }\n}\n\n// Video Preview with Scrubber\n.video-preview-container {\n  margin-bottom: 16px;\n}\n\n.video-wrapper {\n  position: relative;\n  width: 100%;\n  max-width: 640px;\n  background: #000;\n  border-radius: 0;\n  overflow: hidden;\n  aspect-ratio: 16/9;\n}\n\n.thumbnail-video-preview {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n.video-controls-overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.75), transparent);\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.video-scrubber-container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.video-scrubber {\n  flex: 1;\n  height: 4px;\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 2px;\n  outline: none;\n  cursor: pointer;\n\n  &::-webkit-slider-thumb {\n    appearance: none;\n    width: 14px;\n    height: 14px;\n    background: #fff;\n    border-radius: 50%;\n    cursor: pointer;\n  }\n\n  &::-moz-range-thumb {\n    width: 14px;\n    height: 14px;\n    background: #fff;\n    border-radius: 50%;\n    cursor: pointer;\n    border: none;\n  }\n}\n\n.scrubber-time {\n  color: #fff;\n  font-size: 12px;\n  font-weight: 400;\n  white-space: nowrap;\n  min-width: 70px;\n  text-align: right;\n}\n\n.capture-frame-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: rgba(255, 255, 255, 0.9);\n  color: #030303;\n  border: none;\n  border-radius: 2px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s ease;\n\n  &:hover {\n    background: #fff;\n  }\n\n  mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n  }\n}\n\n// Two options in one line\n.thumbnail-options-row {\n  display: flex;\n  gap: 16px;\n  margin-top: 16px;\n  align-items: flex-start;\n  padding: 0;\n  background: transparent;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    gap: 16px;\n  }\n}\n\n.thumbnail-option-column {\n  flex: 1;\n  min-width: 0;\n\n  h5 {\n    font-size: 13px;\n    font-weight: 500;\n    color: #030303;\n    margin: 0 0 8px 0;\n    line-height: 18px;\n  }\n}\n\n// Auto-generated Thumbnails Column\n.auto-thumbnails-column {\n  flex: 1.5;\n}\n\n.thumbnails-horizontal-scroll {\n  display: flex;\n  gap: 8px;\n  overflow-x: auto;\n  padding-bottom: 4px;\n  scrollbar-width: thin;\n  scrollbar-color: #d3d3d3 transparent;\n\n  &::-webkit-scrollbar {\n    height: 4px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #d3d3d3;\n    border-radius: 2px;\n\n    &:hover {\n      background: #b3b3b3;\n    }\n  }\n}\n\n.thumbnail-item-small {\n  position: relative;\n  width: 120px;\n  height: 68px;\n  flex-shrink: 0;\n  border-radius: 0;\n  overflow: hidden;\n  cursor: pointer;\n  border: 2px solid transparent;\n  transition: border-color 0.15s ease;\n  background: #000;\n\n  &:hover {\n    border-color: #065fd4;\n  }\n\n  &.selected {\n    border-color: #065fd4;\n    border-width: 3px;\n  }\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n  }\n}\n\n.thumbnail-check-small {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  background: #065fd4;\n  border-radius: 50%;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  mat-icon {\n    color: #fff;\n    font-size: 12px;\n    width: 12px;\n    height: 12px;\n  }\n}\n\n.thumbnails-loading-small {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 0;\n  color: #606060;\n  font-size: 13px;\n}\n\n.no-thumbnails-message {\n  padding: 12px 0;\n  text-align: left;\n  color: #606060;\n  font-size: 13px;\n}\n\n// Custom Thumbnail Column\n.custom-thumbnail-column {\n  flex: 1;\n  max-width: 200px;\n}\n\n.custom-thumbnail-upload-compact {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-width: 320px;\n}\n\n.upload-preview-compact {\n  position: relative;\n  width: 320px;\n  height: 180px;\n  border-radius: 0;\n  overflow: hidden;\n  background: #f9f9f9;\n  border: 1px solid #d3d3d3;\n  flex-shrink: 0;\n}\n\n.custom-thumbnail-preview-small {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.upload-placeholder-compact {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: #f9f9f9;\n  gap: 8px;\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n    color: #909090;\n  }\n\n  span {\n    font-size: 13px;\n    color: #606060;\n    font-weight: 400;\n  }\n}\n\n.upload-label-compact {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  padding: 12px;\n  cursor: pointer;\n  text-align: center;\n  transition: opacity 0.15s ease;\n\n  &:hover {\n    opacity: 0.7;\n  }\n\n  mat-icon {\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n    color: #606060;\n  }\n\n  span {\n    font-size: 12px;\n    font-weight: 400;\n    color: #030303;\n    line-height: 16px;\n  }\n}\n\n.document-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: nowrap;\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n    flex-wrap: wrap;\n  }\n}\n\n.document-main {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1 1 auto;\n  min-width: 0;\n  max-width: 100%;\n\n  @media (max-width: 767px) {\n    flex: 1 1 auto;\n    min-width: 0;\n    max-width: 100%;\n    width: 100%;\n  }\n}\n\n.doc-file-icon {\n  font-size: 28px;\n  color: #5ea1d8;\n}\n\n.doc-text {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n  flex: 1;\n  overflow: hidden;\n  max-width: 100%;\n}\n\n.doc-name {\n  font-weight: 600;\n  color: #111827;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: inline-block;\n  max-width: 100%;\n  flex-shrink: 1;\n}\n\n.doc-url {\n  font-size: 12px;\n  color: #6b7280;\n  word-break: break-all;\n}\n\n.document-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: nowrap;\n  flex-shrink: 0;\n  min-width: fit-content;\n\n  @media (max-width: 767px) {\n    flex-wrap: nowrap;\n    gap: 6px;\n    flex-shrink: 0;\n    min-width: fit-content;\n    width: 100%;\n    justify-content: flex-start;\n  }\n}\n\n.link-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: 1px solid #d3d3d3;\n  border-radius: 999px;\n  background: #fff;\n  font-size: 12px;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease;\n  flex-shrink: 0;\n  white-space: nowrap;\n\n  mat-icon {\n    font-size: 16px;\n    flex-shrink: 0;\n  }\n\n  &:hover {\n    background: #f4f4f4;\n  }\n\n  @media (max-width: 767px) {\n    padding: 6px 10px;\n    font-size: 11px;\n    gap: 4px;\n  }\n}\n\n.icon-only {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease;\n  flex-shrink: 0;\n\n  mat-icon {\n    font-size: 18px;\n  }\n\n  &:hover {\n    background: #f3f4f6;\n  }\n\n  @media (max-width: 767px) {\n    width: 32px;\n    height: 32px;\n\n    mat-icon {\n      font-size: 16px;\n    }\n  }\n}\n\n.url-preview-dialog {\n  min-width: 280px;\n  max-width: 520px;\n}\n\n.url-preview-text {\n  font-size: 14px;\n  word-break: break-all;\n  margin-bottom: 12px;\n  padding: 8px 12px;\n  background: #f9fafb;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n}\n\n.url-preview-open {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: #0f62fe;\n  text-decoration: none;\n\n  mat-icon {\n    font-size: 16px;\n  }\n}\n\n.upload-progress-compact {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 400;\n}\n\n.upload-btn-compact {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 6px 12px;\n  font-size: 13px;\n  font-weight: 500;\n  width: 100%;\n  background: #065fd4;\n  color: #fff;\n  border: none;\n  border-radius: 2px;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background: #0650c0;\n  }\n\n  &:disabled {\n    background: #ccc;\n    cursor: not-allowed;\n  }\n\n  mat-icon {\n    font-size: 14px;\n    width: 14px;\n    height: 14px;\n  }\n}\n\n// Modern Items List Styles\n.items-list-container {\n  margin-top: 32px;\n}\n\n.items-group-wrapper {\n  margin-bottom: 32px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n// Group header matching summary tab style\n.item-value.group-header {\n  margin: 0 0 16px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n  padding: 0;\n  text-align: left;\n\n  b {\n    font-weight: 600;\n  }\n}\n\n// Keep old styles for backward compatibility if needed elsewhere\n.group-header-line {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 0px;\n  padding: 2px 7px;\n  background: linear-gradient(135deg, #eceff4 0%, #f9fafb 100%);\n  border-radius: 10px;\n  border: 1px solid #e5e7eb;\n  text-align: left;\n}\n\n.group-title-block {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n\n  .group-icon {\n    color: #4b5563;\n    font-size: 20px;\n  }\n\n  .group-title,\n  h4 {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 600;\n    color: #111827;\n  }\n}\n\n.group-count-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 32px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: #e5e7eb;\n  color: #374151;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.items-list-modern {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  background: #f8f9fa;\n  border-radius: 12px;\n  border: 1px solid #e9ecef;\n}\n\n.item-card-modern {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 6px;\n  background: #fff;\n  border: 1px solid #e9ecef;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n  cursor: move;\n  touch-action: none;\n  -webkit-touch-callout: none;\n\n  &:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    border-color: #667eea;\n    transform: translateY(-2px);\n  }\n\n  &.cdk-drag-animating {\n    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n  }\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n    padding: 12px;\n    cursor: move;\n    touch-action: none;\n  }\n}\n\n.item-drag-handle {\n  display: flex;\n  align-items: center;\n  color: #adb5bd;\n  cursor: grab;\n  padding: 4px;\n  touch-action: none;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  user-select: none;\n\n  &:active {\n    cursor: grabbing;\n  }\n\n  @media (max-width: 767px) {\n    padding: 8px;\n    cursor: grab;\n    touch-action: none;\n    \n    &:active {\n      cursor: grabbing;\n    }\n  }\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n\n    @media (max-width: 767px) {\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n    }\n  }\n}\n\n.item-image-section {\n  flex-shrink: 0;\n\n  @media (max-width: 767px) {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n}\n\n.item-image-wrapper {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #f1f3f5;\n  border: 2px solid #e9ecef;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    border-color: #667eea;\n    transform: scale(1.05);\n  }\n\n  @media (max-width: 767px) {\n    width: 100%;\n    max-width: 100px;\n    height: 100px;\n    margin: 0 auto;\n  }\n\n  .item-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .item-image-placeholder {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    color: #adb5bd;\n\n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n    }\n  }\n}\n\n.item-details-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n\n  @media (max-width: 767px) {\n    width: 100%;\n    gap: 10px;\n  }\n}\n\n.item-detail-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  flex-wrap: wrap;\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n    gap: 4px;\n  }\n}\n\n.detail-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #495057;\n  min-width: 80px;\n  flex-shrink: 0;\n\n  @media (max-width: 767px) {\n    min-width: auto;\n    font-size: 12px;\n  }\n}\n\n.detail-value {\n  font-size: 14px;\n  color: #212529;\n  word-break: break-word;\n  flex: 1;\n\n  &.item-name-value {\n    font-weight: 600;\n    color: #212529;\n    font-size: 15px;\n  }\n\n  &.quantity-value {\n    color: #212529;\n    font-weight: 600;\n    background: transparent;\n    padding: 0;\n  }\n\n  &.hyperlink-value {\n    color: #667eea;\n    text-decoration: none;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-weight: 500;\n    transition: color 0.2s;\n    max-width: 100%;\n    overflow: hidden;\n\n    .link-text-mobile {\n      display: none;\n    }\n\n    .link-url-desktop {\n      display: inline;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      max-width: 200px;\n    }\n\n    @media (max-width: 767px) {\n      .link-text-mobile {\n        display: inline;\n      }\n\n      .link-url-desktop {\n        display: none;\n      }\n    }\n\n    &:hover {\n      color: #764ba2;\n      text-decoration: underline;\n    }\n\n    .link-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n      flex-shrink: 0;\n    }\n  }\n\n  &.empty-state {\n    color: #adb5bd;\n    font-style: italic;\n    font-size: 13px;\n  }\n}\n\n.item-actions-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex-shrink: 0;\n\n  @media (max-width: 767px) {\n    flex-direction: row;\n    justify-content: center;\n    gap: 12px;\n    width: 100%;\n    padding-top: 8px;\n    border-top: 1px solid #e9ecef;\n  }\n}\n\n.action-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  background: #f8f9fa;\n  color: #495057;\n\n  &.edit-btn {\n    &:hover {\n      background: #e7f5ff;\n      color: #1976d2;\n    }\n  }\n\n  &.delete-btn {\n    &:hover {\n      background: #fff5f5;\n      color: #dc3545;\n    }\n  }\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.empty-items-state {\n  text-align: center;\n  padding: 48px 24px;\n  color: #adb5bd;\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n    margin-bottom: 16px;\n    color: #ced4da;\n  }\n\n  p {\n    margin: 0;\n    font-size: 14px;\n    color: #6c757d;\n  }\n}\n\n// Summary Section Styles\n.summary-group-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 16px;\n  padding: 10px 16px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);\n\n  .summary-group-icon {\n    color: #fff;\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n\n  .summary-group-title {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 600;\n    color: #fff;\n    flex: 1;\n  }\n\n  .summary-group-count {\n    font-size: 13px;\n    color: rgba(255, 255, 255, 0.9);\n    font-weight: 500;\n  }\n}\n\n.summary-items-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.summary-item-card-modern {\n  display: flex;\n  gap: 16px;\n  padding: 16px;\n  background: #fff;\n  border: 1px solid #e9ecef;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n\n  &:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    border-color: #667eea;\n  }\n}\n\n.summary-item-image-modern {\n  width: 80px;\n  height: 80px;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #f1f3f5;\n  border: 2px solid #e9ecef;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .summary-item-image-placeholder {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    color: #adb5bd;\n\n    mat-icon {\n      font-size: 32px;\n      width: 32px;\n      height: 32px;\n    }\n  }\n}\n\n.summary-item-details-modern {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n.summary-detail-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.summary-detail-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #495057;\n  min-width: 70px;\n  flex-shrink: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-size: 11px;\n}\n\n.summary-detail-value {\n  font-size: 14px;\n  color: #212529;\n  word-break: break-word;\n  flex: 1;\n\n  &.summary-hyperlink {\n    color: #667eea;\n    text-decoration: none;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-weight: 500;\n    transition: color 0.2s;\n\n    &:hover {\n      color: #764ba2;\n      text-decoration: underline;\n    }\n\n    .link-icon-small {\n      font-size: 14px;\n      width: 14px;\n      height: 14px;\n    }\n\n    .link-text {\n      max-width: 200px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n}\n\n// CDK Drag and Drop Styles\n.cdk-drag-preview {\n  box-sizing: border-box;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  opacity: 0.9;\n}\n\n.cdk-drag-placeholder {\n  opacity: 0.3;\n  background: #f8f9fa;\n  border: 2px dashed #667eea;\n}\n\n.cdk-drop-list-dragging .item-card-modern:not(.cdk-drag-placeholder) {\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n// Mobile Preview Styles for Items\n.mobile-group-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n  padding: 8px 12px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 6px;\n\n  .mobile-group-icon {\n    color: #fff;\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n  }\n\n  .mobile-section-title {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 600;\n    color: #fff;\n    flex: 1;\n  }\n\n  .mobile-group-count {\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.9);\n    font-weight: 500;\n  }\n}\n\n.mobile-item-card {\n  .mobile-item-avatar {\n    .mobile-item-placeholder {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 100%;\n      height: 100%;\n      background: #f1f3f5;\n      color: #adb5bd;\n\n      mat-icon {\n        font-size: 24px;\n        width: 24px;\n        height: 24px;\n      }\n    }\n  }\n\n  .mobile-item-content {\n    .mobile-item-row {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      margin-bottom: 6px;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n\n      .mobile-label {\n        font-size: 11px;\n        font-weight: 600;\n        color: #6c757d;\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n        min-width: 45px;\n        flex-shrink: 0;\n      }\n\n      .mobile-item-name {\n        margin: 0;\n        font-size: 14px;\n        font-weight: 600;\n        color: #1f2f46;\n        flex: 1;\n        min-width: 0;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n\n      .mobile-item-quantity {\n        margin: 0;\n        font-size: 13px;\n        color: #667eea;\n        font-weight: 600;\n        background: #f0f4ff;\n        padding: 2px 8px;\n        border-radius: 4px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        max-width: 100%;\n      }\n\n      .mobile-item-link {\n        font-size: 12px;\n        color: #667eea;\n        text-decoration: none;\n        display: inline-flex;\n        align-items: center;\n        gap: 4px;\n        font-weight: 500;\n\n        &:hover {\n          text-decoration: underline;\n          color: #764ba2;\n        }\n\n        .link-icon-tiny {\n          font-size: 14px;\n          width: 14px;\n          height: 14px;\n        }\n      }\n    }\n  }\n}\n\n// Ensure all popups and menus are on top\n.confirm-menu {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e4e8f0;\n\n  h5 {\n    margin: 0 0 8px;\n    font-size: 16px;\n    font-weight: 600;\n  }\n\n  p {\n    margin: 0;\n    font-size: 14px;\n    color: #64748b;\n  }\n}\n\n// Ensure mat-menu overlays are above everything\n::ng-deep .upload-backdrop {\n  .cdk-overlay-pane {\n    z-index: 10030 !important;\n  }\n\n  .cdk-overlay-backdrop {\n    z-index: 10029 !important;\n  }\n\n  .mat-mdc-menu-panel {\n    z-index: 10031 !important;\n  }\n}\n\n// Global override for mat-menu when inside upload-backdrop\n::ng-deep .cdk-overlay-container {\n  .cdk-overlay-pane {\n    &[data-mat-menu-panel],\n    &[class*=\"menu\"],\n    &:has(.mat-mdc-menu-panel),\n    &:has(.mat-menu-panel) {\n      z-index: 10030 !important;\n    }\n  }\n}\n\n// Ensure mat-menu triggered from upload-dialog is on top\n::ng-deep body {\n  .cdk-overlay-pane {\n    &:has(.mat-mdc-menu-panel),\n    &:has(.mat-menu-panel) {\n      z-index: 10030 !important;\n    }\n  }\n\n  .cdk-overlay-container {\n    .cdk-overlay-pane {\n      &[class*=\"menu\"],\n      &:has(.mat-mdc-menu-panel),\n      &:has(.mat-menu-panel) {\n        z-index: 10030 !important;\n      }\n    }\n  }\n}\n\n// Ensure thumbnail dialog close button is on top\n.thumbnail-dialog-card {\n  position: relative;\n  z-index: 10011;\n\n  .thumbnail-dialog-header {\n    .icon-button {\n      z-index: 10013 !important;\n      position: relative;\n    }\n  }\n}\n\n// Ensure url preview dialog is on top\n::ng-deep .url-preview-dialog {\n  z-index: 10015 !important;\n\n  .mat-mdc-dialog-container {\n    z-index: 10016 !important;\n  }\n}\n\n// Mobile view - upload flow style\n.mobile-create-flow {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  width: 100vw;\n  background: #000;\n  color: #fff;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 10000;\n  overflow: hidden;\n\n  // Initial Upload Screen\n  .mobile-upload-screen {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    padding: 20px;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n\n    .mobile-upload-header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      width: 100%;\n      padding: 12px 0;\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      padding-left: 16px;\n      padding-right: 16px;\n      padding-top: max(12px, env(safe-area-inset-top));\n\n      .mobile-back-btn {\n        background: rgba(255, 255, 255, 0.1);\n        border: none;\n        color: #fff;\n        padding: 8px;\n        border-radius: 50%;\n        width: 40px;\n        height: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n\n        mat-icon {\n          font-size: 24px;\n        }\n      }\n\n      .mobile-upload-title {\n        font-size: 18px;\n        font-weight: 600;\n        margin: 0;\n        flex: 1;\n        text-align: center;\n      }\n\n      .mobile-header-spacer {\n        width: 40px;\n      }\n    }\n\n    .mobile-upload-content {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 24px;\n      max-width: 400px;\n      width: 100%;\n\n      .mobile-upload-icon {\n        width: 120px;\n        height: 120px;\n        border-radius: 50%;\n        background: rgba(255, 255, 255, 0.1);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        mat-icon {\n          font-size: 64px;\n          width: 64px;\n          height: 64px;\n          color: #fff;\n        }\n      }\n\n      .mobile-upload-heading {\n        font-size: 24px;\n        font-weight: 600;\n        margin: 0;\n        color: #fff;\n      }\n\n      .mobile-upload-subtitle {\n        font-size: 16px;\n        color: #aaa;\n        margin: 0;\n      }\n\n      .mobile-upload-button {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 12px;\n        padding: 16px 32px;\n        background: #065fd4;\n        color: #fff;\n        border-radius: 24px;\n        cursor: pointer;\n        font-size: 16px;\n        font-weight: 600;\n        border: none;\n        width: 100%;\n        transition: all 0.2s;\n\n        &:active {\n          background: #0550c1;\n          transform: scale(0.98);\n        }\n\n        .upload-btn-content {\n          display: flex;\n          align-items: center;\n          gap: 12px;\n\n          mat-icon {\n            font-size: 24px;\n          }\n        }\n      }\n    }\n  }\n\n  // Main Content\n  .mobile-main-content {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    overflow: hidden;\n\n    .mobile-header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding: 12px 16px;\n      padding-top: max(12px, env(safe-area-inset-top));\n      background: linear-gradient(\n        180deg,\n        rgba(0, 0, 0, 0.9) 0%,\n        transparent 100%\n      );\n      position: relative;\n      z-index: 10;\n\n      .mobile-close-btn {\n        background: rgba(255, 255, 255, 0.1);\n        border: none;\n        color: #fff;\n        padding: 8px;\n        border-radius: 50%;\n        width: 40px;\n        height: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n\n        mat-icon {\n          font-size: 24px;\n        }\n      }\n\n      .mobile-title {\n        font-size: 18px;\n        font-weight: 600;\n        margin: 0;\n        flex: 1;\n        text-align: center;\n      }\n\n      .mobile-header-spacer {\n        width: 40px;\n      }\n    }\n\n    .mobile-cover-preview-section {\n      width: 100%;\n      aspect-ratio: 9 / 16;\n      background: #000;\n      position: relative;\n      overflow: hidden;\n\n      .mobile-media-preview {\n        width: 100%;\n        height: 100%;\n\n        .mobile-preview-image,\n        .mobile-preview-video {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n        }\n      }\n\n      .mobile-preview-title {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        padding: 16px;\n        background: linear-gradient(\n          0deg,\n          rgba(0, 0, 0, 0.9) 0%,\n          transparent 100%\n        );\n        font-size: 18px;\n        font-weight: 600;\n        color: #fff;\n      }\n    }\n\n    // Expansion Panels Container\n    .mobile-expansion-panels {\n      flex: 1;\n      overflow-y: auto;\n      background: #fff;\n      color: #000;\n      -webkit-overflow-scrolling: touch;\n\n      .mobile-expansion-panel {\n        border-radius: 0 !important;\n        box-shadow: none !important;\n        border-bottom: 1px solid #e0e0e0;\n        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n\n        &.mat-expanded {\n          position: fixed;\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n          z-index: 1000;\n          background: #fff;\n          height: 100vh;\n          overflow-y: auto;\n          -webkit-overflow-scrolling: touch;\n\n          .mobile-panel-content {\n            max-height: none;\n            overflow: visible;\n            padding-bottom: 100px; // Space for footer\n          }\n\n          .mat-expansion-panel-header {\n            position: sticky;\n            top: 0;\n            z-index: 10;\n            background: #fff;\n            border-bottom: 1px solid #e0e0e0;\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n          }\n        }\n\n        .mat-expansion-panel-header {\n          padding: 16px;\n          min-height: 64px;\n\n          .mat-expansion-panel-header-title {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n\n            .panel-icon {\n              color: #065fd4;\n              font-size: 24px;\n              width: 24px;\n              height: 24px;\n            }\n\n            span {\n              font-size: 16px;\n              font-weight: 600;\n              color: #0f0f0f;\n            }\n          }\n\n          .mat-expansion-panel-header-description {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n\n            .panel-status {\n              display: flex;\n              align-items: center;\n              gap: 4px;\n              color: #065fd4;\n              font-size: 14px;\n\n              .check-icon {\n                font-size: 20px;\n                width: 20px;\n                height: 20px;\n              }\n            }\n\n            .panel-error {\n              display: flex;\n              align-items: center;\n              gap: 4px;\n              color: #ea4335;\n              font-size: 14px;\n\n              .error-icon {\n                font-size: 20px;\n                width: 20px;\n                height: 20px;\n              }\n            }\n          }\n        }\n\n        .mobile-panel-content {\n          padding: 0;\n          max-height: 0;\n          overflow: hidden;\n          transition: max-height 0.3s ease-out;\n\n          .mobile-form-section {\n            padding: 16px;\n\n            .mobile-section-title {\n              font-size: 20px;\n              font-weight: 600;\n              margin: 0 0 20px 0;\n              color: #0f0f0f;\n            }\n\n            .mobile-section-subtitle {\n              font-size: 18px;\n              font-weight: 600;\n              margin: 24px 0 16px 0;\n              color: #0f0f0f;\n            }\n\n            .mobile-form-field {\n              width: 100%;\n              margin-bottom: 16px;\n            }\n\n            .mobile-label {\n              display: block;\n              font-size: 14px;\n              font-weight: 500;\n              color: #606060;\n              margin-bottom: 8px;\n            }\n\n            .mobile-upload-section {\n              margin-bottom: 16px;\n\n              .mobile-upload-btn {\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                justify-content: center;\n                gap: 8px;\n                width: 100%;\n                padding: 40px 20px;\n                border: 2px dashed #d3d3d3;\n                border-radius: 12px;\n                background: #f9f9f9;\n                cursor: pointer;\n                transition: all 0.2s;\n                position: relative;\n\n                &.uploading {\n                  cursor: not-allowed;\n                  opacity: 0.7;\n                  border-color: #065fd4;\n                  background: #e8f0fe;\n                }\n\n                &:active:not(.uploading) {\n                  background: #f0f0f0;\n                  border-color: #065fd4;\n                }\n\n                .upload-spinner {\n                  margin: 0 auto;\n\n                  ::ng-deep circle {\n                    stroke: #065fd4;\n                  }\n                }\n\n                mat-icon {\n                  font-size: 48px;\n                  width: 48px;\n                  height: 48px;\n                  color: #606060;\n                }\n\n                span {\n                  font-size: 16px;\n                  color: #606060;\n                  font-weight: 500;\n                }\n              }\n\n              .flow-upload-progress {\n                width: 100%;\n                margin-top: 12px;\n\n                .flow-progress-bar-container {\n                  width: 100%;\n                  height: 4px;\n                  background: #e0e0e0;\n                  border-radius: 2px;\n                  overflow: hidden;\n\n                  .flow-progress-bar {\n                    height: 100%;\n                    background: #065fd4;\n                    transition: width 0.3s ease;\n                  }\n                }\n              }\n\n              .mobile-item-preview-img,\n              .mobile-step-preview-img {\n                width: 100%;\n                max-height: 300px;\n                object-fit: contain;\n                border-radius: 8px;\n                margin-top: 12px;\n              }\n\n              .mobile-step-preview-video {\n                width: 100%;\n                max-height: 300px;\n                border-radius: 8px;\n                margin-top: 12px;\n              }\n            }\n\n            .mobile-toggle-section {\n              display: flex;\n              align-items: center;\n              justify-content: space-between;\n              padding: 16px 0;\n              margin-bottom: 16px;\n\n              label {\n                font-size: 16px;\n                color: #0f0f0f;\n              }\n            }\n\n            .mobile-add-btn,\n            .mobile-save-btn {\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              gap: 8px;\n              width: 100%;\n              padding: 16px;\n              border: none;\n              border-radius: 24px;\n              background: #065fd4;\n              color: #fff;\n              font-size: 16px;\n              font-weight: 600;\n              cursor: pointer;\n              transition: all 0.2s;\n              margin-top: 16px;\n              position: relative;\n\n              &:active:not(:disabled) {\n                background: #0550c1;\n                transform: scale(0.98);\n              }\n\n              &:disabled {\n                background: #ccc;\n                cursor: not-allowed;\n                opacity: 0.6;\n              }\n\n              .btn-spinner {\n                margin: 0;\n\n                ::ng-deep circle {\n                  stroke: #fff;\n                }\n              }\n\n              mat-icon {\n                font-size: 24px;\n                width: 24px;\n                height: 24px;\n              }\n            }\n\n            // Items List\n            .mobile-items-list {\n              margin-top: 24px;\n\n              .mobile-group-title {\n                display: flex;\n                align-items: center;\n                gap: 8px;\n                font-size: 18px;\n                font-weight: 600;\n                margin: 24px 0 12px 0;\n                color: #0f0f0f;\n\n                mat-icon {\n                  font-size: 20px;\n                  color: #065fd4;\n                }\n              }\n\n              .mobile-item-card {\n                display: flex;\n                align-items: center;\n                gap: 12px;\n                padding: 12px;\n                background: #f9f9f9;\n                border-radius: 12px;\n                margin-bottom: 8px;\n\n                .mobile-item-img {\n                  width: 60px;\n                  height: 60px;\n                  border-radius: 8px;\n                  object-fit: cover;\n                }\n\n                .mobile-item-info {\n                  flex: 1;\n\n                  .mobile-item-name {\n                    font-size: 16px;\n                    font-weight: 600;\n                    margin: 0 0 4px 0;\n                    color: #0f0f0f;\n                  }\n\n                  .mobile-item-qty {\n                    font-size: 14px;\n                    color: #606060;\n                    margin: 0;\n                  }\n                }\n\n                .mobile-item-actions {\n                  display: flex;\n                  gap: 8px;\n\n                  .mobile-action-btn {\n                    background: transparent;\n                    border: none;\n                    color: #606060;\n                    padding: 8px;\n                    cursor: pointer;\n                    border-radius: 50%;\n\n                    &:active {\n                      background: #e0e0e0;\n                    }\n\n                    mat-icon {\n                      font-size: 20px;\n                    }\n                  }\n                }\n              }\n            }\n\n            // Steps List\n            .mobile-steps-list {\n              margin-top: 24px;\n\n              .mobile-step-card {\n                background: #f9f9f9;\n                border-radius: 12px;\n                padding: 16px;\n                margin-bottom: 16px;\n\n                .mobile-step-header {\n                  display: flex;\n                  align-items: center;\n                  gap: 12px;\n                  margin-bottom: 12px;\n\n                  .mobile-step-number {\n                    font-size: 14px;\n                    color: #065fd4;\n                    font-weight: 600;\n                  }\n\n                  .mobile-step-title {\n                    font-size: 18px;\n                    font-weight: 600;\n                    margin: 0;\n                    color: #0f0f0f;\n                  }\n                }\n\n                .mobile-step-img,\n                .mobile-step-video {\n                  width: 100%;\n                  max-height: 300px;\n                  object-fit: contain;\n                  border-radius: 8px;\n                  margin-bottom: 12px;\n                }\n\n                .mobile-step-description {\n                  font-size: 14px;\n                  color: #606060;\n                  margin-bottom: 12px;\n                }\n\n                .mobile-step-actions {\n                  display: flex;\n                  gap: 8px;\n                  justify-content: flex-end;\n                }\n              }\n            }\n\n            // FAQs List\n            .mobile-faqs-list {\n              margin-top: 24px;\n\n              .mobile-group-title {\n                font-size: 18px;\n                font-weight: 600;\n                margin: 24px 0 12px 0;\n                color: #0f0f0f;\n              }\n\n              .mobile-faq-card {\n                background: #f9f9f9;\n                border-radius: 12px;\n                padding: 16px;\n                margin-bottom: 12px;\n\n                .mobile-faq-question {\n                  display: flex;\n                  align-items: flex-start;\n                  gap: 8px;\n                  margin-bottom: 8px;\n\n                  mat-icon {\n                    color: #065fd4;\n                    font-size: 20px;\n                  }\n\n                  span {\n                    font-size: 16px;\n                    font-weight: 600;\n                    color: #0f0f0f;\n                  }\n                }\n\n                .mobile-faq-answer {\n                  font-size: 14px;\n                  color: #606060;\n                  margin-bottom: 12px;\n                }\n\n                .mobile-faq-actions {\n                  display: flex;\n                  gap: 8px;\n                  justify-content: flex-end;\n                }\n              }\n            }\n\n            // Supporting Documents\n            .mobile-supporting-docs {\n              margin-top: 24px;\n\n              .mobile-tab-group {\n                margin-top: 16px;\n              }\n\n              .mobile-tab-content {\n                padding: 16px 0;\n              }\n\n              .mobile-file-name {\n                font-size: 14px;\n                color: #065fd4;\n                margin: 8px 0;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n                max-width: 100%;\n              }\n\n              .mobile-docs-list {\n                margin-top: 16px;\n\n                .mobile-doc-item {\n                  display: flex;\n                  align-items: center;\n                  gap: 12px;\n                  padding: 12px;\n                  background: #f9f9f9;\n                  border-radius: 8px;\n                  margin-bottom: 8px;\n\n                  mat-icon {\n                    color: #065fd4;\n                    flex-shrink: 0;\n                  }\n\n                  span {\n                    flex: 1;\n                    font-size: 14px;\n                    color: #0f0f0f;\n                    min-width: 0;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    white-space: nowrap;\n                  }\n                }\n              }\n            }\n          }\n\n          // Summary Content\n          &.summary-content {\n            .mobile-summary-view {\n              padding: 16px;\n\n              .summary-section {\n                margin-bottom: 32px;\n\n                h4 {\n                  font-size: 20px;\n                  font-weight: 600;\n                  margin: 0 0 16px 0;\n                  color: #0f0f0f;\n                }\n\n                h5 {\n                  font-size: 16px;\n                  font-weight: 600;\n                  margin: 16px 0 8px 0;\n                  color: #0f0f0f;\n                }\n\n                img,\n                video {\n                  width: 100%;\n                  max-height: 400px;\n                  object-fit: contain;\n                  border-radius: 8px;\n                  margin-bottom: 12px;\n                }\n\n                p {\n                  font-size: 14px;\n                  color: #606060;\n                  line-height: 1.6;\n                  margin: 8px 0;\n                }\n\n                strong {\n                  color: #0f0f0f;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    // Footer\n    .mobile-footer {\n      display: flex;\n      gap: 12px;\n      padding: 16px;\n      padding-bottom: max(16px, env(safe-area-inset-bottom));\n      background: #fff;\n      border-top: 1px solid #e0e0e0;\n      box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n\n      .mobile-footer-btn {\n        flex: 1;\n        padding: 14px 20px;\n        border: none;\n        border-radius: 24px;\n        font-size: 16px;\n        font-weight: 600;\n        cursor: pointer;\n        transition: all 0.2s;\n\n        &.secondary {\n          background: #f1f1f1;\n          color: #0f0f0f;\n\n          &:active {\n            background: #e0e0e0;\n            transform: scale(0.98);\n          }\n        }\n\n        &.primary {\n          background: #065fd4;\n          color: #fff;\n\n          &:active {\n            background: #0550c1;\n            transform: scale(0.98);\n          }\n\n          &:disabled {\n            background: #ccc;\n            cursor: not-allowed;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Hide desktop view on mobile\n@media (max-width: 768px) {\n  .upload-dialog.hide-on-mobile {\n    display: none !important;\n  }\n}\n\n// Tagged Items Section Styles\n.tagged-items-section {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n\n  ::ng-deep {\n    .mat-mdc-chip-set {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 8px;\n    }\n\n    .mat-mdc-chip {\n      cursor: pointer;\n      transition: all 0.2s ease;\n      background-color: #e3f2fd !important;\n      color: #1d67a3 !important;\n      position: relative;\n      padding-right: 8px !important;\n\n      &:hover {\n        background-color: #bbdefb !important;\n        transform: scale(1.05);\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n      }\n\n      .edit-chip-button {\n        opacity: 0.7;\n        transition: opacity 0.2s ease;\n        color: #1d67a3 !important;\n        padding: 0 !important;\n        margin-left: 4px !important;\n\n        &:hover {\n          opacity: 1;\n          background-color: rgba(29, 103, 163, 0.1) !important;\n        }\n\n        mat-icon {\n          color: #1d67a3 !important;\n        }\n      }\n    }\n  }\n}\n\n// Tagged items chips in form section\n.tagged-items-chips {\n  ::ng-deep {\n    .mat-mdc-chip {\n      position: relative;\n      padding-right: 8px !important;\n\n      .edit-chip-button {\n        opacity: 0.7;\n        transition: opacity 0.2s ease;\n        color: #1d67a3 !important;\n        padding: 0 !important;\n        margin-left: 4px !important;\n\n        &:hover {\n          opacity: 1;\n          background-color: rgba(29, 103, 163, 0.1) !important;\n        }\n\n        mat-icon {\n          color: #1d67a3 !important;\n        }\n      }\n    }\n  }\n}\n\n/* Dark mode readability fixes for Create Flow */\n:host-context(body.theme-dark) {\n  .upload-dialog {\n    background: #0f172a !important;\n    color: #e5e7eb !important;\n  }\n\n  .upload-header,\n  .stage-banner,\n  .upload-body,\n  .journey-content,\n  .section-card,\n  .journey-card,\n  .preview-card,\n  .cover-form-wrapper,\n  .flow-main-grid,\n  .flow-main-content,\n  .flow-sidebar.summary-preview-sidebar,\n  .step-navigation,\n  .step-panel-body,\n  .description-section,\n  .video-metadata,\n  .channel-info-section {\n    background: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .upload-dialog h1,\n  .upload-dialog h2,\n  .upload-dialog h3,\n  .upload-dialog h4,\n  .upload-dialog h5,\n  .upload-dialog h6,\n  .upload-dialog p,\n  .upload-dialog span,\n  .upload-dialog label,\n  .upload-dialog li,\n  .upload-dialog strong,\n  .upload-dialog .step-title-text,\n  .upload-dialog .step-description,\n  .upload-dialog .video-title,\n  .upload-dialog .video-title-sticky,\n  .upload-dialog .channel-name,\n  .upload-dialog .channel-meta {\n    color: #f3f4f6 !important;\n  }\n\n  /* Rephrase / AI action links â€” keep hyperlink appearance in dark mode */\n  .upload-dialog .clickable-text {\n    color: #5ea1d8 !important;\n    text-decoration: underline !important;\n    cursor: pointer;\n\n    &:hover {\n      color: #93c5fd !important;\n    }\n\n    .material-icons {\n      color: inherit !important;\n    }\n  }\n\n  .upload-dialog .mat-mdc-text-field-wrapper,\n  .upload-dialog .mdc-text-field,\n  .upload-dialog .mdc-text-field--outlined,\n  .upload-dialog .mdc-text-field--filled,\n  .upload-dialog input,\n  .upload-dialog textarea,\n  .upload-dialog select {\n    background: #111827 !important;\n    color: #f9fafb !important;\n  }\n\n  .upload-dialog [style*=\"background-color: #f0f7ff\"],\n  .upload-dialog [style*=\"background: #f0f7ff\"],\n  .upload-dialog [style*=\"background-color:#f0f7ff\"],\n  .upload-dialog [style*=\"background:#f0f7ff\"],\n  .upload-dialog [style*=\"background-color: #e3f2fd\"],\n  .upload-dialog [style*=\"background: #e3f2fd\"],\n  .upload-dialog [style*=\"background-color:#e3f2fd\"],\n  .upload-dialog [style*=\"background:#e3f2fd\"] {\n    background: rgba(30, 41, 59, 0.75) !important;\n    background-color: rgba(30, 41, 59, 0.75) !important;\n  }\n\n  .upload-dialog [style*=\"color: #333\"],\n  .upload-dialog [style*=\"color:#333\"],\n  .upload-dialog [style*=\"color: #666\"],\n  .upload-dialog [style*=\"color:#666\"] {\n    color: #f3f4f6 !important;\n  }\n}\n\n/* Strict no-white surfaces for all create-flow tabs in dark mode */\n:host-context(body.theme-dark) {\n  .upload-dialog .mat-mdc-tab-group,\n  .upload-dialog .mat-mdc-tab-header,\n  .upload-dialog .mat-mdc-tab-body-wrapper,\n  .upload-dialog .mat-mdc-tab-body,\n  .upload-dialog .mat-mdc-tab-body-content,\n  .upload-dialog [role=\"tabpanel\"],\n  .upload-dialog .quick-create-body,\n  .upload-dialog .upload-section,\n  .upload-dialog .items-section,\n  .upload-dialog .steps-section,\n  .upload-dialog .summary-section,\n  .upload-dialog .upload-all-placeholder,\n  .upload-dialog .cover-upload-placeholder,\n  .upload-dialog .cover-preview,\n  .upload-dialog .step-preview,\n  .upload-dialog .pending-image-preview,\n  .upload-dialog .item-card,\n  .upload-dialog .faq-card,\n  .upload-dialog .step-details-display,\n  .upload-dialog .cover-details-display,\n  .upload-footer,\n  .mobile-footer,\n  .upload-dialog .mobile-footer,\n  .upload-dialog .upload-footer {\n    background: #111827 !important;\n    color: #f3f4f6 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .upload-dialog textarea,\n  .upload-dialog .ql-container,\n  .upload-dialog .ql-editor,\n  .upload-dialog .mat-mdc-form-field-focus-overlay,\n  .upload-dialog ::ng-deep .mat-mdc-form-field-focus-overlay {\n    background: #111827 !important;\n    color: #f9fafb !important;\n  }\n\n  .upload-dialog [style*=\"background: #fff\"],\n  .upload-dialog [style*=\"background:#fff\"],\n  .upload-dialog [style*=\"background: #ffffff\"],\n  .upload-dialog [style*=\"background:#ffffff\"],\n  .upload-dialog [style*=\"background-color: #fff\"],\n  .upload-dialog [style*=\"background-color:#fff\"],\n  .upload-dialog [style*=\"background-color: #ffffff\"],\n  .upload-dialog [style*=\"background-color:#ffffff\"],\n  .upload-dialog [style*=\"background: white\"],\n  .upload-dialog [style*=\"background:white\"],\n  .upload-dialog [style*=\"background-color: white\"],\n  .upload-dialog [style*=\"background-color:white\"] {\n    background: #111827 !important;\n    background-color: #111827 !important;\n  }\n}\n\n/* Final page-scoped dark-mode hardening (Create Flow) */\n:host-context(body.theme-dark) {\n  .upload-dialog {\n    background: #0f172a !important;\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .upload-header,\n  .upload-dialog .stage-banner,\n  .upload-dialog .upload-body,\n  .upload-dialog .journey-content,\n  .upload-dialog .mat-mdc-tab-group,\n  .upload-dialog .mat-mdc-tab-header,\n  .upload-dialog .mat-mdc-tab-body-wrapper,\n  .upload-dialog .mat-mdc-tab-body,\n  .upload-dialog .mat-mdc-tab-body-content,\n  .upload-dialog [role=\"tabpanel\"],\n  .upload-dialog .upload-section,\n  .upload-dialog .items-section,\n  .upload-dialog .steps-section,\n  .upload-dialog .summary-section,\n  .upload-dialog .flow-main-grid,\n  .upload-dialog .flow-main-content,\n  .upload-dialog .flow-sidebar.summary-preview-sidebar,\n  .upload-dialog .step-navigation,\n  .upload-dialog .step-panel-body,\n  .upload-dialog .description-section,\n  .upload-dialog .video-metadata,\n  .upload-dialog .channel-info-section,\n  .upload-dialog .upload-footer,\n  .upload-dialog .mobile-footer,\n  .upload-dialog .upload-all-placeholder,\n  .upload-dialog .cover-upload-placeholder,\n  .upload-dialog .cover-preview,\n  .upload-dialog .step-preview,\n  .upload-dialog .pending-image-preview,\n  .upload-dialog .item-card,\n  .upload-dialog .faq-card,\n  .upload-dialog .step-details-display,\n  .upload-dialog .cover-details-display {\n    background: #111827 !important;\n    color: #f3f4f6 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .upload-dialog textarea,\n  .upload-dialog input,\n  .upload-dialog select,\n  .upload-dialog .mat-mdc-text-field-wrapper,\n  .upload-dialog .mdc-text-field,\n  .upload-dialog .mdc-text-field--outlined,\n  .upload-dialog .mdc-text-field--filled,\n  .upload-dialog .ql-container,\n  .upload-dialog .ql-toolbar,\n  .upload-dialog .ql-editor {\n    background: #111827 !important;\n    color: #f9fafb !important;\n  }\n}\n\n/* Manual mode specific dark-mode fixes: price toggle row + mat-label + icon shells + editor/text areas */\n:host-context(body.theme-dark) {\n  .upload-dialog .form-label-wrapper .form-label,\n  .upload-dialog .form-label {\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog mat-form-field ::ng-deep .mat-mdc-form-field-label,\n  .upload-dialog mat-form-field ::ng-deep .mat-mdc-floating-label,\n  .upload-dialog mat-form-field ::ng-deep mat-label {\n    color: #94a3b8 !important;\n  }\n}\n\n:host-context(body.theme-dark) {\n  .upload-dialog .icon-circle,\n  .upload-dialog .icon-button,\n  .upload-dialog .create-type-button,\n  .upload-dialog .header-right .icon-button,\n  .upload-dialog button.icon-button {\n    background: #1f2937 !important;\n    color: #f3f4f6 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .upload-dialog .icon-button:hover,\n  .upload-dialog button.icon-button:hover {\n    background: #334155 !important;\n  }\n\n  .upload-dialog .quill-field,\n  .upload-dialog .quill-wrapper,\n  .upload-dialog .quill-editor,\n  .upload-dialog .ql-toolbar,\n  .upload-dialog .ql-container,\n  .upload-dialog .ql-editor,\n  .upload-dialog textarea,\n  .upload-dialog .mat-mdc-form-field-textarea-control,\n  .upload-dialog .mat-mdc-input-element {\n    background: #111827 !important;\n    color: #f9fafb !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .upload-dialog ::ng-deep .ql-toolbar button,\n  .upload-dialog ::ng-deep .ql-toolbar .ql-stroke {\n    color: #e5e7eb !important;\n    stroke: #e5e7eb !important;\n  }\n\n  .upload-dialog ::ng-deep .ql-editor.ql-blank::before {\n    color: #94a3b8 !important;\n  }\n}\n\n/* Dark mode â€“ Items section surfaces (items-list-modern, item-card-modern, group headers) */\n:host-context(body.theme-dark) {\n  .upload-dialog .items-list-modern {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .upload-dialog .item-card-modern {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3) !important;\n\n    &:hover {\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4) !important;\n      border-color: #5ea1d8 !important;\n    }\n  }\n\n  .upload-dialog .item-image-wrapper {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .upload-dialog .mobile-item-placeholder {\n    background: #1e293b !important;\n    color: #64748b !important;\n  }\n\n  .upload-dialog .mobile-item-name {\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .mobile-label {\n    color: #94a3b8 !important;\n  }\n\n  .upload-dialog .mobile-item-quantity {\n    background: #1e3a5f !important;\n    color: #7ab8e8 !important;\n  }\n\n  .upload-dialog .group-header-line {\n    background: linear-gradient(135deg, #1e293b 0%, #111827 100%) !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .upload-dialog .group-title-block .group-icon {\n    color: #94a3b8 !important;\n  }\n\n  .upload-dialog .group-title-block .group-title,\n  .upload-dialog .group-title-block h4 {\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .group-count-chip {\n    background: #1e293b !important;\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .item-value.group-header {\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .item-drag-handle {\n    color: #4b5563 !important;\n  }\n\n  .upload-dialog .items-section .section-subtitle {\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .items-section .upload-multiple-section {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.4) !important;\n  }\n}\n\n/* Dark mode â€“ buttons, chips, step nav, action pills, tagged chips (Guided / Create Flow) */\n:host-context(body.theme-dark) {\n  // Footer secondary / ghost buttons\n  .upload-dialog .footer-btn.secondary,\n  .footer-btn.secondary {\n    background: #1e293b !important;\n    color: #f3f4f6 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n\n    &:hover:not(:disabled) {\n      background: #334155 !important;\n    }\n  }\n\n  .upload-dialog .footer-btn.ghost,\n  .footer-btn.ghost {\n    color: #7ab8e8 !important;\n    border-color: #5ea1d8 !important;\n\n    &:hover:not(:disabled) {\n      background: rgba(94, 161, 216, 0.12) !important;\n    }\n  }\n\n  // Mobile footer\n  .upload-dialog .mobile-footer {\n    background: #111827 !important;\n    border-top-color: rgba(148, 163, 184, 0.28) !important;\n\n    .mobile-footer-btn.secondary {\n      background: #1e293b !important;\n      color: #f3f4f6 !important;\n\n      &:active {\n        background: #334155 !important;\n      }\n    }\n  }\n\n  // Info/nav badge chips\n  .upload-dialog .info-badge,\n  .info-badge {\n    background: #1e293b !important;\n    color: #f3f4f6 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n\n    &:hover {\n      background: #334155 !important;\n    }\n\n    .info-step-title {\n      color: #94a3b8 !important;\n    }\n  }\n\n  // Sidebar step buttons\n  .upload-dialog .step-btn,\n  .step-btn {\n    background: #1e293b !important;\n    color: #f3f4f6 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    .step-number,\n    .step-title-text {\n      color: #f3f4f6 !important;\n    }\n\n    &:hover:not(.active) {\n      background: #334155 !important;\n      border-color: rgba(148, 163, 184, 0.5) !important;\n    }\n  }\n\n  // Tagged item chips\n  .upload-dialog .tagged-items-section ::ng-deep .mat-mdc-chip,\n  .tagged-items-section ::ng-deep .mat-mdc-chip {\n    background-color: #1e3a5f !important;\n    color: #7ab8e8 !important;\n\n    &:hover {\n      background-color: #1e4976 !important;\n    }\n\n    .edit-chip-button {\n      color: #7ab8e8 !important;\n\n      mat-icon {\n        color: #7ab8e8 !important;\n      }\n\n      &:hover {\n        background-color: rgba(122, 184, 232, 0.15) !important;\n      }\n    }\n  }\n\n  .upload-dialog .tagged-items-chips ::ng-deep .mat-mdc-chip .edit-chip-button,\n  .tagged-items-chips ::ng-deep .mat-mdc-chip .edit-chip-button {\n    color: #7ab8e8 !important;\n\n    mat-icon {\n      color: #7ab8e8 !important;\n    }\n  }\n\n  // Expand description button\n  .upload-dialog .expand-description-btn,\n  .expand-description-btn {\n    color: #94a3b8 !important;\n\n    &:hover {\n      color: #f3f4f6 !important;\n    }\n  }\n\n  // Summary card (review sidebar)\n  .upload-dialog .summary-card {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  // All journey-step buttons: never show a surface background\n  .upload-dialog .journey-step,\n  .journey-step {\n    background: transparent !important;\n    box-shadow: none !important;\n  }\n\n  // Step connector bar (inactive)\n  .upload-dialog .step-connector {\n    background: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  // Filled connector (after completed step)\n  .upload-dialog .step-connector.fill {\n    background: #16a34a !important;\n  }\n\n  // Journey step inactive text\n  .upload-dialog .journey-step:not(.active):not(.complete) {\n    color: #64748b !important;\n\n    .step-label {\n      border-color: #64748b !important;\n      background: transparent !important;\n      color: #64748b !important;\n    }\n\n    .step-count,\n    .label-text {\n      color: #64748b !important;\n    }\n  }\n\n  // Complete step pill â€” bright green (readable on dark)\n  .upload-dialog .journey-step.complete,\n  .journey-step.complete {\n    color: #4ade80 !important;\n\n    .step-label {\n      background: rgba(22, 163, 74, 0.15) !important;\n      color: #4ade80 !important;\n      border-color: #16a34a !important;\n    }\n\n    .step-count,\n    .label-text,\n    .label-check {\n      color: #4ade80 !important;\n    }\n  }\n\n  // Action pill buttons (publish row)\n  .upload-dialog .action-item {\n    background: #1e293b !important;\n\n    &:hover:not(.disabled) {\n      background: #334155 !important;\n    }\n\n    span {\n      color: #f3f4f6 !important;\n    }\n\n    mat-icon {\n      color: #f3f4f6 !important;\n    }\n  }\n\n  // Journey toolbar strip\n  .upload-dialog .journey-toolbar {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  // btn-secondary used in inline forms\n  .upload-dialog .btn-secondary,\n  .btn-secondary {\n    background: #1e293b !important;\n    color: #f3f4f6 !important;\n    border: 1px solid rgba(148, 163, 184, 0.35) !important;\n\n    &:hover:not(:disabled) {\n      background: #334155 !important;\n    }\n  }\n}\n\n/* Dark mode â€“ cover image container (.table-inner) and cover-form-wrapper children */\n:host-context(body.theme-dark) {\n  .upload-dialog .cover-form-wrapper .table-inner,\n  .cover-form-wrapper .table-inner {\n    background: #0f172a !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    p.text-center {\n      color: #64748b !important;\n    }\n  }\n\n  .upload-dialog .cover-form-wrapper h3,\n  .cover-form-wrapper h3 {\n    color: #f3f4f6 !important;\n  }\n}\n\n/* Dark mode â€“ cover tab: upload button, thumbnail choices, supporting list, placeholders */\n:host-context(body.theme-dark) {\n  // Cover metadata panel (shows file name, price, description)\n  .upload-dialog .cover-meta {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    .description-text {\n      color: #94a3b8 !important;\n    }\n  }\n\n  // Upload icon button (cloud_upload circle)\n  .upload-dialog .upload-icon-btn {\n    background: #1e3a5f !important;\n    color: #7ab8e8 !important;\n    box-shadow: inset 0 0 0 1px rgba(122, 184, 232, 0.2) !important;\n\n    &.light {\n      background: #1e293b !important;\n      color: #94a3b8 !important;\n    }\n\n    &:hover {\n      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.35) !important;\n    }\n\n    mat-icon {\n      color: #7ab8e8 !important;\n    }\n  }\n\n  // Supporting list (accepted formats info)\n  .upload-dialog .supporting-list {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    &__label {\n      color: #f3f4f6 !important;\n    }\n\n    li {\n      color: #cbd5e1 !important;\n    }\n  }\n\n  // Upload compact placeholder (thumbnail / extra media slots)\n  .upload-dialog .upload-placeholder-compact {\n    background: #1e293b !important;\n\n    mat-icon {\n      color: #64748b !important;\n    }\n\n    span {\n      color: #94a3b8 !important;\n    }\n  }\n\n  .upload-dialog .upload-label-compact {\n    mat-icon {\n      color: #64748b !important;\n    }\n\n    span {\n      color: #f3f4f6 !important;\n    }\n  }\n\n  // Thumbnail choice buttons (Use Frame / Upload Custom)\n  .upload-dialog .thumbnail-choice {\n    background: #1e293b !important;\n    color: #f3f4f6 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n\n    &.selected {\n      background: rgba(94, 161, 216, 0.1) !important;\n      border-color: #5ea1d8 !important;\n    }\n\n    &:hover:not(.disabled) {\n      background: #334155 !important;\n    }\n  }\n\n  .upload-dialog .choice-icon {\n    color: #94a3b8 !important;\n  }\n\n  .upload-dialog .choice-text small {\n    color: #94a3b8 !important;\n  }\n\n  // Extracted frames section\n  .upload-dialog .extracted-frames-section {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    h6 {\n      color: #f3f4f6 !important;\n    }\n\n    .frames-subtitle {\n      color: #94a3b8 !important;\n    }\n  }\n\n  // Example list / box (drag-drop item list on cover)\n  .upload-dialog .example-list {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .upload-dialog .example-box {\n    background: #1e293b !important;\n    box-shadow: inset 0 0 0 1px rgba(148, 163, 184, 0.2) !important;\n  }\n\n  // Summary cover placeholder (no image added yet)\n  .upload-dialog .summary-cover-placeholder,\n  .summary-cover-placeholder {\n    background: #1e293b !important;\n    color: #64748b !important;\n  }\n\n  // FAQ modal card (opened from cover/steps)\n  .upload-dialog .faq-modal-card,\n  .faq-modal-card {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .upload-dialog .faq-modal-header,\n  .faq-modal-header {\n    border-bottom-color: rgba(148, 163, 184, 0.28) !important;\n\n    h4 {\n      color: #f3f4f6 !important;\n    }\n  }\n\n  // Inline media size recommendation info box (inline style overrides)\n  .upload-dialog [style*=\"background-color: #f0f7ff\"],\n  .upload-dialog [style*=\"background:#f0f7ff\"] {\n    background-color: #1e293b !important;\n    border-left-color: #5ea1d8 !important;\n  }\n}\n\n/* Dark mode â€“ Summary/step/FAQ cards: title-description panels and inner blocks */\n:host-context(body.theme-dark) {\n\n  // â”€â”€ Top-level summary cards (used in full-screen summary tab) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .summary-card,\n  .summary-card {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4) !important;\n  }\n\n  .upload-dialog .summary-card .summary-card-header h3,\n  .summary-card .summary-card-header h3 {\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .summary-card .summary-card-header p,\n  .summary-card .summary-card-header p {\n    color: #94a3b8 !important;\n  }\n\n  // â”€â”€ Items summary: group blocks â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .summary-items-block,\n  .summary-items-block {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .upload-dialog .summary-items-block .summary-block-title h4,\n  .summary-items-block .summary-block-title h4 {\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .summary-items-block .summary-block-title span,\n  .summary-items-block .summary-block-title span {\n    color: #94a3b8 !important;\n  }\n\n  // â”€â”€ Steps summary: step panels â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .summary-step-panel,\n  .summary-step-panel {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .upload-dialog .summary-step-panel .summary-step-heading,\n  .summary-step-panel .summary-step-heading {\n    color: #f3f4f6 !important;\n  }\n\n  // Step number chip (eef2ff / e0e7ff â†’ dark navy)\n  .upload-dialog .step-chip,\n  .step-chip {\n    background: #1e3a5f !important;\n    color: #7ab8e8 !important;\n  }\n\n  .upload-dialog .summary-step-chip,\n  .summary-step-chip {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n    color: #f3f4f6 !important;\n\n    &.active {\n      border-color: #5ea1d8 !important;\n    }\n\n    .step-chip-number,\n    .step-chip-title {\n      color: #f3f4f6 !important;\n    }\n  }\n\n  // â”€â”€ FAQ summary: faq blocks â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .summary-faq-block,\n  .summary-faq-block {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .upload-dialog .summary-faq-block .summary-faq-header,\n  .summary-faq-block .summary-faq-header {\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .summary-faq-item,\n  .summary-faq-item {\n    border-top-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  // â”€â”€ Preview sidebar: step/FAQ title + description text â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .mobile-section-title,\n  .mobile-section-title {\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .mobile-section-description,\n  .mobile-section-description {\n    color: #cbd5e1 !important;\n\n    // Rich-text innerHTML content inherits\n    p, span, li, strong, em {\n      color: #cbd5e1 !important;\n    }\n  }\n\n  .upload-dialog .selected-step-details,\n  .selected-step-details {\n    background: transparent !important;\n\n    .mobile-step-header {\n      h3 {\n        color: #f3f4f6 !important;\n      }\n    }\n  }\n}\n\n/* Dark mode â€“ Cover summary, Items summary, FAQ tab, Summary tab surfaces */\n:host-context(body.theme-dark) {\n\n  // â”€â”€ Cover summary pills â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .summary-info-pills .info-badge,\n  .upload-dialog .summary-info-pills .summary-pill,\n  .summary-info-pills .info-badge,\n  .summary-info-pills .summary-pill {\n    background: #1e293b !important;\n    color: #f3f4f6 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .upload-dialog .summary-info-pills.secondary .summary-pill,\n  .summary-info-pills.secondary .summary-pill {\n    background: #1e3a5f !important;\n    color: #7ab8e8 !important;\n  }\n\n  // â”€â”€ Preview card (right-rail summary sidebar) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .preview-card,\n  .preview-card {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .upload-dialog .preview-card .flow-info-panel,\n  .preview-card .flow-info-panel {\n    background: #0f172a !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n    scrollbar-color: #334155 #0f172a !important;\n  }\n\n  .upload-dialog .preview-card .flow-info-panel .info-badge,\n  .preview-card .flow-info-panel .info-badge {\n    background: #1e293b !important;\n    color: #f3f4f6 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n\n    &:hover {\n      background: #334155 !important;\n    }\n  }\n\n  .upload-dialog .preview-card .flow-info-panel .info-badge.active,\n  .preview-card .flow-info-panel .info-badge.active {\n    background: #5ea1d8 !important;\n    color: #ffffff !important;\n    border-color: #5ea1d8 !important;\n  }\n\n  // Mobile section inside preview card\n  .upload-dialog .preview-card .mobile-section,\n  .preview-card .mobile-section {\n    background: #0f172a !important;\n  }\n\n  .upload-dialog .preview-card .mobile-section .mobile-media.placeholder,\n  .preview-card .mobile-section .mobile-media.placeholder {\n    background: #1e293b !important;\n  }\n\n  // Mobile items view\n  .upload-dialog .preview-card .mobile-items-view .mobile-items-list,\n  .preview-card .mobile-items-view .mobile-items-list {\n    background: #0f172a !important;\n  }\n\n  .upload-dialog .preview-card .mobile-item-card,\n  .preview-card .mobile-item-card {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  // Mobile FAQ view\n  .upload-dialog .preview-card .mobile-faqs-view .mobile-faq-item,\n  .preview-card .mobile-faqs-view .mobile-faq-item {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .upload-dialog .preview-card .mobile-faqs-view .mobile-faq-item .mobile-faq-question,\n  .preview-card .mobile-faqs-view .mobile-faq-item .mobile-faq-question {\n    color: #f3f4f6 !important;\n\n    span {\n      color: #f3f4f6 !important;\n    }\n\n    mat-icon {\n      color: #7ab8e8 !important;\n    }\n  }\n\n  .upload-dialog .preview-card .mobile-faqs-view .mobile-faq-item .show-answer-btn,\n  .preview-card .mobile-faqs-view .mobile-faq-item .show-answer-btn {\n    background: #1e3a5f !important;\n    color: #7ab8e8 !important;\n    border-color: #5ea1d8 !important;\n\n    &:hover {\n      background: #5ea1d8 !important;\n      color: #ffffff !important;\n    }\n  }\n\n  // â”€â”€ Items summary (item-preview rows, group title) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .group-title-small,\n  .group-title-small {\n    color: #f3f4f6 !important;\n    border-bottom-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .upload-dialog .item-preview,\n  .item-preview {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .upload-dialog .item-preview .item-preview-image.placeholder,\n  .item-preview .item-preview-image.placeholder {\n    background: #334155 !important;\n    color: #94a3b8 !important;\n  }\n\n  .upload-dialog .item-preview .item-preview-name,\n  .item-preview .item-preview-name {\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .item-preview .item-preview-quantity,\n  .item-preview .item-preview-quantity {\n    color: #94a3b8 !important;\n  }\n\n  // Modern items summary card\n  .upload-dialog .summary-item-card-modern,\n  .summary-item-card-modern {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    &:hover {\n      border-color: #5ea1d8 !important;\n    }\n  }\n\n  .upload-dialog .summary-item-image-modern,\n  .summary-item-image-modern {\n    background: #334155 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  // Step nav chip (summary sidebar)\n  .upload-dialog .step-nav-chip,\n  .step-nav-chip {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .upload-dialog .step-nav-chip .chip-step-title,\n  .step-nav-chip .chip-step-title {\n    color: #f3f4f6 !important;\n  }\n\n  // â”€â”€ FAQ tab: example-list / faq-list-container (has background: white !important) â”€â”€\n\n  .upload-dialog .example-list,\n  .upload-dialog .example-list.faq-list-container,\n  .example-list,\n  .example-list.faq-list-container {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .upload-dialog .example-list .example-box,\n  .example-list .example-box {\n    background: #1e293b !important;\n    border-bottom-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  // Empty state (FAQ / Items empty list)\n  .upload-dialog .empty-state,\n  .empty-state {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    p {\n      color: #94a3b8 !important;\n    }\n  }\n\n  // â”€â”€ Summary tab: transfer-toggle-section + toggle-description â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .transfer-toggle-section,\n  .transfer-toggle-section {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    .toggle-label {\n      color: #f3f4f6 !important;\n    }\n  }\n\n  .upload-dialog .transfer-toggle-section .toggle-description,\n  .transfer-toggle-section .toggle-description {\n    background: rgba(94, 161, 216, 0.12) !important;\n    border-left-color: #5ea1d8 !important;\n    color: #7ab8e8 !important;\n\n    .info-icon {\n      color: #7ab8e8 !important;\n    }\n\n    &.warning {\n      background: rgba(255, 193, 7, 0.1) !important;\n      border-left-color: #ffc107 !important;\n      color: #fcd34d !important;\n    }\n  }\n\n  .upload-dialog .transfer-toggle-section .selected-user-info,\n  .transfer-toggle-section .selected-user-info {\n    background: rgba(40, 167, 69, 0.12) !important;\n    border-left-color: #28a745 !important;\n  }\n\n  // â”€â”€ Mobile summary content â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .mobile-summary-view .summary-section h4,\n  .upload-dialog .mobile-summary-view .summary-section h5,\n  .upload-dialog .mobile-summary-view .summary-section strong,\n  .mobile-summary-view .summary-section h4,\n  .mobile-summary-view .summary-section h5,\n  .mobile-summary-view .summary-section strong {\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .mobile-summary-view .summary-section p,\n  .mobile-summary-view .summary-section p {\n    color: #94a3b8 !important;\n  }\n}\n\n/* Dark mode â€“ Items, FAQ, and Steps tab surfaces */\n:host-context(body.theme-dark) {\n\n  // â”€â”€ Items tab â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  // Drag placeholder while reordering items\n  .upload-dialog .cdk-drag-placeholder {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  // Action button (add / edit item row)\n  .upload-dialog .action-btn,\n  .action-btn {\n    background: #1e293b !important;\n    color: #f3f4f6 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n\n    &:hover {\n      background: #334155 !important;\n    }\n  }\n\n  // Example list rows â€“ item name, value, avatar, action buttons\n  .upload-dialog .example-list .example-box .item-avatar,\n  .journey-content .example-list .example-box .item-avatar {\n    background: #1e293b !important;\n  }\n\n  .upload-dialog .example-list .example-box .item-name,\n  .journey-content .example-list .example-box .item-name {\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .example-list .example-box .item-value,\n  .journey-content .example-list .example-box .item-value {\n    color: #94a3b8 !important;\n  }\n\n  .upload-dialog .example-list .example-box .row-actions .icon-button,\n  .journey-content .example-list .example-box .row-actions .icon-button {\n    color: #94a3b8 !important;\n\n    &:hover {\n      color: #f3f4f6 !important;\n      background: rgba(148, 163, 184, 0.12) !important;\n    }\n  }\n\n  // â”€â”€ FAQ tab â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  // FAQ question text (displayed inside faq-row)\n  .upload-dialog .faq-row .faq-content .faq-question-row .faq-question,\n  .faq-row .faq-content .faq-question-row .faq-question {\n    color: #f3f4f6 !important;\n  }\n\n  // FAQ modal answer body text\n  .upload-dialog .faq-modal-value,\n  .faq-modal-value {\n    color: #cbd5e1 !important;\n  }\n\n  // Quill rich-text editor wrapper (FAQ answer editor)\n  .upload-dialog .cover-form-wrapper .quill-wrapper,\n  .cover-form-wrapper .quill-wrapper {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    ::ng-deep .ql-toolbar {\n      background: #1e293b !important;\n      border-color: rgba(148, 163, 184, 0.28) !important;\n    }\n\n    ::ng-deep .ql-container {\n      background: #111827 !important;\n      border-color: rgba(148, 163, 184, 0.28) !important;\n    }\n\n    ::ng-deep .ql-editor {\n      background: #111827 !important;\n      color: #f3f4f6 !important;\n    }\n  }\n\n  // â”€â”€ Steps tab â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  // Step list container background\n  .upload-dialog .example-stepList,\n  .example-stepList {\n    background: #111827 !important;\n  }\n\n  // Individual step cards\n  .upload-dialog .example-stepList .step-card,\n  .upload-dialog .step-card,\n  .example-stepList .step-card,\n  .step-card {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3) !important;\n  }\n\n  // Step card text colours\n  .upload-dialog .example-stepList .step-card .step-header .step-file,\n  .example-stepList .step-card .step-header .step-file {\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .example-stepList .step-card .step-header .step-title,\n  .upload-dialog .step-card .step-title,\n  .example-stepList .step-card .step-header .step-title,\n  .step-card .step-title {\n    color: #94a3b8 !important;\n  }\n\n  .upload-dialog .example-stepList .step-card .step-description,\n  .upload-dialog .step-card .step-description,\n  .example-stepList .step-card .step-description,\n  .step-card .step-description {\n    color: #cbd5e1 !important;\n  }\n\n  // Ghost button in step card actions (Edit / Delete)\n  .upload-dialog .example-stepList .step-card .step-actions .square_btn.ghost,\n  .upload-dialog .step-card .step-actions .square_btn.ghost,\n  .example-stepList .step-card .step-actions .square_btn.ghost,\n  .step-card .step-actions .square_btn.ghost {\n    color: #f3f4f6 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n\n    &:hover {\n      background: #334155 !important;\n    }\n  }\n\n  // YouTube embed button (Steps tab)\n  .upload-dialog .yt-button,\n  .yt-button {\n    background: #1e293b !important;\n    color: #f3f4f6 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n\n    &:hover {\n      background: #334155 !important;\n    }\n  }\n\n  // Thumbnail dialog card (Steps tab â€“ choose video thumbnail)\n  .upload-dialog .thumbnail-dialog-card,\n  .thumbnail-dialog-card {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    h4, h5, h6, p, span {\n      color: #f3f4f6 !important;\n    }\n  }\n}\n\n/* Dark mode â€“ Summary tab: items list polished styling */\n:host-context(body.theme-dark) {\n\n  // â”€â”€ Items container (wraps .item-table in summary view) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .video-player-section .item,\n  .video-player-section .item {\n    background: #111827 !important;\n  }\n\n  // â”€â”€ Group header rows: give them a visual header band â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .item-value.group-header,\n  .item-value.group-header {\n    background: linear-gradient(135deg, #1e3a5f 0%, #1e293b 100%) !important;\n    color: #7ab8e8 !important;\n    padding: 8px 12px !important;\n    border-radius: 8px !important;\n    border: 1px solid rgba(94, 161, 216, 0.25) !important;\n    margin-bottom: 8px !important;\n\n    b {\n      color: #7ab8e8 !important;\n    }\n  }\n\n  // â”€â”€ Item rows â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .example-list .example-box,\n  .example-list .example-box {\n    background: #1e293b !important;\n    border-bottom-color: rgba(148, 163, 184, 0.15) !important;\n    transition: background 0.15s ease;\n\n    &:hover {\n      background: #263548 !important;\n    }\n\n    // Item name (plain text or link)\n    .item-name, a, span:not(.item-value) {\n      color: #f3f4f6 !important;\n    }\n\n    // Quantity / value column\n    .item-value {\n      color: #94a3b8 !important;\n    }\n\n    // Item image circle\n    img {\n      border: 2px solid rgba(148, 163, 184, 0.3) !important;\n      background: #334155 !important;\n    }\n  }\n\n  // â”€â”€ HR divider below list â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .item-table hr,\n  .item-table hr {\n    border-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  // â”€â”€ Copy-link container (has inline background: #f3f4f6) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .copy-link-container,\n  .copy-link-container {\n    background: #1e293b !important;\n    border: 1px solid rgba(148, 163, 184, 0.3) !important;\n    border-radius: 8px !important;\n\n    &:hover {\n      background: #334155 !important;\n    }\n\n    .copy-link-text {\n      color: #f3f4f6 !important;\n    }\n\n    .share-icon, mat-icon {\n      color: #7ab8e8 !important;\n    }\n  }\n\n  // â”€â”€ Override the inline background: #f3f4f6 on copy-link div â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog [style*=\"background: #f3f4f6\"],\n  .upload-dialog [style*=\"background:#f3f4f6\"],\n  .upload-dialog [style*=\"background-color: #f3f4f6\"],\n  .upload-dialog [style*=\"background-color:#f3f4f6\"] {\n    background: #1e293b !important;\n    background-color: #1e293b !important;\n  }\n\n  // â”€â”€ Mat-checkbox in item rows (dark mode) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .example-list ::ng-deep .mat-mdc-checkbox .mdc-checkbox__background,\n  .example-list ::ng-deep .mat-mdc-checkbox .mdc-checkbox__background {\n    background-color: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.5) !important;\n  }\n\n  .upload-dialog .example-list ::ng-deep .mat-mdc-checkbox.mat-mdc-checkbox-checked .mdc-checkbox__background,\n  .example-list ::ng-deep .mat-mdc-checkbox.mat-mdc-checkbox-checked .mdc-checkbox__background {\n    background-color: #5ea1d8 !important;\n    border-color: #5ea1d8 !important;\n  }\n}\n\n/* Dark mode â€“ Summary tab left column + FAQ tab missing surfaces */\n:host-context(body.theme-dark) {\n\n  // â”€â”€ Summary tab: sticky title bar â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n  .upload-dialog .flow-title-sticky,\n  .flow-title-sticky {\n    background: #111827 !important;\n    border-bottom-color: rgba(148, 163, 184, 0.28) !important;\n\n    .video-title-sticky {\n      color: #f3f4f6 !important;\n    }\n  }\n\n  // â”€â”€ Summary tab: step/cover/items navigation pill bar â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n  .upload-dialog .flow-main-content .flow-info-panel,\n  .flow-main-content .flow-info-panel {\n    background: #0f172a !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n    scrollbar-color: #334155 #0f172a !important;\n\n    .info-badge {\n      background: #1e293b !important;\n      color: #f3f4f6 !important;\n      border-color: rgba(148, 163, 184, 0.35) !important;\n\n      &:hover {\n        background: #334155 !important;\n      }\n\n      &.active {\n        background: #5ea1d8 !important;\n        color: #ffffff !important;\n        border-color: #5ea1d8 !important;\n      }\n    }\n  }\n\n  // â”€â”€ FAQ tab: group title headings â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n  .upload-dialog .group-title,\n  .group-title {\n    color: #f3f4f6 !important;\n  }\n\n  // â”€â”€ FAQ tab: \"Show answer\" button â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n  .upload-dialog .faq-row .show-answer-btn,\n  .upload-dialog .faq-content .show-answer-btn,\n  .faq-row .show-answer-btn,\n  .faq-content .show-answer-btn {\n    background: #1e3a5f !important;\n    color: #7ab8e8 !important;\n    border-color: #5ea1d8 !important;\n\n    &:hover {\n      background: #5ea1d8 !important;\n      color: #ffffff !important;\n    }\n  }\n\n  // â”€â”€ FAQ/Items tab: journey pane header text â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n  .upload-dialog .journey-pane-header p,\n  .journey-pane-header p {\n    color: #94a3b8 !important;\n  }\n\n  // â”€â”€ Summary tab: description-section bg (f9f9f9 â†’ dark) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n  .upload-dialog .flow-main-content .description-section,\n  .flow-main-content .description-section {\n    background: #0f172a !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    h3, .duration-timer {\n      color: #f3f4f6 !important;\n    }\n\n    .description-content {\n      color: #cbd5e1 !important;\n    }\n\n    .expand-description-btn {\n      color: #94a3b8 !important;\n\n      &:hover {\n        color: #f3f4f6 !important;\n      }\n    }\n  }\n}\n\n/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•\n   Dark mode â€“ Summary tab: full two-tone UI overhaul\n   Color 1 (base):     #111827  â€” main backgrounds, containers\n   Color 2 (elevated): #1e293b  â€” cards, buttons, raised surfaces\n   â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */\n:host-context(body.theme-dark) {\n\n  // â”€â”€ Left column: video metadata row â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .video-metadata,\n  .video-metadata {\n    border-bottom-color: rgba(148, 163, 184, 0.2) !important;\n\n    .video-title {\n      color: #f3f4f6 !important;\n    }\n\n    .s-num {\n      color: #94a3b8 !important;\n    }\n\n    .share-icon {\n      color: #94a3b8 !important;\n    }\n\n    .copy-link-container {\n      color: #94a3b8 !important;\n\n      .copy-link-text {\n        color: #94a3b8 !important;\n      }\n    }\n\n    // Like / Comment / Share / Saved action pills\n    .video-actions-bar .action-buttons .action-item {\n      background: #1e293b !important;\n      color: #f3f4f6 !important;\n\n      mat-icon {\n        color: #f3f4f6 !important;\n      }\n\n      span {\n        color: #f3f4f6 !important;\n      }\n\n      &:hover:not(.disabled) {\n        background: #334155 !important;\n      }\n    }\n  }\n\n  // â”€â”€ Left column: channel / creator info row â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .channel-info-section,\n  .channel-info-section {\n    border-bottom-color: rgba(148, 163, 184, 0.2) !important;\n\n    .channel-avatar .material-icons {\n      color: #64748b !important;\n    }\n\n    .channel-name {\n      color: #f3f4f6 !important;\n\n      &:hover {\n        color: #94a3b8 !important;\n      }\n    }\n\n    .channel-meta {\n      color: #94a3b8 !important;\n\n      mat-icon {\n        color: #94a3b8 !important;\n      }\n    }\n  }\n\n  // â”€â”€ Left column: video-player-section items list (non-media content) â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .video-player-section .item,\n  .video-player-section .item {\n    background: #111827 !important;\n    color: #f3f4f6 !important;\n  }\n\n  // â”€â”€ Right sidebar: step navigation buttons â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .flow-sidebar .step-btn,\n  .flow-sidebar .step-btn {\n    background: #1e293b !important;\n    color: #f3f4f6 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    .step-number {\n      color: #94a3b8 !important;\n    }\n\n    .step-title-text {\n      color: #f3f4f6 !important;\n    }\n\n    &:hover:not([class*=\"active\"]) {\n      background: #334155 !important;\n      border-color: rgba(148, 163, 184, 0.45) !important;\n    }\n  }\n\n  // Active step button keeps brand blue\n  .upload-dialog .flow-sidebar .step-panel.active .step-btn,\n  .flow-sidebar .step-panel.active .step-btn {\n    background: #5ea1d8 !important;\n    border-color: #5ea1d8 !important;\n\n    .step-number,\n    .step-title-text {\n      color: #ffffff !important;\n    }\n  }\n\n  // â”€â”€ Right sidebar: step panel body (description area) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .flow-sidebar .step-panel-body,\n  .flow-sidebar .step-panel-body {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n    color: #cbd5e1 !important;\n\n    .step-description,\n    .summary-step-description {\n      color: #cbd5e1 !important;\n    }\n\n    // Safety warning block inside step panel body\n    div[style*=\"border-left: 4px solid #d32f2f\"] {\n      background: rgba(211, 47, 47, 0.1) !important;\n    }\n  }\n\n  // â”€â”€ Stage banner: Edit / Draft status pill â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .status-pill,\n  .status-pill {\n    background: #1e3a5f !important;\n    color: #7ab8e8 !important;\n    border: 1px solid #5ea1d8 !important;\n  }\n\n  .current-access-pill {\n    background: #1a2c3d !important;\n    color: #7ec8f0 !important;\n  }\n\n  .approval-comment-input {\n    background: #1b1f27 !important;\n    border-color: #2f3542 !important;\n    color: #e2e8f0 !important;\n  }\n\n  .approval-review {\n    background: #13202e !important;\n    border-color: rgba(94, 161, 216, 0.35) !important;\n\n    .approval-review__label {\n      color: #7ec8f0 !important;\n    }\n  }\n\n  .approval-btn--reject {\n    background: transparent !important;\n    color: #fda29b !important;\n    border-color: rgba(240, 68, 56, 0.45) !important;\n  }\n\n  .current-access-pill.approval-state-pill {\n    &[data-state=\"InReview\"] {\n      background: rgba(181, 71, 8, 0.2) !important;\n      color: #fdba74 !important;\n    }\n\n    &[data-state=\"Approved\"],\n    &[data-state=\"Published\"] {\n      background: rgba(18, 183, 106, 0.16) !important;\n      color: #75e0a7 !important;\n    }\n\n    &[data-state=\"Rejected\"] {\n      background: rgba(240, 68, 56, 0.16) !important;\n      color: #fda29b !important;\n    }\n  }\n\n  .mobile-current-access-bar {\n    background: #1a2c3d !important;\n    border-bottom-color: rgba(94, 161, 216, 0.35) !important;\n  }\n\n  .mobile-access-icon-wrap {\n    background: #16324a !important;\n\n    mat-icon {\n      color: #7ec8f0 !important;\n    }\n  }\n\n  .mobile-access-copy .mobile-access-kicker {\n    color: #7ec8f0 !important;\n  }\n\n  .mobile-access-copy strong {\n    color: #e2e8f0 !important;\n  }\n\n  // â”€â”€ Right sidebar: scrollbar â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .upload-dialog .flow-sidebar .step-scroll,\n  .flow-sidebar .step-scroll {\n    scrollbar-color: #334155 #111827 !important;\n\n    &::-webkit-scrollbar-track {\n      background: #111827 !important;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #334155 !important;\n\n      &:hover {\n        background: #475569 !important;\n      }\n    }\n  }\n}\n\n/* Dark mode â€“ FAQ details modal (rendered outside .upload-dialog) */\n:host-context(body.theme-dark) {\n\n  // Card + backdrop\n  .faq-modal-card {\n    background: #111827 !important;\n    border: 1px solid rgba(148, 163, 184, 0.28) !important;\n    box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6) !important;\n  }\n\n  // Header: title + close icon button\n  .faq-modal-header {\n    background: #111827 !important;\n    border-bottom-color: rgba(148, 163, 184, 0.2) !important;\n\n    h4 {\n      color: #f3f4f6 !important;\n    }\n\n    // X close button â€“ fix white icon bg\n    .icon-button {\n      background: #1e293b !important;\n      color: #f3f4f6 !important;\n      border: 1px solid rgba(148, 163, 184, 0.28) !important;\n\n      mat-icon {\n        color: #f3f4f6 !important;\n      }\n\n      &:hover {\n        background: #334155 !important;\n      }\n    }\n  }\n\n  // Body\n  .faq-modal-body {\n    background: #111827 !important;\n  }\n\n  // Labels (Group / Question / Answer)\n  .faq-modal-label {\n    color: #94a3b8 !important;\n  }\n\n  // Values\n  .faq-modal-value {\n    color: #f3f4f6 !important;\n  }\n\n  .faq-modal-question .faq-modal-value {\n    color: #f3f4f6 !important;\n  }\n\n  .faq-modal-answer .faq-modal-value {\n    color: #cbd5e1 !important;\n\n    // Rich text content rendered via [innerHTML]\n    p, span, li, strong, em, a {\n      color: #cbd5e1 !important;\n    }\n  }\n\n  .faq-modal-group .faq-modal-value {\n    color: #7ab8e8 !important;\n  }\n\n  // Footer: border + Close button\n  .faq-modal-footer {\n    background: #111827 !important;\n    border-top-color: rgba(148, 163, 184, 0.2) !important;\n\n    .close-btn {\n      background: #1e293b !important;\n      color: #f3f4f6 !important;\n      border: 1px solid rgba(148, 163, 184, 0.35) !important;\n      border-radius: 8px !important;\n\n      &:hover {\n        background: #334155 !important;\n      }\n    }\n  }\n}\n\n.duration-input-group {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  width: 100%;\n\n  .duration-unit-field {\n    width: 120px;\n    flex-shrink: 0;\n  }\n\n  .duration-value-field {\n    flex: 1;\n  }\n}\n\n/* Dark mode â€“ Supporting doc added: edit / delete / view-link buttons */\n:host-context(body.theme-dark) {\n  .doc-name {\n    color: #e2e8f0 !important;\n  }\n\n  .doc-url {\n    color: #94a3b8 !important;\n  }\n\n  .link-pill {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n    color: #e2e8f0 !important;\n\n    mat-icon {\n      color: #7ab8e8 !important;\n    }\n\n    &:hover {\n      background: #334155 !important;\n    }\n  }\n\n  .icon-only {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n\n    mat-icon {\n      color: #94a3b8 !important;\n    }\n\n    &:hover {\n      background: #334155 !important;\n\n      mat-icon {\n        color: #e2e8f0 !important;\n      }\n    }\n  }\n}\n\n::ng-deep .access-menu-current {\n  margin-left: 8px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #1976d2;\n}\n\n\n.journey-access-type-row {\n  margin-bottom: 16px;\n  text-align: left;\n  width: 100%;\n  max-width: 100%;\n}\n\n.journey-access-option-list {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 10px;\n  margin-top: 10px;\n  width: 100%;\n  max-width: 100%;\n\n  @media (min-width: 992px) {\n    flex-direction: row;\n    align-items: stretch;\n    gap: 10px;\n  }\n}\n\n.journey-access-option {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  width: 100%;\n  text-align: left;\n  border: 1px solid #d7dee8;\n  border-radius: 12px;\n  background: #fff;\n  color: #1e293b;\n  padding: 14px 16px;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n\n  &:hover:not(:disabled) {\n    border-color: #93c5e8;\n    background: #f8fbfe;\n  }\n\n  &.selected {\n    border-color: #5ea1d8;\n    background: #eef6fc;\n    box-shadow: inset 0 0 0 1px #5ea1d8;\n  }\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n\n  @media (min-width: 992px) {\n    flex: 1 1 0;\n    min-width: 0;\n    align-items: center;\n    gap: 8px;\n    padding: 12px 14px;\n  }\n}\n\n.journey-access-option-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 24px;\n  height: 24px;\n  font-size: 24px;\n  line-height: 24px;\n  overflow: visible;\n  color: #5ea1d8;\n  margin-top: 0;\n}\n\n.journey-access-option-copy {\n  flex: 1 1 auto;\n  min-width: 0;\n\n  strong {\n    display: block;\n    font-size: 14px;\n    font-weight: 600;\n    color: #0f172a;\n    line-height: 24px;\n  }\n\n  p {\n    margin: 4px 0 0;\n    font-size: 13px;\n    line-height: 1.4;\n    color: #64748b;\n  }\n\n  @media (min-width: 992px) {\n    strong {\n      font-size: 13px;\n      line-height: 24px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    p {\n      display: none;\n    }\n  }\n}\n\n.journey-access-option-check {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 22px;\n  height: 22px;\n  font-size: 22px;\n  line-height: 22px;\n  overflow: visible;\n  color: #5ea1d8;\n  margin-top: 0;\n}\n\n.journey-restricted-panel {\n  margin-top: 16px;\n  width: 100%;\n  max-width: 100%;\n  text-align: left;\n  max-height: none;\n  overflow: visible;\n  padding-bottom: 24px;\n}\n\n.access-journey-card {\n  .journey-content {\n    width: 100%;\n  }\n\n  .cover-form-wrapper.journey-access-type-row,\n  .journey-restricted-panel,\n  app-enhanced-restricted-access {\n    display: block;\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n.viewer-features-panel {\n  margin-top: 24px;\n  padding: 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #f8fafc;\n\n  h5 {\n    margin: 0 0 6px;\n    font-size: 15px;\n    font-weight: 700;\n    color: #0f172a;\n  }\n\n  .viewer-features-hint {\n    margin: 0 0 14px;\n    font-size: 13px;\n    line-height: 1.45;\n    color: #64748b;\n  }\n\n  .viewer-features-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n    gap: 10px 16px;\n\n    mat-slide-toggle {\n      font-size: 13px;\n    }\n  }\n}\n\n.preview-card .mobile-section.access-summary-preview,\n.access-summary-preview {\n  overflow: visible;\n\n  .access-summary-badge {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n\n    .access-summary-kicker {\n      display: block;\n      margin-bottom: 0;\n      font-size: 11px;\n      font-weight: 700;\n      letter-spacing: 0.04em;\n      text-transform: uppercase;\n      color: #94a3b8;\n    }\n\n    .access-summary-title-row {\n      display: inline-flex;\n      align-items: center;\n      gap: 8px;\n      min-width: 0;\n      max-width: 100%;\n      min-height: 22px;\n\n      mat-icon {\n        display: inline-flex !important;\n        align-items: center;\n        justify-content: center;\n        flex: 0 0 20px;\n        width: 20px !important;\n        height: 20px !important;\n        font-size: 20px !important;\n        line-height: 20px !important;\n        margin: 0 !important;\n        padding: 0 !important;\n        overflow: visible;\n        color: #5ea1d8;\n        /* Optical nudge: Material glyphs sit slightly high next to text */\n        transform: translateY(1px);\n      }\n\n      strong {\n        display: inline-flex;\n        align-items: center;\n        min-width: 0;\n        margin: 0;\n        padding: 0;\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 20px;\n        color: #0f172a;\n      }\n    }\n\n    mat-icon {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      flex-shrink: 0;\n      width: 20px;\n      height: 20px;\n      font-size: 20px;\n      line-height: 20px;\n      overflow: visible;\n      color: #5ea1d8;\n    }\n\n    strong {\n      display: block;\n      min-width: 0;\n      font-size: 14px;\n      line-height: 20px;\n      color: #0f172a;\n    }\n\n    p {\n      margin: 2px 0 0;\n      font-size: 13px;\n      color: #64748b;\n      line-height: 1.4;\n    }\n  }\n\n  .access-summary-original {\n    margin-top: 14px;\n    padding-top: 12px;\n    border-top: 1px solid #e2e8f0;\n\n    .access-summary-kicker {\n      display: block;\n      margin-bottom: 2px;\n      font-size: 11px;\n      font-weight: 700;\n      letter-spacing: 0.04em;\n      text-transform: uppercase;\n      color: #94a3b8;\n    }\n\n    strong {\n      display: block;\n      font-size: 13px;\n      color: #334155;\n    }\n\n    p {\n      margin: 4px 0 0;\n      font-size: 12px;\n      color: #64748b;\n      line-height: 1.4;\n    }\n\n    .access-restore-btn {\n      display: inline-flex;\n      align-items: center;\n      gap: 6px;\n      margin-top: 10px;\n      padding: 6px 12px;\n      border: 1px solid #5ea1d8;\n      border-radius: 6px;\n      background: transparent;\n      color: #5ea1d8;\n      font-size: 12px;\n      font-weight: 600;\n      line-height: 16px;\n      cursor: pointer;\n      transition: background 0.15s, color 0.15s;\n\n      mat-icon {\n        display: inline-flex !important;\n        align-items: center;\n        justify-content: center;\n        flex: 0 0 16px;\n        width: 16px !important;\n        height: 16px !important;\n        font-size: 16px !important;\n        line-height: 16px !important;\n        margin: 0 !important;\n        padding: 0 !important;\n        overflow: visible;\n        transform: translateY(0.5px);\n      }\n\n      &:hover {\n        background: #5ea1d8;\n        color: #fff;\n      }\n    }\n  }\n\n  .access-summary-meta {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 12px;\n\n    span {\n      display: inline-flex;\n      align-items: center;\n      padding: 4px 10px;\n      border-radius: 999px;\n      background: #eef6fc;\n      color: #1e4d72;\n      font-size: 12px;\n      font-weight: 600;\n    }\n  }\n}\n\n.flows-sequence-hint.muted {\n  margin-top: 8px;\n  color: #6b7280;\n  font-size: 13px;\n  text-align: left;\n}\n\n.access-original-inline {\n  margin-top: 16px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n\n  .access-summary-kicker {\n    display: block;\n    margin-bottom: 4px;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: #94a3b8;\n  }\n\n  .access-summary-title-row {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n    max-width: 100%;\n\n    mat-icon {\n      display: inline-flex !important;\n      align-items: center;\n      justify-content: center;\n      flex: 0 0 20px;\n      width: 20px !important;\n      height: 20px !important;\n      font-size: 20px !important;\n      line-height: 20px !important;\n      margin: 0 !important;\n      padding: 0 !important;\n      overflow: visible;\n      color: #5ea1d8;\n      transform: translateY(1px);\n    }\n\n    strong {\n      display: inline-flex;\n      align-items: center;\n      min-width: 0;\n      margin: 0;\n      font-size: 14px;\n      font-weight: 600;\n      line-height: 20px;\n      color: #0f172a;\n    }\n  }\n\n  > p {\n    margin: 4px 0 0;\n    font-size: 13px;\n    line-height: 1.4;\n    color: #64748b;\n  }\n\n  .access-summary-meta {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 10px;\n\n    span {\n      display: inline-flex;\n      align-items: center;\n      padding: 4px 10px;\n      border-radius: 999px;\n      background: #eef6fc;\n      color: #1e4d72;\n      font-size: 12px;\n      font-weight: 600;\n    }\n  }\n\n  .access-restore-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    margin-top: 12px;\n    padding: 8px 14px;\n    border: 1px solid #5ea1d8;\n    border-radius: 6px;\n    background: transparent;\n    color: #5ea1d8;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 16px;\n    cursor: pointer;\n    transition: background 0.15s, color 0.15s;\n\n    mat-icon {\n      display: inline-flex !important;\n      align-items: center;\n      justify-content: center;\n      flex: 0 0 16px;\n      width: 16px !important;\n      height: 16px !important;\n      font-size: 16px !important;\n      line-height: 16px !important;\n      margin: 0 !important;\n      padding: 0 !important;\n      overflow: visible;\n      transform: translateY(0.5px);\n    }\n\n    &:hover {\n      background: #5ea1d8;\n      color: #fff;\n    }\n  }\n}\n\n.creator-access-notice {\n  .upgrade-free-link {\n    margin-left: 4px;\n    border: none;\n    background: none;\n    padding: 0;\n    color: #5ea1d8;\n    font-weight: 700;\n    font-size: 0.85rem;\n    cursor: pointer;\n    text-decoration: underline;\n  }\n}\n\n","// Rejection reason + \"Live: v3 · Editing: v4\" banners shown in the guide and guide pack editors.\n.publishing-state {\n  padding: 0 32px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  &__banner {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 16px;\n    border-radius: 10px;\n    font-size: 13px;\n    line-height: 1.5;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      flex-shrink: 0;\n    }\n\n    &--rejected {\n      background: #fdecea;\n      border: 1px solid #f5b5ae;\n      color: #8a1c12;\n      mat-icon { color: #d93025; }\n    }\n\n    &--status {\n      background: #eef4ff;\n      border: 1px solid #c7d7fe;\n      color: #1e3a8a;\n      mat-icon { color: #2563eb; }\n    }\n  }\n\n  &__text { flex: 1; }\n\n  &__hint {\n    display: block;\n    font-size: 12px;\n    opacity: 0.8;\n  }\n\n  &__change {\n    margin-left: auto;\n    border: 1px solid currentColor;\n    background: transparent;\n    color: inherit;\n    border-radius: 999px;\n    padding: 4px 12px;\n    font-size: 12px;\n    cursor: pointer;\n    white-space: nowrap;\n\n    &:disabled { opacity: 0.5; cursor: default; }\n  }\n}\n\n// Footer info icon that opens the publishing status details.\n.publishing-info-btn {\n  flex: 0 0 auto;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  color: #2563eb;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    line-height: 20px;\n  }\n\n  &:hover,\n  &:focus-visible {\n    background: rgba(37, 99, 235, 0.1);\n  }\n}\n\n:host-context(body.theme-dark) .publishing-info-btn {\n  color: #8ab4f8;\n}\n\n:host-context(body.theme-dark) .publishing-state {\n  .publishing-state__banner--rejected {\n    background: rgba(217, 48, 37, 0.12);\n    border-color: rgba(217, 48, 37, 0.35);\n    color: #f9b4ad;\n    mat-icon { color: #f28b82; }\n  }\n  .publishing-state__banner--status {\n    background: rgba(37, 99, 235, 0.12);\n    border-color: rgba(37, 99, 235, 0.35);\n    color: #bfd3fe;\n    mat-icon { color: #8ab4f8; }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
